(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ZpBv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $516c4cfaa4b34746$export$71511d61b312f219; });

var $ceUCx = parcelRequire("ceUCx");

var $e1lIn = parcelRequire("e1lIn");

var $OKxK3 = parcelRequire("OKxK3");

var $J66Jb = parcelRequire("J66Jb");
function $516c4cfaa4b34746$export$71511d61b312f219(arr, i) {
    return (0, $ceUCx._)(arr) || (0, $e1lIn._)(arr, i) || (0, $J66Jb._)(arr, i) || (0, $OKxK3._)();
}

});
parcelRegister("ceUCx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8e92b680619f4fa4$export$71511d61b312f219; });
function $8e92b680619f4fa4$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("e1lIn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a35200cd1f91429a$export$71511d61b312f219; });
function $a35200cd1f91429a$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("OKxK3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0988c6241722d902$export$71511d61b312f219; });
function $0988c6241722d902$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("J66Jb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0878f0e8b254b036$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $0878f0e8b254b036$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2PuG4._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2PuG4._)(o, minLen);
}

});
parcelRegister("2PuG4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $20f8241f6119e7d1$export$71511d61b312f219; });
function $20f8241f6119e7d1$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("gMqb0", function(module, exports) {

$parcel$export(module.exports, "Animation", function () { return $44a9a101038c7a37$export$c35d437ae5945fcd; });

var $dxEC4 = parcelRequire("dxEC4");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $gh3Df = parcelRequire("gh3Df");

var $6GUs3 = parcelRequire("6GUs3");
parcelRequire("6VBea");
var $2pyvk = parcelRequire("2pyvk");

var $1TS6r = parcelRequire("1TS6r");
var $44a9a101038c7a37$export$c35d437ae5945fcd = /*#__PURE__*/ function() {
    "use strict";
    function Animation(canvas, src) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $4QweW._)(this, Animation);
        this.dotLottie = null;
        this.dataLight = null;
        this.dataDark = null;
        this.aspectRatio = null;
        this.handleColorModeChange = function() {
            var data = _this.currentAnimationData;
            if (!_this.dotLottie || !data) return;
            _this.dotLottie.load({
                data: data,
                autoplay: _this.autoplay,
                loop: _this.loop,
                layout: {
                    fit: 'contain',
                    align: _this.aspectRatio ? [
                        0,
                        0
                    ] : [
                        0.5,
                        0.5
                    ]
                }
            });
        };
        this.initAnimation = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                var _this, response, dataLight, dataDark, aspectRatio, data;
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            return [
                                4,
                                (0, $1TS6r.fetchAnimationData)(this.src)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response) {
                                this.intersectionObserver.unobserve(this.canvas);
                                return [
                                    2
                                ];
                            }
                            dataLight = response.dataLight, dataDark = response.dataDark, aspectRatio = response.aspectRatio;
                            this.aspectRatio = aspectRatio || null;
                            this.dataLight = dataLight;
                            this.dataDark = dataDark || null;
                            data = this.currentAnimationData;
                            // If data is false, unobserve the current entry and exit early
                            if (!data) {
                                this.intersectionObserver.unobserve(this.canvas);
                                return [
                                    2
                                ];
                            }
                            // Set the aspect ratio
                            if (aspectRatio) {
                                this.canvas.style.setProperty('--aspect-ratio', aspectRatio);
                                this.canvas.classList.add('known-aspect-ratio');
                            }
                            this.dotLottie = new (0, $6GUs3.DotLottieWorker)({
                                canvas: this.canvas,
                                data: data,
                                autoplay: this.autoplay,
                                loop: this.loop,
                                workerId: this.workerId,
                                layout: {
                                    fit: 'contain',
                                    align: aspectRatio ? [
                                        0,
                                        0
                                    ] : [
                                        0.5,
                                        0.5
                                    ]
                                }
                            });
                            // On load callback
                            this.dotLottie.addEventListener('load', function() {
                                _this.canvas.classList.add('loaded');
                                _this.onLoad(_this.dotLottie);
                            });
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        };
        var _options_autoplay = options.autoplay, autoplay = _options_autoplay === void 0 ? false : _options_autoplay, _options_loop = options.loop, loop = _options_loop === void 0 ? false : _options_loop, _options_triggerElement = options.triggerElement, triggerElement = _options_triggerElement === void 0 ? '' : _options_triggerElement, _options_onLoad = options.onLoad, onLoad = _options_onLoad === void 0 ? function() {} : _options_onLoad, _options_pauseOnExit = options.pauseOnExit, pauseOnExit = _options_pauseOnExit === void 0 ? true : _options_pauseOnExit, _options_workerId = options.workerId, workerId = _options_workerId === void 0 ? 'default' : _options_workerId;
        this.canvas = canvas;
        this.src = src;
        // Options
        this.autoplay = autoplay;
        this.loop = loop;
        this.onLoad = onLoad;
        this.pauseOnExit = pauseOnExit;
        this.workerId = workerId;
        document.addEventListener('colorModeChange', this.handleColorModeChange);
        // Check for triggers
        if (triggerElement) document.querySelectorAll(triggerElement).forEach(function(trigger) {
            trigger.addEventListener('mouseenter', function() {
                _this.play();
            });
        });
        // Observe the canvas element
        this.intersectionObserverCallback = this.intersectionObserverCallback.bind(this);
        this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback, {
            rootMargin: '400px'
        });
        this.intersectionObserver.observe(this.canvas);
        (0, $2pyvk.addWindowResizeEvent)(function() {
            return _this.resize();
        });
    }
    (0, $6hK4i._)(Animation, [
        {
            key: "currentAnimationData",
            get: function get() {
                return (0, $1TS6r.getCurrentAnimationData)({
                    dataLight: this.dataLight || '',
                    dataDark: this.dataDark || ''
                });
            }
        },
        {
            key: "intersectionObserverCallback",
            value: function intersectionObserverCallback(entries) {
                var _this = this;
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        if (_this.dotLottie === null) _this.initAnimation();
                        else if (_this.autoplay) _this.dotLottie.play();
                    } else if (_this.dotLottie !== null && _this.autoplay && _this.dotLottie.isPlaying && _this.pauseOnExit) _this.dotLottie.pause();
                });
            }
        },
        {
            key: "play",
            value: function play() {
                var _this_dotLottie;
                (_this_dotLottie = this.dotLottie) === null || _this_dotLottie === void 0 ? void 0 : _this_dotLottie.play();
            }
        },
        {
            key: "pause",
            value: function pause() {
                var _this_dotLottie;
                (_this_dotLottie = this.dotLottie) === null || _this_dotLottie === void 0 ? void 0 : _this_dotLottie.pause();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this_dotLottie;
                (_this_dotLottie = this.dotLottie) === null || _this_dotLottie === void 0 ? void 0 : _this_dotLottie.stop();
            }
        },
        {
            key: "resize",
            value: function resize() {
                var _this_dotLottie;
                (_this_dotLottie = this.dotLottie) === null || _this_dotLottie === void 0 ? void 0 : _this_dotLottie.resize();
            }
        }
    ]);
    return Animation;
}();

});
parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("4QweW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $387506f4e8043722$export$71511d61b312f219; });
function $387506f4e8043722$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6hK4i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $493810cfcf480a5a$export$71511d61b312f219; });
function $493810cfcf480a5a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $493810cfcf480a5a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $493810cfcf480a5a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $493810cfcf480a5a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("6GUs3", function(module, exports) {

$parcel$export(module.exports, "DotLottie", function () { return $4df2746f4766bf20$export$2c434b74e61f4f56; });
$parcel$export(module.exports, "DotLottieWorker", function () { return $4df2746f4766bf20$export$ab8c8a3fed0b35de; });

var $dxEC4 = parcelRequire("dxEC4");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $1DiK7 = parcelRequire("1DiK7");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $gh3Df = parcelRequire("gh3Df");
function $4df2746f4766bf20$var$e(t) {
    "@babel/helpers - typeof";
    return $4df2746f4766bf20$var$e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function e(_e) {
        return typeof _e;
    } : function(e) {
        return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, $4df2746f4766bf20$var$e(t);
}
function $4df2746f4766bf20$var$t(t, n) {
    if ($4df2746f4766bf20$var$e(t) != "object" || !t) return t;
    var _$r = t[Symbol.toPrimitive];
    if (_$r !== void 0) {
        var i = _$r.call(t, n || "default");
        if ($4df2746f4766bf20$var$e(i) != "object") return i;
        throw TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(t);
}
function $4df2746f4766bf20$var$n(n) {
    var _$r = $4df2746f4766bf20$var$t(n, "string");
    return $4df2746f4766bf20$var$e(_$r) == "symbol" ? _$r : _$r + "";
}
function $4df2746f4766bf20$var$r(e, t, r) {
    return (t = $4df2746f4766bf20$var$n(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
var $4df2746f4766bf20$var$i = /*#__PURE__*/ function() {
    "use strict";
    function i() {
        (0, $4QweW._)(this, i);
    }
    (0, $6hK4i._)(i, [
        {
            key: "requestAnimationFrame",
            value: function requestAnimationFrame1(e) {
                return requestAnimationFrame(e);
            }
        },
        {
            key: "cancelAnimationFrame",
            value: function cancelAnimationFrame1(e) {
                cancelAnimationFrame(e);
            }
        }
    ]);
    return i;
}(), $4df2746f4766bf20$var$a = /*#__PURE__*/ function() {
    "use strict";
    function a() {
        (0, $4QweW._)(this, a);
        $4df2746f4766bf20$var$r(this, "_lastHandleId", 0), $4df2746f4766bf20$var$r(this, "_lastImmediate", null);
    }
    (0, $6hK4i._)(a, [
        {
            key: "requestAnimationFrame",
            value: function requestAnimationFrame1(e) {
                return this._lastHandleId >= Math.pow(2, 53) - 1 && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(function() {
                    e(performance.now());
                }), this._lastHandleId;
            }
        },
        {
            key: "cancelAnimationFrame",
            value: function cancelAnimationFrame1(e) {
                this._lastImmediate && clearImmediate(this._lastImmediate);
            }
        }
    ]);
    return a;
}(), $4df2746f4766bf20$var$o = /*#__PURE__*/ function() {
    "use strict";
    function o() {
        (0, $4QweW._)(this, o);
        $4df2746f4766bf20$var$r(this, "_strategy", void 0), this._strategy = typeof requestAnimationFrame == "function" ? new $4df2746f4766bf20$var$i : new $4df2746f4766bf20$var$a;
    }
    (0, $6hK4i._)(o, [
        {
            key: "requestAnimationFrame",
            value: function requestAnimationFrame1(e) {
                return this._strategy.requestAnimationFrame(e);
            }
        },
        {
            key: "cancelAnimationFrame",
            value: function cancelAnimationFrame1(e) {
                this._strategy.cancelAnimationFrame(e);
            }
        }
    ]);
    return o;
}();
var $4df2746f4766bf20$var$s = (typeof window === "undefined" ? "undefined" : (0, $5djcY._)(window)) < "u" && window.document !== void 0, $4df2746f4766bf20$var$c = new Uint8Array([
    80,
    75,
    3,
    4
]), $4df2746f4766bf20$var$l = [
    "v",
    "ip",
    "op",
    "layers",
    "fr",
    "w",
    "h"
];
var $4df2746f4766bf20$var$u;
var $4df2746f4766bf20$var$d = Array(128).fill(void 0);
$4df2746f4766bf20$var$d.push(void 0, null, !0, !1);
function $4df2746f4766bf20$var$f(e) {
    return $4df2746f4766bf20$var$d[e];
}
var $4df2746f4766bf20$var$p = $4df2746f4766bf20$var$d.length;
function $4df2746f4766bf20$var$m(e) {
    $4df2746f4766bf20$var$p === $4df2746f4766bf20$var$d.length && $4df2746f4766bf20$var$d.push($4df2746f4766bf20$var$d.length + 1);
    var t = $4df2746f4766bf20$var$p;
    return $4df2746f4766bf20$var$p = $4df2746f4766bf20$var$d[t], $4df2746f4766bf20$var$d[t] = e, t;
}
function $4df2746f4766bf20$var$h(e, t) {
    try {
        return e.apply(this, t);
    } catch (e) {
        $4df2746f4766bf20$var$u.__wbindgen_export_0($4df2746f4766bf20$var$m(e));
    }
}
function $4df2746f4766bf20$var$g(e) {
    return e == null;
}
var $4df2746f4766bf20$var$ee = (typeof TextDecoder === "undefined" ? "undefined" : (0, $5djcY._)(TextDecoder)) < "u" ? new TextDecoder("utf-8", {
    ignoreBOM: !0,
    fatal: !0
}) : {
    decode: function() {
        throw Error("TextDecoder not available");
    }
};
(typeof TextDecoder === "undefined" ? "undefined" : (0, $5djcY._)(TextDecoder)) < "u" && $4df2746f4766bf20$var$ee.decode();
var $4df2746f4766bf20$var$_ = null;
function $4df2746f4766bf20$var$v() {
    return ($4df2746f4766bf20$var$_ === null || $4df2746f4766bf20$var$_.byteLength === 0) && ($4df2746f4766bf20$var$_ = new Uint8Array($4df2746f4766bf20$var$u.memory.buffer)), $4df2746f4766bf20$var$_;
}
function $4df2746f4766bf20$var$y(e, t) {
    return e >>>= 0, $4df2746f4766bf20$var$ee.decode($4df2746f4766bf20$var$v().subarray(e, e + t));
}
var $4df2746f4766bf20$var$b = 0;
var $4df2746f4766bf20$var$x = (typeof TextEncoder === "undefined" ? "undefined" : (0, $5djcY._)(TextEncoder)) < "u" ? new TextEncoder("utf-8") : {
    encode: function() {
        throw Error("TextEncoder not available");
    }
}, $4df2746f4766bf20$var$te = typeof $4df2746f4766bf20$var$x.encodeInto == "function" ? function te(e, t) {
    return $4df2746f4766bf20$var$x.encodeInto(e, t);
} : function(e, t) {
    var n = $4df2746f4766bf20$var$x.encode(e);
    return t.set(n), {
        read: e.length,
        written: n.length
    };
};
function $4df2746f4766bf20$var$S(e, t, n) {
    if (n === void 0) {
        var _$n = $4df2746f4766bf20$var$x.encode(e), _$r = t(_$n.length, 1) >>> 0;
        return $4df2746f4766bf20$var$v().subarray(_$r, _$r + _$n.length).set(_$n), $4df2746f4766bf20$var$b = _$n.length, _$r;
    }
    var _$r1 = e.length, i = t(_$r1, 1) >>> 0, a = $4df2746f4766bf20$var$v(), o = 0;
    for(; o < _$r1; o++){
        var _$t = e.charCodeAt(o);
        if (_$t > 127) break;
        a[i + o] = _$t;
    }
    if (o !== _$r1) {
        o !== 0 && (e = e.slice(o)), i = n(i, _$r1, _$r1 = o + e.length * 3, 1) >>> 0;
        var _$t1 = $4df2746f4766bf20$var$v().subarray(i + o, i + _$r1), a1 = $4df2746f4766bf20$var$te(e, _$t1);
        o += a1.written, i = n(i, _$r1, o, 1) >>> 0;
    }
    return $4df2746f4766bf20$var$b = o, i;
}
var $4df2746f4766bf20$var$C = null;
function $4df2746f4766bf20$var$w() {
    return ($4df2746f4766bf20$var$C === null || $4df2746f4766bf20$var$C.buffer.detached === !0 || $4df2746f4766bf20$var$C.buffer.detached === void 0 && $4df2746f4766bf20$var$C.buffer !== $4df2746f4766bf20$var$u.memory.buffer) && ($4df2746f4766bf20$var$C = new DataView($4df2746f4766bf20$var$u.memory.buffer)), $4df2746f4766bf20$var$C;
}
function $4df2746f4766bf20$var$T(e, t) {
    var n = t(e.length * 1, 1) >>> 0;
    return $4df2746f4766bf20$var$v().set(e, n / 1), $4df2746f4766bf20$var$b = e.length, n;
}
function $4df2746f4766bf20$var$ne(e) {
    e < 132 || ($4df2746f4766bf20$var$d[e] = $4df2746f4766bf20$var$p, $4df2746f4766bf20$var$p = e);
}
function $4df2746f4766bf20$var$E(e) {
    var t = $4df2746f4766bf20$var$f(e);
    return $4df2746f4766bf20$var$ne(e), t;
}
var $4df2746f4766bf20$var$D = (typeof FinalizationRegistry === "undefined" ? "undefined" : (0, $5djcY._)(FinalizationRegistry)) > "u" ? {
    register: function() {},
    unregister: function() {}
} : new FinalizationRegistry(function(e) {
    $4df2746f4766bf20$var$u.__wbindgen_export_4.get(e.dtor)(e.a, e.b);
});
function $4df2746f4766bf20$var$re(e, t, n, r) {
    var i = {
        a: e,
        b: t,
        cnt: 1,
        dtor: n
    }, a = function() {
        for(var _len = arguments.length, _$e = new Array(_len), _key = 0; _key < _len; _key++){
            _$e[_key] = arguments[_key];
        }
        i.cnt++;
        var _$t = i.a;
        i.a = 0;
        try {
            return r.apply(void 0, [
                _$t,
                i.b
            ].concat((0, $jlUaU._)(_$e)));
        } finally{
            --i.cnt === 0 ? ($4df2746f4766bf20$var$u.__wbindgen_export_4.get(i.dtor)(_$t, i.b), $4df2746f4766bf20$var$D.unregister(i)) : i.a = _$t;
        }
    };
    return a.original = i, $4df2746f4766bf20$var$D.register(a, i, i), a;
}
function $4df2746f4766bf20$var$ie(e, t) {
    var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b, i = $4df2746f4766bf20$var$T(t, $4df2746f4766bf20$var$u.__wbindgen_export_1), a = $4df2746f4766bf20$var$b;
    return $4df2746f4766bf20$var$u.register_font(n, _$r, i, a) !== 0;
}
var $4df2746f4766bf20$var$O = null;
function $4df2746f4766bf20$var$ae() {
    return ($4df2746f4766bf20$var$O === null || $4df2746f4766bf20$var$O.byteLength === 0) && ($4df2746f4766bf20$var$O = new Float32Array($4df2746f4766bf20$var$u.memory.buffer)), $4df2746f4766bf20$var$O;
}
function $4df2746f4766bf20$var$oe(e, t) {
    var n = t(e.length * 4, 4) >>> 0;
    return $4df2746f4766bf20$var$ae().set(e, n / 4), $4df2746f4766bf20$var$b = e.length, n;
}
function $4df2746f4766bf20$var$se(e, t) {
    var n = t(e.length * 4, 4) >>> 0, _$r = $4df2746f4766bf20$var$w();
    for(var _$t = 0; _$t < e.length; _$t++)_$r.setUint32(n + 4 * _$t, $4df2746f4766bf20$var$m(e[_$t]), !0);
    return $4df2746f4766bf20$var$b = e.length, n;
}
function $4df2746f4766bf20$var$ce(e, t, n) {
    $4df2746f4766bf20$var$u.__wbindgen_export_5(e, t, $4df2746f4766bf20$var$m(n));
}
var $4df2746f4766bf20$var$k = Object.freeze({
    Forward: 0,
    0: "Forward",
    Reverse: 1,
    1: "Reverse",
    Bounce: 2,
    2: "Bounce",
    ReverseBounce: 3,
    3: "ReverseBounce"
}), $4df2746f4766bf20$var$A = Object.freeze({
    Idle: 0,
    0: "Idle",
    Playing: 1,
    1: "Playing",
    Paused: 2,
    2: "Paused",
    Stopped: 3,
    3: "Stopped",
    Tweening: 4,
    4: "Tweening"
}), $4df2746f4766bf20$var$le = (typeof FinalizationRegistry === "undefined" ? "undefined" : (0, $5djcY._)(FinalizationRegistry)) > "u" ? {
    register: function() {},
    unregister: function() {}
} : new FinalizationRegistry(function(e) {
    return $4df2746f4766bf20$var$u.__wbg_dotlottieplayerwasm_free(e >>> 0, 1);
});
var $4df2746f4766bf20$var$ue = /*#__PURE__*/ function() {
    "use strict";
    function ue() {
        (0, $4QweW._)(this, ue);
        var e = $4df2746f4766bf20$var$u.dotlottieplayerwasm_new();
        return this.__wbg_ptr = e >>> 0, $4df2746f4766bf20$var$le.register(this, this.__wbg_ptr, this), this;
    }
    (0, $6hK4i._)(ue, [
        {
            key: "__destroy_into_raw",
            value: function __destroy_into_raw() {
                var e = this.__wbg_ptr;
                return this.__wbg_ptr = 0, $4df2746f4766bf20$var$le.unregister(this), e;
            }
        },
        {
            key: "free",
            value: function free() {
                var e = this.__destroy_into_raw();
                $4df2746f4766bf20$var$u.__wbg_dotlottieplayerwasm_free(e, 0);
            }
        },
        {
            key: "clear_slot",
            value: function clear_slot(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_clear_slot(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "layout_fit",
            value: function layout_fit() {
                var e, t;
                try {
                    var i = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_layout_fit(i, this.__wbg_ptr);
                    var n = $4df2746f4766bf20$var$w().getInt32(i + 0, !0), _$r = $4df2746f4766bf20$var$w().getInt32(i + 4, !0);
                    return e = n, t = _$r, $4df2746f4766bf20$var$y(n, _$r);
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t, 1);
                }
            }
        },
        {
            key: "loop_count",
            value: function loop_count() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_loop_count(this.__wbg_ptr) >>> 0;
            }
        },
        {
            key: "poll_event",
            value: function poll_event() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_poll_event(this.__wbg_ptr));
            }
        },
        {
            key: "reset_slot",
            value: function reset_slot(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_reset_slot(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "set_layout",
            value: function set_layout(e, t, n) {
                var _$r = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), i = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_layout(this.__wbg_ptr, _$r, i, t, n) !== 0;
            }
        },
        {
            key: "set_marker",
            value: function set_marker(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_marker(this.__wbg_ptr, t, n);
            }
        },
        {
            key: "clear_slots",
            value: function clear_slots() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_clear_slots(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "is_complete",
            value: function is_complete() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_is_complete(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "reset_slots",
            value: function reset_slots() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_reset_slots(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "reset_theme",
            value: function reset_theme() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_reset_theme(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "segment_end",
            value: function segment_end() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_segment_end(this.__wbg_ptr);
            }
        },
        {
            key: "set_quality",
            value: function set_quality(e) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_quality(this.__wbg_ptr, e) !== 0;
            }
        },
        {
            key: "set_segment",
            value: function set_segment(e, t) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_segment(this.__wbg_ptr, e, t) !== 0;
            }
        },
        {
            key: "sm_set_seed",
            value: function sm_set_seed(e) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_set_seed(this.__wbg_ptr, e) !== 0;
            }
        },
        {
            key: "animation_id",
            value: function animation_id() {
                try {
                    var n = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_animation_id(n, this.__wbg_ptr);
                    var e = $4df2746f4766bf20$var$w().getInt32(n + 0, !0), t = $4df2746f4766bf20$var$w().getInt32(n + 4, !0);
                    var _$r;
                    return e !== 0 && (_$r = $4df2746f4766bf20$var$y(e, t).slice(), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t * 1, 1)), _$r;
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16);
                }
            }
        },
        {
            key: "audio_volume",
            value: function audio_volume() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_audio_volume(this.__wbg_ptr);
            }
        },
        {
            key: "background_a",
            value: function background_a() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_background_a(this.__wbg_ptr);
            }
        },
        {
            key: "background_b",
            value: function background_b() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_background_b(this.__wbg_ptr);
            }
        },
        {
            key: "background_g",
            value: function background_g() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_background_g(this.__wbg_ptr);
            }
        },
        {
            key: "background_r",
            value: function background_r() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_background_r(this.__wbg_ptr);
            }
        },
        {
            key: "clear_marker",
            value: function clear_marker() {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_clear_marker(this.__wbg_ptr);
            }
        },
        {
            key: "emit_on_loop",
            value: function emit_on_loop() {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_emit_on_loop(this.__wbg_ptr);
            }
        },
        {
            key: "get_slot_ids",
            value: function get_slot_ids() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_get_slot_ids(this.__wbg_ptr));
            }
        },
        {
            key: "get_slot_str",
            value: function get_slot_str(e) {
                try {
                    var _$r = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16), i = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_get_slot_str(_$r, this.__wbg_ptr, i, a);
                    var t = $4df2746f4766bf20$var$w().getInt32(_$r + 0, !0), n = $4df2746f4766bf20$var$w().getInt32(_$r + 4, !0);
                    var o;
                    return t !== 0 && (o = $4df2746f4766bf20$var$y(t, n).slice(), $4df2746f4766bf20$var$u.__wbindgen_export_3(t, n * 1, 1)), o;
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16);
                }
            }
        },
        {
            key: "marker_names",
            value: function marker_names() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_marker_names(this.__wbg_ptr));
            }
        },
        {
            key: "set_autoplay",
            value: function set_autoplay(e) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_autoplay(this.__wbg_ptr, e);
            }
        },
        {
            key: "set_slot_str",
            value: function set_slot_str(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b, i = $4df2746f4766bf20$var$S(t, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_slot_str(this.__wbg_ptr, n, _$r, i, a) !== 0;
            }
        },
        {
            key: "set_viewport",
            value: function set_viewport(e, t, n, r) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_viewport(this.__wbg_ptr, e, t, n, r) !== 0;
            }
        },
        {
            key: "total_frames",
            value: function total_frames() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_total_frames(this.__wbg_ptr);
            }
        },
        {
            key: "clear_segment",
            value: function clear_segment() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_clear_segment(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "current_frame",
            value: function current_frame() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_current_frame(this.__wbg_ptr);
            }
        },
        {
            key: "get_slot_type",
            value: function get_slot_type(e) {
                try {
                    var _$r = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16), i = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_get_slot_type(_$r, this.__wbg_ptr, i, a);
                    var t = $4df2746f4766bf20$var$w().getInt32(_$r + 0, !0), n = $4df2746f4766bf20$var$w().getInt32(_$r + 4, !0);
                    var o;
                    return t !== 0 && (o = $4df2746f4766bf20$var$y(t, n).slice(), $4df2746f4766bf20$var$u.__wbindgen_export_3(t, n * 1, 1)), o;
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16);
                }
            }
        },
        {
            key: "get_slots_str",
            value: function get_slots_str() {
                var e, t;
                try {
                    var i = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_get_slots_str(i, this.__wbg_ptr);
                    var n = $4df2746f4766bf20$var$w().getInt32(i + 0, !0), _$r = $4df2746f4766bf20$var$w().getInt32(i + 4, !0);
                    return e = n, t = _$r, $4df2746f4766bf20$var$y(n, _$r);
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t, 1);
                }
            }
        },
        {
            key: "get_transform",
            value: function get_transform() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_get_transform(this.__wbg_ptr));
            }
        },
        {
            key: "segment_start",
            value: function segment_start() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_segment_start(this.__wbg_ptr);
            }
        },
        {
            key: "set_slots_str",
            value: function set_slots_str(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_slots_str(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "set_text_slot",
            value: function set_text_slot(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b, i = $4df2746f4766bf20$var$S(t, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_text_slot(this.__wbg_ptr, n, _$r, i, a) !== 0;
            }
        },
        {
            key: "set_transform",
            value: function set_transform(e) {
                var t = $4df2746f4766bf20$var$oe(e, $4df2746f4766bf20$var$u.__wbindgen_export_1), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_transform(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "sm_get_inputs",
            value: function sm_get_inputs() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_get_inputs(this.__wbg_ptr));
            }
        },
        {
            key: "sm_poll_event",
            value: function sm_poll_event() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_poll_event(this.__wbg_ptr));
            }
        },
        {
            key: "sm_post_click",
            value: function sm_post_click(e, t) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_post_click(this.__wbg_ptr, e, t);
            }
        },
        {
            key: "animation_size",
            value: function animation_size() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_animation_size(this.__wbg_ptr));
            }
        },
        {
            key: "current_marker",
            value: function current_marker() {
                try {
                    var n = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_current_marker(n, this.__wbg_ptr);
                    var e = $4df2746f4766bf20$var$w().getInt32(n + 0, !0), t = $4df2746f4766bf20$var$w().getInt32(n + 4, !0);
                    var _$r;
                    return e !== 0 && (_$r = $4df2746f4766bf20$var$y(e, t).slice(), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t * 1, 1)), _$r;
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16);
                }
            }
        },
        {
            key: "layout_align_x",
            value: function layout_align_x() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_layout_align_x(this.__wbg_ptr);
            }
        },
        {
            key: "layout_align_y",
            value: function layout_align_y() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_layout_align_y(this.__wbg_ptr);
            }
        },
        {
            key: "load_animation",
            value: function load_animation(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_load_animation(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "loop_animation",
            value: function loop_animation() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_loop_animation(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "set_background",
            value: function set_background(e, t, n, r) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_background(this.__wbg_ptr, e, t, n, r) !== 0;
            }
        },
        {
            key: "set_color_slot",
            value: function set_color_slot(e, t, n, r) {
                var i = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_color_slot(this.__wbg_ptr, i, a, t, n, r) !== 0;
            }
        },
        {
            key: "set_image_slot",
            value: function set_image_slot(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b, i = $4df2746f4766bf20$var$S(t, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_image_slot(this.__wbg_ptr, n, _$r, i, a) !== 0;
            }
        },
        {
            key: "set_loop_count",
            value: function set_loop_count(e) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_loop_count(this.__wbg_ptr, e);
            }
        },
        {
            key: "set_theme_data",
            value: function set_theme_data(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_theme_data(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "sm_reset_input",
            value: function sm_reset_input(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_reset_input(this.__wbg_ptr, t, n);
            }
        },
        {
            key: "manifest_string",
            value: function manifest_string() {
                var e, t;
                try {
                    var i = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_manifest_string(i, this.__wbg_ptr);
                    var n = $4df2746f4766bf20$var$w().getInt32(i + 0, !0), _$r = $4df2746f4766bf20$var$w().getInt32(i + 4, !0);
                    return e = n, t = _$r, $4df2746f4766bf20$var$y(n, _$r);
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t, 1);
                }
            }
        },
        {
            key: "set_scalar_slot",
            value: function set_scalar_slot(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_scalar_slot(this.__wbg_ptr, n, _$r, t) !== 0;
            }
        },
        {
            key: "set_vector_slot",
            value: function set_vector_slot(e, t, n) {
                var _$r = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), i = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_vector_slot(this.__wbg_ptr, _$r, i, t, n) !== 0;
            }
        },
        {
            key: "setup_sw_target",
            value: function setup_sw_target(e, t) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_setup_sw_target(this.__wbg_ptr, e, t) !== 0;
            }
        },
        {
            key: "get_pixel_buffer",
            value: function get_pixel_buffer() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_get_pixel_buffer(this.__wbg_ptr));
            }
        },
        {
            key: "set_audio_volume",
            value: function set_audio_volume(e) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_audio_volume(this.__wbg_ptr, e);
            }
        },
        {
            key: "sm_current_state",
            value: function sm_current_state() {
                var e, t;
                try {
                    var i = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_current_state(i, this.__wbg_ptr);
                    var n = $4df2746f4766bf20$var$w().getInt32(i + 0, !0), _$r = $4df2746f4766bf20$var$w().getInt32(i + 4, !0);
                    return e = n, t = _$r, $4df2746f4766bf20$var$y(n, _$r);
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t, 1);
                }
            }
        },
        {
            key: "state_machine_id",
            value: function state_machine_id() {
                try {
                    var n = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_state_machine_id(n, this.__wbg_ptr);
                    var e = $4df2746f4766bf20$var$w().getInt32(n + 0, !0), t = $4df2746f4766bf20$var$w().getInt32(n + 4, !0);
                    var _$r;
                    return e !== 0 && (_$r = $4df2746f4766bf20$var$y(e, t).slice(), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t * 1, 1)), _$r;
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16);
                }
            }
        },
        {
            key: "get_state_machine",
            value: function get_state_machine(e) {
                try {
                    var _$r = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16), i = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_get_state_machine(_$r, this.__wbg_ptr, i, a);
                    var t = $4df2746f4766bf20$var$w().getInt32(_$r + 0, !0), n = $4df2746f4766bf20$var$w().getInt32(_$r + 4, !0);
                    var o;
                    return t !== 0 && (o = $4df2746f4766bf20$var$y(t, n).slice(), $4df2746f4766bf20$var$u.__wbindgen_export_3(t, n * 1, 1)), o;
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16);
                }
            }
        },
        {
            key: "set_position_slot",
            value: function set_position_slot(e, t, n) {
                var _$r = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), i = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_position_slot(this.__wbg_ptr, _$r, i, t, n) !== 0;
            }
        },
        {
            key: "current_loop_count",
            value: function current_loop_count() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_current_loop_count(this.__wbg_ptr) >>> 0;
            }
        },
        {
            key: "set_asset_resolver",
            value: function set_asset_resolver(e) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_asset_resolver(this.__wbg_ptr, $4df2746f4766bf20$var$g(e) ? 0 : $4df2746f4766bf20$var$m(e));
            }
        },
        {
            key: "sm_framework_setup",
            value: function sm_framework_setup() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_framework_setup(this.__wbg_ptr));
            }
        },
        {
            key: "sm_post_pointer_up",
            value: function sm_post_pointer_up(e, t) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_post_pointer_up(this.__wbg_ptr, e, t);
            }
        },
        {
            key: "state_machine_load",
            value: function state_machine_load(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_state_machine_load(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "load_dotlottie_data",
            value: function load_dotlottie_data(e) {
                var t = $4df2746f4766bf20$var$T(e, $4df2746f4766bf20$var$u.__wbindgen_export_1), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_load_dotlottie_data(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "sm_get_string_input",
            value: function sm_get_string_input(e) {
                try {
                    var _$r = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16), i = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_get_string_input(_$r, this.__wbg_ptr, i, a);
                    var t = $4df2746f4766bf20$var$w().getInt32(_$r + 0, !0), n = $4df2746f4766bf20$var$w().getInt32(_$r + 4, !0);
                    var o;
                    return t !== 0 && (o = $4df2746f4766bf20$var$y(t, n).slice(), $4df2746f4766bf20$var$u.__wbindgen_export_3(t, n * 1, 1)), o;
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16);
                }
            }
        },
        {
            key: "sm_set_string_input",
            value: function sm_set_string_input(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b, i = $4df2746f4766bf20$var$S(t, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_set_string_input(this.__wbg_ptr, n, _$r, i, a) !== 0;
            }
        },
        {
            key: "sm_get_boolean_input",
            value: function sm_get_boolean_input(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b, _$r = $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_get_boolean_input(this.__wbg_ptr, t, n);
                return _$r === 16777215 ? void 0 : _$r !== 0;
            }
        },
        {
            key: "sm_get_numeric_input",
            value: function sm_get_numeric_input(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b, _$r = $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_get_numeric_input(this.__wbg_ptr, t, n);
                return _$r === 4294967297 ? void 0 : _$r;
            }
        },
        {
            key: "sm_post_pointer_down",
            value: function sm_post_pointer_down(e, t) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_post_pointer_down(this.__wbg_ptr, e, t);
            }
        },
        {
            key: "sm_post_pointer_exit",
            value: function sm_post_pointer_exit(e, t) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_post_pointer_exit(this.__wbg_ptr, e, t);
            }
        },
        {
            key: "sm_post_pointer_move",
            value: function sm_post_pointer_move(e, t) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_post_pointer_move(this.__wbg_ptr, e, t);
            }
        },
        {
            key: "sm_set_boolean_input",
            value: function sm_set_boolean_input(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_set_boolean_input(this.__wbg_ptr, n, _$r, t) !== 0;
            }
        },
        {
            key: "sm_set_numeric_input",
            value: function sm_set_numeric_input(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_set_numeric_input(this.__wbg_ptr, n, _$r, t) !== 0;
            }
        },
        {
            key: "state_machine_unload",
            value: function state_machine_unload() {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_state_machine_unload(this.__wbg_ptr);
            }
        },
        {
            key: "sm_post_pointer_enter",
            value: function sm_post_pointer_enter(e, t) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_post_pointer_enter(this.__wbg_ptr, e, t);
            }
        },
        {
            key: "load_animation_from_id",
            value: function load_animation_from_id(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_load_animation_from_id(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "sm_poll_internal_event",
            value: function sm_poll_internal_event() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_poll_internal_event(this.__wbg_ptr));
            }
        },
        {
            key: "use_frame_interpolation",
            value: function use_frame_interpolation() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_use_frame_interpolation(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "reset_current_loop_count",
            value: function reset_current_loop_count() {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_reset_current_loop_count(this.__wbg_ptr);
            }
        },
        {
            key: "sm_override_current_state",
            value: function sm_override_current_state(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_override_current_state(this.__wbg_ptr, n, _$r, t) !== 0;
            }
        },
        {
            key: "state_machine_load_from_id",
            value: function state_machine_load_from_id(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_state_machine_load_from_id(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "set_use_frame_interpolation",
            value: function set_use_frame_interpolation(e) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_use_frame_interpolation(this.__wbg_ptr, e);
            }
        },
        {
            key: "mode",
            value: function mode() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_mode(this.__wbg_ptr);
            }
        },
        {
            key: "play",
            value: function play() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_play(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "stop",
            value: function stop() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_stop(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "tick",
            value: function tick(e) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_tick(this.__wbg_ptr, e) !== 0;
            }
        },
        {
            key: "pause",
            value: function pause() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_pause(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "speed",
            value: function speed() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_speed(this.__wbg_ptr);
            }
        },
        {
            key: "width",
            value: function width() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_width(this.__wbg_ptr) >>> 0;
            }
        },
        {
            key: "height",
            value: function height() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_height(this.__wbg_ptr) >>> 0;
            }
        },
        {
            key: "render",
            value: function render() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_render(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "status",
            value: function status() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_status(this.__wbg_ptr);
            }
        },
        {
            key: "markers",
            value: function markers() {
                return $4df2746f4766bf20$var$E($4df2746f4766bf20$var$u.dotlottieplayerwasm_markers(this.__wbg_ptr));
            }
        },
        {
            key: "sm_fire",
            value: function sm_fire(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_fire(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "sm_stop",
            value: function sm_stop() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_stop(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "sm_tick",
            value: function sm_tick(e) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_tick(this.__wbg_ptr, e) !== 0;
            }
        },
        {
            key: "autoplay",
            value: function autoplay() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_autoplay(this.__wbg_ptr) !== 0;
            }
        },
        {
            key: "duration",
            value: function duration() {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_duration(this.__wbg_ptr);
            }
        },
        {
            key: "set_loop",
            value: function set_loop(e) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_loop(this.__wbg_ptr, e);
            }
        },
        {
            key: "set_mode",
            value: function set_mode(e) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_mode(this.__wbg_ptr, e);
            }
        },
        {
            key: "sm_start",
            value: function sm_start(e, t) {
                var n = $4df2746f4766bf20$var$se(t, $4df2746f4766bf20$var$u.__wbindgen_export_1), _$r = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_start(this.__wbg_ptr, e, n, _$r) !== 0;
            }
        },
        {
            key: "theme_id",
            value: function theme_id() {
                try {
                    var n = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_theme_id(n, this.__wbg_ptr);
                    var e = $4df2746f4766bf20$var$w().getInt32(n + 0, !0), t = $4df2746f4766bf20$var$w().getInt32(n + 4, !0);
                    var _$r;
                    return e !== 0 && (_$r = $4df2746f4766bf20$var$y(e, t).slice(), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t * 1, 1)), _$r;
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16);
                }
            }
        },
        {
            key: "load_font",
            value: function load_font(e, t) {
                var n = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b, i = $4df2746f4766bf20$var$T(t, $4df2746f4766bf20$var$u.__wbindgen_export_1), a = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_load_font(this.__wbg_ptr, n, _$r, i, a) !== 0;
            }
        },
        {
            key: "set_frame",
            value: function set_frame(e) {
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_frame(this.__wbg_ptr, e) !== 0;
            }
        },
        {
            key: "set_speed",
            value: function set_speed(e) {
                $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_speed(this.__wbg_ptr, e);
            }
        },
        {
            key: "set_theme",
            value: function set_theme(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_set_theme(this.__wbg_ptr, t, n) !== 0;
            }
        },
        {
            key: "sm_status",
            value: function sm_status() {
                var e, t;
                try {
                    var i = $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(-16);
                    $4df2746f4766bf20$var$u.dotlottieplayerwasm_sm_status(i, this.__wbg_ptr);
                    var n = $4df2746f4766bf20$var$w().getInt32(i + 0, !0), _$r = $4df2746f4766bf20$var$w().getInt32(i + 4, !0);
                    return e = n, t = _$r, $4df2746f4766bf20$var$y(n, _$r);
                } finally{
                    $4df2746f4766bf20$var$u.__wbindgen_add_to_stack_pointer(16), $4df2746f4766bf20$var$u.__wbindgen_export_3(e, t, 1);
                }
            }
        }
    ], [
        {
            key: "unload_font",
            value: function unload_font(e) {
                var t = $4df2746f4766bf20$var$S(e, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), n = $4df2746f4766bf20$var$b;
                return $4df2746f4766bf20$var$u.dotlottieplayerwasm_unload_font(t, n) !== 0;
            }
        }
    ]);
    return ue;
}();
function $4df2746f4766bf20$var$de(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var t1, n, n1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof Response == "function" && e instanceof Response)) return [
                        3,
                        7
                    ];
                    if (!(typeof WebAssembly.instantiateStreaming == "function")) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        WebAssembly.instantiateStreaming(e, t)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    t1 = _state.sent();
                    if (e.headers.get("Content-Type") != "application/wasm") console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", t1);
                    else throw t1;
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        4,
                        e.arrayBuffer()
                    ];
                case 5:
                    n = _state.sent();
                    return [
                        4,
                        WebAssembly.instantiate(n, t)
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    return [
                        4,
                        WebAssembly.instantiate(e, t)
                    ];
                case 8:
                    n1 = _state.sent();
                    return [
                        2,
                        n1 instanceof WebAssembly.Instance ? {
                            instance: n1,
                            module: e
                        } : n1
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $4df2746f4766bf20$var$fe() {
    var e = {};
    return e.wbg = {}, e.wbg.__wbg_appendChild_8204974b7328bf98 = function() {
        return $4df2746f4766bf20$var$h(function(e, t) {
            return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$f(e).appendChild($4df2746f4766bf20$var$f(t)));
        }, arguments);
    }, e.wbg.__wbg_body_942ea927546a04ba = function(e) {
        var t = $4df2746f4766bf20$var$f(e).body;
        return $4df2746f4766bf20$var$g(t) ? 0 : $4df2746f4766bf20$var$m(t);
    }, e.wbg.__wbg_buffer_609cc3eee51ed158 = function(e) {
        var t = $4df2746f4766bf20$var$f(e).buffer;
        return $4df2746f4766bf20$var$m(t);
    }, e.wbg.__wbg_call_672a4d21634d4a24 = function() {
        return $4df2746f4766bf20$var$h(function(e, t) {
            return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$f(e).call($4df2746f4766bf20$var$f(t)));
        }, arguments);
    }, e.wbg.__wbg_call_7cccdd69e0791ae2 = function() {
        return $4df2746f4766bf20$var$h(function(e, t, n) {
            return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$f(e).call($4df2746f4766bf20$var$f(t), $4df2746f4766bf20$var$f(n)));
        }, arguments);
    }, e.wbg.__wbg_catch_a6e601879b2610e9 = function(e, t) {
        return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$f(e).catch($4df2746f4766bf20$var$f(t)));
    }, e.wbg.__wbg_createElement_8c9931a732ee2fea = function() {
        return $4df2746f4766bf20$var$h(function(e, t, n) {
            return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$f(e).createElement($4df2746f4766bf20$var$y(t, n)));
        }, arguments);
    }, e.wbg.__wbg_createObjectURL_6e98d2f9c7bd9764 = function() {
        return $4df2746f4766bf20$var$h(function(e, t) {
            var n = $4df2746f4766bf20$var$S(URL.createObjectURL($4df2746f4766bf20$var$f(t)), $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), _$r = $4df2746f4766bf20$var$b;
            $4df2746f4766bf20$var$w().setInt32(e + 4, _$r, !0), $4df2746f4766bf20$var$w().setInt32(e + 0, n, !0);
        }, arguments);
    }, e.wbg.__wbg_currentTime_7940fe39798a1ca0 = function(e) {
        return $4df2746f4766bf20$var$f(e).currentTime;
    }, e.wbg.__wbg_data_d1ed736c1e42b10e = function(e, t) {
        var n = $4df2746f4766bf20$var$f(t).data, _$r = $4df2746f4766bf20$var$T(n, $4df2746f4766bf20$var$u.__wbindgen_export_1), i = $4df2746f4766bf20$var$b;
        $4df2746f4766bf20$var$w().setInt32(e + 4, i, !0), $4df2746f4766bf20$var$w().setInt32(e + 0, _$r, !0);
    }, e.wbg.__wbg_document_d249400bd7bd996d = function(e) {
        var t = $4df2746f4766bf20$var$f(e).document;
        return $4df2746f4766bf20$var$g(t) ? 0 : $4df2746f4766bf20$var$m(t);
    }, e.wbg.__wbg_drawImage_803dcc46897223c9 = function() {
        return $4df2746f4766bf20$var$h(function(e, t, n, r) {
            $4df2746f4766bf20$var$f(e).drawImage($4df2746f4766bf20$var$f(t), n, r);
        }, arguments);
    }, e.wbg.__wbg_duration_4d32c501d87796c1 = function(e) {
        return $4df2746f4766bf20$var$f(e).duration;
    }, e.wbg.__wbg_error_7534b8e9a36f1ab4 = function(e, t) {
        var n, _$r;
        try {
            n = e, _$r = t, console.error($4df2746f4766bf20$var$y(e, t));
        } finally{
            $4df2746f4766bf20$var$u.__wbindgen_export_3(n, _$r, 1);
        }
    }, e.wbg.__wbg_getContext_e9cf379449413580 = function() {
        return $4df2746f4766bf20$var$h(function(e, t, n) {
            var _$r = $4df2746f4766bf20$var$f(e).getContext($4df2746f4766bf20$var$y(t, n));
            return $4df2746f4766bf20$var$g(_$r) ? 0 : $4df2746f4766bf20$var$m(_$r);
        }, arguments);
    }, e.wbg.__wbg_getImageData_c02374a30b126dab = function() {
        return $4df2746f4766bf20$var$h(function(e, t, n, r, i) {
            return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$f(e).getImageData(t, n, r, i));
        }, arguments);
    }, e.wbg.__wbg_instanceof_CanvasRenderingContext2d_df82a4d3437bf1cc = function(e) {
        var t;
        try {
            t = $4df2746f4766bf20$var$f(e) instanceof CanvasRenderingContext2D;
        } catch (e) {
            t = !1;
        }
        return t;
    }, e.wbg.__wbg_instanceof_HtmlCanvasElement_2ea67072a7624ac5 = function(e) {
        var t;
        try {
            t = $4df2746f4766bf20$var$f(e) instanceof HTMLCanvasElement;
        } catch (e) {
            t = !1;
        }
        return t;
    }, e.wbg.__wbg_instanceof_HtmlVideoElement_7f414b32f362e317 = function(e) {
        var t;
        try {
            t = $4df2746f4766bf20$var$f(e) instanceof HTMLVideoElement;
        } catch (e) {
            t = !1;
        }
        return t;
    }, e.wbg.__wbg_instanceof_Window_def73ea0955fc569 = function(e) {
        var t;
        try {
            t = $4df2746f4766bf20$var$f(e) instanceof Window;
        } catch (e) {
            t = !1;
        }
        return t;
    }, e.wbg.__wbg_length_a446193dc22c12f8 = function(e) {
        return $4df2746f4766bf20$var$f(e).length;
    }, e.wbg.__wbg_load_2671477a3293aadb = function(e) {
        $4df2746f4766bf20$var$f(e).load();
    }, e.wbg.__wbg_new_405e22f390576ce2 = function() {
        return $4df2746f4766bf20$var$m({});
    }, e.wbg.__wbg_new_78feb108b6472713 = function() {
        return $4df2746f4766bf20$var$m([]);
    }, e.wbg.__wbg_new_8a6f238a6ece86ea = function() {
        return $4df2746f4766bf20$var$m(Error());
    }, e.wbg.__wbg_new_a12002a7f91c75be = function(e) {
        return $4df2746f4766bf20$var$m(new Uint8Array($4df2746f4766bf20$var$f(e)));
    }, e.wbg.__wbg_newnoargs_105ed471475aaf50 = function(e, t) {
        return $4df2746f4766bf20$var$m(Function($4df2746f4766bf20$var$y(e, t)));
    }, e.wbg.__wbg_newwithbyteoffsetandlength_d97e637ebe145a9a = function(e, t, n) {
        return $4df2746f4766bf20$var$m(new Uint8Array($4df2746f4766bf20$var$f(e), t >>> 0, n >>> 0));
    }, e.wbg.__wbg_newwithlength_5a5efe313cfd59f1 = function(e) {
        return $4df2746f4766bf20$var$m(new Float32Array(e >>> 0));
    }, e.wbg.__wbg_newwithsrc_20307ca7e8762a81 = function() {
        return $4df2746f4766bf20$var$h(function(e, t) {
            return $4df2746f4766bf20$var$m(new Audio($4df2746f4766bf20$var$y(e, t)));
        }, arguments);
    }, e.wbg.__wbg_newwithu8arraysequenceandoptions_068570c487f69127 = function() {
        return $4df2746f4766bf20$var$h(function(e, t) {
            return $4df2746f4766bf20$var$m(new Blob($4df2746f4766bf20$var$f(e), $4df2746f4766bf20$var$f(t)));
        }, arguments);
    }, e.wbg.__wbg_pause_b74c96d69f769518 = function() {
        return $4df2746f4766bf20$var$h(function(e) {
            $4df2746f4766bf20$var$f(e).pause();
        }, arguments);
    }, e.wbg.__wbg_paused_9b2affc0a8a62e86 = function(e) {
        return $4df2746f4766bf20$var$f(e).paused;
    }, e.wbg.__wbg_play_f6ec5fc4e84b0d26 = function() {
        return $4df2746f4766bf20$var$h(function(e) {
            return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$f(e).play());
        }, arguments);
    }, e.wbg.__wbg_push_737cfc8c1432c2c6 = function(e, t) {
        return $4df2746f4766bf20$var$f(e).push($4df2746f4766bf20$var$f(t));
    }, e.wbg.__wbg_readyState_017c08aa5e73517e = function(e) {
        return $4df2746f4766bf20$var$f(e).readyState;
    }, e.wbg.__wbg_remove_e2d2659f3128c045 = function(e) {
        $4df2746f4766bf20$var$f(e).remove();
    }, e.wbg.__wbg_revokeObjectURL_27267efebeb457c7 = function() {
        return $4df2746f4766bf20$var$h(function(e, t) {
            URL.revokeObjectURL($4df2746f4766bf20$var$y(e, t));
        }, arguments);
    }, e.wbg.__wbg_seeking_c0427be38e698dcd = function(e) {
        return $4df2746f4766bf20$var$f(e).seeking;
    }, e.wbg.__wbg_setAttribute_2704501201f15687 = function() {
        return $4df2746f4766bf20$var$h(function(e, t, n, r, i) {
            $4df2746f4766bf20$var$f(e).setAttribute($4df2746f4766bf20$var$y(t, n), $4df2746f4766bf20$var$y(r, i));
        }, arguments);
    }, e.wbg.__wbg_set_65595bdd868b3009 = function(e, t, n) {
        $4df2746f4766bf20$var$f(e).set($4df2746f4766bf20$var$f(t), n >>> 0);
    }, e.wbg.__wbg_set_bb8cecf6a62b9f46 = function() {
        return $4df2746f4766bf20$var$h(function(e, t, n) {
            return Reflect.set($4df2746f4766bf20$var$f(e), $4df2746f4766bf20$var$f(t), $4df2746f4766bf20$var$f(n));
        }, arguments);
    }, e.wbg.__wbg_setcssText_e018c236104b0233 = function(e, t, n) {
        $4df2746f4766bf20$var$f(e).cssText = $4df2746f4766bf20$var$y(t, n);
    }, e.wbg.__wbg_setcurrentTime_64727eddd3966512 = function(e, t) {
        $4df2746f4766bf20$var$f(e).currentTime = t;
    }, e.wbg.__wbg_setheight_da683a33fa99843c = function(e, t) {
        $4df2746f4766bf20$var$f(e).height = t >>> 0;
    }, e.wbg.__wbg_setindex_4e73afdcd9bb95cd = function(e, t, n) {
        $4df2746f4766bf20$var$f(e)[t >>> 0] = n;
    }, e.wbg.__wbg_setmuted_e93fc48340c43e67 = function(e, t) {
        $4df2746f4766bf20$var$f(e).muted = t !== 0;
    }, e.wbg.__wbg_setplaybackRate_f5c3b8896f82425e = function(e, t) {
        $4df2746f4766bf20$var$f(e).playbackRate = t;
    }, e.wbg.__wbg_setpreload_d2fb02758e3f8e3a = function(e, t, n) {
        $4df2746f4766bf20$var$f(e).preload = $4df2746f4766bf20$var$y(t, n);
    }, e.wbg.__wbg_setsrc_3a759736e2659904 = function(e, t, n) {
        $4df2746f4766bf20$var$f(e).src = $4df2746f4766bf20$var$y(t, n);
    }, e.wbg.__wbg_settype_39ed370d3edd403c = function(e, t, n) {
        $4df2746f4766bf20$var$f(e).type = $4df2746f4766bf20$var$y(t, n);
    }, e.wbg.__wbg_setvolume_3895e06a030ca4f7 = function(e, t) {
        $4df2746f4766bf20$var$f(e).volume = t;
    }, e.wbg.__wbg_setwidth_c5fed9f5e7f0b406 = function(e, t) {
        $4df2746f4766bf20$var$f(e).width = t >>> 0;
    }, e.wbg.__wbg_stack_0ed75d68575b0f3c = function(e, t) {
        var n = $4df2746f4766bf20$var$f(t).stack, _$r = $4df2746f4766bf20$var$S(n, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), i = $4df2746f4766bf20$var$b;
        $4df2746f4766bf20$var$w().setInt32(e + 4, i, !0), $4df2746f4766bf20$var$w().setInt32(e + 0, _$r, !0);
    }, e.wbg.__wbg_static_accessor_GLOBAL_88a902d13a557d07 = function() {
        var e = (typeof $parcel$global === "undefined" ? "undefined" : (0, $5djcY._)($parcel$global)) > "u" ? null : $parcel$global;
        return $4df2746f4766bf20$var$g(e) ? 0 : $4df2746f4766bf20$var$m(e);
    }, e.wbg.__wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0 = function() {
        var e = (typeof globalThis === "undefined" ? "undefined" : (0, $5djcY._)(globalThis)) > "u" ? null : globalThis;
        return $4df2746f4766bf20$var$g(e) ? 0 : $4df2746f4766bf20$var$m(e);
    }, e.wbg.__wbg_static_accessor_SELF_37c5d418e4bf5819 = function() {
        var e = (typeof self === "undefined" ? "undefined" : (0, $5djcY._)(self)) > "u" ? null : self;
        return $4df2746f4766bf20$var$g(e) ? 0 : $4df2746f4766bf20$var$m(e);
    }, e.wbg.__wbg_static_accessor_WINDOW_5de37043a91a9c40 = function() {
        var e = (typeof window === "undefined" ? "undefined" : (0, $5djcY._)(window)) > "u" ? null : window;
        return $4df2746f4766bf20$var$g(e) ? 0 : $4df2746f4766bf20$var$m(e);
    }, e.wbg.__wbg_style_fb30c14e5815805c = function(e) {
        var t = $4df2746f4766bf20$var$f(e).style;
        return $4df2746f4766bf20$var$m(t);
    }, e.wbg.__wbg_videoHeight_3a43327a766c1f03 = function(e) {
        return $4df2746f4766bf20$var$f(e).videoHeight;
    }, e.wbg.__wbg_videoWidth_4b400cf6f4744a4d = function(e) {
        return $4df2746f4766bf20$var$f(e).videoWidth;
    }, e.wbg.__wbindgen_cb_drop = function(e) {
        var t = $4df2746f4766bf20$var$E(e).original;
        return t.cnt-- == 1 ? (t.a = 0, !0) : !1;
    }, e.wbg.__wbindgen_closure_wrapper109 = function(e, t, n) {
        return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$re(e, t, 7, $4df2746f4766bf20$var$ce));
    }, e.wbg.__wbindgen_is_null = function(e) {
        return $4df2746f4766bf20$var$f(e) === null;
    }, e.wbg.__wbindgen_is_undefined = function(e) {
        return $4df2746f4766bf20$var$f(e) === void 0;
    }, e.wbg.__wbindgen_memory = function() {
        var e = $4df2746f4766bf20$var$u.memory;
        return $4df2746f4766bf20$var$m(e);
    }, e.wbg.__wbindgen_number_new = function(e) {
        return $4df2746f4766bf20$var$m(e);
    }, e.wbg.__wbindgen_object_clone_ref = function(e) {
        return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$f(e));
    }, e.wbg.__wbindgen_object_drop_ref = function(e) {
        $4df2746f4766bf20$var$E(e);
    }, e.wbg.__wbindgen_string_get = function(e, t) {
        var n = $4df2746f4766bf20$var$f(t), _$r = typeof n == "string" ? n : void 0;
        var i = $4df2746f4766bf20$var$g(_$r) ? 0 : $4df2746f4766bf20$var$S(_$r, $4df2746f4766bf20$var$u.__wbindgen_export_1, $4df2746f4766bf20$var$u.__wbindgen_export_2), a = $4df2746f4766bf20$var$b;
        $4df2746f4766bf20$var$w().setInt32(e + 4, a, !0), $4df2746f4766bf20$var$w().setInt32(e + 0, i, !0);
    }, e.wbg.__wbindgen_string_new = function(e, t) {
        return $4df2746f4766bf20$var$m($4df2746f4766bf20$var$y(e, t));
    }, e.wbg.__wbindgen_throw = function(e, t) {
        throw Error($4df2746f4766bf20$var$y(e, t));
    }, e;
}
function $4df2746f4766bf20$var$pe(e, t) {
    return $4df2746f4766bf20$var$u = e.exports, $4df2746f4766bf20$var$me.__wbindgen_wasm_module = t, $4df2746f4766bf20$var$C = null, $4df2746f4766bf20$var$O = null, $4df2746f4766bf20$var$_ = null, $4df2746f4766bf20$var$u;
}
function $4df2746f4766bf20$var$me(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var ref, t, _ref, n, _$r;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($4df2746f4766bf20$var$u !== void 0) return [
                        2,
                        $4df2746f4766bf20$var$u
                    ];
                    if (e !== void 0 && (Object.getPrototypeOf(e) === Object.prototype ? (ref = e, e = ref.module_or_path, ref) : console.warn("using deprecated parameters for the initialization function; pass a single object instead")), e === void 0) throw Error("WASM module URL must be provided via DotLottieWasmLoader or setWasmUrl().");
                    t = $4df2746f4766bf20$var$fe();
                    (typeof e == "string" || typeof Request == "function" && e instanceof Request || typeof URL == "function" && e instanceof URL) && (e = fetch(e));
                    return [
                        4,
                        e
                    ];
                case 1:
                    return [
                        4,
                        $4df2746f4766bf20$var$de.apply(void 0, [
                            _state.sent(),
                            t
                        ])
                    ];
                case 2:
                    _ref = _state.sent(), n = _ref.instance, _$r = _ref.module;
                    return [
                        2,
                        $4df2746f4766bf20$var$pe(n, _$r)
                    ];
            }
        });
    })();
}
var $4df2746f4766bf20$var$j = /*#__PURE__*/ function() {
    "use strict";
    function j() {
        (0, $4QweW._)(this, j);
        $4df2746f4766bf20$var$r(this, "_eventListeners", new Map);
    }
    (0, $6hK4i._)(j, [
        {
            key: "addEventListener",
            value: function addEventListener(e, t) {
                var n = this._eventListeners.get(e);
                n || (n = new Set, this._eventListeners.set(e, n)), n.add(t);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(e, t) {
                var n = this._eventListeners.get(e);
                n && (t ? (n.delete(t), n.size === 0 && this._eventListeners.delete(e)) : this._eventListeners.delete(e));
            }
        },
        {
            key: "dispatch",
            value: function dispatch(e) {
                var _this__eventListeners_get;
                (_this__eventListeners_get = this._eventListeners.get(e.type)) === null || _this__eventListeners_get === void 0 ? void 0 : _this__eventListeners_get.forEach(function(t) {
                    return t(e);
                });
            }
        },
        {
            key: "removeAllEventListeners",
            value: function removeAllEventListeners() {
                this._eventListeners.clear();
            }
        }
    ]);
    return j;
}(), $4df2746f4766bf20$var$M = /*#__PURE__*/ function() {
    "use strict";
    function e() {
        (0, $4QweW._)(this, e);
    }
    (0, $6hK4i._)(e, null, [
        {
            key: "_initializeObserver",
            value: function _initializeObserver() {
                e._observer || (e._observer = new IntersectionObserver(function(t) {
                    t.forEach(function(t) {
                        var n = e._observedCanvases.get(t.target);
                        n && (t.isIntersecting ? n.unfreeze() : n.freeze());
                    });
                }, {
                    threshold: 0
                }));
            }
        },
        {
            key: "observe",
            value: function observe(t, n) {
                var _e__observer;
                e._initializeObserver(), !e._observedCanvases.has(t) && (e._observedCanvases.set(t, n), (_e__observer = e._observer) === null || _e__observer === void 0 ? void 0 : _e__observer.observe(t));
            }
        },
        {
            key: "unobserve",
            value: function unobserve(t) {
                var _e__observer, _e__observer1;
                (_e__observer = e._observer) === null || _e__observer === void 0 ? void 0 : _e__observer.unobserve(t), e._observedCanvases.delete(t), e._observedCanvases.size === 0 && ((_e__observer1 = e._observer) === null || _e__observer1 === void 0 ? void 0 : _e__observer1.disconnect(), e._observer = null);
            }
        }
    ]);
    return e;
}();
$4df2746f4766bf20$var$r($4df2746f4766bf20$var$M, "_observer", null), $4df2746f4766bf20$var$r($4df2746f4766bf20$var$M, "_observedCanvases", new Map);
var $4df2746f4766bf20$var$N = /*#__PURE__*/ function() {
    "use strict";
    function e() {
        (0, $4QweW._)(this, e);
    }
    (0, $6hK4i._)(e, null, [
        {
            key: "_initializeObserver",
            value: function _initializeObserver() {
                e._observer || (e._observer = new ResizeObserver(function(t) {
                    t.forEach(function(t) {
                        var n = e._observedCanvases.get(t.target);
                        if (!n) return;
                        var _n = (0, $6ZpBv._)(n, 2), _$r = _n[0], i = _n[1];
                        clearTimeout(i);
                        var a = setTimeout(function() {
                            _$r.resize();
                        }, 100);
                        e._observedCanvases.set(t.target, [
                            _$r,
                            a
                        ]);
                    });
                }));
            }
        },
        {
            key: "observe",
            value: function observe(t, n) {
                var _e__observer;
                e._initializeObserver(), !e._observedCanvases.has(t) && (e._observedCanvases.set(t, [
                    n,
                    0
                ]), (_e__observer = e._observer) === null || _e__observer === void 0 ? void 0 : _e__observer.observe(t));
            }
        },
        {
            key: "unobserve",
            value: function unobserve(t) {
                var _e__observer;
                var n = e._observedCanvases.get(t);
                if (n) {
                    var _$e = n[1];
                    _$e && clearTimeout(_$e);
                }
                (_e__observer = e._observer) === null || _e__observer === void 0 ? void 0 : _e__observer.unobserve(t), e._observedCanvases.delete(t), !e._observedCanvases.size && e._observer && (e._observer.disconnect(), e._observer = null);
            }
        }
    ]);
    return e;
}();
$4df2746f4766bf20$var$r($4df2746f4766bf20$var$N, "_observer", null), $4df2746f4766bf20$var$r($4df2746f4766bf20$var$N, "_observedCanvases", new Map);
function $4df2746f4766bf20$var$he(e) {
    return RegExp("^#([\\da-f]{6}|[\\da-f]{8})$", "iu").test(e);
}
function $4df2746f4766bf20$var$ge(e) {
    if (!$4df2746f4766bf20$var$he(e)) return [
        0,
        0,
        0,
        0
    ];
    var t = e.replace("#", "");
    return t = t.length === 6 ? "".concat(t, "ff") : t, [
        parseInt(t.slice(0, 2), 16) / 255,
        parseInt(t.slice(2, 4), 16) / 255,
        parseInt(t.slice(4, 6), 16) / 255,
        parseInt(t.slice(6, 8), 16) / 255
    ];
}
function $4df2746f4766bf20$var$P(e) {
    if (e.byteLength < 4) return !1;
    var t = new Uint8Array(e.slice(0, $4df2746f4766bf20$var$c.byteLength));
    for(var _$e = 0; _$e < $4df2746f4766bf20$var$c.length; _$e += 1)if ($4df2746f4766bf20$var$c[_$e] !== t[_$e]) return !1;
    return !0;
}
function $4df2746f4766bf20$var$_e(e) {
    return $4df2746f4766bf20$var$l.every(function(t) {
        return Object.hasOwn(e, t);
    });
}
function $4df2746f4766bf20$var$F(e) {
    return typeof e == "string" ? RegExp("^\\s*\\{", "u").test(e) && RegExp("\\}\\s*$", "u").test(e) : $4df2746f4766bf20$var$_e(e);
}
function $4df2746f4766bf20$var$I() {
    return 1 + (($4df2746f4766bf20$var$s ? window.devicePixelRatio : 1) - 1) * .75;
}
function $4df2746f4766bf20$var$L(e) {
    var t = e.getBoundingClientRect(), n = window.innerHeight || document.documentElement.clientHeight, _$r = window.innerWidth || document.documentElement.clientWidth;
    return !(t.bottom < 0 || t.top > n || t.right < 0 || t.left > _$r);
}
function $4df2746f4766bf20$var$R(e) {
    var t = e.target;
    if (t instanceof HTMLCanvasElement) {
        var n = t.getBoundingClientRect();
        if (n.width === 0 || n.height === 0 || t.width === 0 || t.height === 0) return null;
        var _$r = t.width / n.width, i = t.height / n.height, a = (e.clientX - n.left) * _$r, o = (e.clientY - n.top) * i;
        return !Number.isFinite(a) || !Number.isFinite(o) || Number.isNaN(a) || Number.isNaN(o) ? null : {
            x: a,
            y: o
        };
    }
    return null;
}
function $4df2746f4766bf20$var$ve(e) {
    return new Promise(function(t, n) {
        var _$r = new FileReader;
        _$r.onerror = function() {
            var _r_error;
            return n((_r_error = _$r.error) !== null && _r_error !== void 0 ? _r_error : Error("Failed to read image slot source"));
        }, _$r.onload = function() {
            return t(_$r.result);
        }, _$r.readAsDataURL(e);
    });
}
function $4df2746f4766bf20$var$z(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var t;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!/^https?:\/\//i.test(e)) return [
                        2,
                        e
                    ];
                    return [
                        4,
                        fetch(e)
                    ];
                case 1:
                    t = _state.sent();
                    if (!t.ok) throw Error("Failed to fetch image slot source from URL: ".concat(e, ". ").concat(t.status, ": ").concat(t.statusText));
                    return [
                        4,
                        t.blob()
                    ];
                case 2:
                    return [
                        2,
                        $4df2746f4766bf20$var$ve.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    })();
}
function $4df2746f4766bf20$var$B(e) {
    var t = e.replace("OpenUrl: ", ""), n = t.indexOf(" | Target: "), _$r, i;
    n === -1 ? (_$r = t, i = "_blank") : (_$r = t.substring(0, n), i = t.substring(n + 11)), window.open(_$r, i);
}
function $4df2746f4766bf20$var$ye(e, t, n) {
    var _$r = null, i = t, a = n;
    function o(t) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            e({
                                module_or_path: t
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function s(t) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _$n, _tmp;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(t)
                        ];
                    case 1:
                        _$n = _state.sent();
                        if (!_$n.ok) throw Error("fetch ".concat(t, " responded with ").concat(_$n.status, " ").concat(_$n.statusText));
                        _tmp = {};
                        return [
                            4,
                            _$n.arrayBuffer()
                        ];
                    case 2:
                        return [
                            4,
                            e.apply(void 0, [
                                (_tmp.module_or_path = _state.sent(), _tmp)
                            ])
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function c(e, t) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var e1;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            e(t)
                        ];
                    case 1:
                        return [
                            2,
                            (_state.sent(), null)
                        ];
                    case 2:
                        e1 = _state.sent();
                        return [
                            2,
                            e1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return {
        load: function() {
            if (!_$r) {
                var e = i, _$t = null;
                _$t = function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        var _$n, i, l, _tmp, _tmp1;
                        return (0, $gh3Df._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        c(o, e)
                                    ];
                                case 1:
                                    _$n = _state.sent();
                                    if (!_$n) return [
                                        2
                                    ];
                                    console.warn("Primary WASM load failed from ".concat(e, ": ").concat(_$n.message));
                                    i = null;
                                    if (!(a !== null)) return [
                                        3,
                                        3
                                    ];
                                    console.warn("Attempting to load WASM from backup URL: ".concat(a));
                                    return [
                                        4,
                                        c(o, a)
                                    ];
                                case 2:
                                    if (i = _state.sent(), !i) return [
                                        2
                                    ];
                                    console.warn("Backup WASM load failed from ".concat(a, ": ").concat(i.message));
                                    _state.label = 3;
                                case 3:
                                    console.warn("Retrying WASM load with buffered instantiation");
                                    return [
                                        4,
                                        c(s, e)
                                    ];
                                case 4:
                                    l = _state.sent();
                                    _tmp = l;
                                    if (!_tmp) return [
                                        3,
                                        7
                                    ];
                                    console.warn("Buffered WASM load from ".concat(e, " failed: ").concat(l.message));
                                    _tmp1 = a !== null;
                                    if (!_tmp1) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        c(s, a)
                                    ];
                                case 5:
                                    _tmp1 = (l = _state.sent(), !l);
                                    _state.label = 6;
                                case 6:
                                    _tmp = !_tmp1;
                                    _state.label = 7;
                                case 7:
                                    if (_tmp) throw console.error("Primary WASM URL failed: ".concat(_$n.message)), i && console.error("Backup WASM URL failed: ".concat(i.message)), console.error("Buffered fallback failed: ".concat(l.message)), _$r === _$t && (_$r = null), Error("WASM loading failed from all sources.");
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }(), _$r = _$t;
            }
            return _$r;
        },
        setWasmUrl: function(e) {
            if (typeof e != "string" || e.trim() === "") throw TypeError("setWasmUrl() expects a non-empty URL string");
            a = null, e !== i && (i = e, _$r = null);
        }
    };
}
var $4df2746f4766bf20$var$V = null;
function $4df2746f4766bf20$var$H() {
    return $4df2746f4766bf20$var$V !== null && $4df2746f4766bf20$var$V !== void 0 ? $4df2746f4766bf20$var$V : $4df2746f4766bf20$var$V = $4df2746f4766bf20$var$ye($4df2746f4766bf20$var$me, "https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web@0.81.0/dist/dotlottie-player.wasm", "https://unpkg.com/@lottiefiles/dotlottie-web@0.81.0/dist/dotlottie-player.wasm"), $4df2746f4766bf20$var$V;
}
var $4df2746f4766bf20$var$U = function(e) {
    switch(e){
        case "reverse":
            return $4df2746f4766bf20$var$k.Reverse;
        case "bounce":
            return $4df2746f4766bf20$var$k.Bounce;
        case "reverse-bounce":
            return $4df2746f4766bf20$var$k.ReverseBounce;
        default:
            return $4df2746f4766bf20$var$k.Forward;
    }
}, $4df2746f4766bf20$var$W = function(e) {
    switch(e){
        case $4df2746f4766bf20$var$k.Reverse:
            return "reverse";
        case $4df2746f4766bf20$var$k.Bounce:
            return "bounce";
        case $4df2746f4766bf20$var$k.ReverseBounce:
            return "reverse-bounce";
        default:
            return "forward";
    }
}, $4df2746f4766bf20$var$be = function(e) {
    switch(e){
        case "contain":
            return "contain";
        case "cover":
            return "cover";
        case "fill":
            return "fill";
        case "fit-height":
            return "fit-height";
        case "fit-width":
            return "fit-width";
        case "none":
            return "none";
        default:
            return "contain";
    }
};
var $4df2746f4766bf20$export$2c434b74e61f4f56 = /*#__PURE__*/ function() {
    "use strict";
    function xe(e) {
        var _this = this;
        (0, $4QweW._)(this, xe);
        var _e_renderConfig, _e_renderConfig1;
        var _e_canvas, _e_renderConfig_freezeOnOffscreen;
        $4df2746f4766bf20$var$r(this, "_canvas", null), $4df2746f4766bf20$var$r(this, "_pendingLoad", null), $4df2746f4766bf20$var$r(this, "_srcFetchAbort", null), $4df2746f4766bf20$var$r(this, "_context", null), $4df2746f4766bf20$var$r(this, "_eventManager", void 0), $4df2746f4766bf20$var$r(this, "_animationFrameId", null), $4df2746f4766bf20$var$r(this, "_frameManager", void 0), $4df2746f4766bf20$var$r(this, "_boundAnimationLoop", void 0), $4df2746f4766bf20$var$r(this, "_dotLottieCore", null), $4df2746f4766bf20$var$r(this, "_stateMachineId", ""), $4df2746f4766bf20$var$r(this, "_stateMachineConfig", null), $4df2746f4766bf20$var$r(this, "_isStateMachineRunning", !1), $4df2746f4766bf20$var$r(this, "_renderConfig", {}), $4df2746f4766bf20$var$r(this, "_isFrozen", !1), $4df2746f4766bf20$var$r(this, "_backgroundColor", null), $4df2746f4766bf20$var$r(this, "_lastFrameTime", null), $4df2746f4766bf20$var$r(this, "_boundOnClick", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerUp", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerDown", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerMove", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerEnter", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerLeave", null), $4df2746f4766bf20$var$r(this, "_bufferMismatchCount", 0), $4df2746f4766bf20$var$r(this, "_lastExpectedBufferSize", 0), $4df2746f4766bf20$var$r(this, "_cachedImageData", null), $4df2746f4766bf20$var$r(this, "_cachedImageDataBuffer", null), $4df2746f4766bf20$var$r(this, "_cachedImageDataByteOffset", 0), $4df2746f4766bf20$var$r(this, "_marker", ""), $4df2746f4766bf20$var$r(this, "_segment", null), this._canvas = (_e_canvas = e.canvas) !== null && _e_canvas !== void 0 ? _e_canvas : null, this._eventManager = new $4df2746f4766bf20$var$j, this._frameManager = new $4df2746f4766bf20$var$o, this._boundAnimationLoop = this._animationLoop.bind(this), this._renderConfig = (0, $hApvp._)((0, $kWfK0._)({}, e.renderConfig), {
            devicePixelRatio: ((_e_renderConfig = e.renderConfig) === null || _e_renderConfig === void 0 ? void 0 : _e_renderConfig.devicePixelRatio) || $4df2746f4766bf20$var$I(),
            freezeOnOffscreen: (_e_renderConfig_freezeOnOffscreen = (_e_renderConfig1 = e.renderConfig) === null || _e_renderConfig1 === void 0 ? void 0 : _e_renderConfig1.freezeOnOffscreen) !== null && _e_renderConfig_freezeOnOffscreen !== void 0 ? _e_renderConfig_freezeOnOffscreen : !0
        });
        var t = null;
        e.src && !e.data && (this._srcFetchAbort = new AbortController, t = this._fetchData(e.src, this._srcFetchAbort.signal), t.catch(function() {})), this._initWasm().then(function() {
            var _e_layout, _e_layout_align, _e_layout1, _e_layout_align1, _e_layout2;
            var _e_autoplay, _e_loop, _e_loopCount, _e_mode, _e_speed, _e_useFrameInterpolation, _e_marker, _e_layout_fit, _e_layout_align_, _e_layout_align_1, _e_assetResolver, _e_stateMachineId, _e_stateMachineConfig;
            _this._dotLottieCore = _this._createCore(), _this._dotLottieCore.set_autoplay((_e_autoplay = e.autoplay) !== null && _e_autoplay !== void 0 ? _e_autoplay : !1), _this._dotLottieCore.set_loop((_e_loop = e.loop) !== null && _e_loop !== void 0 ? _e_loop : !1), _this._dotLottieCore.set_loop_count((_e_loopCount = e.loopCount) !== null && _e_loopCount !== void 0 ? _e_loopCount : 0), _this._dotLottieCore.set_mode($4df2746f4766bf20$var$U((_e_mode = e.mode) !== null && _e_mode !== void 0 ? _e_mode : "forward")), _this._dotLottieCore.set_speed((_e_speed = e.speed) !== null && _e_speed !== void 0 ? _e_speed : 1), _this._dotLottieCore.set_use_frame_interpolation((_e_useFrameInterpolation = e.useFrameInterpolation) !== null && _e_useFrameInterpolation !== void 0 ? _e_useFrameInterpolation : !0), e.segment && e.segment.length === 2 && (_this._segment = [
                e.segment[0],
                e.segment[1]
            ], _this._dotLottieCore.set_segment(_this._segment[0], _this._segment[1])), _this._marker = (_e_marker = e.marker) !== null && _e_marker !== void 0 ? _e_marker : "", _this._marker && _this._dotLottieCore.set_marker(_this._marker), _this._dotLottieCore.set_layout((_e_layout_fit = (_e_layout = e.layout) === null || _e_layout === void 0 ? void 0 : _e_layout.fit) !== null && _e_layout_fit !== void 0 ? _e_layout_fit : "contain", (_e_layout_align_ = (_e_layout1 = e.layout) === null || _e_layout1 === void 0 ? void 0 : (_e_layout_align = _e_layout1.align) === null || _e_layout_align === void 0 ? void 0 : _e_layout_align[0]) !== null && _e_layout_align_ !== void 0 ? _e_layout_align_ : .5, (_e_layout_align_1 = (_e_layout2 = e.layout) === null || _e_layout2 === void 0 ? void 0 : (_e_layout_align1 = _e_layout2.align) === null || _e_layout_align1 === void 0 ? void 0 : _e_layout_align1[1]) !== null && _e_layout_align_1 !== void 0 ? _e_layout_align_1 : .5), _this._applyAssetResolver((_e_assetResolver = e.assetResolver) !== null && _e_assetResolver !== void 0 ? _e_assetResolver : null), _this._stateMachineId = (_e_stateMachineId = e.stateMachineId) !== null && _e_stateMachineId !== void 0 ? _e_stateMachineId : "", _this._stateMachineConfig = (_e_stateMachineConfig = e.stateMachineConfig) !== null && _e_stateMachineConfig !== void 0 ? _e_stateMachineConfig : null, _this._onCoreCreated(), _this._eventManager.dispatch({
                type: "ready"
            }), e.data ? _this._canvas ? _this._loadFromData(e.data) : _this._pendingLoad = {
                data: e.data
            } : e.src && (_this._canvas ? _this._loadFromSrc(e.src, t) : _this._pendingLoad = {
                src: e.src,
                dataPromise: t
            }), e.backgroundColor && _this.setBackgroundColor(e.backgroundColor);
        }).catch(function(e) {
            var _this__srcFetchAbort;
            (_this__srcFetchAbort = _this._srcFetchAbort) === null || _this__srcFetchAbort === void 0 ? void 0 : _this__srcFetchAbort.abort(), console.error("[dotlottie-web] Initialization failed:", e), _this._eventManager.dispatch({
                type: "loadError",
                error: Error("Failed to load wasm module: ".concat(e))
            });
        });
    }
    (0, $6hK4i._)(xe, [
        {
            key: "_initWasm",
            value: function _initWasm() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            $4df2746f4766bf20$var$H().load()
                        ];
                    });
                })();
            }
        },
        {
            key: "_createCore",
            value: function _createCore() {
                return new $4df2746f4766bf20$var$ue;
            }
        },
        {
            key: "_onCoreCreated",
            value: function _onCoreCreated() {}
        },
        {
            key: "_setupTarget",
            value: function _setupTarget(e, t) {
                return this._dotLottieCore ? this._dotLottieCore.setup_sw_target(e, t) : !1;
            }
        },
        {
            key: "_drainPlayerEvents",
            value: function _drainPlayerEvents() {
                var _this, _loop = function() {
                    var t = _this._dotLottieCore.poll_event();
                    if (t == null) return "break";
                    switch(t.type){
                        case "Load":
                            setTimeout(function() {
                                return _this1._eventManager.dispatch({
                                    type: "load"
                                });
                            }, 0);
                            break;
                        case "LoadError":
                            setTimeout(function() {
                                return _this1._eventManager.dispatch({
                                    type: "loadError",
                                    error: Error("failed to load")
                                });
                            }, 0);
                            break;
                        case "Play":
                            queueMicrotask(function() {
                                return _this1._eventManager.dispatch({
                                    type: "play"
                                });
                            });
                            break;
                        case "Pause":
                            queueMicrotask(function() {
                                return _this1._eventManager.dispatch({
                                    type: "pause"
                                });
                            });
                            break;
                        case "Stop":
                            queueMicrotask(function() {
                                return _this1._eventManager.dispatch({
                                    type: "stop"
                                });
                            });
                            break;
                        case "Frame":
                            {
                                var _t_frameNo;
                                var n = (_t_frameNo = t.frameNo) !== null && _t_frameNo !== void 0 ? _t_frameNo : 0;
                                e || queueMicrotask(function() {
                                    return _this1._eventManager.dispatch({
                                        type: "frame",
                                        currentFrame: n
                                    });
                                });
                                break;
                            }
                        case "Render":
                            {
                                var _t_frameNo1;
                                var n1 = (_t_frameNo1 = t.frameNo) !== null && _t_frameNo1 !== void 0 ? _t_frameNo1 : 0;
                                e || queueMicrotask(function() {
                                    return _this1._eventManager.dispatch({
                                        type: "render",
                                        currentFrame: n1
                                    });
                                });
                                break;
                            }
                        case "Loop":
                            {
                                var _t_loopCount;
                                var e1 = (_t_loopCount = t.loopCount) !== null && _t_loopCount !== void 0 ? _t_loopCount : 0;
                                queueMicrotask(function() {
                                    return _this1._eventManager.dispatch({
                                        type: "loop",
                                        loopCount: e1
                                    });
                                });
                                break;
                            }
                        case "Complete":
                            queueMicrotask(function() {
                                return _this1._eventManager.dispatch({
                                    type: "complete"
                                });
                            });
                            break;
                        default:
                            break;
                    }
                };
                var _this1 = this;
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.skipFrame, e = tmp === void 0 ? !1 : tmp;
                if (this._dotLottieCore) for(;;){
                    var _ret = (_this = this, _loop());
                    if (_ret === "break") break;
                }
            }
        },
        {
            key: "_discardPlayerEvents",
            value: function _discardPlayerEvents() {
                var _this__dotLottieCore;
                for(; ((_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.poll_event()) != null;);
            }
        },
        {
            key: "_drainSmEvents",
            value: function _drainSmEvents() {
                var _this = this;
                if (this._dotLottieCore) {
                    for(;;){
                        var e = this._dotLottieCore.sm_poll_event();
                        if (e == null) break;
                        switch(e.type){
                            case "Start":
                                queueMicrotask(function() {
                                    _this._isStateMachineRunning = !0, _this._eventManager.dispatch({
                                        type: "stateMachineStart"
                                    }), _this._startAnimationLoop();
                                });
                                break;
                            case "Stop":
                                queueMicrotask(function() {
                                    var _this__dotLottieCore;
                                    _this._isStateMachineRunning = !1, _this._eventManager.dispatch({
                                        type: "stateMachineStop"
                                    }), ((_this__dotLottieCore = _this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.status()) !== $4df2746f4766bf20$var$A.Playing && _this._stopAnimationLoop();
                                });
                                break;
                            case "CustomEvent":
                                var _e_message;
                                this._eventManager.dispatch({
                                    type: "stateMachineCustomEvent",
                                    eventName: (_e_message = e.message) !== null && _e_message !== void 0 ? _e_message : ""
                                });
                                break;
                            case "BooleanInputChange":
                                var _e_name;
                                this._eventManager.dispatch({
                                    type: "stateMachineBooleanInputValueChange",
                                    inputName: (_e_name = e.name) !== null && _e_name !== void 0 ? _e_name : "",
                                    newValue: e.newValue,
                                    oldValue: e.oldValue
                                });
                                break;
                            case "NumericInputChange":
                                var _e_name1;
                                this._eventManager.dispatch({
                                    type: "stateMachineNumericInputValueChange",
                                    inputName: (_e_name1 = e.name) !== null && _e_name1 !== void 0 ? _e_name1 : "",
                                    newValue: e.newValue,
                                    oldValue: e.oldValue
                                });
                                break;
                            case "StringInputChange":
                                var _e_name2;
                                this._eventManager.dispatch({
                                    type: "stateMachineStringInputValueChange",
                                    inputName: (_e_name2 = e.name) !== null && _e_name2 !== void 0 ? _e_name2 : "",
                                    newValue: e.newValue,
                                    oldValue: e.oldValue
                                });
                                break;
                            case "InputFired":
                                var _e_name3;
                                this._eventManager.dispatch({
                                    type: "stateMachineInputFired",
                                    inputName: (_e_name3 = e.name) !== null && _e_name3 !== void 0 ? _e_name3 : ""
                                });
                                break;
                            case "Transition":
                                var _e_previousState, _e_newState;
                                this._eventManager.dispatch({
                                    type: "stateMachineTransition",
                                    fromState: (_e_previousState = e.previousState) !== null && _e_previousState !== void 0 ? _e_previousState : "",
                                    toState: (_e_newState = e.newState) !== null && _e_newState !== void 0 ? _e_newState : ""
                                });
                                break;
                            case "StateEntered":
                                var _e_state;
                                this._eventManager.dispatch({
                                    type: "stateMachineStateEntered",
                                    state: (_e_state = e.state) !== null && _e_state !== void 0 ? _e_state : ""
                                });
                                break;
                            case "StateExit":
                                var _e_state1;
                                this._eventManager.dispatch({
                                    type: "stateMachineStateExit",
                                    state: (_e_state1 = e.state) !== null && _e_state1 !== void 0 ? _e_state1 : ""
                                });
                                break;
                            case "Error":
                                var _e_message1;
                                this._eventManager.dispatch({
                                    type: "stateMachineError",
                                    error: (_e_message1 = e.message) !== null && _e_message1 !== void 0 ? _e_message1 : ""
                                });
                                break;
                            default:
                                break;
                        }
                    }
                    for(;;){
                        var e1 = this._dotLottieCore.sm_poll_internal_event();
                        if (e1 == null) break;
                        if (e1.type === "Message") {
                            var _e_message2;
                            var t = (_e_message2 = e1.message) !== null && _e_message2 !== void 0 ? _e_message2 : "";
                            $4df2746f4766bf20$var$s && t.startsWith("OpenUrl: ") ? $4df2746f4766bf20$var$B(t) : this._eventManager.dispatch({
                                type: "stateMachineInternalMessage",
                                message: t
                            });
                        }
                    }
                }
            }
        },
        {
            key: "_dispatchError",
            value: function _dispatchError(e) {
                console.error(e), this._eventManager.dispatch({
                    type: "loadError",
                    error: Error(e)
                });
            }
        },
        {
            key: "_fetchData",
            value: function _fetchData(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var n, _$r;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch(e, {
                                        signal: t
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                if (!n.ok) throw Error("Failed to fetch animation data from URL: ".concat(e, ". ").concat(n.status, ": ").concat(n.statusText));
                                return [
                                    4,
                                    n.arrayBuffer()
                                ];
                            case 2:
                                _$r = _state.sent();
                                return [
                                    2,
                                    $4df2746f4766bf20$var$P(_$r) ? _$r : new TextDecoder().decode(_$r)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_loadFromData",
            value: function _loadFromData(e) {
                var _this = this;
                if (this._dotLottieCore === null) return;
                if (!this._canvas) {
                    console.warn("[dotlottie-web] Cannot load animation without canvas. Call setCanvas() first.");
                    return;
                }
                this._syncCanvasSize(), this._setupTarget(this._canvas.width, this._canvas.height);
                var t = !1;
                if (typeof e == "string") {
                    if (t = this._dotLottieCore.load_animation(e), !t && !$4df2746f4766bf20$var$F(e)) {
                        this._discardPlayerEvents(), this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
                        return;
                    }
                } else if (e instanceof ArrayBuffer) {
                    if (!$4df2746f4766bf20$var$P(e)) {
                        this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
                        return;
                    }
                    t = this._dotLottieCore.load_dotlottie_data(new Uint8Array(e));
                } else if ((typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) == "object") {
                    if (!$4df2746f4766bf20$var$F(e)) {
                        this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
                        return;
                    }
                    t = this._dotLottieCore.load_animation(JSON.stringify(e));
                } else {
                    this._dispatchError("Unsupported data type for animation data. Expected:\n          - string (Lottie JSON),\n          - ArrayBuffer (dotLottie),\n          - object (Lottie JSON).\n          Received: ".concat(typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)));
                    return;
                }
                if (t) {
                    if (this._renderConfig.quality !== void 0 && this._dotLottieCore.set_quality(this._renderConfig.quality), this._drainPlayerEvents({
                        skipFrame: !!this._marker || !!this._segment
                    }), this._marker && this._dotLottieCore.set_marker(this._marker), this._segment) {
                        this._dotLottieCore.set_segment(this._segment[0], this._segment[1]);
                        var _$e = $4df2746f4766bf20$var$W(this._dotLottieCore.mode()), t1 = _$e === "reverse" || _$e === "reverse-bounce" ? this._segment[1] : this._segment[0];
                        this._dotLottieCore.set_frame(t1);
                    }
                    setTimeout(function() {
                        _this._eventManager.dispatch({
                            type: "frame",
                            currentFrame: _this.currentFrame
                        });
                    }, 0), this._dotLottieCore.render(), this._drainPlayerEvents(), this._draw(), this._stateMachineId ? this.stateMachineLoad(this._stateMachineId) && this.stateMachineStart() && this._startAnimationLoop() : this._dotLottieCore.status() === $4df2746f4766bf20$var$A.Playing && this._startAnimationLoop(), $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && ($4df2746f4766bf20$var$M.observe(this._canvas, this), $4df2746f4766bf20$var$L(this._canvas) || this.freeze()), this._renderConfig.autoResize && $4df2746f4766bf20$var$N.observe(this._canvas, this));
                } else this._drainPlayerEvents();
            }
        },
        {
            key: "_loadFromSrc",
            value: function _loadFromSrc(e, t) {
                var _this = this;
                (t !== null && t !== void 0 ? t : this._fetchData(e)).then(function(e) {
                    return _this._loadFromData(e);
                }).catch(function(t) {
                    return _this._dispatchError("Failed to load animation data from URL: ".concat(e, ". ").concat(t));
                });
            }
        },
        {
            key: "buffer",
            get: function get() {
                return this._dotLottieCore ? this._dotLottieCore.get_pixel_buffer() : null;
            }
        },
        {
            key: "activeAnimationId",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_animation_id;
                return (_this__dotLottieCore_animation_id = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.animation_id()) !== null && _this__dotLottieCore_animation_id !== void 0 ? _this__dotLottieCore_animation_id : void 0;
            }
        },
        {
            key: "activeThemeId",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_theme_id;
                return (_this__dotLottieCore_theme_id = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.theme_id()) !== null && _this__dotLottieCore_theme_id !== void 0 ? _this__dotLottieCore_theme_id : void 0;
            }
        },
        {
            key: "layout",
            get: function get() {
                if (this._dotLottieCore) return {
                    align: [
                        this._dotLottieCore.layout_align_x(),
                        this._dotLottieCore.layout_align_y()
                    ],
                    fit: $4df2746f4766bf20$var$be(this._dotLottieCore.layout_fit())
                };
            }
        },
        {
            key: "marker",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_current_marker;
                return (_this__dotLottieCore_current_marker = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.current_marker()) !== null && _this__dotLottieCore_current_marker !== void 0 ? _this__dotLottieCore_current_marker : "";
            }
        },
        {
            key: "manifest",
            get: function get() {
                try {
                    var _this__dotLottieCore;
                    var e = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.manifest_string();
                    if (this._dotLottieCore === null || !e) return null;
                    var t = JSON.parse(e);
                    return Object.keys(t).length === 0 ? null : t;
                } catch (e) {
                    return null;
                }
            }
        },
        {
            key: "renderConfig",
            get: function get() {
                return this._renderConfig;
            }
        },
        {
            key: "segment",
            get: function get() {
                if (this._dotLottieCore) return [
                    this._dotLottieCore.segment_start(),
                    this._dotLottieCore.segment_end()
                ];
            }
        },
        {
            key: "loop",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_loop_animation;
                return (_this__dotLottieCore_loop_animation = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.loop_animation()) !== null && _this__dotLottieCore_loop_animation !== void 0 ? _this__dotLottieCore_loop_animation : !1;
            }
        },
        {
            key: "mode",
            get: function get() {
                return this._dotLottieCore ? $4df2746f4766bf20$var$W(this._dotLottieCore.mode()) : "forward";
            }
        },
        {
            key: "isFrozen",
            get: function get() {
                return this._isFrozen;
            }
        },
        {
            key: "isStateMachineRunning",
            get: function get() {
                return this._isStateMachineRunning;
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                var _this__backgroundColor;
                return (_this__backgroundColor = this._backgroundColor) !== null && _this__backgroundColor !== void 0 ? _this__backgroundColor : "";
            }
        },
        {
            key: "autoplay",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_autoplay;
                return (_this__dotLottieCore_autoplay = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.autoplay()) !== null && _this__dotLottieCore_autoplay !== void 0 ? _this__dotLottieCore_autoplay : !1;
            }
        },
        {
            key: "useFrameInterpolation",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_use_frame_interpolation;
                return (_this__dotLottieCore_use_frame_interpolation = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.use_frame_interpolation()) !== null && _this__dotLottieCore_use_frame_interpolation !== void 0 ? _this__dotLottieCore_use_frame_interpolation : !1;
            }
        },
        {
            key: "speed",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_speed;
                return (_this__dotLottieCore_speed = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.speed()) !== null && _this__dotLottieCore_speed !== void 0 ? _this__dotLottieCore_speed : 0;
            }
        },
        {
            key: "isReady",
            get: function get() {
                return this._dotLottieCore !== null;
            }
        },
        {
            key: "isLoaded",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_status;
                return ((_this__dotLottieCore_status = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.status()) !== null && _this__dotLottieCore_status !== void 0 ? _this__dotLottieCore_status : $4df2746f4766bf20$var$A.Idle) !== $4df2746f4766bf20$var$A.Idle;
            }
        },
        {
            key: "isPlaying",
            get: function get() {
                var _this__dotLottieCore;
                return ((_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.status()) === $4df2746f4766bf20$var$A.Playing;
            }
        },
        {
            key: "isPaused",
            get: function get() {
                var _this__dotLottieCore;
                return ((_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.status()) === $4df2746f4766bf20$var$A.Paused;
            }
        },
        {
            key: "isStopped",
            get: function get() {
                var _this__dotLottieCore;
                return ((_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.status()) === $4df2746f4766bf20$var$A.Stopped;
            }
        },
        {
            key: "currentFrame",
            get: function get() {
                return this._dotLottieCore ? Math.round(this._dotLottieCore.current_frame() * 100) / 100 : 0;
            }
        },
        {
            key: "loopCount",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_current_loop_count;
                return (_this__dotLottieCore_current_loop_count = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.current_loop_count()) !== null && _this__dotLottieCore_current_loop_count !== void 0 ? _this__dotLottieCore_current_loop_count : 0;
            }
        },
        {
            key: "totalFrames",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_total_frames;
                return (_this__dotLottieCore_total_frames = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.total_frames()) !== null && _this__dotLottieCore_total_frames !== void 0 ? _this__dotLottieCore_total_frames : 0;
            }
        },
        {
            key: "duration",
            get: function get() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_duration;
                return ((_this__dotLottieCore_duration = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.duration()) !== null && _this__dotLottieCore_duration !== void 0 ? _this__dotLottieCore_duration : 0) / 1e3;
            }
        },
        {
            key: "canvas",
            get: function get() {
                return this._canvas;
            }
        },
        {
            key: "load",
            value: function load(e) {
                var _e_layout, _e_layout_align, _e_layout1, _e_layout_align1, _e_layout2;
                var _e_autoplay, _e_loop, _e_loopCount, _e_mode, _e_speed, _e_useFrameInterpolation, _e_marker, _e_layout_fit, _e_layout_align_, _e_layout_align_1, _e_assetResolver;
                this._dotLottieCore !== null && (this._stopAnimationLoop(), this._cleanupCanvas(), this._isFrozen = !1, this._dotLottieCore.set_autoplay((_e_autoplay = e.autoplay) !== null && _e_autoplay !== void 0 ? _e_autoplay : !1), this._dotLottieCore.set_loop((_e_loop = e.loop) !== null && _e_loop !== void 0 ? _e_loop : !1), this._dotLottieCore.set_loop_count((_e_loopCount = e.loopCount) !== null && _e_loopCount !== void 0 ? _e_loopCount : 0), this._dotLottieCore.set_mode($4df2746f4766bf20$var$U((_e_mode = e.mode) !== null && _e_mode !== void 0 ? _e_mode : "forward")), this._dotLottieCore.set_speed((_e_speed = e.speed) !== null && _e_speed !== void 0 ? _e_speed : 1), this._dotLottieCore.set_use_frame_interpolation((_e_useFrameInterpolation = e.useFrameInterpolation) !== null && _e_useFrameInterpolation !== void 0 ? _e_useFrameInterpolation : !0), e.segment && e.segment.length === 2 ? (this._segment = [
                    e.segment[0],
                    e.segment[1]
                ], this._dotLottieCore.set_segment(this._segment[0], this._segment[1])) : (this._segment = null, this._dotLottieCore.clear_segment()), this._marker = (_e_marker = e.marker) !== null && _e_marker !== void 0 ? _e_marker : "", this._marker ? this._dotLottieCore.set_marker(this._marker) : this._dotLottieCore.clear_marker(), this._dotLottieCore.set_layout((_e_layout_fit = (_e_layout = e.layout) === null || _e_layout === void 0 ? void 0 : _e_layout.fit) !== null && _e_layout_fit !== void 0 ? _e_layout_fit : "contain", (_e_layout_align_ = (_e_layout1 = e.layout) === null || _e_layout1 === void 0 ? void 0 : (_e_layout_align = _e_layout1.align) === null || _e_layout_align === void 0 ? void 0 : _e_layout_align[0]) !== null && _e_layout_align_ !== void 0 ? _e_layout_align_ : .5, (_e_layout_align_1 = (_e_layout2 = e.layout) === null || _e_layout2 === void 0 ? void 0 : (_e_layout_align1 = _e_layout2.align) === null || _e_layout_align1 === void 0 ? void 0 : _e_layout_align1[1]) !== null && _e_layout_align_1 !== void 0 ? _e_layout_align_1 : .5), this._applyAssetResolver((_e_assetResolver = e.assetResolver) !== null && _e_assetResolver !== void 0 ? _e_assetResolver : null), e.data ? this._canvas ? this._loadFromData(e.data) : this._pendingLoad = {
                    data: e.data
                } : e.src && (this._canvas ? this._loadFromSrc(e.src) : this._pendingLoad = {
                    src: e.src
                }), e.backgroundColor && this.setBackgroundColor(e.backgroundColor));
            }
        },
        {
            key: "_draw",
            value: function _draw() {
                if (this._dotLottieCore === null || this._canvas === null || (!this._context && "getContext" in this._canvas && typeof this._canvas.getContext == "function" && (!$4df2746f4766bf20$var$s || (typeof HTMLCanvasElement === "undefined" ? "undefined" : (0, $5djcY._)(HTMLCanvasElement)) < "u" && this._canvas instanceof HTMLCanvasElement || (typeof OffscreenCanvas === "undefined" ? "undefined" : (0, $5djcY._)(OffscreenCanvas)) < "u" && this._canvas instanceof OffscreenCanvas) && (this._context = this._canvas.getContext("2d")), !this._context)) return;
                var e = this._dotLottieCore.get_pixel_buffer(), t = this._canvas.width, n = this._canvas.height, _$r = t * n * 4;
                if (e.byteLength !== _$r) {
                    this._lastExpectedBufferSize === _$r ? this._bufferMismatchCount += 1 : (this._bufferMismatchCount = 1, this._lastExpectedBufferSize = _$r), this._bufferMismatchCount === 10 && console.warn("[dotlottie-web] Persistent buffer size mismatch detected. Expected ".concat(_$r, " bytes for canvas ").concat(t, "x").concat(n, ", but got ").concat(e.byteLength, " bytes. This may indicate a WASM memory allocation issue or invalid canvas dimensions."));
                    return;
                }
                this._bufferMismatchCount = 0, this._lastExpectedBufferSize = _$r;
                var i = this._cachedImageData;
                if (!(i !== null && i.width === t && i.height === n && i.data.byteLength === _$r && this._cachedImageDataBuffer === e.buffer && this._cachedImageDataByteOffset === e.byteOffset)) {
                    if ((typeof ImageData === "undefined" ? "undefined" : (0, $5djcY._)(ImageData)) > "u") this._cachedImageData = this._context.createImageData(t, n);
                    else {
                        var _$r1 = new Uint8ClampedArray(e.buffer, e.byteOffset, e.byteLength);
                        this._cachedImageData = new ImageData(_$r1, t, n);
                    }
                    this._cachedImageDataBuffer = e.buffer, this._cachedImageDataByteOffset = e.byteOffset;
                }
                if ((typeof ImageData === "undefined" ? "undefined" : (0, $5djcY._)(ImageData)) > "u") {
                    var t1 = new Uint8ClampedArray(e.buffer, e.byteOffset, e.byteLength);
                    this._cachedImageData.data.set(t1);
                }
                this._context.putImageData(this._cachedImageData, 0, 0);
            }
        },
        {
            key: "_cleanupCanvas",
            value: function _cleanupCanvas() {
                this._canvas && $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && ($4df2746f4766bf20$var$M.unobserve(this._canvas), $4df2746f4766bf20$var$N.unobserve(this._canvas), this._cleanupStateMachineListeners());
            }
        },
        {
            key: "_initializeCanvas",
            value: function _initializeCanvas() {
                this._setupRendererOnCanvas(), this._canvas && $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && this.isLoaded && (this._renderConfig.freezeOnOffscreen && ($4df2746f4766bf20$var$M.observe(this._canvas, this), $4df2746f4766bf20$var$L(this._canvas) || this.freeze()), this._renderConfig.autoResize && $4df2746f4766bf20$var$N.observe(this._canvas, this), this._isStateMachineRunning && this._setupStateMachineListeners()), this._canvas && this._dotLottieCore && this.isLoaded && this._setupTarget(this._canvas.width, this._canvas.height) && (this._dotLottieCore.render(), this._draw());
            }
        },
        {
            key: "_setupRendererOnCanvas",
            value: function _setupRendererOnCanvas() {
                this._context = null;
            }
        },
        {
            key: "_stopAnimationLoop",
            value: function _stopAnimationLoop() {
                this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), this._lastFrameTime = null;
            }
        },
        {
            key: "_startAnimationLoop",
            value: function _startAnimationLoop() {
                this._animationFrameId === null && this._dotLottieCore && !this._isFrozen && (this._dotLottieCore.status() === $4df2746f4766bf20$var$A.Playing || this._isStateMachineRunning) && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._boundAnimationLoop));
            }
        },
        {
            key: "_animationLoop",
            value: function _animationLoop(e) {
                if (this._dotLottieCore === null) {
                    this._stopAnimationLoop();
                    return;
                }
                if (this._dotLottieCore.status() !== $4df2746f4766bf20$var$A.Playing && !this._isStateMachineRunning) {
                    this._stopAnimationLoop();
                    return;
                }
                try {
                    var t = this._lastFrameTime === null ? 0 : e - this._lastFrameTime;
                    this._lastFrameTime = e;
                    var n = this._isStateMachineRunning ? this._dotLottieCore.sm_tick(t) : this._dotLottieCore.tick(t);
                    this._isStateMachineRunning ? this._drainSmEvents() : this._drainPlayerEvents(), n && this._draw(), this._animationFrameId = this._frameManager.requestAnimationFrame(this._boundAnimationLoop);
                } catch (e) {
                    console.error("Error in animation frame:", e), this._eventManager.dispatch({
                        type: "renderError",
                        error: e
                    }), e instanceof WebAssembly.RuntimeError && this.destroy();
                }
            }
        },
        {
            key: "play",
            value: function play() {
                if (this._dotLottieCore === null || !this.isLoaded) return;
                this._stopAnimationLoop();
                var e = this._dotLottieCore.play();
                this._drainPlayerEvents(), (e || this._dotLottieCore.status() === $4df2746f4766bf20$var$A.Playing) && (this._isFrozen = !1, this._startAnimationLoop()), this._canvas && $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !$4df2746f4766bf20$var$L(this._canvas) && this.freeze();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._dotLottieCore !== null && (this._dotLottieCore.pause(), this._drainPlayerEvents(), this._stopAnimationLoop());
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this._dotLottieCore === null) return;
                var e = this._dotLottieCore.stop();
                this._drainPlayerEvents(), this._stopAnimationLoop(), e && (this._eventManager.dispatch({
                    type: "frame",
                    currentFrame: this.currentFrame
                }), this._dotLottieCore.render(), this._draw());
            }
        },
        {
            key: "setFrame",
            value: function setFrame(e) {
                if (this._dotLottieCore !== null && this._dotLottieCore.set_frame(e)) {
                    var _$e = this._dotLottieCore.render();
                    this._drainPlayerEvents(), _$e && this._draw();
                }
            }
        },
        {
            key: "setSpeed",
            value: function setSpeed(e) {
                this._dotLottieCore !== null && this._dotLottieCore.set_speed(e);
            }
        },
        {
            key: "setBackgroundColor",
            value: function setBackgroundColor(e) {
                if (this._dotLottieCore !== null) {
                    if ($4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement) this._canvas.style.backgroundColor = e;
                    else {
                        var _ge = (0, $6ZpBv._)($4df2746f4766bf20$var$ge(e), 4), t = _ge[0], n = _ge[1], _$r = _ge[2], i = _ge[3];
                        this._dotLottieCore.set_background(t, n, _$r, i);
                    }
                    this._backgroundColor = e;
                }
            }
        },
        {
            key: "setLoop",
            value: function setLoop(e) {
                this._dotLottieCore !== null && this._dotLottieCore.set_loop(e);
            }
        },
        {
            key: "setLoopCount",
            value: function setLoopCount(e) {
                this._dotLottieCore !== null && this._dotLottieCore.set_loop_count(e);
            }
        },
        {
            key: "setUseFrameInterpolation",
            value: function setUseFrameInterpolation(e) {
                this._dotLottieCore !== null && this._dotLottieCore.set_use_frame_interpolation(e);
            }
        },
        {
            key: "_applyAssetResolver",
            value: function _applyAssetResolver(e) {
                if (this._dotLottieCore !== null) {
                    if (e === null) {
                        this._dotLottieCore.set_asset_resolver(null);
                        return;
                    }
                    this._dotLottieCore.set_asset_resolver(function(t) {
                        try {
                            var _e;
                            return (_e = e(t)) !== null && _e !== void 0 ? _e : null;
                        } catch (e) {
                            return console.error('[dotlottie-web] assetResolver threw for "'.concat(t, '":'), e), null;
                        }
                    });
                }
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(e, t) {
                this._eventManager.addEventListener(e, t);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(e, t) {
                this._eventManager.removeEventListener(e, t);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this__srcFetchAbort;
                this._stopAnimationLoop(), this._isStateMachineRunning = !1, this._cleanupCanvas(), (_this__srcFetchAbort = this._srcFetchAbort) === null || _this__srcFetchAbort === void 0 ? void 0 : _this__srcFetchAbort.abort(), this._srcFetchAbort = null, this._pendingLoad = null;
                var _$e = this._dotLottieCore;
                if (this._dotLottieCore = null, this._context = null, _$e) try {
                    _$e.free();
                } catch (e) {
                    console.warn("[dotlottie-web] Error freeing wasm core during destroy:", e);
                }
                this._eventManager.dispatch({
                    type: "destroy"
                }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this._animationFrameId !== null && (this._stopAnimationLoop(), this._isFrozen = !0, this._eventManager.dispatch({
                    type: "freeze"
                }));
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this._animationFrameId === null && (this._isFrozen = !1, this._eventManager.dispatch({
                    type: "unfreeze"
                }), this._startAnimationLoop());
            }
        },
        {
            key: "_syncCanvasSize",
            value: function _syncCanvasSize() {
                if (!($4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement)) return;
                var e = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, _this__canvas_getBoundingClientRect = this._canvas.getBoundingClientRect(), t = _this__canvas_getBoundingClientRect.height, n = _this__canvas_getBoundingClientRect.width;
                t !== 0 && n !== 0 && (this._canvas.width = n * e, this._canvas.height = t * e);
            }
        },
        {
            key: "resize",
            value: function resize() {
                !this._dotLottieCore || !this.isLoaded || !this._canvas || (this._syncCanvasSize(), this._setupTarget(this._canvas.width, this._canvas.height) && (this._dotLottieCore.render(), this._draw()));
            }
        },
        {
            key: "setCanvas",
            value: function setCanvas(e) {
                if (!(!e || this._canvas === e) && (this._canvas && this._cleanupCanvas(), this._canvas = e, this._initializeCanvas(), this._pendingLoad)) {
                    var _$e = this._pendingLoad;
                    this._pendingLoad = null, _$e.data ? this._loadFromData(_$e.data) : _$e.src && this._loadFromSrc(_$e.src, _$e.dataPromise);
                }
            }
        },
        {
            key: "setTransform",
            value: function setTransform(e) {
                if (!this._dotLottieCore) return !1;
                var t = this._dotLottieCore.set_transform(new Float32Array(e));
                return t && this._dotLottieCore.render() && this._draw(), t;
            }
        },
        {
            key: "getTransform",
            value: function getTransform() {
                if (!this._dotLottieCore) return;
                var e = this._dotLottieCore.get_transform();
                return Array.from(e);
            }
        },
        {
            key: "setSegment",
            value: function setSegment(e, t) {
                this._dotLottieCore !== null && (this._segment = [
                    e,
                    t
                ], this._dotLottieCore.set_segment(e, t));
            }
        },
        {
            key: "resetSegment",
            value: function resetSegment() {
                this._dotLottieCore !== null && (this._segment = null, this._dotLottieCore.clear_segment());
            }
        },
        {
            key: "setMode",
            value: function setMode(e) {
                this._dotLottieCore !== null && this._dotLottieCore.set_mode($4df2746f4766bf20$var$U(e));
            }
        },
        {
            key: "setRenderConfig",
            value: function setRenderConfig(e) {
                var t = e.devicePixelRatio, n = e.freezeOnOffscreen, _$r = e.quality, i = (0, $1DiK7._)(e, [
                    "devicePixelRatio",
                    "freezeOnOffscreen",
                    "quality"
                ]);
                this._renderConfig = (0, $kWfK0._)((0, $hApvp._)((0, $kWfK0._)({}, this._renderConfig, i), {
                    devicePixelRatio: t || $4df2746f4766bf20$var$I(),
                    freezeOnOffscreen: n !== null && n !== void 0 ? n : !0
                }), _$r !== void 0 && {
                    quality: _$r
                }), _$r !== void 0 && this._dotLottieCore && this._dotLottieCore.set_quality(_$r), $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? $4df2746f4766bf20$var$N.observe(this._canvas, this) : $4df2746f4766bf20$var$N.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? ($4df2746f4766bf20$var$M.observe(this._canvas, this), $4df2746f4766bf20$var$L(this._canvas) || this.freeze()) : ($4df2746f4766bf20$var$M.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
            }
        },
        {
            key: "loadAnimation",
            value: function loadAnimation(e) {
                this._dotLottieCore === null || this._dotLottieCore.animation_id() === e || !this._canvas || (this._syncCanvasSize(), this._setupTarget(this._canvas.width, this._canvas.height), this._dotLottieCore.load_animation_from_id(e) ? (this._renderConfig.quality !== void 0 && this._dotLottieCore.set_quality(this._renderConfig.quality), this._drainPlayerEvents(), this._dotLottieCore.render(), this._draw()) : this._dispatchError("Failed to load animation with id: ".concat(e)));
            }
        },
        {
            key: "setMarker",
            value: function setMarker(e) {
                this._dotLottieCore !== null && (this.markers().some(function(t) {
                    return t.name === e;
                }) ? (this._marker = e, this._dotLottieCore.set_marker(e)) : (this._marker = "", this._segment = null, this._dotLottieCore.clear_marker(), this._dotLottieCore.clear_segment()));
            }
        },
        {
            key: "markers",
            value: function markers() {
                var _this__dotLottieCore;
                var e = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.markers();
                return e && Array.isArray(e) ? e : [];
            }
        },
        {
            key: "setTheme",
            value: function setTheme(e) {
                if (this._dotLottieCore === null) return !1;
                var t = this._dotLottieCore.set_theme(e);
                return t && (this._dotLottieCore.render(), this._draw()), t;
            }
        },
        {
            key: "resetTheme",
            value: function resetTheme() {
                if (this._dotLottieCore === null) return !1;
                var e = this._dotLottieCore.reset_theme();
                return e && (this._dotLottieCore.render(), this._draw()), e;
            }
        },
        {
            key: "setThemeData",
            value: function setThemeData(e) {
                if (this._dotLottieCore === null) return !1;
                var t = typeof e == "string" ? e : JSON.stringify(e), n = this._dotLottieCore.set_theme_data(t);
                return n && (this._dotLottieCore.render(), this._draw()), n;
            }
        },
        {
            key: "setSlots",
            value: function setSlots(e) {
                this._dotLottieCore !== null && this._dotLottieCore.set_slots_str(JSON.stringify(e)) && (this._dotLottieCore.render(), this._draw());
            }
        },
        {
            key: "_isKeyframeArray",
            value: function _isKeyframeArray(e) {
                return Array.isArray(e) && e.length > 0 && (0, $5djcY._)(e[0]) == "object" && e[0] !== null && "t" in e[0] && "s" in e[0];
            }
        },
        {
            key: "getSlotIds",
            value: function getSlotIds() {
                if (!this._dotLottieCore) return [];
                var e = this._dotLottieCore.get_slot_ids();
                return Array.isArray(e) ? e : [];
            }
        },
        {
            key: "getSlotType",
            value: function getSlotType(e) {
                if (!this._dotLottieCore) return;
                var t = this._dotLottieCore.get_slot_type(e);
                if (t) return t;
            }
        },
        {
            key: "getSlot",
            value: function getSlot(e) {
                if (!this._dotLottieCore) return;
                var t = this._dotLottieCore.get_slot_str(e);
                if (t) try {
                    return JSON.parse(t);
                } catch (e) {
                    return;
                }
            }
        },
        {
            key: "getSlots",
            value: function getSlots() {
                if (!this._dotLottieCore) return {};
                try {
                    return JSON.parse(this._dotLottieCore.get_slots_str());
                } catch (e) {
                    return {};
                }
            }
        },
        {
            key: "setColorSlot",
            value: function setColorSlot(e, t) {
                if (this._dotLottieCore === null) return !1;
                var n = this._isKeyframeArray(t), _$r = JSON.stringify({
                    a: +!!n,
                    k: t
                }), i = this._dotLottieCore.set_slot_str(e, _$r);
                return this._dotLottieCore.render(), this._draw(), i;
            }
        },
        {
            key: "setScalarSlot",
            value: function setScalarSlot(e, t) {
                if (this._dotLottieCore === null) return !1;
                var n = JSON.stringify({
                    a: typeof t == "number" ? 0 : 1,
                    k: t
                }), _$r = this._dotLottieCore.set_slot_str(e, n);
                return this._dotLottieCore.render(), this._draw(), _$r;
            }
        },
        {
            key: "setVectorSlot",
            value: function setVectorSlot(e, t) {
                if (this._dotLottieCore === null) return !1;
                var n = this._isKeyframeArray(t), _$r = JSON.stringify({
                    a: +!!n,
                    k: t
                }), i = this._dotLottieCore.set_slot_str(e, _$r);
                return this._dotLottieCore.render(), this._draw(), i;
            }
        },
        {
            key: "setGradientSlot",
            value: function setGradientSlot(e, t, n) {
                if (this._dotLottieCore === null) return !1;
                var _$r = this._isKeyframeArray(t), i = JSON.stringify({
                    k: {
                        a: +!!_$r,
                        k: t
                    },
                    p: n
                }), a = this._dotLottieCore.set_slot_str(e, i);
                return this._dotLottieCore.render(), this._draw(), a;
            }
        },
        {
            key: "setTextSlot",
            value: function setTextSlot(e, t) {
                if (this._dotLottieCore === null) return !1;
                var n = this._dotLottieCore.get_slot_str(e), _$r = t;
                if (n) {
                    var _$e = JSON.parse(n);
                    if (_$e && "k" in _$e && Array.isArray(_$e.k)) {
                        var n1 = _$e.k[0];
                        "s" in n1 && (0, $5djcY._)(n1.s) == "object" && (_$r = (0, $kWfK0._)({}, n1.s, t));
                    }
                }
                var i = JSON.stringify({
                    a: 0,
                    k: [
                        {
                            t: 0,
                            s: _$r
                        }
                    ]
                }), a = this._dotLottieCore.set_slot_str(e, i);
                return this._dotLottieCore.render(), this._draw(), a;
            }
        },
        {
            key: "setImageSlot",
            value: function setImageSlot(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var n, _$r;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this._dotLottieCore === null) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    $4df2746f4766bf20$var$z(t)
                                ];
                            case 1:
                                n = _state.sent();
                                if (this._dotLottieCore === null) return [
                                    2,
                                    !1
                                ];
                                _$r = this._dotLottieCore.set_image_slot(e, n);
                                return [
                                    2,
                                    (this._dotLottieCore.render(), this._draw(), _$r)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "resetSlot",
            value: function resetSlot(e) {
                if (this._dotLottieCore === null) return !1;
                var t = this._dotLottieCore.reset_slot(e);
                return this._dotLottieCore.render(), this._draw(), t;
            }
        },
        {
            key: "clearSlot",
            value: function clearSlot(e) {
                if (this._dotLottieCore === null) return !1;
                var t = this._dotLottieCore.clear_slot(e);
                return this._dotLottieCore.render(), this._draw(), t;
            }
        },
        {
            key: "resetSlots",
            value: function resetSlots() {
                if (this._dotLottieCore === null) return !1;
                var e = this._dotLottieCore.reset_slots();
                return this._dotLottieCore.render(), this._draw(), e;
            }
        },
        {
            key: "clearSlots",
            value: function clearSlots() {
                if (this._dotLottieCore === null) return !1;
                var e = this._dotLottieCore.clear_slots();
                return this._dotLottieCore.render(), this._draw(), e;
            }
        },
        {
            key: "setLayout",
            value: function setLayout(e) {
                var _e_align, _e_align1;
                var _e_fit, _e_align_, _e_align_1;
                this._dotLottieCore !== null && this._dotLottieCore.set_layout((_e_fit = e.fit) !== null && _e_fit !== void 0 ? _e_fit : "contain", (_e_align_ = (_e_align = e.align) === null || _e_align === void 0 ? void 0 : _e_align[0]) !== null && _e_align_ !== void 0 ? _e_align_ : .5, (_e_align_1 = (_e_align1 = e.align) === null || _e_align1 === void 0 ? void 0 : _e_align1[1]) !== null && _e_align_1 !== void 0 ? _e_align_1 : .5);
            }
        },
        {
            key: "setViewport",
            value: function setViewport(e, t, n, r) {
                return this._dotLottieCore === null ? !1 : this._dotLottieCore.set_viewport(e, t, n, r);
            }
        },
        {
            key: "animationSize",
            value: function animationSize() {
                var _this__dotLottieCore;
                var e = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.animation_size();
                var _e_, _e_1;
                return {
                    width: (_e_ = e === null || e === void 0 ? void 0 : e[0]) !== null && _e_ !== void 0 ? _e_ : 0,
                    height: (_e_1 = e === null || e === void 0 ? void 0 : e[1]) !== null && _e_1 !== void 0 ? _e_1 : 0
                };
            }
        },
        {
            key: "stateMachineLoad",
            value: function stateMachineLoad(e) {
                return this._dotLottieCore ? this._dotLottieCore.state_machine_load_from_id(e) : !1;
            }
        },
        {
            key: "stateMachineLoadData",
            value: function stateMachineLoadData(e) {
                return this._dotLottieCore ? this._dotLottieCore.state_machine_load(e) : !1;
            }
        },
        {
            key: "stateMachineSetConfig",
            value: function stateMachineSetConfig(e) {
                this._stateMachineConfig = e;
            }
        },
        {
            key: "stateMachineStart",
            value: function stateMachineStart() {
                var _this__stateMachineConfig_openUrlPolicy, _this__stateMachineConfig, _this__stateMachineConfig_openUrlPolicy1, _this__stateMachineConfig1;
                if (this._dotLottieCore === null) return !1;
                var _this__stateMachineConfig_openUrlPolicy_requireUserInteraction, _this__stateMachineConfig_openUrlPolicy_whitelist;
                var e = this._dotLottieCore.sm_start((_this__stateMachineConfig_openUrlPolicy_requireUserInteraction = (_this__stateMachineConfig = this._stateMachineConfig) === null || _this__stateMachineConfig === void 0 ? void 0 : (_this__stateMachineConfig_openUrlPolicy = _this__stateMachineConfig.openUrlPolicy) === null || _this__stateMachineConfig_openUrlPolicy === void 0 ? void 0 : _this__stateMachineConfig_openUrlPolicy.requireUserInteraction) !== null && _this__stateMachineConfig_openUrlPolicy_requireUserInteraction !== void 0 ? _this__stateMachineConfig_openUrlPolicy_requireUserInteraction : !0, (_this__stateMachineConfig_openUrlPolicy_whitelist = (_this__stateMachineConfig1 = this._stateMachineConfig) === null || _this__stateMachineConfig1 === void 0 ? void 0 : (_this__stateMachineConfig_openUrlPolicy1 = _this__stateMachineConfig1.openUrlPolicy) === null || _this__stateMachineConfig_openUrlPolicy1 === void 0 ? void 0 : _this__stateMachineConfig_openUrlPolicy1.whitelist) !== null && _this__stateMachineConfig_openUrlPolicy_whitelist !== void 0 ? _this__stateMachineConfig_openUrlPolicy_whitelist : []);
                return this._drainSmEvents(), e && (this._isStateMachineRunning = !0, this._setupStateMachineListeners(), this._startAnimationLoop()), e;
            }
        },
        {
            key: "stateMachineStop",
            value: function stateMachineStop() {
                if (!this._dotLottieCore) return !1;
                var e = this._dotLottieCore.sm_stop();
                return this._drainSmEvents(), e && (this._isStateMachineRunning = !1, this._cleanupStateMachineListeners(), this._dotLottieCore.status() !== $4df2746f4766bf20$var$A.Playing && this._stopAnimationLoop()), e;
            }
        },
        {
            key: "stateMachineGetStatus",
            value: function stateMachineGetStatus() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_status;
                return (_this__dotLottieCore_sm_status = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_status()) !== null && _this__dotLottieCore_sm_status !== void 0 ? _this__dotLottieCore_sm_status : "";
            }
        },
        {
            key: "stateMachineGetCurrentState",
            value: function stateMachineGetCurrentState() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_current_state;
                return (_this__dotLottieCore_sm_current_state = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_current_state()) !== null && _this__dotLottieCore_sm_current_state !== void 0 ? _this__dotLottieCore_sm_current_state : "";
            }
        },
        {
            key: "stateMachineGetActiveId",
            value: function stateMachineGetActiveId() {
                var _this__dotLottieCore;
                var _this__dotLottieCore_state_machine_id;
                return (_this__dotLottieCore_state_machine_id = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.state_machine_id()) !== null && _this__dotLottieCore_state_machine_id !== void 0 ? _this__dotLottieCore_state_machine_id : "";
            }
        },
        {
            key: "stateMachineOverrideState",
            value: function stateMachineOverrideState(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_override_current_state;
                return (_this__dotLottieCore_sm_override_current_state = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_override_current_state(e, t)) !== null && _this__dotLottieCore_sm_override_current_state !== void 0 ? _this__dotLottieCore_sm_override_current_state : !1;
            }
        },
        {
            key: "stateMachineSetSeed",
            value: function stateMachineSetSeed(e) {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_set_seed;
                return (_this__dotLottieCore_sm_set_seed = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_set_seed(BigInt(Math.trunc(e)))) !== null && _this__dotLottieCore_sm_set_seed !== void 0 ? _this__dotLottieCore_sm_set_seed : !1;
            }
        },
        {
            key: "stateMachineGet",
            value: function stateMachineGet(e) {
                var _this__dotLottieCore;
                var _this__dotLottieCore_get_state_machine;
                return (_this__dotLottieCore_get_state_machine = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.get_state_machine(e)) !== null && _this__dotLottieCore_get_state_machine !== void 0 ? _this__dotLottieCore_get_state_machine : "";
            }
        },
        {
            key: "stateMachineGetListeners",
            value: function stateMachineGetListeners() {
                if (!this._dotLottieCore) return [];
                var e = this._dotLottieCore.sm_framework_setup();
                return Array.isArray(e) ? e : [];
            }
        },
        {
            key: "stateMachineSetBooleanInput",
            value: function stateMachineSetBooleanInput(e, t) {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_set_boolean_input;
                return (_this__dotLottieCore_sm_set_boolean_input = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_set_boolean_input(e, t)) !== null && _this__dotLottieCore_sm_set_boolean_input !== void 0 ? _this__dotLottieCore_sm_set_boolean_input : !1;
            }
        },
        {
            key: "stateMachineSetNumericInput",
            value: function stateMachineSetNumericInput(e, t) {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_set_numeric_input;
                return (_this__dotLottieCore_sm_set_numeric_input = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_set_numeric_input(e, t)) !== null && _this__dotLottieCore_sm_set_numeric_input !== void 0 ? _this__dotLottieCore_sm_set_numeric_input : !1;
            }
        },
        {
            key: "stateMachineSetStringInput",
            value: function stateMachineSetStringInput(e, t) {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_set_string_input;
                return (_this__dotLottieCore_sm_set_string_input = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_set_string_input(e, t)) !== null && _this__dotLottieCore_sm_set_string_input !== void 0 ? _this__dotLottieCore_sm_set_string_input : !1;
            }
        },
        {
            key: "stateMachineGetBooleanInput",
            value: function stateMachineGetBooleanInput(e) {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_get_boolean_input;
                return (_this__dotLottieCore_sm_get_boolean_input = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_get_boolean_input(e)) !== null && _this__dotLottieCore_sm_get_boolean_input !== void 0 ? _this__dotLottieCore_sm_get_boolean_input : void 0;
            }
        },
        {
            key: "stateMachineGetNumericInput",
            value: function stateMachineGetNumericInput(e) {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_get_numeric_input;
                return (_this__dotLottieCore_sm_get_numeric_input = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_get_numeric_input(e)) !== null && _this__dotLottieCore_sm_get_numeric_input !== void 0 ? _this__dotLottieCore_sm_get_numeric_input : void 0;
            }
        },
        {
            key: "stateMachineGetStringInput",
            value: function stateMachineGetStringInput(e) {
                var _this__dotLottieCore;
                var _this__dotLottieCore_sm_get_string_input;
                return (_this__dotLottieCore_sm_get_string_input = (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_get_string_input(e)) !== null && _this__dotLottieCore_sm_get_string_input !== void 0 ? _this__dotLottieCore_sm_get_string_input : void 0;
            }
        },
        {
            key: "stateMachineGetInputs",
            value: function stateMachineGetInputs() {
                if (!this._dotLottieCore) return [];
                var e = this._dotLottieCore.sm_get_inputs();
                return Array.isArray(e) ? e : [];
            }
        },
        {
            key: "stateMachineFireEvent",
            value: function stateMachineFireEvent(e) {
                var _this__dotLottieCore;
                (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_fire(e);
            }
        },
        {
            key: "stateMachinePostClickEvent",
            value: function stateMachinePostClickEvent(e, t) {
                var _this__dotLottieCore;
                (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_post_click(e, t);
            }
        },
        {
            key: "stateMachinePostPointerUpEvent",
            value: function stateMachinePostPointerUpEvent(e, t) {
                var _this__dotLottieCore;
                (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_post_pointer_up(e, t);
            }
        },
        {
            key: "stateMachinePostPointerDownEvent",
            value: function stateMachinePostPointerDownEvent(e, t) {
                var _this__dotLottieCore;
                (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_post_pointer_down(e, t);
            }
        },
        {
            key: "stateMachinePostPointerMoveEvent",
            value: function stateMachinePostPointerMoveEvent(e, t) {
                var _this__dotLottieCore;
                (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_post_pointer_move(e, t);
            }
        },
        {
            key: "stateMachinePostPointerEnterEvent",
            value: function stateMachinePostPointerEnterEvent(e, t) {
                var _this__dotLottieCore;
                (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_post_pointer_enter(e, t);
            }
        },
        {
            key: "stateMachinePostPointerExitEvent",
            value: function stateMachinePostPointerExitEvent(e, t) {
                var _this__dotLottieCore;
                (_this__dotLottieCore = this._dotLottieCore) === null || _this__dotLottieCore === void 0 ? void 0 : _this__dotLottieCore.sm_post_pointer_exit(e, t);
            }
        },
        {
            key: "_onClick",
            value: function _onClick(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this.stateMachinePostClickEvent(t.x, t.y);
            }
        },
        {
            key: "_onPointerUp",
            value: function _onPointerUp(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this.stateMachinePostPointerUpEvent(t.x, t.y);
            }
        },
        {
            key: "_onPointerDown",
            value: function _onPointerDown(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this.stateMachinePostPointerDownEvent(t.x, t.y);
            }
        },
        {
            key: "_onPointerMove",
            value: function _onPointerMove(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this.stateMachinePostPointerMoveEvent(t.x, t.y);
            }
        },
        {
            key: "_onPointerEnter",
            value: function _onPointerEnter(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this.stateMachinePostPointerEnterEvent(t.x, t.y);
            }
        },
        {
            key: "_onPointerLeave",
            value: function _onPointerLeave(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this.stateMachinePostPointerExitEvent(t.x, t.y);
            }
        },
        {
            key: "_setupStateMachineListeners",
            value: function _setupStateMachineListeners() {
                if ($4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
                    var e = this.stateMachineGetListeners();
                    this._cleanupStateMachineListeners(), e.includes("Click") && (this._boundOnClick = this._onClick.bind(this), this._canvas.addEventListener("click", this._boundOnClick)), e.includes("PointerUp") && (this._boundOnPointerUp = this._onPointerUp.bind(this), this._canvas.addEventListener("pointerup", this._boundOnPointerUp)), e.includes("PointerDown") && (this._boundOnPointerDown = this._onPointerDown.bind(this), this._canvas.addEventListener("pointerdown", this._boundOnPointerDown)), e.includes("PointerMove") && (this._boundOnPointerMove = this._onPointerMove.bind(this), this._canvas.addEventListener("pointermove", this._boundOnPointerMove)), e.includes("PointerEnter") && (this._boundOnPointerEnter = this._onPointerEnter.bind(this), this._canvas.addEventListener("pointerenter", this._boundOnPointerEnter)), e.includes("PointerExit") && (this._boundOnPointerLeave = this._onPointerLeave.bind(this), this._canvas.addEventListener("pointerleave", this._boundOnPointerLeave));
                }
            }
        },
        {
            key: "_cleanupStateMachineListeners",
            value: function _cleanupStateMachineListeners() {
                $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && (this._boundOnClick && (this._canvas.removeEventListener("click", this._boundOnClick), this._boundOnClick = null), this._boundOnPointerUp && (this._canvas.removeEventListener("pointerup", this._boundOnPointerUp), this._boundOnPointerUp = null), this._boundOnPointerDown && (this._canvas.removeEventListener("pointerdown", this._boundOnPointerDown), this._boundOnPointerDown = null), this._boundOnPointerMove && (this._canvas.removeEventListener("pointermove", this._boundOnPointerMove), this._boundOnPointerMove = null), this._boundOnPointerEnter && (this._canvas.removeEventListener("pointerenter", this._boundOnPointerEnter), this._boundOnPointerEnter = null), this._boundOnPointerLeave && (this._canvas.removeEventListener("pointerleave", this._boundOnPointerLeave), this._boundOnPointerLeave = null));
            }
        }
    ], [
        {
            key: "setWasmUrl",
            value: function setWasmUrl(e) {
                $4df2746f4766bf20$var$H().setWasmUrl(e);
            }
        },
        {
            key: "preload",
            value: function preload() {
                return $4df2746f4766bf20$var$H().load();
            }
        },
        {
            key: "registerFont",
            value: function registerFont(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var n, _$e, _, _$r, t1;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $4df2746f4766bf20$var$H().load()
                                ];
                            case 1:
                                _state.sent();
                                if (!(typeof t == "string")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    fetch(t)
                                ];
                            case 2:
                                _$e = _state.sent();
                                if (!_$e.ok) return [
                                    2,
                                    (console.error("Failed to fetch font from URL: ".concat(t, ". Status: ").concat(_$e.status)), !1)
                                ];
                                _ = Uint8Array.bind;
                                return [
                                    4,
                                    _$e.arrayBuffer()
                                ];
                            case 3:
                                n = new (_.apply(Uint8Array, [
                                    void 0,
                                    _state.sent()
                                ]));
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                n = t instanceof Uint8Array ? t : new Uint8Array(t);
                                _state.label = 5;
                            case 5:
                                _$r = $4df2746f4766bf20$var$ie(e, n);
                                return [
                                    2,
                                    (_$r || console.error('Failed to register font "'.concat(e, '". Font data may be invalid.')), _$r)
                                ];
                            case 6:
                                t1 = _state.sent();
                                return [
                                    2,
                                    (console.error('Error registering font "'.concat(e, '":'), t1), !1)
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return xe;
}(), $4df2746f4766bf20$var$Se = function Se() {
    "use strict";
    (0, $4QweW._)(this, Se);
    if ((typeof Worker === "undefined" ? "undefined" : (0, $5djcY._)(Worker)) > "u") throw Error("Worker is not supported in this environment.");
    var e = (typeof globalThis === "undefined" ? "undefined" : (0, $5djcY._)(globalThis)) < "u" && globalThis.__dotLottieWorkerUrl;
    if (e) return new Worker(e);
    var t = new Blob([
        '"use strict";(()=>{var bt=Object.defineProperty;var vt=(n,t,e)=>t in n?bt(n,t,{enumerable:!0,configurable:!0,writable:!0,value:e}):n[t]=e;var u=(n,t,e)=>vt(n,typeof t!="symbol"?t+"":t,e);var Y=class{requestAnimationFrame(t){return requestAnimationFrame(t)}cancelAnimationFrame(t){cancelAnimationFrame(t)}},X=class{constructor(){u(this,"_lastHandleId",0);u(this,"_lastImmediate",null)}requestAnimationFrame(t){return this._lastHandleId>=Number.MAX_SAFE_INTEGER&&(this._lastHandleId=0),this._lastHandleId+=1,this._lastImmediate=setImmediate(()=>{t(performance.now())}),this._lastHandleId}cancelAnimationFrame(t){this._lastImmediate&&clearImmediate(this._lastImmediate)}},N=class{constructor(){u(this,"_strategy");this._strategy=typeof requestAnimationFrame=="function"?new Y:new X}requestAnimationFrame(t){return this._strategy.requestAnimationFrame(t)}cancelAnimationFrame(t){this._strategy.cancelAnimationFrame(t)}};var E=typeof window<"u"&&typeof window.document<"u";var W=new Uint8Array([80,75,3,4]),st=["v","ip","op","layers","fr","w","h"],Z="0.81.0",Q="@lottiefiles/dotlottie-web",ot=.75,it=4;var o,S=new Array(128).fill(void 0);S.push(void 0,null,!0,!1);function _(n){return S[n]}var z=S.length;function m(n){z===S.length&&S.push(S.length+1);let t=z;return z=S[t],S[t]=n,t}function v(n,t){try{return n.apply(this,t)}catch(e){o.__wbindgen_export_0(m(e))}}function L(n){return n==null}var ct=typeof TextDecoder<"u"?new TextDecoder("utf-8",{ignoreBOM:!0,fatal:!0}):{decode:()=>{throw Error("TextDecoder not available")}};typeof TextDecoder<"u"&&ct.decode();var D=null;function V(){return(D===null||D.byteLength===0)&&(D=new Uint8Array(o.memory.buffer)),D}function g(n,t){return n=n>>>0,ct.decode(V().subarray(n,n+t))}var d=0,G=typeof TextEncoder<"u"?new TextEncoder("utf-8"):{encode:()=>{throw Error("TextEncoder not available")}},yt=typeof G.encodeInto=="function"?function(n,t){return G.encodeInto(n,t)}:function(n,t){let e=G.encode(n);return t.set(e),{read:n.length,written:e.length}};function p(n,t,e){if(e===void 0){let l=G.encode(n),y=t(l.length,1)>>>0;return V().subarray(y,y+l.length).set(l),d=l.length,y}let r=n.length,s=t(r,1)>>>0,i=V(),c=0;for(;c<r;c++){let l=n.charCodeAt(c);if(l>127)break;i[s+c]=l}if(c!==r){c!==0&&(n=n.slice(c)),s=e(s,r,r=c+n.length*3,1)>>>0;let l=V().subarray(s+c,s+r),y=yt(n,l);c+=y.written,s=e(s,r,c,1)>>>0}return d=c,s}var T=null;function h(){return(T===null||T.buffer.detached===!0||T.buffer.detached===void 0&&T.buffer!==o.memory.buffer)&&(T=new DataView(o.memory.buffer)),T}function H(n,t){let e=t(n.length*1,1)>>>0;return V().set(n,e/1),d=n.length,e}function Et(n){n<132||(S[n]=z,z=n)}function M(n){let t=_(n);return Et(n),t}var at=typeof FinalizationRegistry>"u"?{register:()=>{},unregister:()=>{}}:new FinalizationRegistry(n=>{o.__wbindgen_export_4.get(n.dtor)(n.a,n.b)});function Mt(n,t,e,r){let s={a:n,b:t,cnt:1,dtor:e},i=(...c)=>{s.cnt++;let l=s.a;s.a=0;try{return r(l,s.b,...c)}finally{--s.cnt===0?(o.__wbindgen_export_4.get(s.dtor)(l,s.b),at.unregister(s)):s.a=l}};return i.original=s,at.register(i,s,s),i}function dt(n,t){let e=p(n,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d,s=H(t,o.__wbindgen_export_1),i=d;return o.register_font(e,r,s,i)!==0}var $=null;function Ct(){return($===null||$.byteLength===0)&&($=new Float32Array(o.memory.buffer)),$}function It(n,t){let e=t(n.length*4,4)>>>0;return Ct().set(n,e/4),d=n.length,e}function Lt(n,t){let e=t(n.length*4,4)>>>0,r=h();for(let s=0;s<n.length;s++)r.setUint32(e+4*s,m(n[s]),!0);return d=n.length,e}function St(n,t,e){o.__wbindgen_export_5(n,t,m(e))}var x=Object.freeze({Forward:0,0:"Forward",Reverse:1,1:"Reverse",Bounce:2,2:"Bounce",ReverseBounce:3,3:"ReverseBounce"}),C=Object.freeze({Idle:0,0:"Idle",Playing:1,1:"Playing",Paused:2,2:"Paused",Stopped:3,3:"Stopped",Tweening:4,4:"Tweening"}),_t=typeof FinalizationRegistry>"u"?{register:()=>{},unregister:()=>{}}:new FinalizationRegistry(n=>o.__wbg_dotlottieplayerwasm_free(n>>>0,1)),j=class{__destroy_into_raw(){let t=this.__wbg_ptr;return this.__wbg_ptr=0,_t.unregister(this),t}free(){let t=this.__destroy_into_raw();o.__wbg_dotlottieplayerwasm_free(t,0)}clear_slot(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_clear_slot(this.__wbg_ptr,e,r)!==0}layout_fit(){let t,e;try{let i=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_layout_fit(i,this.__wbg_ptr);var r=h().getInt32(i+0,!0),s=h().getInt32(i+4,!0);return t=r,e=s,g(r,s)}finally{o.__wbindgen_add_to_stack_pointer(16),o.__wbindgen_export_3(t,e,1)}}loop_count(){return o.dotlottieplayerwasm_loop_count(this.__wbg_ptr)>>>0}poll_event(){let t=o.dotlottieplayerwasm_poll_event(this.__wbg_ptr);return M(t)}reset_slot(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_reset_slot(this.__wbg_ptr,e,r)!==0}set_layout(t,e,r){let s=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),i=d;return o.dotlottieplayerwasm_set_layout(this.__wbg_ptr,s,i,e,r)!==0}set_marker(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;o.dotlottieplayerwasm_set_marker(this.__wbg_ptr,e,r)}clear_slots(){return o.dotlottieplayerwasm_clear_slots(this.__wbg_ptr)!==0}is_complete(){return o.dotlottieplayerwasm_is_complete(this.__wbg_ptr)!==0}reset_slots(){return o.dotlottieplayerwasm_reset_slots(this.__wbg_ptr)!==0}reset_theme(){return o.dotlottieplayerwasm_reset_theme(this.__wbg_ptr)!==0}segment_end(){return o.dotlottieplayerwasm_segment_end(this.__wbg_ptr)}set_quality(t){return o.dotlottieplayerwasm_set_quality(this.__wbg_ptr,t)!==0}set_segment(t,e){return o.dotlottieplayerwasm_set_segment(this.__wbg_ptr,t,e)!==0}sm_set_seed(t){return o.dotlottieplayerwasm_sm_set_seed(this.__wbg_ptr,t)!==0}static unload_font(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_unload_font(e,r)!==0}animation_id(){try{let r=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_animation_id(r,this.__wbg_ptr);var t=h().getInt32(r+0,!0),e=h().getInt32(r+4,!0);let s;return t!==0&&(s=g(t,e).slice(),o.__wbindgen_export_3(t,e*1,1)),s}finally{o.__wbindgen_add_to_stack_pointer(16)}}audio_volume(){return o.dotlottieplayerwasm_audio_volume(this.__wbg_ptr)}background_a(){return o.dotlottieplayerwasm_background_a(this.__wbg_ptr)}background_b(){return o.dotlottieplayerwasm_background_b(this.__wbg_ptr)}background_g(){return o.dotlottieplayerwasm_background_g(this.__wbg_ptr)}background_r(){return o.dotlottieplayerwasm_background_r(this.__wbg_ptr)}clear_marker(){o.dotlottieplayerwasm_clear_marker(this.__wbg_ptr)}emit_on_loop(){o.dotlottieplayerwasm_emit_on_loop(this.__wbg_ptr)}get_slot_ids(){let t=o.dotlottieplayerwasm_get_slot_ids(this.__wbg_ptr);return M(t)}get_slot_str(t){try{let s=o.__wbindgen_add_to_stack_pointer(-16),i=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;o.dotlottieplayerwasm_get_slot_str(s,this.__wbg_ptr,i,c);var e=h().getInt32(s+0,!0),r=h().getInt32(s+4,!0);let l;return e!==0&&(l=g(e,r).slice(),o.__wbindgen_export_3(e,r*1,1)),l}finally{o.__wbindgen_add_to_stack_pointer(16)}}marker_names(){let t=o.dotlottieplayerwasm_marker_names(this.__wbg_ptr);return M(t)}set_autoplay(t){o.dotlottieplayerwasm_set_autoplay(this.__wbg_ptr,t)}set_slot_str(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d,i=p(e,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;return o.dotlottieplayerwasm_set_slot_str(this.__wbg_ptr,r,s,i,c)!==0}set_viewport(t,e,r,s){return o.dotlottieplayerwasm_set_viewport(this.__wbg_ptr,t,e,r,s)!==0}total_frames(){return o.dotlottieplayerwasm_total_frames(this.__wbg_ptr)}clear_segment(){return o.dotlottieplayerwasm_clear_segment(this.__wbg_ptr)!==0}current_frame(){return o.dotlottieplayerwasm_current_frame(this.__wbg_ptr)}get_slot_type(t){try{let s=o.__wbindgen_add_to_stack_pointer(-16),i=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;o.dotlottieplayerwasm_get_slot_type(s,this.__wbg_ptr,i,c);var e=h().getInt32(s+0,!0),r=h().getInt32(s+4,!0);let l;return e!==0&&(l=g(e,r).slice(),o.__wbindgen_export_3(e,r*1,1)),l}finally{o.__wbindgen_add_to_stack_pointer(16)}}get_slots_str(){let t,e;try{let i=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_get_slots_str(i,this.__wbg_ptr);var r=h().getInt32(i+0,!0),s=h().getInt32(i+4,!0);return t=r,e=s,g(r,s)}finally{o.__wbindgen_add_to_stack_pointer(16),o.__wbindgen_export_3(t,e,1)}}get_transform(){let t=o.dotlottieplayerwasm_get_transform(this.__wbg_ptr);return M(t)}segment_start(){return o.dotlottieplayerwasm_segment_start(this.__wbg_ptr)}set_slots_str(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_set_slots_str(this.__wbg_ptr,e,r)!==0}set_text_slot(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d,i=p(e,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;return o.dotlottieplayerwasm_set_text_slot(this.__wbg_ptr,r,s,i,c)!==0}set_transform(t){let e=It(t,o.__wbindgen_export_1),r=d;return o.dotlottieplayerwasm_set_transform(this.__wbg_ptr,e,r)!==0}sm_get_inputs(){let t=o.dotlottieplayerwasm_sm_get_inputs(this.__wbg_ptr);return M(t)}sm_poll_event(){let t=o.dotlottieplayerwasm_sm_poll_event(this.__wbg_ptr);return M(t)}sm_post_click(t,e){o.dotlottieplayerwasm_sm_post_click(this.__wbg_ptr,t,e)}animation_size(){let t=o.dotlottieplayerwasm_animation_size(this.__wbg_ptr);return M(t)}current_marker(){try{let r=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_current_marker(r,this.__wbg_ptr);var t=h().getInt32(r+0,!0),e=h().getInt32(r+4,!0);let s;return t!==0&&(s=g(t,e).slice(),o.__wbindgen_export_3(t,e*1,1)),s}finally{o.__wbindgen_add_to_stack_pointer(16)}}layout_align_x(){return o.dotlottieplayerwasm_layout_align_x(this.__wbg_ptr)}layout_align_y(){return o.dotlottieplayerwasm_layout_align_y(this.__wbg_ptr)}load_animation(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_load_animation(this.__wbg_ptr,e,r)!==0}loop_animation(){return o.dotlottieplayerwasm_loop_animation(this.__wbg_ptr)!==0}set_background(t,e,r,s){return o.dotlottieplayerwasm_set_background(this.__wbg_ptr,t,e,r,s)!==0}set_color_slot(t,e,r,s){let i=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;return o.dotlottieplayerwasm_set_color_slot(this.__wbg_ptr,i,c,e,r,s)!==0}set_image_slot(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d,i=p(e,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;return o.dotlottieplayerwasm_set_image_slot(this.__wbg_ptr,r,s,i,c)!==0}set_loop_count(t){o.dotlottieplayerwasm_set_loop_count(this.__wbg_ptr,t)}set_theme_data(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_set_theme_data(this.__wbg_ptr,e,r)!==0}sm_reset_input(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;o.dotlottieplayerwasm_sm_reset_input(this.__wbg_ptr,e,r)}manifest_string(){let t,e;try{let i=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_manifest_string(i,this.__wbg_ptr);var r=h().getInt32(i+0,!0),s=h().getInt32(i+4,!0);return t=r,e=s,g(r,s)}finally{o.__wbindgen_add_to_stack_pointer(16),o.__wbindgen_export_3(t,e,1)}}set_scalar_slot(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d;return o.dotlottieplayerwasm_set_scalar_slot(this.__wbg_ptr,r,s,e)!==0}set_vector_slot(t,e,r){let s=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),i=d;return o.dotlottieplayerwasm_set_vector_slot(this.__wbg_ptr,s,i,e,r)!==0}setup_sw_target(t,e){return o.dotlottieplayerwasm_setup_sw_target(this.__wbg_ptr,t,e)!==0}get_pixel_buffer(){let t=o.dotlottieplayerwasm_get_pixel_buffer(this.__wbg_ptr);return M(t)}set_audio_volume(t){o.dotlottieplayerwasm_set_audio_volume(this.__wbg_ptr,t)}sm_current_state(){let t,e;try{let i=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_sm_current_state(i,this.__wbg_ptr);var r=h().getInt32(i+0,!0),s=h().getInt32(i+4,!0);return t=r,e=s,g(r,s)}finally{o.__wbindgen_add_to_stack_pointer(16),o.__wbindgen_export_3(t,e,1)}}state_machine_id(){try{let r=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_state_machine_id(r,this.__wbg_ptr);var t=h().getInt32(r+0,!0),e=h().getInt32(r+4,!0);let s;return t!==0&&(s=g(t,e).slice(),o.__wbindgen_export_3(t,e*1,1)),s}finally{o.__wbindgen_add_to_stack_pointer(16)}}get_state_machine(t){try{let s=o.__wbindgen_add_to_stack_pointer(-16),i=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;o.dotlottieplayerwasm_get_state_machine(s,this.__wbg_ptr,i,c);var e=h().getInt32(s+0,!0),r=h().getInt32(s+4,!0);let l;return e!==0&&(l=g(e,r).slice(),o.__wbindgen_export_3(e,r*1,1)),l}finally{o.__wbindgen_add_to_stack_pointer(16)}}set_position_slot(t,e,r){let s=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),i=d;return o.dotlottieplayerwasm_set_position_slot(this.__wbg_ptr,s,i,e,r)!==0}current_loop_count(){return o.dotlottieplayerwasm_current_loop_count(this.__wbg_ptr)>>>0}set_asset_resolver(t){o.dotlottieplayerwasm_set_asset_resolver(this.__wbg_ptr,L(t)?0:m(t))}sm_framework_setup(){let t=o.dotlottieplayerwasm_sm_framework_setup(this.__wbg_ptr);return M(t)}sm_post_pointer_up(t,e){o.dotlottieplayerwasm_sm_post_pointer_up(this.__wbg_ptr,t,e)}state_machine_load(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_state_machine_load(this.__wbg_ptr,e,r)!==0}load_dotlottie_data(t){let e=H(t,o.__wbindgen_export_1),r=d;return o.dotlottieplayerwasm_load_dotlottie_data(this.__wbg_ptr,e,r)!==0}sm_get_string_input(t){try{let s=o.__wbindgen_add_to_stack_pointer(-16),i=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;o.dotlottieplayerwasm_sm_get_string_input(s,this.__wbg_ptr,i,c);var e=h().getInt32(s+0,!0),r=h().getInt32(s+4,!0);let l;return e!==0&&(l=g(e,r).slice(),o.__wbindgen_export_3(e,r*1,1)),l}finally{o.__wbindgen_add_to_stack_pointer(16)}}sm_set_string_input(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d,i=p(e,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;return o.dotlottieplayerwasm_sm_set_string_input(this.__wbg_ptr,r,s,i,c)!==0}sm_get_boolean_input(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d,s=o.dotlottieplayerwasm_sm_get_boolean_input(this.__wbg_ptr,e,r);return s===16777215?void 0:s!==0}sm_get_numeric_input(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d,s=o.dotlottieplayerwasm_sm_get_numeric_input(this.__wbg_ptr,e,r);return s===4294967297?void 0:s}sm_post_pointer_down(t,e){o.dotlottieplayerwasm_sm_post_pointer_down(this.__wbg_ptr,t,e)}sm_post_pointer_exit(t,e){o.dotlottieplayerwasm_sm_post_pointer_exit(this.__wbg_ptr,t,e)}sm_post_pointer_move(t,e){o.dotlottieplayerwasm_sm_post_pointer_move(this.__wbg_ptr,t,e)}sm_set_boolean_input(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d;return o.dotlottieplayerwasm_sm_set_boolean_input(this.__wbg_ptr,r,s,e)!==0}sm_set_numeric_input(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d;return o.dotlottieplayerwasm_sm_set_numeric_input(this.__wbg_ptr,r,s,e)!==0}state_machine_unload(){o.dotlottieplayerwasm_state_machine_unload(this.__wbg_ptr)}sm_post_pointer_enter(t,e){o.dotlottieplayerwasm_sm_post_pointer_enter(this.__wbg_ptr,t,e)}load_animation_from_id(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_load_animation_from_id(this.__wbg_ptr,e,r)!==0}sm_poll_internal_event(){let t=o.dotlottieplayerwasm_sm_poll_internal_event(this.__wbg_ptr);return M(t)}use_frame_interpolation(){return o.dotlottieplayerwasm_use_frame_interpolation(this.__wbg_ptr)!==0}reset_current_loop_count(){o.dotlottieplayerwasm_reset_current_loop_count(this.__wbg_ptr)}sm_override_current_state(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d;return o.dotlottieplayerwasm_sm_override_current_state(this.__wbg_ptr,r,s,e)!==0}state_machine_load_from_id(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_state_machine_load_from_id(this.__wbg_ptr,e,r)!==0}set_use_frame_interpolation(t){o.dotlottieplayerwasm_set_use_frame_interpolation(this.__wbg_ptr,t)}constructor(){let t=o.dotlottieplayerwasm_new();return this.__wbg_ptr=t>>>0,_t.register(this,this.__wbg_ptr,this),this}mode(){return o.dotlottieplayerwasm_mode(this.__wbg_ptr)}play(){return o.dotlottieplayerwasm_play(this.__wbg_ptr)!==0}stop(){return o.dotlottieplayerwasm_stop(this.__wbg_ptr)!==0}tick(t){return o.dotlottieplayerwasm_tick(this.__wbg_ptr,t)!==0}pause(){return o.dotlottieplayerwasm_pause(this.__wbg_ptr)!==0}speed(){return o.dotlottieplayerwasm_speed(this.__wbg_ptr)}width(){return o.dotlottieplayerwasm_width(this.__wbg_ptr)>>>0}height(){return o.dotlottieplayerwasm_height(this.__wbg_ptr)>>>0}render(){return o.dotlottieplayerwasm_render(this.__wbg_ptr)!==0}status(){return o.dotlottieplayerwasm_status(this.__wbg_ptr)}markers(){let t=o.dotlottieplayerwasm_markers(this.__wbg_ptr);return M(t)}sm_fire(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_sm_fire(this.__wbg_ptr,e,r)!==0}sm_stop(){return o.dotlottieplayerwasm_sm_stop(this.__wbg_ptr)!==0}sm_tick(t){return o.dotlottieplayerwasm_sm_tick(this.__wbg_ptr,t)!==0}autoplay(){return o.dotlottieplayerwasm_autoplay(this.__wbg_ptr)!==0}duration(){return o.dotlottieplayerwasm_duration(this.__wbg_ptr)}set_loop(t){o.dotlottieplayerwasm_set_loop(this.__wbg_ptr,t)}set_mode(t){o.dotlottieplayerwasm_set_mode(this.__wbg_ptr,t)}sm_start(t,e){let r=Lt(e,o.__wbindgen_export_1),s=d;return o.dotlottieplayerwasm_sm_start(this.__wbg_ptr,t,r,s)!==0}theme_id(){try{let r=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_theme_id(r,this.__wbg_ptr);var t=h().getInt32(r+0,!0),e=h().getInt32(r+4,!0);let s;return t!==0&&(s=g(t,e).slice(),o.__wbindgen_export_3(t,e*1,1)),s}finally{o.__wbindgen_add_to_stack_pointer(16)}}load_font(t,e){let r=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),s=d,i=H(e,o.__wbindgen_export_1),c=d;return o.dotlottieplayerwasm_load_font(this.__wbg_ptr,r,s,i,c)!==0}set_frame(t){return o.dotlottieplayerwasm_set_frame(this.__wbg_ptr,t)!==0}set_speed(t){o.dotlottieplayerwasm_set_speed(this.__wbg_ptr,t)}set_theme(t){let e=p(t,o.__wbindgen_export_1,o.__wbindgen_export_2),r=d;return o.dotlottieplayerwasm_set_theme(this.__wbg_ptr,e,r)!==0}sm_status(){let t,e;try{let i=o.__wbindgen_add_to_stack_pointer(-16);o.dotlottieplayerwasm_sm_status(i,this.__wbg_ptr);var r=h().getInt32(i+0,!0),s=h().getInt32(i+4,!0);return t=r,e=s,g(r,s)}finally{o.__wbindgen_add_to_stack_pointer(16),o.__wbindgen_export_3(t,e,1)}}};async function xt(n,t){if(typeof Response=="function"&&n instanceof Response){if(typeof WebAssembly.instantiateStreaming=="function")try{return await WebAssembly.instantiateStreaming(n,t)}catch(r){if(n.headers.get("Content-Type")!="application/wasm")console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\\n",r);else throw r}let e=await n.arrayBuffer();return await WebAssembly.instantiate(e,t)}else{let e=await WebAssembly.instantiate(n,t);return e instanceof WebAssembly.Instance?{instance:e,module:n}:e}}function Rt(){let n={};return n.wbg={},n.wbg.__wbg_appendChild_8204974b7328bf98=function(){return v(function(t,e){let r=_(t).appendChild(_(e));return m(r)},arguments)},n.wbg.__wbg_body_942ea927546a04ba=function(t){let e=_(t).body;return L(e)?0:m(e)},n.wbg.__wbg_buffer_609cc3eee51ed158=function(t){let e=_(t).buffer;return m(e)},n.wbg.__wbg_call_672a4d21634d4a24=function(){return v(function(t,e){let r=_(t).call(_(e));return m(r)},arguments)},n.wbg.__wbg_call_7cccdd69e0791ae2=function(){return v(function(t,e,r){let s=_(t).call(_(e),_(r));return m(s)},arguments)},n.wbg.__wbg_catch_a6e601879b2610e9=function(t,e){let r=_(t).catch(_(e));return m(r)},n.wbg.__wbg_createElement_8c9931a732ee2fea=function(){return v(function(t,e,r){let s=_(t).createElement(g(e,r));return m(s)},arguments)},n.wbg.__wbg_createObjectURL_6e98d2f9c7bd9764=function(){return v(function(t,e){let r=URL.createObjectURL(_(e)),s=p(r,o.__wbindgen_export_1,o.__wbindgen_export_2),i=d;h().setInt32(t+4,i,!0),h().setInt32(t+0,s,!0)},arguments)},n.wbg.__wbg_currentTime_7940fe39798a1ca0=function(t){return _(t).currentTime},n.wbg.__wbg_data_d1ed736c1e42b10e=function(t,e){let r=_(e).data,s=H(r,o.__wbindgen_export_1),i=d;h().setInt32(t+4,i,!0),h().setInt32(t+0,s,!0)},n.wbg.__wbg_document_d249400bd7bd996d=function(t){let e=_(t).document;return L(e)?0:m(e)},n.wbg.__wbg_drawImage_803dcc46897223c9=function(){return v(function(t,e,r,s){_(t).drawImage(_(e),r,s)},arguments)},n.wbg.__wbg_duration_4d32c501d87796c1=function(t){return _(t).duration},n.wbg.__wbg_error_7534b8e9a36f1ab4=function(t,e){let r,s;try{r=t,s=e,console.error(g(t,e))}finally{o.__wbindgen_export_3(r,s,1)}},n.wbg.__wbg_getContext_e9cf379449413580=function(){return v(function(t,e,r){let s=_(t).getContext(g(e,r));return L(s)?0:m(s)},arguments)},n.wbg.__wbg_getImageData_c02374a30b126dab=function(){return v(function(t,e,r,s,i){let c=_(t).getImageData(e,r,s,i);return m(c)},arguments)},n.wbg.__wbg_instanceof_CanvasRenderingContext2d_df82a4d3437bf1cc=function(t){let e;try{e=_(t)instanceof CanvasRenderingContext2D}catch{e=!1}return e},n.wbg.__wbg_instanceof_HtmlCanvasElement_2ea67072a7624ac5=function(t){let e;try{e=_(t)instanceof HTMLCanvasElement}catch{e=!1}return e},n.wbg.__wbg_instanceof_HtmlVideoElement_7f414b32f362e317=function(t){let e;try{e=_(t)instanceof HTMLVideoElement}catch{e=!1}return e},n.wbg.__wbg_instanceof_Window_def73ea0955fc569=function(t){let e;try{e=_(t)instanceof Window}catch{e=!1}return e},n.wbg.__wbg_length_a446193dc22c12f8=function(t){return _(t).length},n.wbg.__wbg_load_2671477a3293aadb=function(t){_(t).load()},n.wbg.__wbg_new_405e22f390576ce2=function(){let t=new Object;return m(t)},n.wbg.__wbg_new_78feb108b6472713=function(){let t=new Array;return m(t)},n.wbg.__wbg_new_8a6f238a6ece86ea=function(){let t=new Error;return m(t)},n.wbg.__wbg_new_a12002a7f91c75be=function(t){let e=new Uint8Array(_(t));return m(e)},n.wbg.__wbg_newnoargs_105ed471475aaf50=function(t,e){let r=new Function(g(t,e));return m(r)},n.wbg.__wbg_newwithbyteoffsetandlength_d97e637ebe145a9a=function(t,e,r){let s=new Uint8Array(_(t),e>>>0,r>>>0);return m(s)},n.wbg.__wbg_newwithlength_5a5efe313cfd59f1=function(t){let e=new Float32Array(t>>>0);return m(e)},n.wbg.__wbg_newwithsrc_20307ca7e8762a81=function(){return v(function(t,e){let r=new Audio(g(t,e));return m(r)},arguments)},n.wbg.__wbg_newwithu8arraysequenceandoptions_068570c487f69127=function(){return v(function(t,e){let r=new Blob(_(t),_(e));return m(r)},arguments)},n.wbg.__wbg_pause_b74c96d69f769518=function(){return v(function(t){_(t).pause()},arguments)},n.wbg.__wbg_paused_9b2affc0a8a62e86=function(t){return _(t).paused},n.wbg.__wbg_play_f6ec5fc4e84b0d26=function(){return v(function(t){let e=_(t).play();return m(e)},arguments)},n.wbg.__wbg_push_737cfc8c1432c2c6=function(t,e){return _(t).push(_(e))},n.wbg.__wbg_readyState_017c08aa5e73517e=function(t){return _(t).readyState},n.wbg.__wbg_remove_e2d2659f3128c045=function(t){_(t).remove()},n.wbg.__wbg_revokeObjectURL_27267efebeb457c7=function(){return v(function(t,e){URL.revokeObjectURL(g(t,e))},arguments)},n.wbg.__wbg_seeking_c0427be38e698dcd=function(t){return _(t).seeking},n.wbg.__wbg_setAttribute_2704501201f15687=function(){return v(function(t,e,r,s,i){_(t).setAttribute(g(e,r),g(s,i))},arguments)},n.wbg.__wbg_set_65595bdd868b3009=function(t,e,r){_(t).set(_(e),r>>>0)},n.wbg.__wbg_set_bb8cecf6a62b9f46=function(){return v(function(t,e,r){return Reflect.set(_(t),_(e),_(r))},arguments)},n.wbg.__wbg_setcssText_e018c236104b0233=function(t,e,r){_(t).cssText=g(e,r)},n.wbg.__wbg_setcurrentTime_64727eddd3966512=function(t,e){_(t).currentTime=e},n.wbg.__wbg_setheight_da683a33fa99843c=function(t,e){_(t).height=e>>>0},n.wbg.__wbg_setindex_4e73afdcd9bb95cd=function(t,e,r){_(t)[e>>>0]=r},n.wbg.__wbg_setmuted_e93fc48340c43e67=function(t,e){_(t).muted=e!==0},n.wbg.__wbg_setplaybackRate_f5c3b8896f82425e=function(t,e){_(t).playbackRate=e},n.wbg.__wbg_setpreload_d2fb02758e3f8e3a=function(t,e,r){_(t).preload=g(e,r)},n.wbg.__wbg_setsrc_3a759736e2659904=function(t,e,r){_(t).src=g(e,r)},n.wbg.__wbg_settype_39ed370d3edd403c=function(t,e,r){_(t).type=g(e,r)},n.wbg.__wbg_setvolume_3895e06a030ca4f7=function(t,e){_(t).volume=e},n.wbg.__wbg_setwidth_c5fed9f5e7f0b406=function(t,e){_(t).width=e>>>0},n.wbg.__wbg_stack_0ed75d68575b0f3c=function(t,e){let r=_(e).stack,s=p(r,o.__wbindgen_export_1,o.__wbindgen_export_2),i=d;h().setInt32(t+4,i,!0),h().setInt32(t+0,s,!0)},n.wbg.__wbg_static_accessor_GLOBAL_88a902d13a557d07=function(){let t=typeof global>"u"?null:global;return L(t)?0:m(t)},n.wbg.__wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0=function(){let t=typeof globalThis>"u"?null:globalThis;return L(t)?0:m(t)},n.wbg.__wbg_static_accessor_SELF_37c5d418e4bf5819=function(){let t=typeof self>"u"?null:self;return L(t)?0:m(t)},n.wbg.__wbg_static_accessor_WINDOW_5de37043a91a9c40=function(){let t=typeof window>"u"?null:window;return L(t)?0:m(t)},n.wbg.__wbg_style_fb30c14e5815805c=function(t){let e=_(t).style;return m(e)},n.wbg.__wbg_videoHeight_3a43327a766c1f03=function(t){return _(t).videoHeight},n.wbg.__wbg_videoWidth_4b400cf6f4744a4d=function(t){return _(t).videoWidth},n.wbg.__wbindgen_cb_drop=function(t){let e=M(t).original;return e.cnt--==1?(e.a=0,!0):!1},n.wbg.__wbindgen_closure_wrapper109=function(t,e,r){let s=Mt(t,e,7,St);return m(s)},n.wbg.__wbindgen_is_null=function(t){return _(t)===null},n.wbg.__wbindgen_is_undefined=function(t){return _(t)===void 0},n.wbg.__wbindgen_memory=function(){let t=o.memory;return m(t)},n.wbg.__wbindgen_number_new=function(t){return m(t)},n.wbg.__wbindgen_object_clone_ref=function(t){let e=_(t);return m(e)},n.wbg.__wbindgen_object_drop_ref=function(t){M(t)},n.wbg.__wbindgen_string_get=function(t,e){let r=_(e),s=typeof r=="string"?r:void 0;var i=L(s)?0:p(s,o.__wbindgen_export_1,o.__wbindgen_export_2),c=d;h().setInt32(t+4,c,!0),h().setInt32(t+0,i,!0)},n.wbg.__wbindgen_string_new=function(t,e){let r=g(t,e);return m(r)},n.wbg.__wbindgen_throw=function(t,e){throw new Error(g(t,e))},n}function kt(n,t){return o=n.exports,lt.__wbindgen_wasm_module=t,T=null,$=null,D=null,o}async function lt(n){if(o!==void 0)return o;if(typeof n<"u"&&(Object.getPrototypeOf(n)===Object.prototype?{module_or_path:n}=n:console.warn("using deprecated parameters for the initialization function; pass a single object instead")),typeof n>"u")throw new Error("WASM module URL must be provided via DotLottieWasmLoader or setWasmUrl().");let t=Rt();(typeof n=="string"||typeof Request=="function"&&n instanceof Request||typeof URL=="function"&&n instanceof URL)&&(n=fetch(n));let{instance:e,module:r}=await xt(await n,t);return kt(e,r)}var ut=lt;var J=class{constructor(){u(this,"_eventListeners",new Map)}addEventListener(t,e){let r=this._eventListeners.get(t);r||(r=new Set,this._eventListeners.set(t,r)),r.add(e)}removeEventListener(t,e){let r=this._eventListeners.get(t);r&&(e?(r.delete(e),r.size===0&&this._eventListeners.delete(t)):this._eventListeners.delete(t))}dispatch(t){this._eventListeners.get(t.type)?.forEach(r=>r(t))}removeAllEventListeners(){this._eventListeners.clear()}};var b=class b{static _initializeObserver(){if(b._observer)return;let t=e=>{e.forEach(r=>{let s=b._observedCanvases.get(r.target);s&&(r.isIntersecting?s.unfreeze():s.freeze())})};b._observer=new IntersectionObserver(t,{threshold:0})}static observe(t,e){b._initializeObserver(),!b._observedCanvases.has(t)&&(b._observedCanvases.set(t,e),b._observer?.observe(t))}static unobserve(t){b._observer?.unobserve(t),b._observedCanvases.delete(t),b._observedCanvases.size===0&&(b._observer?.disconnect(),b._observer=null)}};u(b,"_observer",null),u(b,"_observedCanvases",new Map);var R=b;var f=class f{static _initializeObserver(){if(f._observer)return;let t=e=>{e.forEach(r=>{let s=f._observedCanvases.get(r.target);if(!s)return;let[i,c]=s;clearTimeout(c);let l=setTimeout(()=>{i.resize()},100);f._observedCanvases.set(r.target,[i,l])})};f._observer=new ResizeObserver(t)}static observe(t,e){f._initializeObserver(),!f._observedCanvases.has(t)&&(f._observedCanvases.set(t,[e,0]),f._observer?.observe(t))}static unobserve(t){let e=f._observedCanvases.get(t);if(e){let r=e[1];r&&clearTimeout(r)}f._observer?.unobserve(t),f._observedCanvases.delete(t),!f._observedCanvases.size&&f._observer&&(f._observer.disconnect(),f._observer=null)}};u(f,"_observer",null),u(f,"_observedCanvases",new Map);var k=f;function Pt(n){return/^#([\\da-f]{6}|[\\da-f]{8})$/iu.test(n)}function pt(n){if(!Pt(n))return[0,0,0,0];let t=n.replace("#","");t=t.length===6?`${t}ff`:t;let e=parseInt(t.slice(0,2),16)/255,r=parseInt(t.slice(2,4),16)/255,s=parseInt(t.slice(4,6),16)/255,i=parseInt(t.slice(6,8),16)/255;return[e,r,s,i]}function q(n){if(n.byteLength<4)return!1;let t=new Uint8Array(n.slice(0,W.byteLength));for(let e=0;e<W.length;e+=1)if(W[e]!==t[e])return!1;return!0}function Tt(n){return st.every(t=>Object.hasOwn(n,t))}function tt(n){return typeof n=="string"?/^\\s*\\{/u.test(n)&&/\\}\\s*$/u.test(n):Tt(n)}function et(){return 1+((E?window.devicePixelRatio:1)-1)*ot}function U(n){let t=n.getBoundingClientRect(),e=window.innerHeight||document.documentElement.clientHeight,r=window.innerWidth||document.documentElement.clientWidth;return!(t.bottom<0||t.top>e||t.right<0||t.left>r)}function A(n){let t=n.target;if(t instanceof HTMLCanvasElement){let e=t.getBoundingClientRect();if(e.width===0||e.height===0||t.width===0||t.height===0)return null;let r=t.width/e.width,s=t.height/e.height,i=(n.clientX-e.left)*r,c=(n.clientY-e.top)*s;return!Number.isFinite(i)||!Number.isFinite(c)||Number.isNaN(i)||Number.isNaN(c)?null:{x:i,y:c}}return null}function At(n){return new Promise((t,e)=>{let r=new FileReader;r.onerror=()=>e(r.error??new Error("Failed to read image slot source")),r.onload=()=>t(r.result),r.readAsDataURL(n)})}async function ht(n){if(!/^https?:\\/\\//i.test(n))return n;let t=await fetch(n);if(!t.ok)throw new Error(`Failed to fetch image slot source from URL: ${n}. ${t.status}: ${t.statusText}`);return At(await t.blob())}function mt(n){let t=n.replace("OpenUrl: ",""),e=t.indexOf(" | Target: "),r,s;e===-1?(r=t,s="_blank"):(r=t.substring(0,e),s=t.substring(e+11)),window.open(r,s)}function gt(n,t,e){let r=null,s=t,i=e;async function c(w){await n({module_or_path:w})}async function l(w){let I=await fetch(w);if(!I.ok)throw new Error(`fetch ${w} responded with ${I.status} ${I.statusText}`);let P=await I.arrayBuffer();await n({module_or_path:P})}async function y(w,I){try{return await w(I),null}catch(P){return P}}return{load(){if(!r){let w=s,I=null;I=(async()=>{let P=await y(c,w);if(!P)return;console.warn(`Primary WASM load failed from ${w}: ${P.message}`);let O=null;if(i!==null){if(console.warn(`Attempting to load WASM from backup URL: ${i}`),O=await y(c,i),!O)return;console.warn(`Backup WASM load failed from ${i}: ${O.message}`)}console.warn("Retrying WASM load with buffered instantiation");let B=await y(l,w);if(B&&(console.warn(`Buffered WASM load from ${w} failed: ${B.message}`),!(i!==null&&(B=await y(l,i),!B))))throw console.error(`Primary WASM URL failed: ${P.message}`),O&&console.error(`Backup WASM URL failed: ${O.message}`),console.error(`Buffered fallback failed: ${B.message}`),r===I&&(r=null),new Error("WASM loading failed from all sources.")})(),r=I}return r},setWasmUrl(w){if(typeof w!="string"||w.trim()==="")throw new TypeError("setWasmUrl() expects a non-empty URL string");i=null,w!==s&&(s=w,r=null)}}}var ft=null;function K(){return ft??(ft=gt(ut,`https://cdn.jsdelivr.net/npm/${Q}@${Z}/dist/dotlottie-player.wasm`,`https://unpkg.com/${Q}@${Z}/dist/dotlottie-player.wasm`)),ft}var nt=n=>{switch(n){case"reverse":return x.Reverse;case"bounce":return x.Bounce;case"reverse-bounce":return x.ReverseBounce;default:return x.Forward}},wt=n=>{switch(n){case x.Reverse:return"reverse";case x.Bounce:return"bounce";case x.ReverseBounce:return"reverse-bounce";default:return"forward"}},Ft=n=>{switch(n){case"contain":return"contain";case"cover":return"cover";case"fill":return"fill";case"fit-height":return"fit-height";case"fit-width":return"fit-width";case"none":return"none";default:return"contain"}},F=class{constructor(t){u(this,"_canvas",null);u(this,"_pendingLoad",null);u(this,"_srcFetchAbort",null);u(this,"_context",null);u(this,"_eventManager");u(this,"_animationFrameId",null);u(this,"_frameManager");u(this,"_boundAnimationLoop");u(this,"_dotLottieCore",null);u(this,"_stateMachineId","");u(this,"_stateMachineConfig",null);u(this,"_isStateMachineRunning",!1);u(this,"_renderConfig",{});u(this,"_isFrozen",!1);u(this,"_backgroundColor",null);u(this,"_lastFrameTime",null);u(this,"_boundOnClick",null);u(this,"_boundOnPointerUp",null);u(this,"_boundOnPointerDown",null);u(this,"_boundOnPointerMove",null);u(this,"_boundOnPointerEnter",null);u(this,"_boundOnPointerLeave",null);u(this,"_bufferMismatchCount",0);u(this,"_lastExpectedBufferSize",0);u(this,"_cachedImageData",null);u(this,"_cachedImageDataBuffer",null);u(this,"_cachedImageDataByteOffset",0);u(this,"_marker","");u(this,"_segment",null);this._canvas=t.canvas??null,this._eventManager=new J,this._frameManager=new N,this._boundAnimationLoop=this._animationLoop.bind(this),this._renderConfig={...t.renderConfig,devicePixelRatio:t.renderConfig?.devicePixelRatio||et(),freezeOnOffscreen:t.renderConfig?.freezeOnOffscreen??!0};let e=null;t.src&&!t.data&&(this._srcFetchAbort=new AbortController,e=this._fetchData(t.src,this._srcFetchAbort.signal),e.catch(()=>{})),this._initWasm().then(()=>{this._dotLottieCore=this._createCore(),this._dotLottieCore.set_autoplay(t.autoplay??!1),this._dotLottieCore.set_loop(t.loop??!1),this._dotLottieCore.set_loop_count(t.loopCount??0),this._dotLottieCore.set_mode(nt(t.mode??"forward")),this._dotLottieCore.set_speed(t.speed??1),this._dotLottieCore.set_use_frame_interpolation(t.useFrameInterpolation??!0),t.segment&&t.segment.length===2&&(this._segment=[t.segment[0],t.segment[1]],this._dotLottieCore.set_segment(this._segment[0],this._segment[1])),this._marker=t.marker??"",this._marker&&this._dotLottieCore.set_marker(this._marker),this._dotLottieCore.set_layout(t.layout?.fit??"contain",t.layout?.align?.[0]??.5,t.layout?.align?.[1]??.5),this._applyAssetResolver(t.assetResolver??null),this._stateMachineId=t.stateMachineId??"",this._stateMachineConfig=t.stateMachineConfig??null,this._onCoreCreated(),this._eventManager.dispatch({type:"ready"}),t.data?this._canvas?this._loadFromData(t.data):this._pendingLoad={data:t.data}:t.src&&(this._canvas?this._loadFromSrc(t.src,e):this._pendingLoad={src:t.src,dataPromise:e}),t.backgroundColor&&this.setBackgroundColor(t.backgroundColor)}).catch(r=>{this._srcFetchAbort?.abort(),console.error("[dotlottie-web] Initialization failed:",r),this._eventManager.dispatch({type:"loadError",error:new Error(`Failed to load wasm module: ${r}`)})})}async _initWasm(){return K().load()}_createCore(){return new j}_onCoreCreated(){}_setupTarget(t,e){return this._dotLottieCore?this._dotLottieCore.setup_sw_target(t,e):!1}_drainPlayerEvents({skipFrame:t=!1}={}){if(this._dotLottieCore)for(;;){let e=this._dotLottieCore.poll_event();if(e==null)break;switch(e.type){case"Load":setTimeout(()=>this._eventManager.dispatch({type:"load"}),0);break;case"LoadError":setTimeout(()=>this._eventManager.dispatch({type:"loadError",error:new Error("failed to load")}),0);break;case"Play":queueMicrotask(()=>this._eventManager.dispatch({type:"play"}));break;case"Pause":queueMicrotask(()=>this._eventManager.dispatch({type:"pause"}));break;case"Stop":queueMicrotask(()=>this._eventManager.dispatch({type:"stop"}));break;case"Frame":{let r=e.frameNo??0;t||queueMicrotask(()=>this._eventManager.dispatch({type:"frame",currentFrame:r}));break}case"Render":{let r=e.frameNo??0;t||queueMicrotask(()=>this._eventManager.dispatch({type:"render",currentFrame:r}));break}case"Loop":{let r=e.loopCount??0;queueMicrotask(()=>this._eventManager.dispatch({type:"loop",loopCount:r}));break}case"Complete":queueMicrotask(()=>this._eventManager.dispatch({type:"complete"}));break;default:break}}}_discardPlayerEvents(){for(;this._dotLottieCore?.poll_event()!=null;);}_drainSmEvents(){if(this._dotLottieCore){for(;;){let t=this._dotLottieCore.sm_poll_event();if(t==null)break;switch(t.type){case"Start":queueMicrotask(()=>{this._isStateMachineRunning=!0,this._eventManager.dispatch({type:"stateMachineStart"}),this._startAnimationLoop()});break;case"Stop":queueMicrotask(()=>{this._isStateMachineRunning=!1,this._eventManager.dispatch({type:"stateMachineStop"}),this._dotLottieCore?.status()!==C.Playing&&this._stopAnimationLoop()});break;case"CustomEvent":this._eventManager.dispatch({type:"stateMachineCustomEvent",eventName:t.message??""});break;case"BooleanInputChange":this._eventManager.dispatch({type:"stateMachineBooleanInputValueChange",inputName:t.name??"",newValue:t.newValue,oldValue:t.oldValue});break;case"NumericInputChange":this._eventManager.dispatch({type:"stateMachineNumericInputValueChange",inputName:t.name??"",newValue:t.newValue,oldValue:t.oldValue});break;case"StringInputChange":this._eventManager.dispatch({type:"stateMachineStringInputValueChange",inputName:t.name??"",newValue:t.newValue,oldValue:t.oldValue});break;case"InputFired":this._eventManager.dispatch({type:"stateMachineInputFired",inputName:t.name??""});break;case"Transition":this._eventManager.dispatch({type:"stateMachineTransition",fromState:t.previousState??"",toState:t.newState??""});break;case"StateEntered":this._eventManager.dispatch({type:"stateMachineStateEntered",state:t.state??""});break;case"StateExit":this._eventManager.dispatch({type:"stateMachineStateExit",state:t.state??""});break;case"Error":this._eventManager.dispatch({type:"stateMachineError",error:t.message??""});break;default:break}}for(;;){let t=this._dotLottieCore.sm_poll_internal_event();if(t==null)break;if(t.type==="Message"){let e=t.message??"";E&&e.startsWith("OpenUrl: ")?mt(e):this._eventManager.dispatch({type:"stateMachineInternalMessage",message:e})}}}}_dispatchError(t){console.error(t),this._eventManager.dispatch({type:"loadError",error:new Error(t)})}async _fetchData(t,e=null){let r=await fetch(t,{signal:e});if(!r.ok)throw new Error(`Failed to fetch animation data from URL: ${t}. ${r.status}: ${r.statusText}`);let s=await r.arrayBuffer();return q(s)?s:new TextDecoder().decode(s)}_loadFromData(t){if(this._dotLottieCore===null)return;if(!this._canvas){console.warn("[dotlottie-web] Cannot load animation without canvas. Call setCanvas() first.");return}this._syncCanvasSize(),this._setupTarget(this._canvas.width,this._canvas.height);let e=!1;if(typeof t=="string"){if(e=this._dotLottieCore.load_animation(t),!e&&!tt(t)){this._discardPlayerEvents(),this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");return}}else if(t instanceof ArrayBuffer){if(!q(t)){this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");return}e=this._dotLottieCore.load_dotlottie_data(new Uint8Array(t))}else if(typeof t=="object"){if(!tt(t)){this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");return}e=this._dotLottieCore.load_animation(JSON.stringify(t))}else{this._dispatchError(`Unsupported data type for animation data. Expected:\n          - string (Lottie JSON),\n          - ArrayBuffer (dotLottie),\n          - object (Lottie JSON).\n          Received: ${typeof t}`);return}if(e){if(this._renderConfig.quality!==void 0&&this._dotLottieCore.set_quality(this._renderConfig.quality),this._drainPlayerEvents({skipFrame:!!this._marker||!!this._segment}),this._marker&&this._dotLottieCore.set_marker(this._marker),this._segment){this._dotLottieCore.set_segment(this._segment[0],this._segment[1]);let r=wt(this._dotLottieCore.mode()),s=r==="reverse"||r==="reverse-bounce"?this._segment[1]:this._segment[0];this._dotLottieCore.set_frame(s)}setTimeout(()=>{this._eventManager.dispatch({type:"frame",currentFrame:this.currentFrame})},0),this._dotLottieCore.render(),this._drainPlayerEvents(),this._draw(),this._stateMachineId?this.stateMachineLoad(this._stateMachineId)&&this.stateMachineStart()&&this._startAnimationLoop():this._dotLottieCore.status()===C.Playing&&this._startAnimationLoop(),E&&this._canvas instanceof HTMLCanvasElement&&(this._renderConfig.freezeOnOffscreen&&(R.observe(this._canvas,this),U(this._canvas)||this.freeze()),this._renderConfig.autoResize&&k.observe(this._canvas,this))}else this._drainPlayerEvents()}_loadFromSrc(t,e){(e??this._fetchData(t)).then(r=>this._loadFromData(r)).catch(r=>this._dispatchError(`Failed to load animation data from URL: ${t}. ${r}`))}get buffer(){return this._dotLottieCore?this._dotLottieCore.get_pixel_buffer():null}get activeAnimationId(){return this._dotLottieCore?.animation_id()??void 0}get activeThemeId(){return this._dotLottieCore?.theme_id()??void 0}get layout(){if(this._dotLottieCore)return{align:[this._dotLottieCore.layout_align_x(),this._dotLottieCore.layout_align_y()],fit:Ft(this._dotLottieCore.layout_fit())}}get marker(){return this._dotLottieCore?.current_marker()??""}get manifest(){try{let t=this._dotLottieCore?.manifest_string();if(this._dotLottieCore===null||!t)return null;let e=JSON.parse(t);return Object.keys(e).length===0?null:e}catch{return null}}get renderConfig(){return this._renderConfig}get segment(){if(this._dotLottieCore)return[this._dotLottieCore.segment_start(),this._dotLottieCore.segment_end()]}get loop(){return this._dotLottieCore?.loop_animation()??!1}get mode(){return this._dotLottieCore?wt(this._dotLottieCore.mode()):"forward"}get isFrozen(){return this._isFrozen}get isStateMachineRunning(){return this._isStateMachineRunning}get backgroundColor(){return this._backgroundColor??""}get autoplay(){return this._dotLottieCore?.autoplay()??!1}get useFrameInterpolation(){return this._dotLottieCore?.use_frame_interpolation()??!1}get speed(){return this._dotLottieCore?.speed()??0}get isReady(){return this._dotLottieCore!==null}get isLoaded(){return(this._dotLottieCore?.status()??C.Idle)!==C.Idle}get isPlaying(){return this._dotLottieCore?.status()===C.Playing}get isPaused(){return this._dotLottieCore?.status()===C.Paused}get isStopped(){return this._dotLottieCore?.status()===C.Stopped}get currentFrame(){return this._dotLottieCore?Math.round(this._dotLottieCore.current_frame()*100)/100:0}get loopCount(){return this._dotLottieCore?.current_loop_count()??0}get totalFrames(){return this._dotLottieCore?.total_frames()??0}get duration(){return(this._dotLottieCore?.duration()??0)/1e3}get canvas(){return this._canvas}load(t){this._dotLottieCore!==null&&(this._stopAnimationLoop(),this._cleanupCanvas(),this._isFrozen=!1,this._dotLottieCore.set_autoplay(t.autoplay??!1),this._dotLottieCore.set_loop(t.loop??!1),this._dotLottieCore.set_loop_count(t.loopCount??0),this._dotLottieCore.set_mode(nt(t.mode??"forward")),this._dotLottieCore.set_speed(t.speed??1),this._dotLottieCore.set_use_frame_interpolation(t.useFrameInterpolation??!0),t.segment&&t.segment.length===2?(this._segment=[t.segment[0],t.segment[1]],this._dotLottieCore.set_segment(this._segment[0],this._segment[1])):(this._segment=null,this._dotLottieCore.clear_segment()),this._marker=t.marker??"",this._marker?this._dotLottieCore.set_marker(this._marker):this._dotLottieCore.clear_marker(),this._dotLottieCore.set_layout(t.layout?.fit??"contain",t.layout?.align?.[0]??.5,t.layout?.align?.[1]??.5),this._applyAssetResolver(t.assetResolver??null),t.data?this._canvas?this._loadFromData(t.data):this._pendingLoad={data:t.data}:t.src&&(this._canvas?this._loadFromSrc(t.src):this._pendingLoad={src:t.src}),t.backgroundColor&&this.setBackgroundColor(t.backgroundColor))}_draw(){if(this._dotLottieCore===null||this._canvas===null||(!this._context&&"getContext"in this._canvas&&typeof this._canvas.getContext=="function"&&(!E||typeof HTMLCanvasElement<"u"&&this._canvas instanceof HTMLCanvasElement||typeof OffscreenCanvas<"u"&&this._canvas instanceof OffscreenCanvas)&&(this._context=this._canvas.getContext("2d")),!this._context))return;let t=this._dotLottieCore.get_pixel_buffer(),e=this._canvas.width,r=this._canvas.height,s=e*r*it;if(t.byteLength!==s){this._lastExpectedBufferSize===s?this._bufferMismatchCount+=1:(this._bufferMismatchCount=1,this._lastExpectedBufferSize=s),this._bufferMismatchCount===10&&console.warn(`[dotlottie-web] Persistent buffer size mismatch detected. Expected ${s} bytes for canvas ${e}x${r}, but got ${t.byteLength} bytes. This may indicate a WASM memory allocation issue or invalid canvas dimensions.`);return}this._bufferMismatchCount=0,this._lastExpectedBufferSize=s;let i=this._cachedImageData;if(!(i!==null&&i.width===e&&i.height===r&&i.data.byteLength===s&&this._cachedImageDataBuffer===t.buffer&&this._cachedImageDataByteOffset===t.byteOffset)){if(typeof ImageData>"u")this._cachedImageData=this._context.createImageData(e,r);else{let l=new Uint8ClampedArray(t.buffer,t.byteOffset,t.byteLength);this._cachedImageData=new ImageData(l,e,r)}this._cachedImageDataBuffer=t.buffer,this._cachedImageDataByteOffset=t.byteOffset}if(typeof ImageData>"u"){let l=new Uint8ClampedArray(t.buffer,t.byteOffset,t.byteLength);this._cachedImageData.data.set(l)}this._context.putImageData(this._cachedImageData,0,0)}_cleanupCanvas(){this._canvas&&E&&this._canvas instanceof HTMLCanvasElement&&(R.unobserve(this._canvas),k.unobserve(this._canvas),this._cleanupStateMachineListeners())}_initializeCanvas(){this._setupRendererOnCanvas(),this._canvas&&E&&this._canvas instanceof HTMLCanvasElement&&this.isLoaded&&(this._renderConfig.freezeOnOffscreen&&(R.observe(this._canvas,this),U(this._canvas)||this.freeze()),this._renderConfig.autoResize&&k.observe(this._canvas,this),this._isStateMachineRunning&&this._setupStateMachineListeners()),this._canvas&&this._dotLottieCore&&this.isLoaded&&this._setupTarget(this._canvas.width,this._canvas.height)&&(this._dotLottieCore.render(),this._draw())}_setupRendererOnCanvas(){this._context=null}_stopAnimationLoop(){this._animationFrameId!==null&&(this._frameManager.cancelAnimationFrame(this._animationFrameId),this._animationFrameId=null),this._lastFrameTime=null}_startAnimationLoop(){this._animationFrameId===null&&this._dotLottieCore&&!this._isFrozen&&(this._dotLottieCore.status()===C.Playing||this._isStateMachineRunning)&&(this._animationFrameId=this._frameManager.requestAnimationFrame(this._boundAnimationLoop))}_animationLoop(t){if(this._dotLottieCore===null){this._stopAnimationLoop();return}if(this._dotLottieCore.status()!==C.Playing&&!this._isStateMachineRunning){this._stopAnimationLoop();return}try{let e=this._lastFrameTime!==null?t-this._lastFrameTime:0;this._lastFrameTime=t;let r=this._isStateMachineRunning?this._dotLottieCore.sm_tick(e):this._dotLottieCore.tick(e);this._isStateMachineRunning?this._drainSmEvents():this._drainPlayerEvents(),r&&this._draw(),this._animationFrameId=this._frameManager.requestAnimationFrame(this._boundAnimationLoop)}catch(e){console.error("Error in animation frame:",e),this._eventManager.dispatch({type:"renderError",error:e}),e instanceof WebAssembly.RuntimeError&&this.destroy()}}play(){if(this._dotLottieCore===null||!this.isLoaded)return;this._stopAnimationLoop();let t=this._dotLottieCore.play();this._drainPlayerEvents(),(t||this._dotLottieCore.status()===C.Playing)&&(this._isFrozen=!1,this._startAnimationLoop()),this._canvas&&E&&this._canvas instanceof HTMLCanvasElement&&this._renderConfig.freezeOnOffscreen&&!U(this._canvas)&&this.freeze()}pause(){this._dotLottieCore!==null&&(this._dotLottieCore.pause(),this._drainPlayerEvents(),this._stopAnimationLoop())}stop(){if(this._dotLottieCore===null)return;let t=this._dotLottieCore.stop();this._drainPlayerEvents(),this._stopAnimationLoop(),t&&(this._eventManager.dispatch({type:"frame",currentFrame:this.currentFrame}),this._dotLottieCore.render(),this._draw())}setFrame(t){if(this._dotLottieCore===null)return;if(this._dotLottieCore.set_frame(t)){let r=this._dotLottieCore.render();this._drainPlayerEvents(),r&&this._draw()}}setSpeed(t){this._dotLottieCore!==null&&this._dotLottieCore.set_speed(t)}setBackgroundColor(t){if(this._dotLottieCore!==null){if(E&&this._canvas instanceof HTMLCanvasElement)this._canvas.style.backgroundColor=t;else{let[e,r,s,i]=pt(t);this._dotLottieCore.set_background(e,r,s,i)}this._backgroundColor=t}}setLoop(t){this._dotLottieCore!==null&&this._dotLottieCore.set_loop(t)}setLoopCount(t){this._dotLottieCore!==null&&this._dotLottieCore.set_loop_count(t)}setUseFrameInterpolation(t){this._dotLottieCore!==null&&this._dotLottieCore.set_use_frame_interpolation(t)}_applyAssetResolver(t){if(this._dotLottieCore!==null){if(t===null){this._dotLottieCore.set_asset_resolver(null);return}this._dotLottieCore.set_asset_resolver(e=>{try{return t(e)??null}catch(r){return console.error(`[dotlottie-web] assetResolver threw for "${e}":`,r),null}})}}addEventListener(t,e){this._eventManager.addEventListener(t,e)}removeEventListener(t,e){this._eventManager.removeEventListener(t,e)}destroy(){this._stopAnimationLoop(),this._isStateMachineRunning=!1,this._cleanupCanvas(),this._srcFetchAbort?.abort(),this._srcFetchAbort=null,this._pendingLoad=null;let t=this._dotLottieCore;if(this._dotLottieCore=null,this._context=null,t)try{t.free()}catch(e){console.warn("[dotlottie-web] Error freeing wasm core during destroy:",e)}this._eventManager.dispatch({type:"destroy"}),this._eventManager.removeAllEventListeners(),this._cleanupStateMachineListeners()}freeze(){this._animationFrameId!==null&&(this._stopAnimationLoop(),this._isFrozen=!0,this._eventManager.dispatch({type:"freeze"}))}unfreeze(){this._animationFrameId===null&&(this._isFrozen=!1,this._eventManager.dispatch({type:"unfreeze"}),this._startAnimationLoop())}_syncCanvasSize(){if(!(E&&this._canvas instanceof HTMLCanvasElement))return;let t=this._renderConfig.devicePixelRatio||window.devicePixelRatio||1,{height:e,width:r}=this._canvas.getBoundingClientRect();e!==0&&r!==0&&(this._canvas.width=r*t,this._canvas.height=e*t)}resize(){if(!this._dotLottieCore||!this.isLoaded||!this._canvas)return;this._syncCanvasSize(),this._setupTarget(this._canvas.width,this._canvas.height)&&(this._dotLottieCore.render(),this._draw())}setCanvas(t){if(!(!t||this._canvas===t)&&(this._canvas&&this._cleanupCanvas(),this._canvas=t,this._initializeCanvas(),this._pendingLoad)){let e=this._pendingLoad;this._pendingLoad=null,e.data?this._loadFromData(e.data):e.src&&this._loadFromSrc(e.src,e.dataPromise)}}setTransform(t){if(!this._dotLottieCore)return!1;let e=this._dotLottieCore.set_transform(new Float32Array(t));return e&&this._dotLottieCore.render()&&this._draw(),e}getTransform(){if(!this._dotLottieCore)return;let t=this._dotLottieCore.get_transform();return Array.from(t)}setSegment(t,e){this._dotLottieCore!==null&&(this._segment=[t,e],this._dotLottieCore.set_segment(t,e))}resetSegment(){this._dotLottieCore!==null&&(this._segment=null,this._dotLottieCore.clear_segment())}setMode(t){this._dotLottieCore!==null&&this._dotLottieCore.set_mode(nt(t))}setRenderConfig(t){let{devicePixelRatio:e,freezeOnOffscreen:r,quality:s,...i}=t;this._renderConfig={...this._renderConfig,...i,devicePixelRatio:e||et(),freezeOnOffscreen:r??!0,...s!==void 0&&{quality:s}},s!==void 0&&this._dotLottieCore&&this._dotLottieCore.set_quality(s),E&&this._canvas instanceof HTMLCanvasElement&&(this._renderConfig.autoResize?k.observe(this._canvas,this):k.unobserve(this._canvas),this._renderConfig.freezeOnOffscreen?(R.observe(this._canvas,this),U(this._canvas)||this.freeze()):(R.unobserve(this._canvas),this._isFrozen&&this.unfreeze()))}loadAnimation(t){if(this._dotLottieCore===null||this._dotLottieCore.animation_id()===t||!this._canvas)return;this._syncCanvasSize(),this._setupTarget(this._canvas.width,this._canvas.height),this._dotLottieCore.load_animation_from_id(t)?(this._renderConfig.quality!==void 0&&this._dotLottieCore.set_quality(this._renderConfig.quality),this._drainPlayerEvents(),this._dotLottieCore.render(),this._draw()):this._dispatchError(`Failed to load animation with id: ${t}`)}setMarker(t){if(this._dotLottieCore===null)return;this.markers().some(s=>s.name===t)?(this._marker=t,this._dotLottieCore.set_marker(t)):(this._marker="",this._segment=null,this._dotLottieCore.clear_marker(),this._dotLottieCore.clear_segment())}markers(){let t=this._dotLottieCore?.markers();return t&&Array.isArray(t)?t:[]}setTheme(t){if(this._dotLottieCore===null)return!1;let e=this._dotLottieCore.set_theme(t);return e&&(this._dotLottieCore.render(),this._draw()),e}resetTheme(){if(this._dotLottieCore===null)return!1;let t=this._dotLottieCore.reset_theme();return t&&(this._dotLottieCore.render(),this._draw()),t}setThemeData(t){if(this._dotLottieCore===null)return!1;let e=typeof t=="string"?t:JSON.stringify(t),r=this._dotLottieCore.set_theme_data(e);return r&&(this._dotLottieCore.render(),this._draw()),r}setSlots(t){this._dotLottieCore!==null&&this._dotLottieCore.set_slots_str(JSON.stringify(t))&&(this._dotLottieCore.render(),this._draw())}_isKeyframeArray(t){return Array.isArray(t)&&t.length>0&&typeof t[0]=="object"&&t[0]!==null&&"t"in t[0]&&"s"in t[0]}getSlotIds(){if(!this._dotLottieCore)return[];let t=this._dotLottieCore.get_slot_ids();return Array.isArray(t)?t:[]}getSlotType(t){if(!this._dotLottieCore)return;let e=this._dotLottieCore.get_slot_type(t);if(e)return e}getSlot(t){if(!this._dotLottieCore)return;let e=this._dotLottieCore.get_slot_str(t);if(e)try{return JSON.parse(e)}catch{return}}getSlots(){if(!this._dotLottieCore)return{};try{return JSON.parse(this._dotLottieCore.get_slots_str())}catch{return{}}}setColorSlot(t,e){if(this._dotLottieCore===null)return!1;let r=this._isKeyframeArray(e),s=JSON.stringify({a:r?1:0,k:e}),i=this._dotLottieCore.set_slot_str(t,s);return this._dotLottieCore.render(),this._draw(),i}setScalarSlot(t,e){if(this._dotLottieCore===null)return!1;let s=JSON.stringify({a:typeof e!="number"?1:0,k:e}),i=this._dotLottieCore.set_slot_str(t,s);return this._dotLottieCore.render(),this._draw(),i}setVectorSlot(t,e){if(this._dotLottieCore===null)return!1;let r=this._isKeyframeArray(e),s=JSON.stringify({a:r?1:0,k:e}),i=this._dotLottieCore.set_slot_str(t,s);return this._dotLottieCore.render(),this._draw(),i}setGradientSlot(t,e,r){if(this._dotLottieCore===null)return!1;let s=this._isKeyframeArray(e),i=JSON.stringify({k:{a:s?1:0,k:e},p:r}),c=this._dotLottieCore.set_slot_str(t,i);return this._dotLottieCore.render(),this._draw(),c}setTextSlot(t,e){if(this._dotLottieCore===null)return!1;let r=this._dotLottieCore.get_slot_str(t),s=e;if(r){let l=JSON.parse(r);if(l&&"k"in l&&Array.isArray(l.k)){let y=l.k[0];"s"in y&&typeof y.s=="object"&&(s={...y.s,...e})}}let i=JSON.stringify({a:0,k:[{t:0,s}]}),c=this._dotLottieCore.set_slot_str(t,i);return this._dotLottieCore.render(),this._draw(),c}async setImageSlot(t,e){if(this._dotLottieCore===null)return!1;let r=await ht(e);if(this._dotLottieCore===null)return!1;let s=this._dotLottieCore.set_image_slot(t,r);return this._dotLottieCore.render(),this._draw(),s}resetSlot(t){if(this._dotLottieCore===null)return!1;let e=this._dotLottieCore.reset_slot(t);return this._dotLottieCore.render(),this._draw(),e}clearSlot(t){if(this._dotLottieCore===null)return!1;let e=this._dotLottieCore.clear_slot(t);return this._dotLottieCore.render(),this._draw(),e}resetSlots(){if(this._dotLottieCore===null)return!1;let t=this._dotLottieCore.reset_slots();return this._dotLottieCore.render(),this._draw(),t}clearSlots(){if(this._dotLottieCore===null)return!1;let t=this._dotLottieCore.clear_slots();return this._dotLottieCore.render(),this._draw(),t}setLayout(t){this._dotLottieCore!==null&&this._dotLottieCore.set_layout(t.fit??"contain",t.align?.[0]??.5,t.align?.[1]??.5)}setViewport(t,e,r,s){return this._dotLottieCore===null?!1:this._dotLottieCore.set_viewport(t,e,r,s)}static setWasmUrl(t){K().setWasmUrl(t)}static preload(){return K().load()}static async registerFont(t,e){try{await K().load();let r;if(typeof e=="string"){let i=await fetch(e);if(!i.ok)return console.error(`Failed to fetch font from URL: ${e}. Status: ${i.status}`),!1;r=new Uint8Array(await i.arrayBuffer())}else e instanceof Uint8Array?r=e:r=new Uint8Array(e);let s=dt(t,r);return s||console.error(`Failed to register font "${t}". Font data may be invalid.`),s}catch(r){return console.error(`Error registering font "${t}":`,r),!1}}animationSize(){let t=this._dotLottieCore?.animation_size();return{width:t?.[0]??0,height:t?.[1]??0}}stateMachineLoad(t){return this._dotLottieCore?this._dotLottieCore.state_machine_load_from_id(t):!1}stateMachineLoadData(t){return this._dotLottieCore?this._dotLottieCore.state_machine_load(t):!1}stateMachineSetConfig(t){this._stateMachineConfig=t}stateMachineStart(){if(this._dotLottieCore===null)return!1;let t=this._dotLottieCore.sm_start(this._stateMachineConfig?.openUrlPolicy?.requireUserInteraction??!0,this._stateMachineConfig?.openUrlPolicy?.whitelist??[]);return this._drainSmEvents(),t&&(this._isStateMachineRunning=!0,this._setupStateMachineListeners(),this._startAnimationLoop()),t}stateMachineStop(){if(!this._dotLottieCore)return!1;let t=this._dotLottieCore.sm_stop();return this._drainSmEvents(),t&&(this._isStateMachineRunning=!1,this._cleanupStateMachineListeners(),this._dotLottieCore.status()!==C.Playing&&this._stopAnimationLoop()),t}stateMachineGetStatus(){return this._dotLottieCore?.sm_status()??""}stateMachineGetCurrentState(){return this._dotLottieCore?.sm_current_state()??""}stateMachineGetActiveId(){return this._dotLottieCore?.state_machine_id()??""}stateMachineOverrideState(t,e=!1){return this._dotLottieCore?.sm_override_current_state(t,e)??!1}stateMachineSetSeed(t){return this._dotLottieCore?.sm_set_seed(BigInt(Math.trunc(t)))??!1}stateMachineGet(t){return this._dotLottieCore?.get_state_machine(t)??""}stateMachineGetListeners(){if(!this._dotLottieCore)return[];let t=this._dotLottieCore.sm_framework_setup();return Array.isArray(t)?t:[]}stateMachineSetBooleanInput(t,e){return this._dotLottieCore?.sm_set_boolean_input(t,e)??!1}stateMachineSetNumericInput(t,e){return this._dotLottieCore?.sm_set_numeric_input(t,e)??!1}stateMachineSetStringInput(t,e){return this._dotLottieCore?.sm_set_string_input(t,e)??!1}stateMachineGetBooleanInput(t){return this._dotLottieCore?.sm_get_boolean_input(t)??void 0}stateMachineGetNumericInput(t){return this._dotLottieCore?.sm_get_numeric_input(t)??void 0}stateMachineGetStringInput(t){return this._dotLottieCore?.sm_get_string_input(t)??void 0}stateMachineGetInputs(){if(!this._dotLottieCore)return[];let t=this._dotLottieCore.sm_get_inputs();return Array.isArray(t)?t:[]}stateMachineFireEvent(t){this._dotLottieCore?.sm_fire(t)}stateMachinePostClickEvent(t,e){this._dotLottieCore?.sm_post_click(t,e)}stateMachinePostPointerUpEvent(t,e){this._dotLottieCore?.sm_post_pointer_up(t,e)}stateMachinePostPointerDownEvent(t,e){this._dotLottieCore?.sm_post_pointer_down(t,e)}stateMachinePostPointerMoveEvent(t,e){this._dotLottieCore?.sm_post_pointer_move(t,e)}stateMachinePostPointerEnterEvent(t,e){this._dotLottieCore?.sm_post_pointer_enter(t,e)}stateMachinePostPointerExitEvent(t,e){this._dotLottieCore?.sm_post_pointer_exit(t,e)}_onClick(t){let e=A(t);e&&this.stateMachinePostClickEvent(e.x,e.y)}_onPointerUp(t){let e=A(t);e&&this.stateMachinePostPointerUpEvent(e.x,e.y)}_onPointerDown(t){let e=A(t);e&&this.stateMachinePostPointerDownEvent(e.x,e.y)}_onPointerMove(t){let e=A(t);e&&this.stateMachinePostPointerMoveEvent(e.x,e.y)}_onPointerEnter(t){let e=A(t);e&&this.stateMachinePostPointerEnterEvent(e.x,e.y)}_onPointerLeave(t){let e=A(t);e&&this.stateMachinePostPointerExitEvent(e.x,e.y)}_setupStateMachineListeners(){if(E&&this._canvas instanceof HTMLCanvasElement&&this._dotLottieCore!==null&&this.isLoaded){let t=this.stateMachineGetListeners();this._cleanupStateMachineListeners(),t.includes("Click")&&(this._boundOnClick=this._onClick.bind(this),this._canvas.addEventListener("click",this._boundOnClick)),t.includes("PointerUp")&&(this._boundOnPointerUp=this._onPointerUp.bind(this),this._canvas.addEventListener("pointerup",this._boundOnPointerUp)),t.includes("PointerDown")&&(this._boundOnPointerDown=this._onPointerDown.bind(this),this._canvas.addEventListener("pointerdown",this._boundOnPointerDown)),t.includes("PointerMove")&&(this._boundOnPointerMove=this._onPointerMove.bind(this),this._canvas.addEventListener("pointermove",this._boundOnPointerMove)),t.includes("PointerEnter")&&(this._boundOnPointerEnter=this._onPointerEnter.bind(this),this._canvas.addEventListener("pointerenter",this._boundOnPointerEnter)),t.includes("PointerExit")&&(this._boundOnPointerLeave=this._onPointerLeave.bind(this),this._canvas.addEventListener("pointerleave",this._boundOnPointerLeave))}}_cleanupStateMachineListeners(){E&&this._canvas instanceof HTMLCanvasElement&&(this._boundOnClick&&(this._canvas.removeEventListener("click",this._boundOnClick),this._boundOnClick=null),this._boundOnPointerUp&&(this._canvas.removeEventListener("pointerup",this._boundOnPointerUp),this._boundOnPointerUp=null),this._boundOnPointerDown&&(this._canvas.removeEventListener("pointerdown",this._boundOnPointerDown),this._boundOnPointerDown=null),this._boundOnPointerMove&&(this._canvas.removeEventListener("pointermove",this._boundOnPointerMove),this._boundOnPointerMove=null),this._boundOnPointerEnter&&(this._canvas.removeEventListener("pointerenter",this._boundOnPointerEnter),this._boundOnPointerEnter=null),this._boundOnPointerLeave&&(this._canvas.removeEventListener("pointerleave",this._boundOnPointerLeave),this._boundOnPointerLeave=null))}};var a=new Map,Ot={ready:n=>t=>{let e={id:"",method:"onReady",result:{instanceId:n,event:t}};self.postMessage(e)},complete:n=>t=>{let e={id:"",method:"onComplete",result:{instanceId:n,event:t}};self.postMessage(e)},load:n=>t=>{let r={id:"",method:"onLoad",result:{instanceId:n,event:t}};self.postMessage(r)},loadError:n=>t=>{let r={id:"",method:"onLoadError",result:{instanceId:n,event:t}};self.postMessage(r)},renderError:n=>t=>{let r={id:"",method:"onRenderError",result:{instanceId:n,event:t}};self.postMessage(r)},loop:n=>t=>{let r={id:"",method:"onLoop",result:{instanceId:n,event:t}};self.postMessage(r)},play:n=>t=>{let r={id:"",method:"onPlay",result:{instanceId:n,event:t}};self.postMessage(r)},pause:n=>t=>{let r={id:"",method:"onPause",result:{instanceId:n,event:t}};self.postMessage(r)},stop:n=>t=>{let r={id:"",method:"onStop",result:{instanceId:n,event:t}};self.postMessage(r)},frame:n=>t=>{let r={id:"",method:"onFrame",result:{instanceId:n,event:t}};self.postMessage(r)},render:n=>t=>{let r={id:"",method:"onRender",result:{instanceId:n,event:t}};self.postMessage(r)},freeze:n=>t=>{let r={id:"",method:"onFreeze",result:{instanceId:n,event:t}};self.postMessage(r)},unfreeze:n=>t=>{let r={id:"",method:"onUnfreeze",result:{instanceId:n,event:t}};self.postMessage(r)},destroy:n=>t=>{let r={id:"",method:"onDestroy",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineStart:n=>t=>{let r={id:"",method:"onStateMachineStart",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineStop:n=>t=>{let r={id:"",method:"onStateMachineStop",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineTransition:n=>t=>{let r={id:"",method:"onStateMachineTransition",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineStateEntered:n=>t=>{let r={id:"",method:"onStateMachineStateEntered",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineStateExit:n=>t=>{let r={id:"",method:"onStateMachineStateExit",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineCustomEvent:n=>t=>{let r={id:"",method:"onStateMachineCustomEvent",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineError:n=>t=>{let r={id:"",method:"onStateMachineError",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineBooleanInputValueChange:n=>t=>{let r={id:"",method:"onStateMachineBooleanInputValueChange",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineNumericInputValueChange:n=>t=>{let r={id:"",method:"onStateMachineNumericInputValueChange",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineStringInputValueChange:n=>t=>{let r={id:"",method:"onStateMachineStringInputValueChange",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineInputFired:n=>t=>{let r={id:"",method:"onStateMachineInputFired",result:{instanceId:n,event:t}};self.postMessage(r)},stateMachineInternalMessage:n=>t=>{let r={id:"",method:"onStateMachineInternalMessage",result:{instanceId:n,event:t}};self.postMessage(r)}},rt={setTransform(n){let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.setTransform(n.params.transform)},getTransform(n){let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.getTransform()},getDotLottieInstanceState(n){let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return{state:{loopCount:e.loopCount,isLoaded:e.isLoaded,isPaused:e.isPaused,isPlaying:e.isPlaying,isStopped:e.isStopped,isFrozen:e.isFrozen,loop:e.loop,mode:e.mode,speed:e.speed,currentFrame:e.currentFrame,totalFrames:e.totalFrames,duration:e.duration,useFrameInterpolation:e.useFrameInterpolation,renderConfig:e.renderConfig,marker:e.marker,backgroundColor:e.backgroundColor,markers:e.markers(),activeAnimationId:e.activeAnimationId,activeThemeId:e.activeThemeId,autoplay:e.autoplay,segment:e.segment,layout:e.layout,isReady:e.isReady,manifest:e.manifest}}},setLayout(n){let t=n.params.instanceId,e=n.params.layout,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setLayout(e)},stateMachineGetListeners(n){let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.stateMachineGetListeners()},stateMachineStart(n){let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.stateMachineStart()},stateMachineStop(n){let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.stateMachineStop()},stateMachineLoad(n){let t=n.params.instanceId,e=n.params.stateMachineId,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.stateMachineLoad(e)},stateMachineLoadData(n){let t=n.params.instanceId,e=n.params.stateMachineData,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.stateMachineLoadData(e)},stateMachinePostClickEvent(n){let t=n.params.instanceId,e=n.params.x,r=n.params.y,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachinePostClickEvent(e,r)},stateMachinePostPointerUpEvent(n){let t=n.params.instanceId,e=n.params.x,r=n.params.y,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachinePostPointerUpEvent(e,r)},stateMachinePostPointerDownEvent(n){let t=n.params.instanceId,e=n.params.x,r=n.params.y,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachinePostPointerDownEvent(e,r)},stateMachinePostPointerMoveEvent(n){let t=n.params.instanceId,e=n.params.x,r=n.params.y,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachinePostPointerMoveEvent(e,r)},stateMachinePostPointerEnterEvent(n){let t=n.params.instanceId,e=n.params.x,r=n.params.y,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachinePostPointerEnterEvent(e,r)},stateMachinePostPointerExitEvent(n){let t=n.params.instanceId,e=n.params.x,r=n.params.y,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachinePostPointerExitEvent(e,r)},stateMachineSetNumericInput:n=>{let t=n.params.instanceId,e=n.params.name,r=n.params.value,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachineSetNumericInput(e,r)},stateMachineSetBooleanInput:n=>{let t=n.params.instanceId,e=n.params.name,r=n.params.value,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachineSetBooleanInput(e,r)},stateMachineSetConfig:n=>{let t=n.params.instanceId,e=n.params.config,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.stateMachineSetConfig(e)},stateMachineSetStringInput:n=>{let t=n.params.instanceId,e=n.params.name,r=n.params.value,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachineSetStringInput(e,r)},stateMachineGetNumericInput:n=>{let t=n.params.instanceId,e=n.params.name,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.stateMachineGetNumericInput(e)},stateMachineGetBooleanInput:n=>{let t=n.params.instanceId,e=n.params.name,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.stateMachineGetBooleanInput(e)},stateMachineGetStringInput:n=>{let t=n.params.instanceId,e=n.params.name,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.stateMachineGetStringInput(e)},stateMachineGetInputs:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.stateMachineGetInputs()},stateMachineFireEvent:n=>{let t=n.params.instanceId,e=n.params.name,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.stateMachineFireEvent(e)},stateMachineGetStatus:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.stateMachineGetStatus()},stateMachineGetCurrentState:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.stateMachineGetCurrentState()},stateMachineGetActiveId:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.stateMachineGetActiveId()},stateMachineOverrideState:n=>{let t=n.params.instanceId,e=n.params.state,r=n.params.immediate,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);return s.stateMachineOverrideState(e,r)},stateMachineSetSeed:n=>{let t=n.params.instanceId,e=n.params.seed,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.stateMachineSetSeed(e)},stateMachineGet:n=>{let t=n.params.instanceId,e=n.params.stateMachineId,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.stateMachineGet(e)},create:n=>{let t=n.params.instanceId,e=n.params.config,r=n.params.width,s=n.params.height;if(a.has(t))throw new Error(`Instance with id ${t} already exists.`);let i=new F(e);return i.canvas&&(i.canvas.height=s,i.canvas.width=r),a.set(t,i),["complete","frame","load","loadError","renderError","loop","pause","play","stop","destroy","freeze","unfreeze","render","ready","stateMachineStart","stateMachineStop","stateMachineTransition","stateMachineStateEntered","stateMachineStateExit","stateMachineCustomEvent","stateMachineError","stateMachineBooleanInputValueChange","stateMachineNumericInputValueChange","stateMachineStringInputValueChange","stateMachineInputFired","stateMachineInternalMessage"].forEach(l=>{i.addEventListener(l,Ot[l](t))}),{instanceId:t}},destroy:n=>{let t=n.params.instanceId,e=a.get(t);e&&(e.destroy(),a.delete(t))},freeze:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);e.freeze()},load:n=>{let t=n.params.instanceId,e=n.params.config,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.load(e)},loadAnimation:n=>{let t=n.params.instanceId,e=n.params.animationId,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.loadAnimation(e)},setTheme:n=>{let t=n.params.instanceId,e=n.params.themeId,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.setTheme(e)},setThemeData:n=>{let t=n.params.instanceId,e=n.params.themeData,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);return r.setThemeData(e)},pause:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.pause()},play:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.play()},registerFont:async n=>{let{fontName:t,fontSource:e}=n.params;return F.registerFont(t,e)},resize:n=>{let t=n.params.instanceId,e=n.params.width,r=n.params.height,s=a.get(t);if(!s)throw new Error(`Instance with id ${t} does not exist.`);s.canvas&&(s.canvas.height=r,s.canvas.width=e),s.resize()},setBackgroundColor:n=>{let t=n.params.instanceId,e=n.params.backgroundColor,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setBackgroundColor(e)},setSlots:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);e.setSlots(n.params.slots)},getSlotIds:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.getSlotIds()},getSlotType:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.getSlotType(n.params.slotId)},getSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.getSlot(n.params.slotId)},getSlots:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.getSlots()},setColorSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.setColorSlot(n.params.slotId,n.params.value)},setScalarSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.setScalarSlot(n.params.slotId,n.params.value)},setVectorSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.setVectorSlot(n.params.slotId,n.params.value)},setGradientSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.setGradientSlot(n.params.slotId,n.params.value,n.params.colorStopCount)},setTextSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.setTextSlot(n.params.slotId,n.params.value)},setImageSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.setImageSlot(n.params.slotId,n.params.src)},resetSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.resetSlot(n.params.slotId)},clearSlot:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.clearSlot(n.params.slotId)},resetSlots:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.resetSlots()},clearSlots:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);return e.clearSlots()},setFrame:n=>{let t=n.params.instanceId,e=n.params.frame,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setFrame(e)},setMode:n=>{let t=n.params.instanceId,e=n.params.mode,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setMode(e)},setRenderConfig:n=>{let t=n.params.instanceId,e=n.params.renderConfig,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setRenderConfig(e)},setSegment:n=>{let t=n.params.instanceId,e=n.params.segment,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setSegment(e[0],e[1])},resetSegment:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);e.resetSegment()},setSpeed:n=>{let t=n.params.instanceId,e=n.params.speed,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setSpeed(e)},setUseFrameInterpolation:n=>{let t=n.params.instanceId,e=n.params.useFrameInterpolation,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setUseFrameInterpolation(e)},setWasmUrl:n=>{F.setWasmUrl(n.params.url)},stop:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);e.stop()},unfreeze:n=>{let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);e.unfreeze()},setViewport(n){let t=n.params.instanceId,e=n.params.x,r=n.params.y,s=n.params.width,i=n.params.height,c=a.get(t);if(!c)throw new Error(`Instance with id ${t} does not exist.`);return c.setViewport(e,r,s,i)},animationSize(n){let t=n.params.instanceId,e=a.get(t);if(!e)throw new Error(`Instance with id ${t} does not exist.`);let{height:r,width:s}=e.animationSize();return{height:r,width:s}},setMarker(n){let t=n.params.instanceId,e=n.params.marker,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setMarker(e)},setLoop(n){let t=n.params.instanceId,e=n.params.loop,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setLoop(e)},setLoopCount(n){let t=n.params.instanceId,e=n.params.loopCount,r=a.get(t);if(!r)throw new Error(`Instance with id ${t} does not exist.`);r.setLoopCount(e)}};function Bt(n){let t=n.method;if(Object.hasOwn(rt,t)&&typeof rt[t]=="function")return rt[t](n);throw new Error(`Method ${String(t)} is not implemented in commands.`)}self.onmessage=async n=>{try{let t=await Bt(n.data),e={id:n.data.id,method:n.data.method,result:t};self.postMessage(e)}catch(t){let e={id:n.data.id,method:n.data.method,error:t.message};self.postMessage(e)}};var Dt="",ce=Dt;})();\n'
    ], {
        type: "application/javascript"
    }), n = URL.createObjectURL(t), _$r = new Worker(n);
    return URL.revokeObjectURL(n), _$r;
}, $4df2746f4766bf20$var$Ce = /*#__PURE__*/ function() {
    "use strict";
    function Ce() {
        var _this = this;
        (0, $4QweW._)(this, Ce);
        $4df2746f4766bf20$var$r(this, "_workers", new Map), $4df2746f4766bf20$var$r(this, "_animationWorkerMap", new Map), $4df2746f4766bf20$var$r(this, "_eventHandlers", new Map), $4df2746f4766bf20$var$r(this, "_rpcHandlers", new Map), $4df2746f4766bf20$var$r(this, "_routeMessage", function(e) {
            var _t_result;
            var t = e.data;
            if (t.id) {
                var n = _this._rpcHandlers.get(t.id);
                n && n(e);
                return;
            }
            var n1 = (_t_result = t.result) === null || _t_result === void 0 ? void 0 : _t_result.instanceId;
            if (n1) {
                var t1 = _this._eventHandlers.get(n1);
                t1 && t1(e);
            }
        });
    }
    (0, $6hK4i._)(Ce, [
        {
            key: "getWorker",
            value: function getWorker(e) {
                var t = this._workers.get(e);
                return t || (t = new $4df2746f4766bf20$var$Se, t.addEventListener("message", this._routeMessage), this._workers.set(e, t)), t;
            }
        },
        {
            key: "assignAnimationToWorker",
            value: function assignAnimationToWorker(e, t) {
                this._animationWorkerMap.set(e, t);
            }
        },
        {
            key: "unassignAnimationFromWorker",
            value: function unassignAnimationFromWorker(e) {
                this._animationWorkerMap.delete(e);
            }
        },
        {
            key: "sendMessage",
            value: function sendMessage(e, t, n) {
                this.getWorker(e).postMessage(t, n || []);
            }
        },
        {
            key: "broadcastMessage",
            value: function broadcastMessage(e, t) {
                this._workers.forEach(function(n) {
                    n.postMessage(e, t || []);
                });
            }
        },
        {
            key: "terminateWorker",
            value: function terminateWorker(e) {
                var t = this._workers.get(e);
                t && (t.removeEventListener("message", this._routeMessage), t.terminate(), this._workers.delete(e));
            }
        },
        {
            key: "registerEventHandler",
            value: function registerEventHandler(e, t) {
                this._eventHandlers.set(e, t);
            }
        },
        {
            key: "unregisterEventHandler",
            value: function unregisterEventHandler(e) {
                this._eventHandlers.delete(e);
            }
        },
        {
            key: "registerRpcReplyHandler",
            value: function registerRpcReplyHandler(e, t) {
                this._rpcHandlers.set(e, t);
            }
        },
        {
            key: "unregisterRpcReplyHandler",
            value: function unregisterRpcReplyHandler(e) {
                this._rpcHandlers.delete(e);
            }
        }
    ]);
    return Ce;
}();
function $4df2746f4766bf20$var$G(e, t) {
    if ((typeof HTMLCanvasElement === "undefined" ? "undefined" : (0, $5djcY._)(HTMLCanvasElement)) < "u" && e instanceof HTMLCanvasElement) {
        var _e_getBoundingClientRect = e.getBoundingClientRect(), n = _e_getBoundingClientRect.height, _$r = _e_getBoundingClientRect.width;
        if (n !== 0 && _$r !== 0) return {
            width: _$r * t,
            height: n * t
        };
    }
    return {
        width: e.width,
        height: e.height
    };
}
function $4df2746f4766bf20$var$K() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var $4df2746f4766bf20$var$q = null;
function $4df2746f4766bf20$var$J() {
    return $4df2746f4766bf20$var$q !== null && $4df2746f4766bf20$var$q !== void 0 ? $4df2746f4766bf20$var$q : $4df2746f4766bf20$var$q = new $4df2746f4766bf20$var$Ce, $4df2746f4766bf20$var$q;
}
function $4df2746f4766bf20$var$Y(e, t) {
    return {
        id: "dotlottie-request-".concat($4df2746f4766bf20$var$K()),
        method: e,
        params: t
    };
}
var $4df2746f4766bf20$var$X = "";
var $4df2746f4766bf20$var$Z = new Map;
var $4df2746f4766bf20$var$we = !1;
function $4df2746f4766bf20$var$Q(e) {
    if ((typeof document === "undefined" ? "undefined" : (0, $5djcY._)(document)) > "u") return e;
    try {
        return new URL(e, document.baseURI).href;
    } catch (e1) {
        return e;
    }
}
function $4df2746f4766bf20$var$$(e) {
    var t = e.assetResolver, n = (0, $1DiK7._)(e, [
        "assetResolver"
    ]);
    return t !== void 0 && !$4df2746f4766bf20$var$we && ($4df2746f4766bf20$var$we = !0, console.warn("[dotlottie-web] `assetResolver` is not supported by DotLottieWorker and has been ignored: a resolver must run synchronously, which is not possible across the worker boundary. Use `DotLottie` instead if the animation references assets it does not embed.")), typeof n.src == "string" ? (0, $hApvp._)((0, $kWfK0._)({}, n), {
        src: $4df2746f4766bf20$var$Q(n.src)
    }) : n;
}
var $4df2746f4766bf20$export$ab8c8a3fed0b35de = /*#__PURE__*/ function() {
    "use strict";
    function Te(e) {
        (0, $4QweW._)(this, Te);
        var _e_renderConfig, _e_renderConfig1;
        if ($4df2746f4766bf20$var$r(this, "_eventManager", new $4df2746f4766bf20$var$j), $4df2746f4766bf20$var$r(this, "_id", void 0), $4df2746f4766bf20$var$r(this, "_workerId", void 0), $4df2746f4766bf20$var$r(this, "_worker", void 0), $4df2746f4766bf20$var$r(this, "_canvas", void 0), $4df2746f4766bf20$var$r(this, "_dotLottieInstanceState", {
            loopCount: 0,
            markers: [],
            autoplay: !1,
            backgroundColor: "",
            currentFrame: 0,
            duration: 0,
            loop: !1,
            mode: "forward",
            segment: [
                0,
                0
            ],
            speed: 1,
            totalFrames: 0,
            isLoaded: !1,
            isPlaying: !1,
            isPaused: !1,
            isStopped: !0,
            isFrozen: !1,
            useFrameInterpolation: !1,
            renderConfig: {
                devicePixelRatio: $4df2746f4766bf20$var$I()
            },
            activeAnimationId: "",
            activeThemeId: "",
            layout: void 0,
            marker: "",
            isReady: !1,
            manifest: null
        }), $4df2746f4766bf20$var$r(this, "_created", !1), $4df2746f4766bf20$var$r(this, "_retired", !1), $4df2746f4766bf20$var$r(this, "_boundOnClick", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerUp", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerDown", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerMove", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerEnter", null), $4df2746f4766bf20$var$r(this, "_boundOnPointerLeave", null), $4df2746f4766bf20$var$r(this, "_pendingConfig", null), e.canvas) {
            var t = (typeof HTMLCanvasElement === "undefined" ? "undefined" : (0, $5djcY._)(HTMLCanvasElement)) < "u" && e.canvas instanceof HTMLCanvasElement, n = (typeof OffscreenCanvas === "undefined" ? "undefined" : (0, $5djcY._)(OffscreenCanvas)) < "u" && e.canvas instanceof OffscreenCanvas;
            if (!t && !n) throw Error("Worker-based DotLottie requires HTMLCanvasElement or OffscreenCanvas");
        }
        var _e_canvas;
        this._canvas = (_e_canvas = e.canvas) !== null && _e_canvas !== void 0 ? _e_canvas : null, this._id = "dotlottie-".concat($4df2746f4766bf20$var$K()), this._workerId = e.workerId || "defaultWorker", this._worker = $4df2746f4766bf20$var$J().getWorker(this._workerId), $4df2746f4766bf20$var$J().assignAnimationToWorker(this._id, this._workerId), $4df2746f4766bf20$var$X && this._sendMessage("setWasmUrl", {
            url: $4df2746f4766bf20$var$X
        });
        var _e_renderConfig_freezeOnOffscreen;
        var t1 = (0, $hApvp._)((0, $kWfK0._)({}, e), {
            renderConfig: (0, $hApvp._)((0, $kWfK0._)({}, e.renderConfig), {
                devicePixelRatio: ((_e_renderConfig = e.renderConfig) === null || _e_renderConfig === void 0 ? void 0 : _e_renderConfig.devicePixelRatio) || $4df2746f4766bf20$var$I(),
                freezeOnOffscreen: (_e_renderConfig_freezeOnOffscreen = (_e_renderConfig1 = e.renderConfig) === null || _e_renderConfig1 === void 0 ? void 0 : _e_renderConfig1.freezeOnOffscreen) !== null && _e_renderConfig_freezeOnOffscreen !== void 0 ? _e_renderConfig_freezeOnOffscreen : !0
            })
        });
        this._pendingConfig = t1, this._canvas && (this._create(t1), this._pendingConfig = null), $4df2746f4766bf20$var$J().registerEventHandler(this._id, this._handleWorkerEvent.bind(this));
    }
    (0, $6hK4i._)(Te, [
        {
            key: "_handleWorkerEvent",
            value: function _handleWorkerEvent(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t, _tmp, _tmp1, _tmp2, _tmp3, _tmp4, _tmp5, _tmp6, _tmp7, _tmp8, _tmp9, _tmp10, _tmp11, _tmp12, _tmp13, _tmp14, _tmp15, _tmp16, _tmp17, _tmp18, _tmp19, _tmp20, _tmp21, _tmp22, _tmp23, _tmp24, _$e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e.data;
                                _tmp = !t.id;
                                if (!_tmp) return [
                                    3,
                                    47
                                ];
                                _tmp1 = t.method === "onLoad" && t.result.instanceId === this._id;
                                if (!_tmp1) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 1:
                                _state.sent(), this._eventManager.dispatch(t.result.event);
                                _tmp2 = $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement;
                                if (!_tmp2) return [
                                    3,
                                    5
                                ];
                                _tmp3 = this._dotLottieInstanceState.renderConfig.freezeOnOffscreen;
                                if (!_tmp3) return [
                                    3,
                                    4
                                ];
                                $4df2746f4766bf20$var$M.observe(this._canvas, this);
                                _tmp4 = $4df2746f4766bf20$var$L(this._canvas);
                                if (_tmp4) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.freeze()
                                ];
                            case 2:
                                _tmp4 = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp3 = _tmp4;
                                _state.label = 4;
                            case 4:
                                _tmp2 = (_tmp3, this._dotLottieInstanceState.renderConfig.autoResize && $4df2746f4766bf20$var$N.observe(this._canvas, this));
                                _state.label = 5;
                            case 5:
                                _tmp1 = _tmp2;
                                _state.label = 6;
                            case 6:
                                _tmp1;
                                _tmp5 = t.method === "onComplete" && t.result.instanceId === this._id;
                                if (!_tmp5) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 7:
                                _tmp5 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 8;
                            case 8:
                                _tmp5, t.method === "onDestroy" && t.result.instanceId === this._id && this._eventManager.dispatch(t.result.event);
                                _tmp6 = t.method === "onUnfreeze" && t.result.instanceId === this._id;
                                if (!_tmp6) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 9:
                                _tmp6 = (_state.sent(), this._dotLottieInstanceState.isFrozen = !1, this._eventManager.dispatch(t.result.event));
                                _state.label = 10;
                            case 10:
                                _tmp6, t.method === "onFrame" && t.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = t.result.event.currentFrame, this._eventManager.dispatch(t.result.event)), t.method === "onRender" && t.result.instanceId === this._id && this._eventManager.dispatch(t.result.event);
                                _tmp7 = t.method === "onFreeze" && t.result.instanceId === this._id;
                                if (!_tmp7) return [
                                    3,
                                    12
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 11:
                                _tmp7 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 12;
                            case 12:
                                _tmp7;
                                _tmp8 = t.method === "onPause" && t.result.instanceId === this._id;
                                if (!_tmp8) return [
                                    3,
                                    14
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 13:
                                _tmp8 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 14;
                            case 14:
                                _tmp8;
                                _tmp9 = t.method === "onPlay" && t.result.instanceId === this._id;
                                if (!_tmp9) return [
                                    3,
                                    16
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 15:
                                _tmp9 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 16;
                            case 16:
                                _tmp9;
                                _tmp10 = t.method === "onStop" && t.result.instanceId === this._id;
                                if (!_tmp10) return [
                                    3,
                                    18
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 17:
                                _tmp10 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 18;
                            case 18:
                                _tmp10;
                                _tmp11 = t.method === "onLoadError" && t.result.instanceId === this._id;
                                if (!_tmp11) return [
                                    3,
                                    20
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 19:
                                _tmp11 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 20;
                            case 20:
                                _tmp11, t.method === "onRenderError" && t.result.instanceId === this._id && this._eventManager.dispatch(t.result.event);
                                _tmp12 = t.method === "onReady" && t.result.instanceId === this._id;
                                if (!_tmp12) return [
                                    3,
                                    22
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 21:
                                _tmp12 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 22;
                            case 22:
                                _tmp12;
                                _tmp13 = t.method === "onLoop" && t.result.instanceId === this._id;
                                if (!_tmp13) return [
                                    3,
                                    24
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 23:
                                _tmp13 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 24;
                            case 24:
                                _tmp13;
                                _tmp14 = t.method === "onStateMachineStart" && t.result.instanceId === this._id;
                                if (!_tmp14) return [
                                    3,
                                    26
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 25:
                                _tmp14 = (_state.sent(), this._setupStateMachineListeners(), this._eventManager.dispatch(t.result.event));
                                _state.label = 26;
                            case 26:
                                _tmp14;
                                _tmp15 = t.method === "onStateMachineStop" && t.result.instanceId === this._id;
                                if (!_tmp15) return [
                                    3,
                                    28
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 27:
                                _tmp15 = (_state.sent(), this._cleanupStateMachineListeners(), this._eventManager.dispatch(t.result.event));
                                _state.label = 28;
                            case 28:
                                _tmp15;
                                _tmp16 = t.method === "onStateMachineTransition" && t.result.instanceId === this._id;
                                if (!_tmp16) return [
                                    3,
                                    30
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 29:
                                _tmp16 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 30;
                            case 30:
                                _tmp16;
                                _tmp17 = t.method === "onStateMachineStateEntered" && t.result.instanceId === this._id;
                                if (!_tmp17) return [
                                    3,
                                    32
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 31:
                                _tmp17 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 32;
                            case 32:
                                _tmp17;
                                _tmp18 = t.method === "onStateMachineStateExit" && t.result.instanceId === this._id;
                                if (!_tmp18) return [
                                    3,
                                    34
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 33:
                                _tmp18 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 34;
                            case 34:
                                _tmp18;
                                _tmp19 = t.method === "onStateMachineCustomEvent" && t.result.instanceId === this._id;
                                if (!_tmp19) return [
                                    3,
                                    36
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 35:
                                _tmp19 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 36;
                            case 36:
                                _tmp19;
                                _tmp20 = t.method === "onStateMachineError" && t.result.instanceId === this._id;
                                if (!_tmp20) return [
                                    3,
                                    38
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 37:
                                _tmp20 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 38;
                            case 38:
                                _tmp20;
                                _tmp21 = t.method === "onStateMachineBooleanInputValueChange" && t.result.instanceId === this._id;
                                if (!_tmp21) return [
                                    3,
                                    40
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 39:
                                _tmp21 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 40;
                            case 40:
                                _tmp21;
                                _tmp22 = t.method === "onStateMachineNumericInputValueChange" && t.result.instanceId === this._id;
                                if (!_tmp22) return [
                                    3,
                                    42
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 41:
                                _tmp22 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 42;
                            case 42:
                                _tmp22;
                                _tmp23 = t.method === "onStateMachineStringInputValueChange" && t.result.instanceId === this._id;
                                if (!_tmp23) return [
                                    3,
                                    44
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 43:
                                _tmp23 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 44;
                            case 44:
                                _tmp23;
                                _tmp24 = t.method === "onStateMachineInputFired" && t.result.instanceId === this._id;
                                if (!_tmp24) return [
                                    3,
                                    46
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 45:
                                _tmp24 = (_state.sent(), this._eventManager.dispatch(t.result.event));
                                _state.label = 46;
                            case 46:
                                _tmp = (_tmp24, t.method === "onStateMachineInternalMessage" && t.result.instanceId === this._id);
                                _state.label = 47;
                            case 47:
                                if (!_tmp) return [
                                    3,
                                    49
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 48:
                                _state.sent();
                                _$e = t.result.event;
                                _$e.message.startsWith("OpenUrl: ") && $4df2746f4766bf20$var$B(_$e.message);
                                _state.label = 49;
                            case 49:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_create",
            value: function _create(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _e_renderConfig, t, n, _ref, n1, _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._canvas) return [
                                    2
                                ];
                                if (!(this._canvas instanceof HTMLCanvasElement)) return [
                                    3,
                                    3
                                ];
                                n = $4df2746f4766bf20$var$Z.get(this._canvas);
                                if (!(n && n.workerId === this._workerId)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._adopt(n, e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                t = this._canvas.transferControlToOffscreen(), $4df2746f4766bf20$var$Z.set(this._canvas, {
                                    destroyTimer: null,
                                    facade: this,
                                    instanceId: this._id,
                                    workerId: this._workerId
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                t = this._canvas;
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    this._sendMessage("create", (0, $kWfK0._)({
                                        instanceId: this._id,
                                        config: (0, $hApvp._)((0, $kWfK0._)({}, $4df2746f4766bf20$var$$(e)), {
                                            canvas: t
                                        })
                                    }, $4df2746f4766bf20$var$G(this._canvas, ((_e_renderConfig = e.renderConfig) === null || _e_renderConfig === void 0 ? void 0 : _e_renderConfig.devicePixelRatio) || $4df2746f4766bf20$var$I())), [
                                        t
                                    ])
                                ];
                            case 5:
                                _ref = _state.sent(), n1 = _ref.instanceId;
                                if (n1 !== this._id) throw Error("Instance ID mismatch");
                                _tmp = this._retired;
                                if (_tmp) return [
                                    3,
                                    7
                                ];
                                this._created = !0;
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 6:
                                _tmp = _state.sent();
                                _state.label = 7;
                            case 7:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_adopt",
            value: function _adopt(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _$, n, _$r;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e.destroyTimer === null ? e.facade._retire() : (clearTimeout(e.destroyTimer), e.destroyTimer = null), $4df2746f4766bf20$var$J().unassignAnimationFromWorker(this._id), this._id = e.instanceId, $4df2746f4766bf20$var$J().assignAnimationToWorker(this._id, this._workerId), e.facade = this, this._created = !0;
                                _$ = $4df2746f4766bf20$var$$(t), n = _$.canvas, _$r = (0, $1DiK7._)(_$, [
                                    "canvas"
                                ]);
                                return [
                                    4,
                                    this._sendMessage("load", {
                                        config: _$r,
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_retire",
            value: function _retire() {
                this._retired = !0, this._created && (this._created = !1, this._cleanupStateMachineListeners(), this._eventManager.dispatch({
                    type: "destroy"
                }), this._eventManager.removeAllEventListeners(), $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && ($4df2746f4766bf20$var$M.unobserve(this._canvas), $4df2746f4766bf20$var$N.unobserve(this._canvas)));
            }
        },
        {
            key: "loopCount",
            get: function get() {
                return this._dotLottieInstanceState.loopCount;
            }
        },
        {
            key: "isLoaded",
            get: function get() {
                return this._dotLottieInstanceState.isLoaded;
            }
        },
        {
            key: "isPlaying",
            get: function get() {
                return this._dotLottieInstanceState.isPlaying;
            }
        },
        {
            key: "isPaused",
            get: function get() {
                return this._dotLottieInstanceState.isPaused;
            }
        },
        {
            key: "isStopped",
            get: function get() {
                return this._dotLottieInstanceState.isStopped;
            }
        },
        {
            key: "currentFrame",
            get: function get() {
                return this._dotLottieInstanceState.currentFrame;
            }
        },
        {
            key: "isFrozen",
            get: function get() {
                return this._dotLottieInstanceState.isFrozen;
            }
        },
        {
            key: "totalFrames",
            get: function get() {
                return this._dotLottieInstanceState.totalFrames;
            }
        },
        {
            key: "segment",
            get: function get() {
                return this._dotLottieInstanceState.segment;
            }
        },
        {
            key: "speed",
            get: function get() {
                return this._dotLottieInstanceState.speed;
            }
        },
        {
            key: "duration",
            get: function get() {
                return this._dotLottieInstanceState.duration;
            }
        },
        {
            key: "isReady",
            get: function get() {
                return this._dotLottieInstanceState.isReady;
            }
        },
        {
            key: "mode",
            get: function get() {
                return this._dotLottieInstanceState.mode;
            }
        },
        {
            key: "canvas",
            get: function get() {
                return this._canvas;
            }
        },
        {
            key: "setCanvas",
            value: function setCanvas(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t, n, _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = (typeof HTMLCanvasElement === "undefined" ? "undefined" : (0, $5djcY._)(HTMLCanvasElement)) < "u" && e instanceof HTMLCanvasElement, n = (typeof OffscreenCanvas === "undefined" ? "undefined" : (0, $5djcY._)(OffscreenCanvas)) < "u" && e instanceof OffscreenCanvas;
                                if (!t && !n) throw Error("Worker-based DotLottie requires HTMLCanvasElement or OffscreenCanvas");
                                if (!(this._canvas !== e)) return [
                                    3,
                                    3
                                ];
                                if (this._created && this._canvas !== null) throw Error("Cannot change canvas after worker instance is already created with a different canvas.");
                                this._canvas = e;
                                _tmp = !this._created && this._pendingConfig;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._create(this._pendingConfig)
                                ];
                            case 1:
                                _tmp = (_state.sent(), this._pendingConfig = null);
                                _state.label = 2;
                            case 2:
                                _tmp;
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "autoplay",
            get: function get() {
                return this._dotLottieInstanceState.autoplay;
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                return this._dotLottieInstanceState.backgroundColor;
            }
        },
        {
            key: "loop",
            get: function get() {
                return this._dotLottieInstanceState.loop;
            }
        },
        {
            key: "useFrameInterpolation",
            get: function get() {
                return this._dotLottieInstanceState.useFrameInterpolation;
            }
        },
        {
            key: "renderConfig",
            get: function get() {
                return this._dotLottieInstanceState.renderConfig;
            }
        },
        {
            key: "manifest",
            get: function get() {
                return this._dotLottieInstanceState.manifest;
            }
        },
        {
            key: "activeAnimationId",
            get: function get() {
                return this._dotLottieInstanceState.activeAnimationId;
            }
        },
        {
            key: "marker",
            get: function get() {
                return this._dotLottieInstanceState.marker;
            }
        },
        {
            key: "activeThemeId",
            get: function get() {
                return this._dotLottieInstanceState.activeThemeId;
            }
        },
        {
            key: "layout",
            get: function get() {
                return this._dotLottieInstanceState.layout;
            }
        },
        {
            key: "play",
            value: function play() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp, _tmp1;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this._sendMessage("play", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                _tmp1 = $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !$4df2746f4766bf20$var$L(this._canvas);
                                if (!_tmp1) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.freeze()
                                ];
                            case 3:
                                _tmp1 = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp = _tmp1;
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "pause",
            value: function pause() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("pause", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "stop",
            value: function stop() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("stop", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setSpeed",
            value: function setSpeed(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setSpeed", {
                                        instanceId: this._id,
                                        speed: e
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setMode",
            value: function setMode(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setMode", {
                                        instanceId: this._id,
                                        mode: e
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setFrame",
            value: function setFrame(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setFrame", {
                                        frame: e,
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setSegment",
            value: function setSegment(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setSegment", {
                                        instanceId: this._id,
                                        segment: [
                                            e,
                                            t
                                        ]
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "resetSegment",
            value: function resetSegment() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("resetSegment", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setRenderConfig",
            value: function setRenderConfig(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t, n, _$r, i, _tmp, _tmp1, _tmp2, _tmp3;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2
                                ];
                                t = e.devicePixelRatio, n = e.freezeOnOffscreen, _$r = e.quality, i = (0, $1DiK7._)(e, [
                                    "devicePixelRatio",
                                    "freezeOnOffscreen",
                                    "quality"
                                ]);
                                return [
                                    4,
                                    this._sendMessage("setRenderConfig", {
                                        instanceId: this._id,
                                        renderConfig: (0, $kWfK0._)((0, $hApvp._)((0, $kWfK0._)({}, this._dotLottieInstanceState.renderConfig, i), {
                                            devicePixelRatio: t || $4df2746f4766bf20$var$I(),
                                            freezeOnOffscreen: n !== null && n !== void 0 ? n : !0
                                        }), _$r !== void 0 && {
                                            quality: _$r
                                        })
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                _tmp = $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement;
                                if (!_tmp) return [
                                    3,
                                    9
                                ];
                                this._dotLottieInstanceState.renderConfig.autoResize ? $4df2746f4766bf20$var$N.observe(this._canvas, this) : $4df2746f4766bf20$var$N.unobserve(this._canvas);
                                if (!this._dotLottieInstanceState.renderConfig.freezeOnOffscreen) return [
                                    3,
                                    5
                                ];
                                $4df2746f4766bf20$var$M.observe(this._canvas, this);
                                _tmp2 = $4df2746f4766bf20$var$L(this._canvas);
                                if (_tmp2) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.freeze()
                                ];
                            case 3:
                                _tmp2 = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp1 = _tmp2;
                                return [
                                    3,
                                    8
                                ];
                            case 5:
                                $4df2746f4766bf20$var$M.unobserve(this._canvas);
                                _tmp3 = this._dotLottieInstanceState.isFrozen;
                                if (!_tmp3) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    this.unfreeze()
                                ];
                            case 6:
                                _tmp3 = _state.sent();
                                _state.label = 7;
                            case 7:
                                _tmp1 = _tmp3;
                                _state.label = 8;
                            case 8:
                                _tmp = _tmp1;
                                _state.label = 9;
                            case 9:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setUseFrameInterpolation",
            value: function setUseFrameInterpolation(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setUseFrameInterpolation", {
                                        instanceId: this._id,
                                        useFrameInterpolation: e
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setTheme",
            value: function setTheme(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this._sendMessage("setTheme", {
                                        instanceId: this._id,
                                        themeId: e
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "load",
            value: function load(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) {
                                    this._pendingConfig && (this._pendingConfig = (0, $kWfK0._)({}, this._pendingConfig, e));
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    this._sendMessage("load", {
                                        config: $4df2746f4766bf20$var$$(e),
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setLoop",
            value: function setLoop(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setLoop", {
                                        instanceId: this._id,
                                        loop: e
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setLoopCount",
            value: function setLoopCount(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setLoopCount", {
                                        instanceId: this._id,
                                        loopCount: e
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "resize",
            value: function resize() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _G, e, t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created || !this._canvas) return [
                                    2
                                ];
                                _G = $4df2746f4766bf20$var$G(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || $4df2746f4766bf20$var$I()), e = _G.height, t = _G.width;
                                return [
                                    4,
                                    this._sendMessage("resize", {
                                        height: e,
                                        instanceId: this._id,
                                        width: t
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, e, t, _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!this._created) return [
                                    2
                                ];
                                e = this._canvas, t = e instanceof HTMLCanvasElement ? $4df2746f4766bf20$var$Z.get(e) : void 0;
                                this._retire();
                                if (!(t && t.facade === this)) return [
                                    3,
                                    1
                                ];
                                _tmp = t.destroyTimer = setTimeout(function() {
                                    $4df2746f4766bf20$var$Z.delete(e), _this._finalizeDestroy();
                                }, 0);
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    this._finalizeDestroy()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_finalizeDestroy",
            value: function _finalizeDestroy() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $4df2746f4766bf20$var$J().unregisterEventHandler(this._id), $4df2746f4766bf20$var$J().unassignAnimationFromWorker(this._id);
                                return [
                                    4,
                                    this._sendMessage("destroy", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("freeze", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("unfreeze", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setBackgroundColor",
            value: function setBackgroundColor(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setBackgroundColor", {
                                        instanceId: this._id,
                                        backgroundColor: e
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "loadAnimation",
            value: function loadAnimation(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("loadAnimation", {
                                        animationId: e,
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setLayout",
            value: function setLayout(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setLayout", {
                                        instanceId: this._id,
                                        layout: e
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setSlots",
            value: function setSlots(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._sendMessage("setSlots", {
                                        instanceId: this._id,
                                        slots: e
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getSlotIds",
            value: function getSlotIds() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("getSlotIds", {
                                instanceId: this._id
                            }) : []
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getSlotType",
            value: function getSlotType(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("getSlotType", {
                                instanceId: this._id,
                                slotId: e
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getSlot",
            value: function getSlot(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("getSlot", {
                                instanceId: this._id,
                                slotId: e
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getSlots",
            value: function getSlots() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("getSlots", {
                                instanceId: this._id
                            }) : {}
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "setColorSlot",
            value: function setColorSlot(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("setColorSlot", {
                                instanceId: this._id,
                                slotId: e,
                                value: t
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "setScalarSlot",
            value: function setScalarSlot(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("setScalarSlot", {
                                instanceId: this._id,
                                slotId: e,
                                value: t
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "setVectorSlot",
            value: function setVectorSlot(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("setVectorSlot", {
                                instanceId: this._id,
                                slotId: e,
                                value: t
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "setGradientSlot",
            value: function setGradientSlot(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("setGradientSlot", {
                                instanceId: this._id,
                                slotId: e,
                                value: t,
                                colorStopCount: n
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "setTextSlot",
            value: function setTextSlot(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("setTextSlot", {
                                instanceId: this._id,
                                slotId: e,
                                value: t
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "setImageSlot",
            value: function setImageSlot(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var n;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    $4df2746f4766bf20$var$z(t)
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    2,
                                    this._sendMessage("setImageSlot", {
                                        instanceId: this._id,
                                        slotId: e,
                                        src: n
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "resetSlot",
            value: function resetSlot(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("resetSlot", {
                                instanceId: this._id,
                                slotId: e
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "clearSlot",
            value: function clearSlot(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("clearSlot", {
                                instanceId: this._id,
                                slotId: e
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "resetSlots",
            value: function resetSlots() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("resetSlots", {
                                instanceId: this._id
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "clearSlots",
            value: function clearSlots() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("clearSlots", {
                                instanceId: this._id
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "_updateDotLottieInstanceState",
            value: function _updateDotLottieInstanceState() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2
                                ];
                                return [
                                    4,
                                    this._sendMessage("getDotLottieInstanceState", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                e = _state.sent();
                                this._dotLottieInstanceState = e.state;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "markers",
            value: function markers() {
                return this._dotLottieInstanceState.markers;
            }
        },
        {
            key: "setMarker",
            value: function setMarker(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setMarker", {
                                        instanceId: this._id,
                                        marker: e
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setThemeData",
            value: function setThemeData(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this._sendMessage("setThemeData", {
                                        instanceId: this._id,
                                        themeData: e
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setViewport",
            value: function setViewport(e, t, n, r) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("setViewport", {
                                x: e,
                                y: t,
                                width: n,
                                height: r,
                                instanceId: this._id
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "animationSize",
            value: function animationSize() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("animationSize", {
                                instanceId: this._id
                            }) : {
                                height: 0,
                                width: 0
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "setTransform",
            value: function setTransform(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("setTransform", {
                                instanceId: this._id,
                                transform: e
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getTransform",
            value: function getTransform() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("getTransform", {
                                instanceId: this._id
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "_sendMessage",
            value: function _sendMessage(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, _$r;
                    return (0, $gh3Df._)(this, function(_state) {
                        _this = this;
                        _$r = $4df2746f4766bf20$var$Y(e, t);
                        return [
                            2,
                            new Promise(function(t, i) {
                                $4df2746f4766bf20$var$J().registerRpcReplyHandler(_$r.id, function(n) {
                                    $4df2746f4766bf20$var$J().unregisterRpcReplyHandler(_$r.id);
                                    var a = n.data;
                                    a.error ? i(Error("Failed to execute method ".concat(e, ": ").concat(a.error))) : t(a.result);
                                }), _this._worker.postMessage(_$r, n || []);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(e, t) {
                this._eventManager.addEventListener(e, t);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(e, t) {
                this._eventManager.removeEventListener(e, t);
            }
        },
        {
            key: "stateMachineLoad",
            value: function stateMachineLoad(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this._sendMessage("stateMachineLoad", {
                                        instanceId: this._id,
                                        stateMachineId: e
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineLoadData",
            value: function stateMachineLoadData(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this._sendMessage("stateMachineLoadData", {
                                        instanceId: this._id,
                                        stateMachineData: e
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineStart",
            value: function stateMachineStart() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var e, _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this._sendMessage("stateMachineStart", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                e = _state.sent();
                                _tmp = e;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                this._setupStateMachineListeners();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    (_tmp, e)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineStop",
            value: function stateMachineStop() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stateMachineStop", {
                                instanceId: this._id
                            })) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineSetNumericInput",
            value: function stateMachineSetNumericInput(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineSetNumericInput", {
                                instanceId: this._id,
                                name: e,
                                value: t
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineSetBooleanInput",
            value: function stateMachineSetBooleanInput(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineSetBooleanInput", {
                                instanceId: this._id,
                                name: e,
                                value: t
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineSetConfig",
            value: function stateMachineSetConfig(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        this._created && this._sendMessage("stateMachineSetConfig", {
                            instanceId: this._id,
                            config: e
                        });
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineSetStringInput",
            value: function stateMachineSetStringInput(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineSetStringInput", {
                                instanceId: this._id,
                                name: e,
                                value: t
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGetNumericInput",
            value: function stateMachineGetNumericInput(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachineGetNumericInput", {
                                instanceId: this._id,
                                name: e
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGetBooleanInput",
            value: function stateMachineGetBooleanInput(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachineGetBooleanInput", {
                                instanceId: this._id,
                                name: e
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGetStringInput",
            value: function stateMachineGetStringInput(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachineGetStringInput", {
                                instanceId: this._id,
                                name: e
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGetInputs",
            value: function stateMachineGetInputs() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachineGetInputs", {
                                instanceId: this._id
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineFireEvent",
            value: function stateMachineFireEvent(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        this._created && this._sendMessage("stateMachineFireEvent", {
                            instanceId: this._id,
                            name: e
                        });
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGetStatus",
            value: function stateMachineGetStatus() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineGetStatus", {
                                instanceId: this._id
                            }) : ""
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGetCurrentState",
            value: function stateMachineGetCurrentState() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineGetCurrentState", {
                                instanceId: this._id
                            }) : ""
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGetActiveId",
            value: function stateMachineGetActiveId() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineGetActiveId", {
                                instanceId: this._id
                            }) : ""
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineOverrideState",
            value: function stateMachineOverrideState(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function(e) {
                    var t;
                    var _arguments = arguments;
                    return (0, $gh3Df._)(this, function(_state) {
                        t = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !1;
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineOverrideState", {
                                instanceId: this._id,
                                state: e,
                                immediate: t
                            }) : !1
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "stateMachineSetSeed",
            value: function stateMachineSetSeed(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineSetSeed", {
                                instanceId: this._id,
                                seed: e
                            }) : !1
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGet",
            value: function stateMachineGet(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineGet", {
                                instanceId: this._id,
                                stateMachineId: e
                            }) : ""
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachineGetListeners",
            value: function stateMachineGetListeners() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("stateMachineGetListeners", {
                                instanceId: this._id
                            }) : []
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachinePostClickEvent",
            value: function stateMachinePostClickEvent(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachinePostClickEvent", {
                                instanceId: this._id,
                                x: e,
                                y: t
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachinePostPointerUpEvent",
            value: function stateMachinePostPointerUpEvent(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachinePostPointerUpEvent", {
                                instanceId: this._id,
                                x: e,
                                y: t
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachinePostPointerDownEvent",
            value: function stateMachinePostPointerDownEvent(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachinePostPointerDownEvent", {
                                instanceId: this._id,
                                x: e,
                                y: t
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachinePostPointerMoveEvent",
            value: function stateMachinePostPointerMoveEvent(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachinePostPointerMoveEvent", {
                                instanceId: this._id,
                                x: e,
                                y: t
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachinePostPointerEnterEvent",
            value: function stateMachinePostPointerEnterEvent(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachinePostPointerEnterEvent", {
                                instanceId: this._id,
                                x: e,
                                y: t
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "stateMachinePostPointerExitEvent",
            value: function stateMachinePostPointerExitEvent(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this._created) return [
                            2,
                            this._sendMessage("stateMachinePostPointerExitEvent", {
                                instanceId: this._id,
                                x: e,
                                y: t
                            })
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "_onClick",
            value: function _onClick(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this._sendMessage("stateMachinePostClickEvent", {
                    instanceId: this._id,
                    x: t.x,
                    y: t.y
                });
            }
        },
        {
            key: "_onPointerUp",
            value: function _onPointerUp(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this._sendMessage("stateMachinePostPointerUpEvent", {
                    instanceId: this._id,
                    x: t.x,
                    y: t.y
                });
            }
        },
        {
            key: "_onPointerDown",
            value: function _onPointerDown(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this._sendMessage("stateMachinePostPointerDownEvent", {
                    instanceId: this._id,
                    x: t.x,
                    y: t.y
                });
            }
        },
        {
            key: "_onPointerMove",
            value: function _onPointerMove(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this._sendMessage("stateMachinePostPointerMoveEvent", {
                    instanceId: this._id,
                    x: t.x,
                    y: t.y
                });
            }
        },
        {
            key: "_onPointerEnter",
            value: function _onPointerEnter(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this._sendMessage("stateMachinePostPointerEnterEvent", {
                    instanceId: this._id,
                    x: t.x,
                    y: t.y
                });
            }
        },
        {
            key: "_onPointerLeave",
            value: function _onPointerLeave(e) {
                var t = $4df2746f4766bf20$var$R(e);
                t && this._sendMessage("stateMachinePostPointerExitEvent", {
                    instanceId: this._id,
                    x: t.x,
                    y: t.y
                });
            }
        },
        {
            key: "_setupStateMachineListeners",
            value: function _setupStateMachineListeners() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!($4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && this.isLoaded)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._sendMessage("stateMachineGetListeners", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                e = _state.sent();
                                if (e.length === 0) return [
                                    2
                                ];
                                this._cleanupStateMachineListeners(), e.includes("Click") && (this._boundOnClick = this._onClick.bind(this), this._canvas.addEventListener("click", this._boundOnClick)), e.includes("PointerUp") && (this._boundOnPointerUp = this._onPointerUp.bind(this), this._canvas.addEventListener("pointerup", this._boundOnPointerUp)), e.includes("PointerDown") && (this._boundOnPointerDown = this._onPointerDown.bind(this), this._canvas.addEventListener("pointerdown", this._boundOnPointerDown)), e.includes("PointerMove") && (this._boundOnPointerMove = this._onPointerMove.bind(this), this._canvas.addEventListener("pointermove", this._boundOnPointerMove)), e.includes("PointerEnter") && (this._boundOnPointerEnter = this._onPointerEnter.bind(this), this._canvas.addEventListener("pointerenter", this._boundOnPointerEnter)), e.includes("PointerExit") && (this._boundOnPointerLeave = this._onPointerLeave.bind(this), this._canvas.addEventListener("pointerleave", this._boundOnPointerLeave));
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_cleanupStateMachineListeners",
            value: function _cleanupStateMachineListeners() {
                $4df2746f4766bf20$var$s && this._canvas instanceof HTMLCanvasElement && (this._boundOnClick && (this._canvas.removeEventListener("click", this._boundOnClick), this._boundOnClick = null), this._boundOnPointerUp && (this._canvas.removeEventListener("pointerup", this._boundOnPointerUp), this._boundOnPointerUp = null), this._boundOnPointerDown && (this._canvas.removeEventListener("pointerdown", this._boundOnPointerDown), this._boundOnPointerDown = null), this._boundOnPointerMove && (this._canvas.removeEventListener("pointermove", this._boundOnPointerMove), this._boundOnPointerMove = null), this._boundOnPointerEnter && (this._canvas.removeEventListener("pointerenter", this._boundOnPointerEnter), this._boundOnPointerEnter = null), this._boundOnPointerLeave && (this._canvas.removeEventListener("pointerleave", this._boundOnPointerLeave), this._boundOnPointerLeave = null));
            }
        }
    ], [
        {
            key: "setWasmUrl",
            value: function setWasmUrl(e) {
                if (typeof e != "string" || e.trim() === "") throw TypeError("setWasmUrl() expects a non-empty URL string");
                $4df2746f4766bf20$var$X = $4df2746f4766bf20$var$Q(e), $4df2746f4766bf20$var$J().broadcastMessage($4df2746f4766bf20$var$Y("setWasmUrl", {
                    url: $4df2746f4766bf20$var$X
                }));
            }
        },
        {
            key: "setWorkerUrl",
            value: function setWorkerUrl(e) {
                if (typeof e != "string" || e.trim() === "") throw TypeError("setWorkerUrl() expects a non-empty URL string");
                globalThis.__dotLottieWorkerUrl = e;
            }
        },
        {
            key: "registerFont",
            value: function registerFont(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        try {
                            return [
                                2,
                                ($4df2746f4766bf20$var$J().broadcastMessage($4df2746f4766bf20$var$Y("registerFont", {
                                    fontName: e,
                                    fontSource: t
                                })), !0)
                            ];
                        } catch (t) {
                            return [
                                2,
                                (console.error('Error broadcasting registerFont for "'.concat(e, '":'), t), !1)
                            ];
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return Te;
}();

});
parcelRegister("kWfK0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3e56f3eac89eefa$export$71511d61b312f219; });

var $6tY97 = parcelRequire("6tY97");
function $f3e56f3eac89eefa$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6tY97._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("6tY97", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b841b45c75a3225$export$71511d61b312f219; });
function $4b841b45c75a3225$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hApvp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccd99553ef7f1c61$export$71511d61b312f219; });
function $ccd99553ef7f1c61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ccd99553ef7f1c61$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $ccd99553ef7f1c61$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("1DiK7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1307f8e9916ec00c$export$71511d61b312f219; });

var $fD3AT = parcelRequire("fD3AT");
function $1307f8e9916ec00c$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $fD3AT._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("fD3AT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b60d49377240381a$export$71511d61b312f219; });
function $b60d49377240381a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("jlUaU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e16b8da7da809cdc$export$71511d61b312f219; });

var $dTQYG = parcelRequire("dTQYG");

var $d95Qy = parcelRequire("d95Qy");

var $eanwW = parcelRequire("eanwW");

var $J66Jb = parcelRequire("J66Jb");
function $e16b8da7da809cdc$export$71511d61b312f219(arr) {
    return (0, $dTQYG._)(arr) || (0, $d95Qy._)(arr) || (0, $J66Jb._)(arr) || (0, $eanwW._)();
}

});
parcelRegister("dTQYG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a1e981ac9d7864a0$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $a1e981ac9d7864a0$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2PuG4._)(arr);
}

});

parcelRegister("d95Qy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9920a6ac5bee97c9$export$71511d61b312f219; });
function $9920a6ac5bee97c9$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eanwW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a504407b7f865a13$export$71511d61b312f219; });
function $a504407b7f865a13$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("5djcY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cbd10fe5fe1c504$export$71511d61b312f219; });
function $3cbd10fe5fe1c504$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("6VBea", function(module, exports) {
$parcel$export(module.exports, "b64_decode", function () { return (parcelRequire("hDdJN")).b64_decode; });
$parcel$export(module.exports, "getAllCookies", function () { return (parcelRequire("fnNvV")).getAllCookies; });
$parcel$export(module.exports, "elementReady", function () { return (parcelRequire("7YAJ4")).elementReady; });
$parcel$export(module.exports, "addWindowResizeEvent", function () { return (parcelRequire("2pyvk")).addWindowResizeEvent; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return (parcelRequire("2pyvk")).addWindowScrollEvent; });
$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return (parcelRequire("9uiPq")).getReCAPTCHAResponse; });
$parcel$export(module.exports, "slideDown", function () { return (parcelRequire("cPDzI")).slideDown; });
$parcel$export(module.exports, "slideUp", function () { return (parcelRequire("cPDzI")).slideUp; });
$parcel$export(module.exports, "scrollToElement", function () { return (parcelRequire("9vUSI")).scrollToElement; });
$parcel$export(module.exports, "getThemeData", function () { return (parcelRequire("4XCT3")).getThemeData; });
$parcel$export(module.exports, "waitForElement", function () { return (parcelRequire("5BaYK")).waitForElement; });
parcelRequire("hDdJN");
parcelRequire("fnNvV");
parcelRequire("7YAJ4");
parcelRequire("2pyvk");
parcelRequire("9uiPq");
parcelRequire("cPDzI");
parcelRequire("9vUSI");
parcelRequire("4XCT3");
parcelRequire("5BaYK");

});
parcelRegister("hDdJN", function(module, exports) {

$parcel$export(module.exports, "b64_decode", function () { return $cd60bc3867d72b58$export$bf9d481ba07b53f9; });
var $cd60bc3867d72b58$export$3c2a198a9c1ae5f3 = function(string) {
    return window.btoa(unescape(encodeURIComponent(string)));
};
var $cd60bc3867d72b58$export$bf9d481ba07b53f9 = function(string) {
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("fnNvV", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", function () { return $b32f6972fc6e67b5$export$1191989ae3ee4c15; });
var $b32f6972fc6e67b5$export$1191989ae3ee4c15 = function() {
    var cookies = document.cookie.split('; ');
    var allCookies = [];
    cookies.forEach(function(cookie) {
        var cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("7YAJ4", function(module, exports) {

$parcel$export(module.exports, "elementReady", function () { return $5cea9fff8806cfad$export$5a68694636710d38; });
var $5cea9fff8806cfad$export$5a68694636710d38 = function(selector) {
    return new Promise(function(resolve) {
        var el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(function() {
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach(function(element) {
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });
};

});

parcelRegister("2pyvk", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", function () { return $1c18ae62fb4dbf93$export$5f2cd73bfe4df536; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return $1c18ae62fb4dbf93$export$b502183889628ce0; });
var $1c18ae62fb4dbf93$export$5f2cd73bfe4df536 = function(callback) {
    var timeout;
    window.addEventListener('resize', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
var $1c18ae62fb4dbf93$export$b502183889628ce0 = function(callback) {
    var timeout;
    window.addEventListener('scroll', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("9uiPq", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return $6e85854efd3089cd$export$26ae508a4c7ca84d; });

var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");

var $4XCT3 = parcelRequire("4XCT3");
var $6e85854efd3089cd$export$26ae508a4c7ca84d = function(action) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _themeData_ajax_actions, themeData, e;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $4XCT3.getThemeData)()
                    ];
                case 1:
                    themeData = _state.sent();
                    if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
                    if (!((_themeData_ajax_actions = themeData.ajax_actions) === null || _themeData_ajax_actions === void 0 ? void 0 : _themeData_ajax_actions.recaptcha_verify)) throw new Error('Missing AJAX route to verify reCAPTCHA token');
                    if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            if (window.grecaptcha === undefined) {
                                console.warn('Google reCAPTCHA is not loaded');
                                resolve({
                                    success: true,
                                    score: 1
                                });
                            } else window.grecaptcha.ready(function() {
                                window.grecaptcha.execute(themeData.recaptcha_site_key, {
                                    action: action
                                }).then(function(token) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                        var formData, testParam, url, response, json, errorMessages, e;
                                        return (0, $gh3Df._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    formData = new FormData();
                                                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                                                    // Determine if request is just a test
                                                    testParam = 'e2e-test';
                                                    url = new URL(window.location);
                                                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                                                    // Set reCAPTCHA token
                                                    formData.append('recaptcha_token', token);
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        4,
                                                        ,
                                                        5
                                                    ]);
                                                    return [
                                                        4,
                                                        fetch(themeData.ajax_route, {
                                                            method: 'POST',
                                                            body: formData
                                                        })
                                                    ];
                                                case 2:
                                                    response = _state.sent();
                                                    return [
                                                        4,
                                                        response.json()
                                                    ];
                                                case 3:
                                                    json = _state.sent();
                                                    if (json.success) resolve(json);
                                                    else if (json['error-codes']) {
                                                        /**
								 * reCAPTCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ errorMessages = [];
                                                        json['error-codes'].forEach(function(errorCode) {
                                                            switch(errorCode){
                                                                case 'missing-input-secret':
                                                                    errorMessages.push('The secret parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-secret':
                                                                    errorMessages.push('The secret parameter is invalid or malformed.');
                                                                    break;
                                                                case 'missing-input-response':
                                                                    errorMessages.push('The response parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-response':
                                                                    errorMessages.push('The response parameter is invalid or malformed.');
                                                                    break;
                                                                case 'bad-request':
                                                                    errorMessages.push('The request is invalid or malformed.');
                                                                    break;
                                                                case 'timeout-or-duplicate':
                                                                    errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                                                    break;
                                                                default:
                                                                    errorMessages.push('Unknown reCAPTCHA error code');
                                                            }
                                                        });
                                                        throw new Error("There was an error when trying to verify the user's response by reCAPTCHA:\n".concat(errorMessages.join('\n')));
                                                    } else if (json.data) throw new Error("The request to verify the reCAPTCHA user token failed: ".concat(response.data));
                                                    else throw new Error('Unknown error occurred when trying to verify the reCAPTCHA user token');
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 4:
                                                    e = _state.sent();
                                                    reject(e);
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                            });
                        })
                    ];
                case 2:
                    e = _state.sent();
                    console.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};

});
parcelRegister("4XCT3", function(module, exports) {

$parcel$export(module.exports, "getThemeData", function () { return $39cad640efa60b84$export$3c72f11fd9e5031f; });
var $39cad640efa60b84$export$3c72f11fd9e5031f = function() {
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        var sessionStorageKey = 'themeData';
        return new Promise(function(resolve, reject) {
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then(function(res) {
                return res.json();
            }).then(function(data) {
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch(function(e) {
                return reject(e);
            });
        });
    }
};

});


parcelRegister("cPDzI", function(module, exports) {

$parcel$export(module.exports, "slideUp", function () { return $9578f243206a91ae$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $9578f243206a91ae$export$abdd11a06a163232; });
var $9578f243206a91ae$export$deed561b1a0ff1ea = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        window.setTimeout(function() {
            if (!isSearchable) target.style.display = 'none';
            [
                'height',
                'padding-top',
                'padding-bottom',
                'margin-top',
                'margin-bottom',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$abdd11a06a163232 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        if (!isSearchable) {
            target.style.removeProperty('display');
            var display = window.getComputedStyle(target).display;
            if (display === 'none') display = 'block';
            target.style.display = display;
        }
        var height = target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        [
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom'
        ].forEach(function(prop) {
            return target.style.removeProperty(prop);
        });
        window.setTimeout(function() {
            [
                'height',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$715de50cedc228a8 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    return window.getComputedStyle(target).display === 'none' ? $9578f243206a91ae$export$abdd11a06a163232(target, duration) : $9578f243206a91ae$export$deed561b1a0ff1ea(target, duration);
};

});

parcelRegister("9vUSI", function(module, exports) {

$parcel$export(module.exports, "scrollToElement", function () { return $6ed321ce261ae421$export$2353115f31f4d15; });
var $6ed321ce261ae421$export$2353115f31f4d15 = function(selector) {
    var targetEl = document.querySelector(selector);
    if (!targetEl) return;
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top);
};

});

parcelRegister("5BaYK", function(module, exports) {

$parcel$export(module.exports, "waitForElement", function () { return $4138ec9fb36217c9$export$1a1c301579a08d1e; });
var $4138ec9fb36217c9$export$1a1c301579a08d1e = function(selector) {
    return new Promise(function(resolve) {
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        var observer = new MutationObserver(function() {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});


parcelRegister("1TS6r", function(module, exports) {

$parcel$export(module.exports, "fetchAnimationData", function () { return $1e001876c1feae28$export$b8223fa037cc21d8; });
$parcel$export(module.exports, "getCurrentAnimationData", function () { return $1e001876c1feae28$export$cf594973debfe9c3; });

var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");
var $1e001876c1feae28$export$b8223fa037cc21d8 = function(src) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var response, error;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(src)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new Error("Error fetching animation data: ".concat(response.status));
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    console.error('Error fetching animation data', error);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $1e001876c1feae28$export$cf594973debfe9c3 = function(data) {
    var colorScheme = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement.getAttribute('data-color-scheme');
    var isDark = colorScheme === 'dark';
    return isDark && data.dataDark ? data.dataDark : data.dataLight;
};

});


parcelRegister("jAcWp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("iQHBV")).S; });
/**
 * Swiper 14.3.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 28, 2026
 */ 
var $iQHBV = parcelRequire("iQHBV");

});
parcelRegister("iQHBV", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $9cce2902fa373f83$export$25ce5a424b770e84; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $g9Jbh = parcelRequire("g9Jbh");
var $9cce2902fa373f83$var$supportCached;
function $9cce2902fa373f83$var$calcSupport() {
    if (typeof window === 'undefined') return {
        touch: false
    };
    return {
        touch: 'ontouchstart' in window || navigator.maxTouchPoints > 0
    };
}
function $9cce2902fa373f83$var$getSupport() {
    if (!$9cce2902fa373f83$var$supportCached) $9cce2902fa373f83$var$supportCached = $9cce2902fa373f83$var$calcSupport();
    return $9cce2902fa373f83$var$supportCached;
}
var $9cce2902fa373f83$var$deviceCached;
function $9cce2902fa373f83$var$calcDevice() {
    var userAgent = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).userAgent;
    if (typeof window === 'undefined') return {
        ios: false,
        android: false
    };
    var support = $9cce2902fa373f83$var$getSupport();
    var platform = navigator.platform;
    var ua = userAgent || navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
    var isIPhoneOrIPod = /(iPhone\sOS|iOS|iPod)/.test(ua);
    var isIPadDirect = /iPad/.test(ua);
    // iPad on iPadOS 13+ reports as MacIntel; distinguish from a real Mac by touch capability.
    var isIPadMasquerade = platform === 'MacIntel' && support.touch && navigator.maxTouchPoints > 1;
    var isIPad = isIPadDirect || isIPadMasquerade;
    var isWindows = platform === 'Win32';
    if (isAndroid && !isWindows) {
        device.os = 'android';
        device.android = true;
    }
    if (isIPad || isIPhoneOrIPod) {
        device.os = 'ios';
        device.ios = true;
    }
    return device;
}
function $9cce2902fa373f83$var$getDevice() {
    var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!$9cce2902fa373f83$var$deviceCached) $9cce2902fa373f83$var$deviceCached = $9cce2902fa373f83$var$calcDevice(overrides);
    return $9cce2902fa373f83$var$deviceCached;
}
var $9cce2902fa373f83$var$browserCached;
function $9cce2902fa373f83$var$calcBrowser() {
    if (typeof window === 'undefined') return {
        isSafari: false,
        isWebView: false,
        need3dFix: false
    };
    var device = $9cce2902fa373f83$var$getDevice();
    var ua = navigator.userAgent;
    var uaLower = ua.toLowerCase();
    var isSafari = uaLower.includes('safari') && !uaLower.includes('chrome') && !uaLower.includes('android');
    var isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
    // 3D transform glitches still affect iOS WebView and Safari at the baseline (16.4+).
    var need3dFix = isSafari || isWebView && device.ios;
    return {
        isSafari: isSafari,
        isWebView: isWebView,
        need3dFix: need3dFix
    };
}
function $9cce2902fa373f83$var$getBrowser() {
    if (!$9cce2902fa373f83$var$browserCached) $9cce2902fa373f83$var$browserCached = $9cce2902fa373f83$var$calcBrowser();
    return $9cce2902fa373f83$var$browserCached;
}
var $9cce2902fa373f83$var$processLazyPreloader = function(swiper, imageEl) {
    if (!swiper || swiper.destroyed || !swiper.params || !swiper.params.lazyPreload) return;
    var slideSelector = function() {
        return swiper.isElement ? 'swiper-slide' : ".".concat(swiper.params.slideClass);
    };
    var slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        var lazyEl = slideEl.querySelector(".".concat(swiper.params.lazyPreloaderClass));
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(".".concat(swiper.params.lazyPreloaderClass));
            else requestAnimationFrame(function() {
                if (slideEl.shadowRoot) {
                    var innerLazy = slideEl.shadowRoot.querySelector(".".concat(swiper.params.lazyPreloaderClass));
                    if (innerLazy && !innerLazy.lazyPreloaderManaged) innerLazy.remove();
                }
            });
        }
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
};
var $9cce2902fa373f83$var$unlazy = function(swiper, index) {
    if (!swiper.slides[index]) return;
    var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
var $9cce2902fa373f83$var$preload = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params || !swiper.params.lazyPreload) return;
    var amount = swiper.params.lazyPreloadPrevNext;
    var len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    var slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    var activeIndex = swiper.activeIndex;
    var _swiper_params_grid_rows;
    if (swiper.params.grid && ((_swiper_params_grid_rows = swiper.params.grid.rows) !== null && _swiper_params_grid_rows !== void 0 ? _swiper_params_grid_rows : 1) > 1) {
        var _preloadColumns;
        var activeColumn = activeIndex;
        var preloadColumns = [
            activeColumn - amount
        ];
        (_preloadColumns = preloadColumns).push.apply(_preloadColumns, (0, $jlUaU._)(Array.from({
            length: amount
        }).map(function(_, i) {
            return activeColumn + slidesPerView + i;
        })));
        swiper.slides.forEach(function(slideEl, i) {
            if (slideEl.column !== undefined && preloadColumns.includes(slideEl.column)) $9cce2902fa373f83$var$unlazy(swiper, i);
        });
        return;
    }
    var slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        var realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $9cce2902fa373f83$var$unlazy(swiper, realIndex);
    }
    else {
        for(var i1 = Math.max(activeIndex - amount, 0); i1 <= Math.min(slideIndexLastInView + amount, len - 1); i1 += 1)if (i1 !== activeIndex && (i1 > slideIndexLastInView || i1 < activeIndex)) $9cce2902fa373f83$var$unlazy(swiper, i1);
    }
};
function $9cce2902fa373f83$var$getBreakpoint(breakpoints) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'window', containerEl = arguments.length > 2 ? arguments[2] : void 0;
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    var breakpoint = false;
    var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(String(a.value), 10) - parseInt(String(b.value), 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === 'window') {
            if (window.matchMedia("(min-width: ".concat(value, "px)")).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $9cce2902fa373f83$var$isGridEnabled = function(swiper, params) {
    return !!(swiper.grid && params.grid && params.grid.rows > 1);
};
function $9cce2902fa373f83$var$setBreakpoint() {
    var swiper = this;
    var realIndex = swiper.realIndex, initialized = swiper.initialized, params = swiper.params, el = swiper.el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window/container width and update parameters
    var breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    var breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document.querySelector(params.breakpointsBase);
    var breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointsRecord = breakpoints;
    var breakpointOnlyParams = breakpoint in breakpointsRecord ? breakpointsRecord[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = $9cce2902fa373f83$var$isGridEnabled(swiper, params);
    var isMultiRow = $9cce2902fa373f83$var$isGridEnabled(swiper, breakpointParams);
    var wasGrabCursor = swiper.params.grabCursor;
    var isGrabCursor = breakpointParams.grabCursor;
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add("".concat(params.containerModifierClass, "grid"));
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add("".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    var moduleOpt = function(opts, prop) {
        return opts[prop];
    };
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach(function(prop) {
        var _moduleApi_disable, _moduleApi_enable;
        var bpOpts = moduleOpt(breakpointParams, prop);
        if (typeof bpOpts === 'undefined') return;
        var paramsOpts = moduleOpt(params, prop);
        var wasModuleEnabled = (typeof paramsOpts === "undefined" ? "undefined" : (0, $5djcY._)(paramsOpts)) === 'object' && paramsOpts !== null && paramsOpts.enabled;
        var isModuleEnabled = (typeof bpOpts === "undefined" ? "undefined" : (0, $5djcY._)(bpOpts)) === 'object' && bpOpts !== null && bpOpts.enabled;
        var moduleApi = swiper[prop];
        if (wasModuleEnabled && !isModuleEnabled) moduleApi === null || moduleApi === void 0 ? void 0 : (_moduleApi_disable = moduleApi.disable) === null || _moduleApi_disable === void 0 ? void 0 : _moduleApi_disable.call(moduleApi);
        if (!wasModuleEnabled && isModuleEnabled) moduleApi === null || moduleApi === void 0 ? void 0 : (_moduleApi_enable = moduleApi.enable) === null || _moduleApi_enable === void 0 ? void 0 : _moduleApi_enable.call(moduleApi);
    });
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    var wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $g9Jbh.n)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    var hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        // Lay out with the new params before loopCreate(), so loopFix() sees current sizes and
        // isLocked state (a slider locked by watchOverflow skips loop entirely, #8228)
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.updateSlides();
            swiper.loopCreate(realIndex);
        } else if (!wasLoop && hasLoop) {
            swiper.updateSlides();
            swiper.loopCreate(realIndex);
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
var $9cce2902fa373f83$var$breakpoints = {
    setBreakpoint: $9cce2902fa373f83$var$setBreakpoint,
    getBreakpoint: $9cce2902fa373f83$var$getBreakpoint
};
function $9cce2902fa373f83$var$checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $9cce2902fa373f83$var$checkOverflow$1 = {
    checkOverflow: $9cce2902fa373f83$var$checkOverflow
};
function $9cce2902fa373f83$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if ((typeof item === "undefined" ? "undefined" : (0, $5djcY._)(item)) === 'object') Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $9cce2902fa373f83$var$addClasses() {
    var _classNames, _el_classList;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, el = swiper.el, device = swiper.device;
    // oxfmt-ignore
    var suffixes = $9cce2902fa373f83$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, $jlUaU._)(suffixes));
    (_el_classList = el.classList).add.apply(_el_classList, (0, $jlUaU._)(classNames));
    swiper.emitContainerClasses();
}
function $9cce2902fa373f83$var$removeClasses() {
    var _el_classList;
    var swiper = this;
    var el = swiper.el, classNames = swiper.classNames;
    if (!el || typeof el === 'string') return;
    (_el_classList = el.classList).remove.apply(_el_classList, (0, $jlUaU._)(classNames));
    swiper.emitContainerClasses();
}
var $9cce2902fa373f83$var$classes = {
    addClasses: $9cce2902fa373f83$var$addClasses,
    removeClasses: $9cce2902fa373f83$var$removeClasses
};
var $9cce2902fa373f83$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreload: true,
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
var $9cce2902fa373f83$var$eventsEmitter = {
    on: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        var onceHandler = function onceHandlerFn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        };
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(function(event) {
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            var opts = args[0];
            events = opts.events;
            var _opts_data;
            data = (_opts_data = opts.data) !== null && _opts_data !== void 0 ? _opts_data : [];
            context = opts.context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, $jlUaU._)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $9cce2902fa373f83$var$onClick(e) {
    var swiper = this;
    if (swiper.destroyed) return;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $9cce2902fa373f83$var$onDocumentTouchStart() {
    var swiper = this;
    if (swiper.destroyed) return;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
function $9cce2902fa373f83$var$onLoad(e) {
    var swiper = this;
    if (swiper.destroyed) return;
    $9cce2902fa373f83$var$processLazyPreloader(swiper, e.target);
    if (e.type === 'error' || swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $9cce2902fa373f83$var$onResize() {
    var _swiper_params_virtual;
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    var isVirtual = swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled);
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    var isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
        var slidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
        swiper.slideTo(slidesLength - 1, 0, false, true);
    } else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        var autoplay = swiper.autoplay;
        clearTimeout(autoplay.resizeTimeout);
        autoplay.resizeTimeout = setTimeout(function() {
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $9cce2902fa373f83$var$onScroll() {
    var swiper = this;
    if (swiper.destroyed) return;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $9cce2902fa373f83$var$onTouchEnd(event) {
    var swiper = this;
    if (swiper.destroyed) return;
    var data = swiper.touchEventsData;
    var _event_originalEvent;
    var e = (_event_originalEvent = event.originalEvent) !== null && _event_originalEvent !== void 0 ? _event_originalEvent : event;
    var isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        var pe = e;
        if (pe.pointerId !== data.pointerId) return;
    } else {
        var te = e;
        var found = (0, $jlUaU._)(te.changedTouches).find(function(t) {
            return t.identifier === data.touchId;
        });
        if (!found || found.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        var proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    data.startEventPath = undefined;
    data.lastMoveEvent = undefined;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    var touchEndTime = (0, $g9Jbh.u)();
    var timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var _e_path;
        // Legacy `e.path` was a non-standard Chrome extension; `composedPath()` is the modern API.
        var pathTree = (_e_path = e.path) !== null && _e_path !== void 0 ? _e_path : e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0], pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $g9Jbh.u)();
    (0, $g9Jbh.t)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    var _data_currentTranslate;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -((_data_currentTranslate = data.currentTranslate) !== null && _data_currentTranslate !== void 0 ? _data_currentTranslate : 0);
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    var swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    var rewindFirstIndex = null;
    var rewindLastIndex = null;
    if (params.rewind) {
        var _params_virtual;
        if (swiper.isBeginning) rewindLastIndex = ((_params_virtual = params.virtual) === null || _params_virtual === void 0 ? void 0 : _params_virtual.enabled) && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment1);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}
function $9cce2902fa373f83$var$onTouchMove(event) {
    var swiper = this;
    if (swiper.destroyed) return;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    // Legacy event wrappers nest the native event under .originalEvent.
    var wrapped = event;
    var _wrapped_originalEvent;
    var e = (_wrapped_originalEvent = wrapped.originalEvent) !== null && _wrapped_originalEvent !== void 0 ? _wrapped_originalEvent : wrapped;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        var pe = e;
        if (pe.pointerId !== data.pointerId) return;
    }
    var targetTouch;
    if (e.type === 'touchmove') {
        var te = e;
        var found = (0, $jlUaU._)(te.changedTouches).find(function(t) {
            return t.identifier === data.touchId;
        });
        if (!found || found.identifier !== data.touchId) return;
        targetTouch = found;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    // Nested swipers listen on document in capture phase, so they run in registration order and
    // an ancestor initialized first would move before its descendant can set
    // preventedByNestedSwiper. Run touched nested descendants first, innermost to outermost.
    if (data.lastMoveEvent === e) return;
    data.lastMoveEvent = e;
    var _data_startEventPath;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((_data_startEventPath = data.startEventPath) !== null && _data_startEventPath !== void 0 ? _data_startEventPath : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (node === swiper.el) break;
            var child = node.swiper;
            if (child && child !== swiper && !child.destroyed && child.params.nested && child.touchEventsData.isTouched) child.onTouchMove(event);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var pageX = targetTouch.pageX;
    var pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $g9Jbh.u)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== e.target && e.pointerType !== 'mouse') document.activeElement.blur();
    if (document.activeElement) {
        if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    var diff = swiper.isHorizontal() ? diffX : diffY;
    var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    var prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    var isLoop = swiper.params.loop && !params.cssMode;
    var allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            var evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    var _data_startTranslate;
    // startTranslate is guaranteed to be set by this point (set in onTouchStart-side init).
    var startTranslate = (_data_startTranslate = data.startTranslate) !== null && _data_startTranslate !== void 0 ? _data_startTranslate : 0;
    data.currentTranslate = diff + startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + startTranslate + diff, resistanceRatio);
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(String(params.slidesPerView))))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - startTranslate - diff, resistanceRatio);
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    var _data_currentTranslate;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && ((_data_currentTranslate = data.currentTranslate) !== null && _data_currentTranslate !== void 0 ? _data_currentTranslate : 0) < startTranslate) data.currentTranslate = startTranslate;
    var _data_currentTranslate1;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && ((_data_currentTranslate1 = data.currentTranslate) !== null && _data_currentTranslate1 !== void 0 ? _data_currentTranslate1 : 0) > startTranslate) data.currentTranslate = startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    var _data_currentTranslate2;
    // Update translate
    swiper.setTranslate((_data_currentTranslate2 = data.currentTranslate) !== null && _data_currentTranslate2 !== void 0 ? _data_currentTranslate2 : 0);
}
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $9cce2902fa373f83$var$closestElement(selector, base) {
    function __closestFrom(el) {
        if (!el || el === document || el === window) return null;
        var cur = el;
        if (cur.assignedSlot) cur = cur.assignedSlot;
        var found = cur.closest(selector);
        if (!found && !cur.getRootNode) return null;
        var root = cur.getRootNode();
        return found || __closestFrom(root.host);
    }
    return __closestFrom(base);
}
function $9cce2902fa373f83$var$preventEdgeSwipe(swiper, event, startX) {
    var params = swiper.params;
    var edgeSwipeDetection = params.edgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $9cce2902fa373f83$var$onTouchStart(event) {
    var swiper = this;
    if (swiper.destroyed) return;
    var _event_originalEvent;
    var e = (_event_originalEvent = event.originalEvent) !== null && _event_originalEvent !== void 0 ? _event_originalEvent : event;
    var data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        var pe = e;
        if (data.pointerId !== null && data.pointerId !== pe.pointerId) return;
        data.pointerId = pe.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $9cce2902fa373f83$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $g9Jbh.f)(targetEl, swiper.wrapperEl)) return;
    }
    // Secondary mouse buttons (right-click / middle-click) shouldn't start a swipe.
    var mouseLike = e;
    if (typeof mouseLike.which === 'number' && mouseLike.which === 3) return;
    if (typeof mouseLike.button === 'number' && mouseLike.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // `path` is a non-standard Chrome extension; `composedPath()` is the modern API.
    var eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
    var isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $9cce2902fa373f83$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (typeof params.swipeHandler === 'string' && !targetEl.closest(params.swipeHandler)) return;
    }
    // At this point `e` is a PointerEvent or MouseEvent (touchstart returned earlier).
    var pe1 = e;
    touches.currentX = pe1.pageX;
    touches.currentY = pe1.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$9cce2902fa373f83$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $g9Jbh.u)();
    data.startEventPath = eventPath;
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    var preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl && (pe1.pointerType === 'mouse' || pe1.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document.activeElement.blur();
    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
var $9cce2902fa373f83$var$events = function(swiper, method) {
    var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device;
    var capture = !!params.nested;
    var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    var swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    var subscribe = function(events) {
        swiper[swiperMethod](events, $9cce2902fa373f83$var$onResize, true);
    };
    if (params.updateOnWindowResize) subscribe(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate');
    else subscribe('observerUpdate');
    // Images loader
    if (params.lazyPreload) {
        el[domMethod]('load', swiper.onLoad, {
            capture: true
        });
        el[domMethod]('error', swiper.onLoad, {
            capture: true
        });
    }
};
function $9cce2902fa373f83$var$attachEvents() {
    var swiper = this;
    var params = swiper.params;
    swiper.onTouchStart = $9cce2902fa373f83$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $9cce2902fa373f83$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $9cce2902fa373f83$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $9cce2902fa373f83$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $9cce2902fa373f83$var$onScroll.bind(swiper);
    swiper.onClick = $9cce2902fa373f83$var$onClick.bind(swiper);
    swiper.onLoad = $9cce2902fa373f83$var$onLoad.bind(swiper);
    $9cce2902fa373f83$var$events(swiper, 'on');
}
function $9cce2902fa373f83$var$detachEvents() {
    var swiper = this;
    $9cce2902fa373f83$var$events(swiper, 'off');
}
var $9cce2902fa373f83$var$events$1 = {
    attachEvents: $9cce2902fa373f83$var$attachEvents,
    detachEvents: $9cce2902fa373f83$var$detachEvents
};
function $9cce2902fa373f83$var$setGrabCursor(moving) {
    var swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
function $9cce2902fa373f83$var$unsetGrabCursor() {
    var swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
var $9cce2902fa373f83$var$grabCursor = {
    setGrabCursor: $9cce2902fa373f83$var$setGrabCursor,
    unsetGrabCursor: $9cce2902fa373f83$var$unsetGrabCursor
};
function $9cce2902fa373f83$var$loopCreate(slideRealIndex, initial) {
    var _swiper_params_virtual;
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled)) return;
    var initSlides = function() {
        var slides = (0, $g9Jbh.e)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
        slides.forEach(function(el, index) {
            el.setAttribute('data-swiper-slide-index', String(index));
        });
    };
    var clearBlankSlides = function() {
        var slides = (0, $g9Jbh.e)(slidesEl, ".".concat(params.slideBlankClass));
        slides.forEach(function(el) {
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    var slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    var shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    var shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    var addBlankSlides = function(amountOfSlides) {
        for(var i = 0; i < amountOfSlides; i += 1){
            var slideEl = swiper.isElement ? (0, $g9Jbh.a)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $g9Jbh.a)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            var slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $g9Jbh.x)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            var slidesToAdd1 = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd1);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $g9Jbh.x)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    var bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $9cce2902fa373f83$var$loopDestroy() {
    var _swiper_params_virtual;
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || !slidesEl || swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled)) return;
    swiper.recalcSlides();
    var newSlidesOrder = [];
    swiper.slides.forEach(function(slideEl) {
        var loopSlideEl = slideEl;
        var index = typeof loopSlideEl.swiperSlideIndex === 'undefined' ? Number(slideEl.getAttribute('data-swiper-slide-index')) : loopSlideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach(function(slideEl) {
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach(function(slideEl) {
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
function $9cce2902fa373f83$var$loopFix() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _params_virtual, _swiper_controller;
    var slideRealIndex = options.slideRealIndex, _options_slideTo = options.slideTo, _$slideTo = _options_slideTo === void 0 ? true : _options_slideTo, direction = options.direction, _$setTranslate = options.setTranslate, activeSlideIndexParam = options.activeSlideIndex, initial = options.initial, byController = options.byController, byMousewheel = options.byMousewheel;
    var activeSlideIndex = activeSlideIndexParam;
    var swiper = this;
    if (!swiper.params.loop) return;
    // A locked slider (watchOverflow, all slides fit) can't move, so there is nothing to loop:
    // keep the original slide order and don't warn about too few slides (#8228)
    if (swiper.params.watchOverflow && swiper.isLocked) return;
    swiper.emit('beforeLoopFix');
    // The compensating slideTo() teleports below change indexes/translate without any
    // observable slide change, so updateActiveIndex() must not emit index-change events
    // while this flag is set (otherwise pagination flickers mid-drag, see #8015)
    swiper.__loopFixInProgress__ = true;
    var slides = swiper.slides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, slidesEl = swiper.slidesEl, params = swiper.params;
    var centeredSlides = params.centeredSlides, slidesOffsetBefore = params.slidesOffsetBefore, slidesOffsetAfter = params.slidesOffsetAfter, initialSlide = params.initialSlide;
    var bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && ((_params_virtual = params.virtual) === null || _params_virtual === void 0 ? void 0 : _params_virtual.enabled)) {
        if (_$slideTo) {
            var virtualSlidesLength = swiper.virtual.slides.length;
            var _swiper_virtual_slidesBefore;
            var virtualSlidesBefore = (_swiper_virtual_slidesBefore = swiper.virtual.slidesBefore) !== null && _swiper_virtual_slidesBefore !== void 0 ? _swiper_virtual_slidesBefore : 0;
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(virtualSlidesLength, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(virtualSlidesLength + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(virtualSlidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.__loopFixInProgress__ = false;
        swiper.emit('loopFix');
        return;
    }
    var slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(String(params.slidesPerView)));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    var slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    // How many slides the before/after offsets are worth. Unlike centeredSlides
    // (which hides ~slidesPerView / 2 slides on each side), an offset hides only
    // offset / slideSize slides, so sizing the loop buffer from slidesPerView / 2
    // would teleport further than the snapGrid allows with few slides (#8203).
    // Offsets accept a legacy function form at runtime (see updateSlides), so
    // narrow before doing math on them.
    var resolveOffset = function(value) {
        return (typeof value === 'function' ? value.call(swiper) : value) || 0;
    };
    var slidesGridStep = swiper.slidesGrid.length > 1 ? (swiper.slidesGrid[swiper.slidesGrid.length - 1] - swiper.slidesGrid[0]) / (swiper.slidesGrid.length - 1) : swiper.size;
    var offsetSlidesBefore = slidesGridStep > 0 ? resolveOffset(slidesOffsetBefore) / slidesGridStep : 0;
    var offsetSlidesAfter = slidesGridStep > 0 ? resolveOffset(slidesOffsetAfter) / slidesGridStep : 0;
    var loopedSlides = bothDirections ? Math.max(slidesPerGroup, (centeredSlides ? Math.ceil(slidesPerView / 2) : 0) + Math.ceil(Math.max(offsetSlidesBefore, offsetSlidesAfter))) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $g9Jbh.x)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $g9Jbh.x)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    var prependSlidesIndexes = [];
    var appendSlidesIndexes = [];
    var cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    var isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    var activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find(function(el) {
        return el.classList.contains(params.slideActiveClass);
    }));
    else activeIndex = activeSlideIndex;
    var isNext = direction === 'next' || !direction;
    var isPrev = direction === 'prev' || !direction;
    var slidesPrepended = 0;
    var slidesAppended = 0;
    var _slides_activeSlideIndex_column;
    var activeColIndex = gridEnabled ? (_slides_activeSlideIndex_column = slides[activeSlideIndex].column) !== null && _slides_activeSlideIndex_column !== void 0 ? _slides_activeSlideIndex_column : 0 : activeSlideIndex;
    var activeColIndexWithShift = activeColIndex + (bothDirections && typeof _$setTranslate === 'undefined' ? (centeredSlides ? -slidesPerView / 2 + 0.5 : 0) - offsetSlidesBefore : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(var i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            var index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                var colIndexToPrepend = cols - index - 1;
                for(var j = slides.length - 1; j >= 0; j -= 1)if (slides[j].column === colIndexToPrepend) prependSlidesIndexes.push(j);
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        var _loop = function(i1) {
            var index = i1 - Math.floor(i1 / cols) * cols;
            if (gridEnabled) slides.forEach(function(slide, slideIndex) {
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        };
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(var i1 = 0; i1 < slidesAppended; i1 += 1)_loop(i1);
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach(function(index) {
        var slideEl = slides[index];
        slideEl.swiperLoopMoveDOM = true;
        slidesEl.prepend(slideEl);
        slideEl.swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach(function(index) {
        var slideEl = slides[index];
        slideEl.swiperLoopMoveDOM = true;
        slidesEl.append(slideEl);
        slideEl.swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach(function(slide, slideIndex) {
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (_$slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                var currentSlideTranslate = swiper.slidesGrid[activeIndex];
                var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                var diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (_$setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (_$setTranslate) {
                var shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                var currentSlideTranslate1 = swiper.slidesGrid[activeIndex];
                var newSlideTranslate1 = swiper.slidesGrid[activeIndex - slidesAppended];
                var diff1 = newSlideTranslate1 - currentSlideTranslate1;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff1);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (_$setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff1;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff1;
                    }
                }
            } else {
                var shift1 = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift1, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    var controlled = (_swiper_controller = swiper.controller) === null || _swiper_controller === void 0 ? void 0 : _swiper_controller.control;
    if (controlled && !byController) {
        var loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: _$setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(controlled)) controlled.forEach(function(c) {
            if (!c.destroyed && c.params.loop) c.loopFix((0, $hApvp._)((0, $kWfK0._)({}, loopParams), {
                slideTo: c.params.slidesPerView === params.slidesPerView ? _$slideTo : false
            }));
        });
        else if (controlled instanceof swiper.constructor && controlled.params.loop) controlled.loopFix((0, $hApvp._)((0, $kWfK0._)({}, loopParams), {
            slideTo: controlled.params.slidesPerView === params.slidesPerView ? _$slideTo : false
        }));
    }
    swiper.__loopFixInProgress__ = false;
    swiper.emit('loopFix');
}
var $9cce2902fa373f83$var$loop = {
    loopCreate: $9cce2902fa373f83$var$loopCreate,
    loopFix: $9cce2902fa373f83$var$loopFix,
    loopDestroy: $9cce2902fa373f83$var$loopDestroy
};
function $9cce2902fa373f83$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams() {
        var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if ((typeof moduleParams === "undefined" ? "undefined" : (0, $5djcY._)(moduleParams)) !== 'object' || moduleParams === null) {
            (0, $g9Jbh.n)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $g9Jbh.n)(allModulesParams, obj);
            return;
        }
        if ((0, $5djcY._)(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $g9Jbh.n)(allModulesParams, obj);
    };
}
var $9cce2902fa373f83$var$Observer = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    var observers = [];
    var attach = function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        if (!ObserverFunc) return;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                swiper.emit('observerUpdate', mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                swiper.emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options.childList),
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = (0, $g9Jbh.j)(swiper.hostEl);
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
};
var $9cce2902fa373f83$var$Resize = function(param) {
    var swiper = param.swiper, on = param.on, emit = param.emit;
    var observer = null;
    var animationFrame = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        // Entry sizes come from the layout before the rAF, while onResize() stores the live size in
        // swiper.width/height. Comparing entries against swiper.width therefore skipped every other
        // frame of a continuous resize, painting those frames with a stale translate (#8230), so
        // compare against the last handled entry size instead.
        var observedWidth = swiper.width;
        var observedHeight = swiper.height;
        observer = new ResizeObserver(function(entries) {
            animationFrame = window.requestAnimationFrame(function() {
                var newWidth = observedWidth;
                var newHeight = observedHeight;
                entries.forEach(function(param) {
                    var contentBoxSize = param.contentBoxSize, contentRect = param.contentRect, target = param.target;
                    if (target && target !== swiper.el) return;
                    // Older Safari (≤15) exposed `contentBoxSize` as a single object instead of an array.
                    var box = Array.isArray(contentBoxSize) ? contentBoxSize[0] : contentBoxSize;
                    newWidth = contentRect ? contentRect.width : box.inlineSize;
                    newHeight = contentRect ? contentRect.height : box.blockSize;
                });
                if (newWidth !== observedWidth || newHeight !== observedHeight) {
                    observedWidth = newWidth;
                    observedHeight = newHeight;
                    resizeHandler();
                }
            });
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', function() {
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', function() {
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
};
function $9cce2902fa373f83$var$slideNext(speed) {
    var runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var _params_virtual;
    var swiper = this;
    var enabled = swiper.enabled, params = swiper.params, animating = swiper.animating;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    var isVirtual = swiper.virtual && ((_params_virtual = params.virtual) === null || _params_virtual === void 0 ? void 0 : _params_virtual.enabled);
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(function() {
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function $9cce2902fa373f83$var$slidePrev(speed) {
    var runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var _params_virtual;
    var swiper = this;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled, animating = swiper.animating;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var isVirtual = swiper.virtual && ((_params_virtual = params.virtual) === null || _params_virtual === void 0 ? void 0 : _params_virtual.enabled);
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var isFreeMode = params.freeMode && params.freeMode.enabled;
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        var _swiper_params_virtual;
        var lastIndex = ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled) && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(function() {
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function $9cce2902fa373f83$var$slideReset(speed) {
    var runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function $9cce2902fa373f83$var$slideTo() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 ? arguments[1] : void 0, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0, initial = arguments.length > 4 ? arguments[4] : void 0;
    var _swiper_params_virtual;
    if (typeof index === 'string') index = parseInt(index, 10);
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    var translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    var direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    var isVirtual = swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled);
    var isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        var _obj;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            var _swiper_params_initialSlide;
            if (isVirtual && !swiper._cssModeVirtualInitialSet && ((_swiper_params_initialSlide = swiper.params.initialSlide) !== null && _swiper_params_initialSlide !== void 0 ? _swiper_params_initialSlide : 0) > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(function() {
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else wrapperEl.scrollTo((_obj = {}, (0, $6tY97._)(_obj, isH ? 'left' : 'top', t), (0, $6tY97._)(_obj, "behavior", 'smooth'), _obj));
        return true;
    }
    var browser = $9cce2902fa373f83$var$getBrowser();
    var isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $9cce2902fa373f83$var$slideToClickedSlide() {
    var swiper = this;
    if (swiper.destroyed) return;
    var params = swiper.params, slidesEl = swiper.slidesEl, clickedSlide = swiper.clickedSlide, clickedIndex = swiper.clickedIndex;
    if (clickedSlide === undefined || clickedIndex === undefined) return;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.getSlideIndexWhenGrid(clickedIndex);
    var realIndex;
    var slideSelector = swiper.isElement ? "swiper-slide" : ".".concat(params.slideClass);
    var isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $g9Jbh.e)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
            (0, $g9Jbh.t)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
function $9cce2902fa373f83$var$slideToClosest(speed) {
    var runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0, threshold = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $9cce2902fa373f83$var$slideToLoop() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 ? arguments[1] : void 0, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof index === 'string') {
        var indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    var newIndex = index;
    if (swiper.params.loop) {
        var _swiper_params_virtual;
        var _swiper_virtual_slidesBefore;
        if (swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled)) newIndex = newIndex + ((_swiper_virtual_slidesBefore = swiper.virtual.slidesBefore) !== null && _swiper_virtual_slidesBefore !== void 0 ? _swiper_virtual_slidesBefore : 0);
        else {
            var targetSlideIndex;
            if (gridEnabled) {
                var slideIndex = newIndex * swiper.params.grid.rows;
                var targetSlideEl = swiper.slides.find(function(slideEl) {
                    return Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex;
                });
                var _targetSlideEl_column;
                targetSlideIndex = (_targetSlideEl_column = targetSlideEl === null || targetSlideEl === void 0 ? void 0 : targetSlideEl.column) !== null && _targetSlideEl_column !== void 0 ? _targetSlideEl_column : 0;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            var cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            var _swiper_params = swiper.params, centeredSlides = _swiper_params.centeredSlides, slidesOffsetBefore = _swiper_params.slidesOffsetBefore, slidesOffsetAfter = _swiper_params.slidesOffsetAfter;
            var bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            var slidesPerView;
            if (swiper.params.slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(String(swiper.params.slidesPerView)));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            var needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                var direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                var slideIndex1 = newIndex * swiper.params.grid.rows;
                var targetSlideEl1 = swiper.slides.find(function(slideEl) {
                    return Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex1;
                });
                var _targetSlideEl_column1;
                newIndex = (_targetSlideEl_column1 = targetSlideEl1 === null || targetSlideEl1 === void 0 ? void 0 : targetSlideEl1.column) !== null && _targetSlideEl_column1 !== void 0 ? _targetSlideEl_column1 : 0;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(function() {
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
var $9cce2902fa373f83$var$slide = {
    slideTo: $9cce2902fa373f83$var$slideTo,
    slideToLoop: $9cce2902fa373f83$var$slideToLoop,
    slideNext: $9cce2902fa373f83$var$slideNext,
    slidePrev: $9cce2902fa373f83$var$slidePrev,
    slideReset: $9cce2902fa373f83$var$slideReset,
    slideToClosest: $9cce2902fa373f83$var$slideToClosest,
    slideToClickedSlide: $9cce2902fa373f83$var$slideToClickedSlide
};
function $9cce2902fa373f83$var$setTransition(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = "".concat(duration, "ms");
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? "0ms" : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $9cce2902fa373f83$var$transitionEmit(param) {
    var swiper = param.swiper, runCallbacks = param.runCallbacks, direction = param.direction, step = param.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit("transition".concat(step));
    if (runCallbacks && dir === 'reset') swiper.emit("slideResetTransition".concat(step));
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit("slideChangeTransition".concat(step));
        if (dir === 'next') swiper.emit("slideNextTransition".concat(step));
        else swiper.emit("slidePrevTransition".concat(step));
    }
}
function $9cce2902fa373f83$var$transitionEnd() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $9cce2902fa373f83$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
function $9cce2902fa373f83$var$transitionStart() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $9cce2902fa373f83$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
var $9cce2902fa373f83$var$transition = {
    setTransition: $9cce2902fa373f83$var$setTransition,
    transitionStart: $9cce2902fa373f83$var$transitionStart,
    transitionEnd: $9cce2902fa373f83$var$transitionEnd
};
function $9cce2902fa373f83$var$getSwiperTranslate() {
    var axis = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isHorizontal() ? 'x' : 'y';
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, wrapperEl = swiper.wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $g9Jbh.q)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $9cce2902fa373f83$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $9cce2902fa373f83$var$minTranslate() {
    return -this.snapGrid[0];
}
function $9cce2902fa373f83$var$setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)");
    }
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $9cce2902fa373f83$var$translateTo() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, translateBounds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, internal = arguments.length > 4 ? arguments[4] : void 0;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var _$minTranslate = swiper.minTranslate();
    var _$maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > _$minTranslate) newTranslate = _$minTranslate;
    else if (translateBounds && translate < _$maxTranslate) newTranslate = _$maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var _obj;
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else wrapperEl.scrollTo((_obj = {}, (0, $6tY97._)(_obj, isH ? 'left' : 'top', -newTranslate), (0, $6tY97._)(_obj, "behavior", 'smooth'), _obj));
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $9cce2902fa373f83$var$translate = {
    getTranslate: $9cce2902fa373f83$var$getSwiperTranslate,
    setTranslate: $9cce2902fa373f83$var$setTranslate,
    minTranslate: $9cce2902fa373f83$var$minTranslate,
    maxTranslate: $9cce2902fa373f83$var$maxTranslate,
    translateTo: $9cce2902fa373f83$var$translateTo
};
function $9cce2902fa373f83$var$getActiveIndexByTranslate(swiper) {
    var slidesGrid = swiper.slidesGrid, params = swiper.params;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var activeIndex;
    for(var i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $9cce2902fa373f83$var$updateActiveIndex(newActiveIndex) {
    var _swiper_params_virtual, _params_virtual;
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    var getVirtualRealIndex = function(aIndex) {
        var virtualSlides = swiper.virtual.slides;
        var _swiper_virtual_slidesBefore;
        var realIndex = aIndex - ((_swiper_virtual_slidesBefore = swiper.virtual.slidesBefore) !== null && _swiper_virtual_slidesBefore !== void 0 ? _swiper_virtual_slidesBefore : 0);
        if (realIndex < 0) realIndex = virtualSlides.length + realIndex;
        if (realIndex >= virtualSlides.length) realIndex -= virtualSlides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $9cce2902fa373f83$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled)) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    var realIndex;
    if (swiper.virtual && ((_params_virtual = params.virtual) === null || _params_virtual === void 0 ? void 0 : _params_virtual.enabled)) {
        if (params.loop) realIndex = getVirtualRealIndex(activeIndex);
        else realIndex = activeIndex;
    } else if (gridEnabled) {
        var firstSlideInColumn = swiper.slides.find(function(slideEl) {
            return slideEl.column === activeIndex;
        });
        var activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        var slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $9cce2902fa373f83$var$preload(swiper);
    // Loop-fix teleports change indexes without any observable slide change —
    // emitting here would make pagination and other listeners react to transient
    // wrong indexes (#8015). The enclosing slide action emits the final events.
    if (swiper.__loopFixInProgress__) return;
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        var _swiper___lastEmittedRealIndex__;
        // Compare to the realIndex listeners last heard, not to the previous call's
        // value — a suppressed loop-fix call in between would otherwise advance the
        // baseline and swallow (or duplicate) a realIndexChange
        if (((_swiper___lastEmittedRealIndex__ = swiper.__lastEmittedRealIndex__) !== null && _swiper___lastEmittedRealIndex__ !== void 0 ? _swiper___lastEmittedRealIndex__ : previousRealIndex) !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
    swiper.__lastEmittedRealIndex__ = realIndex;
}
function $9cce2902fa373f83$var$updateAutoHeight(speed) {
    var _swiper_params_virtual;
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled);
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            var slide = getSlideByIndex(index);
            if (slide) activeSlides.push(slide);
        }
    } else {
        var slide1 = getSlideByIndex(swiper.activeIndex);
        if (slide1) activeSlides.push(slide1);
    }
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = "".concat(newHeight, "px");
}
function $9cce2902fa373f83$var$updateClickedSlide(el, path) {
    var swiper = this;
    var params = swiper.params;
    var slide = el.closest(".".concat(params.slideClass, ", swiper-slide"));
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) (0, $jlUaU._)(path.slice(path.indexOf(el) + 1, path.length)).forEach(function(pathEl) {
        if (!slide && pathEl.matches && pathEl.matches(".".concat(params.slideClass, ", swiper-slide"))) slide = pathEl;
    });
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        var _swiper_params_virtual;
        swiper.clickedSlide = slide;
        if (swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled)) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
function $9cce2902fa373f83$var$updateProgress(translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
        var multiplier = swiper.rtlTranslate ? -1 : 1;
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd;
    var progressLoop = swiper.progressLoop;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        var firstSlideIndex = swiper.getSlideIndexByData(0);
        var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        var translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
function $9cce2902fa373f83$var$updateSize() {
    var swiper = this;
    var width;
    var height;
    var el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $g9Jbh.l)(el, 'padding-left') || '0', 10) - parseInt((0, $g9Jbh.l)(el, 'padding-right') || '0', 10);
    height = height - parseInt((0, $g9Jbh.l)(el, 'padding-top') || '0', 10) - parseInt((0, $g9Jbh.l)(el, 'padding-bottom') || '0', 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $9cce2902fa373f83$var$updateSlides() {
    var _params_virtual;
    var swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || '0');
    }
    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl, slidesEl = swiper.slidesEl, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = !!(swiper.virtual && ((_params_virtual = params.virtual) === null || _params_virtual === void 0 ? void 0 : _params_virtual.enabled));
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = (0, $g9Jbh.e)(slidesEl, ".".concat(swiper.params.slideClass, ", swiper-slide"));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var resolveOffset = function(value) {
        return typeof value === 'function' ? value.call(swiper) : value;
    };
    var offsetBefore = resolveOffset(params.slidesOffsetBefore);
    var offsetAfter = resolveOffset(params.slidesOffsetAfter);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var swiperSize = swiper.size - offsetBefore - offsetAfter;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach(function(slideEl) {
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $g9Jbh.v)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $g9Jbh.v)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0, $g9Jbh.v)(wrapperEl, '--swiper-slides-offset-before', "".concat(offsetBefore, "px"));
        (0, $g9Jbh.v)(wrapperEl, '--swiper-slides-offset-after', "".concat(offsetAfter, "px"));
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    var slideSize = 0;
    var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        var bp = params.breakpoints[key];
        return typeof (bp === null || bp === void 0 ? void 0 : bp.slidesPerView) !== 'undefined';
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $g9Jbh.l)(slide, 'display') === 'none') continue;
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            var _params_virtual1;
            if ((_params_virtual1 = params.virtual) === null || _params_virtual1 === void 0 ? void 0 : _params_virtual1.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = "".concat(slideSize, "px");
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = "";
            var slideStyles = getComputedStyle(slide);
            var currentTransform = slide.style.transform;
            var currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $g9Jbh.i)(slide, 'width') : (0, $g9Jbh.i)(slide, 'height');
            else {
                var width = getDirectionPropertyValue(slideStyles, 'width');
                var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                var boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    var clientWidth = slide.clientWidth, offsetWidth = slide.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = "".concat(slideSize, "px");
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        var isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        var shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        var lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            var minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                var accumulatedSize = 0;
                for(var i1 = slidesSizesGrid.length - 1; i1 >= 0; i1 -= 1){
                    accumulatedSize += slidesSizesGrid[i1] + (i1 < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) minVisibleSlides = slidesSizesGrid.length - i1;
                    else break;
                }
            } else minVisibleSlides = Math.floor(params.slidesPerView);
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        var newSlidesGrid = [];
        for(var i2 = 0; i2 < snapGrid.length; i2 += 1){
            var slidesGridItem = snapGrid[i2];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            {
                if (i2 <= lastAllowedSnapIndex) newSlidesGrid.push(slidesGridItem);
            } else if (snapGrid[i2] <= swiper.virtualSize - swiperSize) // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) // Only add edge-aligned snap if snapToSlideEdge is not enabled
        {
            if (!shouldSnapToSlideEdge) snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (isVirtual && params.loop) {
        var size = slidesSizesGrid[0] + spaceBetween;
        var _swiper_virtual_slidesBefore;
        var slidesBefore = (_swiper_virtual_slidesBefore = swiper.virtual.slidesBefore) !== null && _swiper_virtual_slidesBefore !== void 0 ? _swiper_virtual_slidesBefore : 0;
        var _swiper_virtual_slidesAfter;
        var slidesAfter = (_swiper_virtual_slidesAfter = swiper.virtual.slidesAfter) !== null && _swiper_virtual_slidesAfter !== void 0 ? _swiper_virtual_slidesAfter : 0;
        var virtualLoopCount = slidesBefore + slidesAfter;
        if (params.slidesPerGroup > 1) {
            var groups = Math.ceil(virtualLoopCount / params.slidesPerGroup);
            var groupSize = size * params.slidesPerGroup;
            for(var i3 = 0; i3 < groups; i3 += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(var i4 = 0; i4 < virtualLoopCount; i4 += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach(function(slideEl) {
            slideEl.style[key] = "".concat(spaceBetween, "px");
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        var maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map(function(snap) {
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize1 -= spaceBetween;
        if (allSlidesSize1 < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $g9Jbh.v)(wrapperEl, '--swiper-centered-offset-before', "".concat(-snapGrid[0], "px"));
        (0, $g9Jbh.v)(wrapperEl, '--swiper-centered-offset-after', "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        var backFaceHiddenClass = "".concat(params.containerModifierClass, "backface-hidden");
        var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
var $9cce2902fa373f83$var$toggleSlideClasses$1 = function(slideEl, condition, className) {
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $9cce2902fa373f83$var$updateSlidesClasses() {
    var _params_virtual;
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, slidesEl = swiper.slidesEl, activeIndex = swiper.activeIndex;
    var isVirtual = !!(swiper.virtual && ((_params_virtual = params.virtual) === null || _params_virtual === void 0 ? void 0 : _params_virtual.enabled));
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    var getFilteredSlide = function(selector) {
        return (0, $g9Jbh.e)(slidesEl, ".".concat(params.slideClass).concat(selector, ", swiper-slide").concat(selector))[0];
    };
    var activeSlide;
    var prevSlide;
    var nextSlide;
    if (isVirtual) {
        if (params.loop) {
            var virtualSlides = swiper.virtual.slides;
            var _swiper_virtual_slidesBefore;
            var slideIndex = activeIndex - ((_swiper_virtual_slidesBefore = swiper.virtual.slidesBefore) !== null && _swiper_virtual_slidesBefore !== void 0 ? _swiper_virtual_slidesBefore : 0);
            if (slideIndex < 0) slideIndex = virtualSlides.length + slideIndex;
            if (slideIndex >= virtualSlides.length) slideIndex -= virtualSlides.length;
            activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(slideIndex, '"]'));
        } else activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(activeIndex, '"]'));
    } else if (gridEnabled) {
        activeSlide = slides.find(function(slideEl) {
            return slideEl.column === activeIndex;
        });
        nextSlide = slides.find(function(slideEl) {
            return slideEl.column === activeIndex + 1;
        });
        prevSlide = slides.find(function(slideEl) {
            return slideEl.column === activeIndex - 1;
        });
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $g9Jbh.g)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $g9Jbh.k)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
            // NOTE: legacy guard from v9; `(!prevSlide) === 0` is always false, but we preserve
            // the original behaviour (no-op) to avoid runtime changes in v14. Audit candidate.
            params.loop;
        }
    }
    slides.forEach(function(slideEl) {
        $9cce2902fa373f83$var$toggleSlideClasses$1(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $9cce2902fa373f83$var$toggleSlideClasses$1(slideEl, slideEl === nextSlide, params.slideNextClass);
        $9cce2902fa373f83$var$toggleSlideClasses$1(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
function $9cce2902fa373f83$var$updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
var $9cce2902fa373f83$var$toggleSlideClasses = function(slideEl, condition, className) {
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $9cce2902fa373f83$var$updateSlidesProgress() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    var spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var _slide_swiperSlideOffset;
        var slideOffset = (_slide_swiperSlideOffset = slide.swiperSlideOffset) !== null && _slide_swiperSlideOffset !== void 0 ? _slide_swiperSlideOffset : 0;
        var _slides__swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= (_slides__swiperSlideOffset = slides[0].swiperSlideOffset) !== null && _slides__swiperSlideOffset !== void 0 ? _slides__swiperSlideOffset : 0;
        var _slide_swiperSlideSize;
        var slideSize = (_slide_swiperSlideSize = slide.swiperSlideSize) !== null && _slide_swiperSlideSize !== void 0 ? _slide_swiperSlideSize : 0;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slideSize + spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slideSize + spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $9cce2902fa373f83$var$toggleSlideClasses(slide, isVisible, params.slideVisibleClass);
        $9cce2902fa373f83$var$toggleSlideClasses(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
var $9cce2902fa373f83$var$update = {
    updateSize: $9cce2902fa373f83$var$updateSize,
    updateSlides: $9cce2902fa373f83$var$updateSlides,
    updateAutoHeight: $9cce2902fa373f83$var$updateAutoHeight,
    updateSlidesOffset: $9cce2902fa373f83$var$updateSlidesOffset,
    updateSlidesProgress: $9cce2902fa373f83$var$updateSlidesProgress,
    updateProgress: $9cce2902fa373f83$var$updateProgress,
    updateSlidesClasses: $9cce2902fa373f83$var$updateSlidesClasses,
    updateActiveIndex: $9cce2902fa373f83$var$updateActiveIndex,
    updateClickedSlide: $9cce2902fa373f83$var$updateClickedSlide
};
var $9cce2902fa373f83$var$prototypes = {
    eventsEmitter: $9cce2902fa373f83$var$eventsEmitter,
    update: $9cce2902fa373f83$var$update,
    translate: $9cce2902fa373f83$var$translate,
    transition: $9cce2902fa373f83$var$transition,
    slide: $9cce2902fa373f83$var$slide,
    loop: $9cce2902fa373f83$var$loop,
    grabCursor: $9cce2902fa373f83$var$grabCursor,
    events: $9cce2902fa373f83$var$events$1,
    breakpoints: $9cce2902fa373f83$var$breakpoints,
    checkOverflow: $9cce2902fa373f83$var$checkOverflow$1,
    classes: $9cce2902fa373f83$var$classes
};
var $9cce2902fa373f83$var$extendedDefaults = {};
var $9cce2902fa373f83$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4QweW._)(this, Swiper);
        var el;
        var params;
        var ref;
        if (args.length === 1 && args[0] !== null && (0, $5djcY._)(args[0]) === 'object' && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else ref = (0, $6ZpBv._)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, $g9Jbh.n)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && typeof params.el === 'string' && typeof document !== 'undefined' && document.querySelectorAll(params.el).length > 1) {
            var swipers = [];
            document.querySelectorAll(params.el).forEach(function(containerEl) {
                var newParams = (0, $g9Jbh.n)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return swipers;
        }
        // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $9cce2902fa373f83$var$getSupport();
        var _params_userAgent;
        swiper.device = $9cce2902fa373f83$var$getDevice({
            userAgent: (_params_userAgent = params.userAgent) !== null && _params_userAgent !== void 0 ? _params_userAgent : undefined
        });
        swiper.browser = $9cce2902fa373f83$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, $jlUaU._)(swiper.__modules__ || []);
        if (params.modules && Array.isArray(params.modules)) params.modules.forEach(function(mod) {
            var fn = mod;
            if (typeof fn === 'function' && swiper.modules.indexOf(fn) < 0) swiper.modules.push(fn);
        });
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                params: params,
                swiper: swiper,
                extendParams: $9cce2902fa373f83$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        var swiperParams = (0, $g9Jbh.n)({}, $9cce2902fa373f83$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $g9Jbh.n)({}, swiperParams, $9cce2902fa373f83$var$extendedDefaults, params);
        swiper.originalParams = (0, $g9Jbh.n)({}, swiper.params);
        swiper.passedParams = (0, $g9Jbh.n)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) {
            var onHandlers = swiper.params.on;
            Object.keys(onHandlers).forEach(function(eventName) {
                var handler = onHandlers[eventName];
                if (handler) swiper.on(eventName, handler);
            });
        }
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === 'horizontal';
            },
            isVertical: function() {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment: function() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        return swiper;
    }
    (0, $6hK4i._)(Swiper, [
        {
            key: "getDirectionLabel",
            value: function getDirectionLabel(property) {
                if (this.isHorizontal()) return property;
                // oxfmt-ignore
                return ({
                    'width': 'height',
                    'margin-top': 'margin-left',
                    'margin-bottom ': 'margin-right',
                    'margin-left': 'margin-top',
                    'margin-right': 'margin-bottom',
                    'padding-left': 'padding-top',
                    'padding-right': 'padding-bottom',
                    'marginRight': 'marginBottom'
                })[property];
            }
        },
        {
            /**
     * !INTERNAL
     */ key: "isHorizontal",
            value: function isHorizontal() {
                return this.params.direction === 'horizontal';
            }
        },
        {
            key: "isVertical",
            value: function isVertical() {
                return this.params.direction === 'vertical';
            }
        },
        {
            key: "cssOverflowAdjustment",
            value: function cssOverflowAdjustment() {
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            }
        },
        {
            key: "getSlideIndex",
            value: function getSlideIndex(slideEl) {
                var _this = this, slidesEl = _this.slidesEl, params = _this.params;
                var slides = (0, $g9Jbh.e)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
                var firstSlideIndex = (0, $g9Jbh.b)(slides[0]);
                return (0, $g9Jbh.b)(slideEl) - (firstSlideIndex !== null && firstSlideIndex !== void 0 ? firstSlideIndex : 0);
            }
        },
        {
            key: "getSlideIndexByData",
            value: function getSlideIndexByData(index) {
                return this.getSlideIndex(this.slides.find(function(slideEl) {
                    return Number(slideEl.getAttribute('data-swiper-slide-index')) === index;
                }));
            }
        },
        {
            key: "getSlideIndexWhenGrid",
            value: function getSlideIndexWhenGrid(index) {
                if (this.grid && this.params.grid && this.params.grid.rows > 1) {
                    if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
                    else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
                }
                return index;
            }
        },
        {
            key: "recalcSlides",
            value: function recalcSlides() {
                var _this = this, slidesEl = _this.slidesEl, params = _this.params;
                this.slides = (0, $g9Jbh.e)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
            }
        },
        {
            /**
     * Enable Swiper (if it was disabled)
     */ key: "enable",
            value: function enable() {
                if (this.enabled) return;
                this.enabled = true;
                if (this.params.grabCursor) this.setGrabCursor();
                this.emit('enable');
            }
        },
        {
            /**
     * Disable Swiper (if it was enabled). When Swiper is disabled, it will hide all navigation elements and won't respond to any events and interactions
     */ key: "disable",
            value: function disable() {
                if (!this.enabled) return;
                this.enabled = false;
                if (this.params.grabCursor) this.unsetGrabCursor();
                this.emit('disable');
            }
        },
        {
            /**
     * Set Swiper translate progress (from 0 to 1). Where 0 - its initial position (offset) on first slide, and 1 - its maximum position (offset) on last slide
     *
     * @param progress Swiper translate progress (from 0 to 1).
     * @param speed Transition duration (in ms).
     */ key: "setProgress",
            value: function setProgress(progress, speed) {
                progress = Math.min(Math.max(progress, 0), 1);
                var min = this.minTranslate();
                var max = this.maxTranslate();
                var current = (max - min) * progress + min;
                this.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
                this.updateActiveIndex();
                this.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var _this = this;
                if (!this.params._emitClasses || !this.el) return;
                var cls = this.el.className.split(' ').filter(function(className) {
                    return className.indexOf('swiper') === 0 || className.indexOf(_this.params.containerModifierClass) === 0;
                });
                this.emit('_containerClasses', cls.join(' '));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var _this = this;
                if (this.destroyed) return '';
                return slideEl.className.split(' ').filter(function(className) {
                    return className.indexOf('swiper-slide') === 0 || className.indexOf(_this.params.slideClass) === 0;
                }).join(' ');
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var _this = this;
                if (!this.params._emitClasses || !this.el) return;
                var updates = [];
                this.slides.forEach(function(slideEl) {
                    var classNames = _this.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    _this.emit('_slideClass', slideEl, classNames);
                });
                this.emit('_slideClasses', updates);
            }
        },
        {
            /**
     * Get dynamically calculated amount of slides per view, useful only when slidesPerView set to `auto`
     */ key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic() {
                var view = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'current', exact = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this, params = _this.params, slides = _this.slides, slidesGrid = _this.slidesGrid, slidesSizesGrid = _this.slidesSizesGrid, swiperSize = _this.size, activeIndex = _this.activeIndex;
                var spv = 1;
                if (typeof params.slidesPerView === 'number') return params.slidesPerView;
                // container not measured yet — centered branch below would never break and return ~slides.length (#7586)
                if (!swiperSize) return spv;
                if (params.centeredSlides) {
                    var _slides_activeIndex_swiperSlideSize;
                    var slideSize = slides[activeIndex] ? Math.ceil((_slides_activeIndex_swiperSlideSize = slides[activeIndex].swiperSlideSize) !== null && _slides_activeIndex_swiperSlideSize !== void 0 ? _slides_activeIndex_swiperSlideSize : 0) : 0;
                    var breakLoop = false;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        var _slides_i_swiperSlideSize;
                        slideSize += Math.ceil((_slides_i_swiperSlideSize = slides[i].swiperSlideSize) !== null && _slides_i_swiperSlideSize !== void 0 ? _slides_i_swiperSlideSize : 0);
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        var _slides_i_swiperSlideSize1;
                        slideSize += (_slides_i_swiperSlideSize1 = slides[i1].swiperSlideSize) !== null && _slides_i_swiperSlideSize1 !== void 0 ? _slides_i_swiperSlideSize1 : 0;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else if (view === 'current') for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                    var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                    if (slideInView) spv += 1;
                }
                else // previous
                for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                    var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                    if (slideInView1) spv += 1;
                }
                return spv;
            }
        },
        {
            /**
     * You should call it after you add/remove slides
     * manually, or after you hide/show it, or do any
     * custom DOM modifications with Swiper
     * This method also includes subcall of the following
     * methods which you can use separately:
     */ key: "update",
            value: function update() {
                var _params_freeMode;
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                if (params.lazyPreload) (0, $jlUaU._)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) $9cce2902fa373f83$var$processLazyPreloader(swiper, imageEl);
                });
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }
                var translated;
                if (((_params_freeMode = params.freeMode) === null || _params_freeMode === void 0 ? void 0 : _params_freeMode.enabled) && !params.cssMode) {
                    setTranslate();
                    if (params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                        var _params_virtual;
                        var slidesLength = swiper.virtual && ((_params_virtual = params.virtual) === null || _params_virtual === void 0 ? void 0 : _params_virtual.enabled) ? swiper.virtual.slides.length : swiper.slides.length;
                        translated = swiper.slideTo(slidesLength - 1, 0, false, true);
                    } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit('update');
            }
        },
        {
            /**
     * Changes slider direction from horizontal to vertical and back.
     *
     * @param direction New direction. If not specified, then will automatically changed to opposite direction
     * @param needUpdate Will call swiper.update(). Default true
     */ key: "changeDirection",
            value: function changeDirection(newDirection) {
                var needUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
                if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
                swiper.el.classList.remove("".concat(swiper.params.containerModifierClass).concat(currentDirection));
                swiper.el.classList.add("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                // RTL only inverts the translate axis while horizontal, so recompute the flag here —
                // a stale `true` flips the sign of every translate read on a vertical slider.
                swiper.rtlTranslate = newDirection === 'horizontal' && swiper.rtl;
                swiper.slides.forEach(function(slideEl) {
                    if (newDirection === 'vertical') slideEl.style.width = '';
                    else slideEl.style.height = '';
                });
                swiper.emit('changeDirection');
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            /**
     * Changes slider language
     *
     * @param direction New direction. Should be `rtl` or `ltr`
     */ key: "changeLanguageDirection",
            value: function changeLanguageDirection(direction) {
                var swiper = this;
                if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
                swiper.rtl = direction === 'rtl';
                swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
                if (swiper.rtl) {
                    swiper.el.classList.add("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = 'rtl';
                } else {
                    swiper.el.classList.remove("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = 'ltr';
                }
                swiper.update();
            }
        },
        {
            key: "mount",
            value: function mount(element) {
                var swiper = this;
                if (swiper.mounted) return true;
                // No DOM (SSR / Node) — nothing to mount to.
                if (typeof document === 'undefined') return false;
                // Find el (params.el can be a CSSSelector, HTMLElement, or undefined)
                var initialEl = element !== null && element !== void 0 ? element : swiper.params.el;
                var el = null;
                if (typeof initialEl === 'string') el = document.querySelector(initialEl);
                else if (initialEl instanceof HTMLElement) el = initialEl;
                if (!el) return false;
                el.swiper = swiper;
                var parent = el.parentNode;
                if (parent && parent.host && parent.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
                var getWrapperSelector = function() {
                    return ".".concat((swiper.params.wrapperClass || '').trim().split(' ').join('.'));
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot) {
                        var res = el.shadowRoot.querySelector(getWrapperSelector());
                        // Children needs to return slot items
                        return res;
                    }
                    return (0, $g9Jbh.e)(el, getWrapperSelector())[0];
                };
                // Find Wrapper
                var wrapperEl = getWrapper();
                if (!wrapperEl && swiper.params.createElements) {
                    wrapperEl = (0, $g9Jbh.a)('div', swiper.params.wrapperClass);
                    el.append(wrapperEl);
                    (0, $g9Jbh.e)(el, ".".concat(swiper.params.slideClass)).forEach(function(slideEl) {
                        wrapperEl.append(slideEl);
                    });
                }
                var host = swiper.isElement ? el.parentNode.host : null;
                Object.assign(swiper, {
                    el: el,
                    wrapperEl: wrapperEl,
                    slidesEl: swiper.isElement && !host.slideSlots ? host : wrapperEl,
                    hostEl: swiper.isElement ? host : el,
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === 'rtl' || (0, $g9Jbh.l)(el, 'direction') === 'rtl',
                    rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $g9Jbh.l)(el, 'direction') === 'rtl'),
                    wrongRTL: (0, $g9Jbh.l)(wrapperEl, 'display') === '-webkit-box'
                });
                return true;
            }
        },
        {
            /**
     * Initialize slider
     */ key: "init",
            value: function init(el) {
                var _swiper_params_virtual;
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit('beforeInit');
                // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                // Add Classes
                swiper.addClasses();
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                var _swiper_params_initialSlide, _swiper_virtual_slidesBefore;
                // Slide To Initial Slide
                if (swiper.params.loop && swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled)) swiper.slideTo(((_swiper_params_initialSlide = swiper.params.initialSlide) !== null && _swiper_params_initialSlide !== void 0 ? _swiper_params_initialSlide : 0) + ((_swiper_virtual_slidesBefore = swiper.virtual.slidesBefore) !== null && _swiper_virtual_slidesBefore !== void 0 ? _swiper_virtual_slidesBefore : 0), 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                // Create loop
                if (swiper.params.loop) swiper.loopCreate(undefined, true);
                // Attach events
                swiper.attachEvents();
                if (swiper.params.lazyPreload) {
                    var _lazyElements;
                    var lazyElements = (0, $jlUaU._)(swiper.el.querySelectorAll('[loading="lazy"]'));
                    if (swiper.isElement) (_lazyElements = lazyElements).push.apply(_lazyElements, (0, $jlUaU._)(swiper.hostEl.querySelectorAll('[loading="lazy"]')));
                    lazyElements.forEach(function(imageEl) {
                        // Not-yet-complete images are handled by the delegated `load`/`error` listener in attachEvents()
                        if (imageEl.complete) $9cce2902fa373f83$var$processLazyPreloader(swiper, imageEl);
                    });
                }
                // Init Flag
                swiper.initialized = true;
                $9cce2902fa373f83$var$preload(swiper);
                // Emit
                swiper.emit('init');
                swiper.emit('afterInit');
                return swiper;
            }
        },
        {
            /**
     * Destroy slider instance and detach all events listeners
     *
     * @param deleteInstance Set it to false (by default it is true) to not to delete Swiper instance
     * @param cleanStyles Set it to true (by default it is true) and all custom styles will be removed from slides, wrapper and container.
     * Useful if you need to destroy Swiper and to init again with new options or in different direction
     */ key: "destroy",
            value: function destroy() {
                var deleteInstance = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, cleanStyles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
                swiper.emit('beforeDestroy');
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) swiper.loopDestroy();
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    if (el && typeof el !== 'string') el.removeAttribute('style');
                    if (wrapperEl) wrapperEl.removeAttribute('style');
                    if (slides && slides.length) slides.forEach(function(slideEl) {
                        slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                        slideEl.removeAttribute('style');
                        slideEl.removeAttribute('data-swiper-slide-index');
                    });
                }
                swiper.emit('destroy');
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
                    (0, $g9Jbh.d)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, $g9Jbh.n)($9cce2902fa373f83$var$extendedDefaults, newDefaults);
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
(0, $6tY97._)($9cce2902fa373f83$export$25ce5a424b770e84, "extendedDefaults", void 0);
(0, $6tY97._)($9cce2902fa373f83$export$25ce5a424b770e84, "defaults", void 0);
Object.defineProperty($9cce2902fa373f83$export$25ce5a424b770e84, 'extendedDefaults', {
    get: function() {
        return $9cce2902fa373f83$var$extendedDefaults;
    }
});
Object.defineProperty($9cce2902fa373f83$export$25ce5a424b770e84, 'defaults', {
    get: function() {
        return $9cce2902fa373f83$export$4368d992c4eafac0;
    }
});
// Attach prototype-mixin method groups onto Swiper.prototype. Each group is a
// plain record of method-name → function; we copy them across as-is.
var $9cce2902fa373f83$var$prototypeRecord = $9cce2902fa373f83$var$prototypes;
var $9cce2902fa373f83$var$swiperProto = $9cce2902fa373f83$export$25ce5a424b770e84.prototype;
Object.keys($9cce2902fa373f83$var$prototypeRecord).forEach(function(prototypeGroup) {
    var group = $9cce2902fa373f83$var$prototypeRecord[prototypeGroup];
    Object.keys(group).forEach(function(protoMethod) {
        $9cce2902fa373f83$var$swiperProto[protoMethod] = group[protoMethod];
    });
});
$9cce2902fa373f83$export$25ce5a424b770e84.use([
    $9cce2902fa373f83$var$Resize,
    $9cce2902fa373f83$var$Observer
]);

});
parcelRegister("g9Jbh", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $edd0d8f75733d3c0$export$db3b6bfb95261072; });
$parcel$export(module.exports, "d", function () { return $edd0d8f75733d3c0$export$4368d992c4eafac0; });
$parcel$export(module.exports, "t", function () { return $edd0d8f75733d3c0$export$625550452a3fa3ec; });
$parcel$export(module.exports, "u", function () { return $edd0d8f75733d3c0$export$3b14a55fb2447963; });
$parcel$export(module.exports, "q", function () { return $edd0d8f75733d3c0$export$9e5f44173e64f162; });
$parcel$export(module.exports, "r", function () { return $edd0d8f75733d3c0$export$43caf9889c228507; });
$parcel$export(module.exports, "n", function () { return $edd0d8f75733d3c0$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "v", function () { return $edd0d8f75733d3c0$export$90a7f3efeed30595; });
$parcel$export(module.exports, "p", function () { return $edd0d8f75733d3c0$export$ffb5f4729a158638; });
$parcel$export(module.exports, "e", function () { return $edd0d8f75733d3c0$export$f1e1789686576879; });
$parcel$export(module.exports, "f", function () { return $edd0d8f75733d3c0$export$2d1720544b23b823; });
$parcel$export(module.exports, "x", function () { return $edd0d8f75733d3c0$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "a", function () { return $edd0d8f75733d3c0$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $edd0d8f75733d3c0$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "k", function () { return $edd0d8f75733d3c0$export$342063e11d6c3cad; });
$parcel$export(module.exports, "g", function () { return $edd0d8f75733d3c0$export$39b482c5e57630a8; });
$parcel$export(module.exports, "l", function () { return $edd0d8f75733d3c0$export$882b5998b3b9117c; });
$parcel$export(module.exports, "b", function () { return $edd0d8f75733d3c0$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "j", function () { return $edd0d8f75733d3c0$export$35e795649ee09318; });
$parcel$export(module.exports, "m", function () { return $edd0d8f75733d3c0$export$953cecd6e717a553; });
$parcel$export(module.exports, "i", function () { return $edd0d8f75733d3c0$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "s", function () { return $edd0d8f75733d3c0$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "o", function () { return $edd0d8f75733d3c0$export$ae1af26003f05816; });
$parcel$export(module.exports, "w", function () { return $edd0d8f75733d3c0$export$efccba1c4a2ef57b; });

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");
function $edd0d8f75733d3c0$export$db3b6bfb95261072() {
    var classes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return classes.trim().split(' ').filter(function(c) {
        return !!c.trim();
    });
}
function $edd0d8f75733d3c0$export$4368d992c4eafac0(obj) {
    Object.keys(obj).forEach(function(key) {
        try {
            obj[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete obj[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $edd0d8f75733d3c0$export$625550452a3fa3ec(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return setTimeout(callback, delay);
}
function $edd0d8f75733d3c0$export$3b14a55fb2447963() {
    return Date.now();
}
function $edd0d8f75733d3c0$var$getComputedStyle(el) {
    return window.getComputedStyle(el, null);
}
function $edd0d8f75733d3c0$export$9e5f44173e64f162(el) {
    var axis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'x';
    var style = $edd0d8f75733d3c0$var$getComputedStyle(el);
    var transform = style.transform || style.webkitTransform;
    if (!transform || transform === 'none') return 0;
    var matrix = new DOMMatrixReadOnly(transform);
    return axis === 'x' ? matrix.m41 : matrix.m42;
}
function $edd0d8f75733d3c0$export$43caf9889c228507(o) {
    // `constructor === Object` would be false for a plain object created in another realm
    // (params built in the parent page, Swiper running inside an iframe), which makes extend()
    // replace a nested defaults object instead of merging into it.
    return (typeof o === "undefined" ? "undefined" : (0, $5djcY._)(o)) === 'object' && o !== null && !!o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $edd0d8f75733d3c0$var$isNode(node) {
    if (typeof HTMLElement !== 'undefined' && node instanceof HTMLElement) return true;
    return !!node && (typeof node === "undefined" ? "undefined" : (0, $5djcY._)(node)) === 'object' && (node.nodeType === 1 || node.nodeType === 11);
}
function $edd0d8f75733d3c0$export$7ccc53e8f1e7dfc5(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        sources[_key - 1] = arguments[_key];
    }
    var to = Object(target);
    for(var i = 0; i < sources.length; i += 1){
        var nextSource = sources[i];
        if (nextSource === undefined || nextSource === null || $edd0d8f75733d3c0$var$isNode(nextSource)) continue;
        var sourceObj = nextSource;
        var keysArray = Object.keys(Object(sourceObj));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
            var nextKey = keysArray[nextIndex];
            if (nextKey === '__proto__' || nextKey === 'constructor' || nextKey === 'prototype') continue;
            var desc = Object.getOwnPropertyDescriptor(sourceObj, nextKey);
            if (!desc || !desc.enumerable) continue;
            var sourceVal = sourceObj[nextKey];
            if ($edd0d8f75733d3c0$export$43caf9889c228507(to[nextKey]) && $edd0d8f75733d3c0$export$43caf9889c228507(sourceVal)) {
                if (sourceVal.__swiper__) to[nextKey] = sourceVal;
                else $edd0d8f75733d3c0$export$7ccc53e8f1e7dfc5(to[nextKey], sourceVal);
            } else if (!$edd0d8f75733d3c0$export$43caf9889c228507(to[nextKey]) && $edd0d8f75733d3c0$export$43caf9889c228507(sourceVal)) {
                to[nextKey] = {};
                if (sourceVal.__swiper__) to[nextKey] = sourceVal;
                else $edd0d8f75733d3c0$export$7ccc53e8f1e7dfc5(to[nextKey], sourceVal);
            } else to[nextKey] = sourceVal;
        }
    }
    return to;
}
function $edd0d8f75733d3c0$export$90a7f3efeed30595(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $edd0d8f75733d3c0$export$ffb5f4729a158638(slideEl) {
    var direct = slideEl.querySelector('.swiper-slide-transform');
    if (direct) return direct;
    if (slideEl.shadowRoot) {
        var shadowed = slideEl.shadowRoot.querySelector('.swiper-slide-transform');
        if (shadowed) return shadowed;
    }
    return slideEl;
}
function $edd0d8f75733d3c0$export$f1e1789686576879(element) {
    var selector = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var _children;
    var children = (0, $jlUaU._)(element.children);
    if (element instanceof HTMLSlotElement) (_children = children).push.apply(_children, (0, $jlUaU._)(element.assignedElements()));
    return selector ? children.filter(function(el) {
        return el.matches(selector);
    }) : children;
}
function $edd0d8f75733d3c0$var$elementIsChildOfSlot(el, slot) {
    var queue = [
        slot
    ];
    while(queue.length > 0){
        var _queue;
        var cur = queue.shift();
        if (el === cur) return true;
        (_queue = queue).push.apply(_queue, (0, $jlUaU._)(cur.children).concat((0, $jlUaU._)(cur.shadowRoot ? cur.shadowRoot.children : []), (0, $jlUaU._)(cur.assignedElements ? cur.assignedElements() : [])));
    }
    return false;
}
function $edd0d8f75733d3c0$export$2d1720544b23b823(el, parent) {
    var isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        var children = (0, $jlUaU._)(parent.assignedElements());
        isChild = children.includes(el);
        if (!isChild) isChild = $edd0d8f75733d3c0$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $edd0d8f75733d3c0$export$d141bba7fdc215a3(text) {
    try {
        console.warn(text);
    } catch (e) {
    // err
    }
}
function $edd0d8f75733d3c0$export$407448d2b89b1813(tag) {
    var classes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var _el_classList;
    var el = document.createElement(tag);
    (_el_classList = el.classList).add.apply(_el_classList, (0, $jlUaU._)(Array.isArray(classes) ? classes : $edd0d8f75733d3c0$export$db3b6bfb95261072(classes)));
    return el;
}
// Viewport-relative on purpose: every caller either compares against viewport quantities
// or adds window.scrollX/Y itself, so folding the scroll offset in here double-counts.
function $edd0d8f75733d3c0$export$dda1d9f60106f0e9(el) {
    var box = el.getBoundingClientRect();
    return {
        top: box.top - (el.clientTop || 0),
        left: box.left - (el.clientLeft || 0)
    };
}
function $edd0d8f75733d3c0$export$342063e11d6c3cad(el, selector) {
    var prevEls = [];
    var prev = el.previousElementSibling;
    while(prev){
        if (!selector || prev.matches(selector)) prevEls.push(prev);
        prev = prev.previousElementSibling;
    }
    return prevEls;
}
function $edd0d8f75733d3c0$export$39b482c5e57630a8(el, selector) {
    var nextEls = [];
    var next = el.nextElementSibling;
    while(next){
        if (!selector || next.matches(selector)) nextEls.push(next);
        next = next.nextElementSibling;
    }
    return nextEls;
}
function $edd0d8f75733d3c0$export$882b5998b3b9117c(el, prop) {
    return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function $edd0d8f75733d3c0$export$8b22cf2602fb60ce(el) {
    if (!el || !el.parentNode) return undefined;
    return (0, $jlUaU._)(el.parentNode.children).indexOf(el);
}
function $edd0d8f75733d3c0$export$35e795649ee09318(el, selector) {
    var parents = [];
    var parent = el.parentElement;
    while(parent){
        if (!selector || parent.matches(selector)) parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $edd0d8f75733d3c0$export$953cecd6e717a553(el, callback) {
    if (!callback) return;
    el.addEventListener('transitionend', function fireCallBack(e) {
        if (e.target !== el) return;
        el.removeEventListener('transitionend', fireCallBack);
        callback.call(el, e);
    });
}
function $edd0d8f75733d3c0$export$23f2a1d2818174ef(el, size, includeMargins) {
    {
        var style = window.getComputedStyle(el, null);
        return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(style.getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(style.getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    }
}
function $edd0d8f75733d3c0$export$2408f22a0fab9ae5(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter(function(e) {
        return !!e;
    });
}
function $edd0d8f75733d3c0$export$ae1af26003f05816(swiper) {
    return function(v) {
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $edd0d8f75733d3c0$export$efccba1c4a2ef57b(el) {
    var html = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var tt = globalThis.trustedTypes;
    if (typeof tt !== 'undefined') el.innerHTML = tt.createPolicy('html', {
        createHTML: function(s) {
            return s;
        }
    }).createHTML(html);
    else el.innerHTML = html;
}

});



parcelRegister("kP7YF", function(module, exports) {

$parcel$export(module.exports, "Keyboard", function () { return (parcelRequire("cogvT")).default; });
$parcel$export(module.exports, "Navigation", function () { return (parcelRequire("65Ws1")).default; });
$parcel$export(module.exports, "Pagination", function () { return (parcelRequire("lUpSt")).default; });
$parcel$export(module.exports, "EffectFade", function () { return (parcelRequire("cLqMg")).default; });

var $6NNmA = parcelRequire("6NNmA");

var $cogvT = parcelRequire("cogvT");

var $6apsl = parcelRequire("6apsl");

var $65Ws1 = parcelRequire("65Ws1");

var $lUpSt = parcelRequire("lUpSt");

var $fIJRW = parcelRequire("fIJRW");

var $9jPJC = parcelRequire("9jPJC");

var $hYIfu = parcelRequire("hYIfu");

var $dJ2Ih = parcelRequire("dJ2Ih");

var $cfC7D = parcelRequire("cfC7D");

var $1mkGn = parcelRequire("1mkGn");

var $1DdR6 = parcelRequire("1DdR6");

var $83P8R = parcelRequire("83P8R");

var $gAVbe = parcelRequire("gAVbe");

var $41pcR = parcelRequire("41pcR");

var $92XIM = parcelRequire("92XIM");

var $cvzkk = parcelRequire("cvzkk");

var $cLqMg = parcelRequire("cLqMg");

var $bV7YR = parcelRequire("bV7YR");

var $e5B0u = parcelRequire("e5B0u");

var $f1wTr = parcelRequire("f1wTr");

var $3Ei1g = parcelRequire("3Ei1g");

var $51qv4 = parcelRequire("51qv4");

});
parcelRegister("6NNmA", function(module, exports) {

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $g9Jbh = parcelRequire("g9Jbh");
var $e6483ec026da82c2$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var cssModeTimeout;
    // Methods (appendSlide/prependSlide/removeSlide/removeAllSlides/update) are
    // attached via Object.assign below once they're defined. Cast through
    // Partial<> so the initial state-only literal can be assigned without
    // pretending the methods exist yet.
    swiper.virtual = {
        cache: {},
        from: 0,
        // -1 marks "nothing rendered yet": no real update can produce to < from,
        // so the first update() never mistakes slide 0 for an already-rendered
        // slide and always appends the full [from, to] window (#8202).
        to: -1,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function getParams() {
        return swiper.params.virtual;
    }
    // Created lazily so module init does not touch the DOM (SSR / Node safe).
    var tempDOM;
    var getTempDOM = function() {
        return tempDOM !== null && tempDOM !== void 0 ? tempDOM : tempDOM = document.createElement('div');
    };
    function renderSlide(slide, index) {
        var params = getParams();
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        var slideEl;
        if (params.renderSlide) {
            var rendered = params.renderSlide.call(swiper, slide, index);
            if (typeof rendered === 'string') {
                var el = getTempDOM();
                (0, $g9Jbh.w)(el, rendered);
                slideEl = el.children[0];
            } else slideEl = rendered;
        } else if (swiper.isElement) slideEl = (0, $g9Jbh.a)('swiper-slide');
        else slideEl = (0, $g9Jbh.a)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', String(index));
        if (!params.renderSlide) (0, $g9Jbh.w)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        var _swiper_params = swiper.params, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides, slidesPerView = _swiper_params.slidesPerView, isLoop = _swiper_params.loop, initialSlide = _swiper_params.initialSlide;
        if (beforeInit && !isLoop && (initialSlide !== null && initialSlide !== void 0 ? initialSlide : 0) > 0) return;
        var _getParams = getParams(), addSlidesBefore = _getParams.addSlidesBefore, addSlidesAfter = _getParams.addSlidesAfter, slidesPerViewAutoSlideSize = _getParams.slidesPerViewAutoSlideSize;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, previousOffset = _swiper_virtual.offset;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        var activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        var slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                var swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView !== null && slidesPerView !== void 0 ? slidesPerView : 1;
        var groupSize = slidesPerGroup !== null && slidesPerGroup !== void 0 ? slidesPerGroup : 1;
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (groupSize - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : groupSize) + addSlidesBefore;
        }
        var from = activeIndex - slidesBefore;
        var to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach(function(slideEl) {
                slideEl.style.setProperty(offsetProp, "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px"));
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        var virtualParams = getParams();
        if (virtualParams.renderExternal) {
            var slidesToRender = [];
            for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
            virtualParams.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: slidesToRender
            });
            if (virtualParams.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        var getSlideIndex = function(index) {
            var slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter(function(el) {
            return el.matches(".".concat(swiper.params.slideClass, ", swiper-slide"));
        }).forEach(function(slideEl) {
            slideEl.remove();
        });
        else {
            var _loop = function(i1) {
                if (i1 < from || i1 > to) {
                    var slideIndex = getSlideIndex(i1);
                    swiper.slides.filter(function(el) {
                        return el.matches(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(slideIndex, '"], swiper-slide[data-swiper-slide-index="').concat(slideIndex, '"]'));
                    }).forEach(function(slideEl) {
                        slideEl.remove();
                    });
                }
            };
            for(var i1 = previousFrom; i1 <= previousTo; i1 += 1)_loop(i1);
        }
        var loopFrom = isLoop ? -slides.length : 0;
        var loopTo = isLoop ? slides.length * 2 : slides.length;
        for(var i2 = loopFrom; i2 < loopTo; i2 += 1)if (i2 >= from && i2 <= to) {
            var slideIndex = getSlideIndex(i2);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i2 > previousTo) appendIndexes.push(slideIndex);
                if (i2 < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(var i3 = prependIndexes.length - 1; i3 >= 0; i3 -= 1){
            var index = prependIndexes[i3];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort(function(a, b) {
                return b - a;
            });
            prependIndexes.forEach(function(index) {
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $g9Jbh.e)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach(function(slideEl) {
            slideEl.style.setProperty(offsetProp, "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px"));
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (slides !== null && (typeof slides === "undefined" ? "undefined" : (0, $5djcY._)(slides)) === 'object' && 'length' in slides) {
            var arr = slides;
            for(var i = 0; i < arr.length; i += 1)if (arr[i]) swiper.virtual.slides.push(arr[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (getParams().cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var cachedEl = cache[Number(cachedIndex)];
                var cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', String(parseInt(cachedElIndex, 10) + numberOfNewSlides));
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        var shiftCacheDownFrom = function(removedIndex) {
            Object.keys(swiper.virtual.cache).forEach(function(key) {
                var numericKey = Number(key);
                if (numericKey > removedIndex) {
                    var shifted = swiper.virtual.cache[numericKey];
                    swiper.virtual.cache[numericKey - 1] = shifted;
                    shifted.setAttribute('data-swiper-slide-index', String(numericKey - 1));
                    delete swiper.virtual.cache[numericKey];
                }
            });
        };
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                shiftCacheDownFrom(slidesIndexes[i]);
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes];
                shiftCacheDownFrom(slidesIndexes);
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (getParams().cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', function() {
        if (!getParams().enabled) return;
        var domSlidesAssigned = false;
        var passedVirtual = swiper.passedParams.virtual;
        var passedSlidesUndefined = !passedVirtual || (typeof passedVirtual === "undefined" ? "undefined" : (0, $5djcY._)(passedVirtual)) !== 'object' || passedVirtual.slides === undefined;
        if (passedSlidesUndefined) {
            var slides = (0, $jlUaU._)(swiper.slidesEl.children).filter(function(el) {
                return el.matches(".".concat(swiper.params.slideClass, ", swiper-slide"));
            });
            if (slides && slides.length) {
                swiper.virtual.slides = (0, $jlUaU._)(slides);
                domSlidesAssigned = true;
                slides.forEach(function(slideEl, slideIndex) {
                    slideEl.setAttribute('data-swiper-slide-index', String(slideIndex));
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = getParams().slides;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', function() {
        if (!getParams().enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(function() {
                update();
            }, 100);
        } else update();
    });
    on('init update resize', function() {
        if (!getParams().enabled) return;
        if (swiper.params.cssMode) (0, $g9Jbh.v)(swiper.wrapperEl, '--swiper-virtual-size', "".concat(swiper.virtualSize, "px"));
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
};

});

parcelRegister("cogvT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51bc8af4d544649f$export$2e2bcd8739ae039; });

var $g9Jbh = parcelRequire("g9Jbh");
var $51bc8af4d544649f$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined
        }
    });
    function getParams() {
        return swiper.params.keyboard;
    }
    function handle(event) {
        if (!swiper.enabled) return;
        var rtl = swiper.rtlTranslate;
        var e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        var kc = e.keyCode || e.charCode;
        var params = getParams();
        var pageUpDown = !!params.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        var activeElement = document.activeElement;
        if (activeElement && (activeElement.isContentEditable || activeElement.nodeName && (activeElement.nodeName.toLowerCase() === 'input' || activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (params.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $g9Jbh.j)(swiper.el, ".".concat(swiper.params.slideClass, ", swiper-slide")).length > 0 && (0, $g9Jbh.j)(swiper.el, ".".concat(swiper.params.slideActiveClass)).length === 0) return undefined;
            var el = swiper.el;
            var swiperWidth = el.clientWidth;
            var swiperHeight = el.clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = (0, $g9Jbh.h)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue;
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        var speed = params.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.cancelable) e.preventDefault();
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.cancelable) e.preventDefault();
            }
            if (isPageDown || isArrowDown) swiper.slideNext(speed);
            if (isPageUp || isArrowUp) swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    swiper.keyboard = {
        enabled: false,
        enable: enable,
        disable: disable
    };
    on('init', function() {
        if (getParams().enabled) enable();
    });
    on('destroy', function() {
        if (swiper.keyboard.enabled) disable();
    });
};

});

parcelRegister("6apsl", function(module, exports) {

var $g9Jbh = parcelRequire("g9Jbh");
var $b21d9132d3b3a158$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    var timeout;
    var lastScrollTime = (0, $g9Jbh.u)();
    var lastEventBeforeSnap;
    var mouseEntered = false;
    var recentWheelEvents = [];
    function getParams() {
        return swiper.params.mousewheel;
    }
    function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var ev = e;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if (ev.detail !== undefined) sY = ev.detail;
        if (ev.wheelDelta !== undefined) sY = -ev.wheelDelta / 120;
        if (ev.wheelDeltaY !== undefined) sY = -ev.wheelDeltaY / 120;
        if (ev.wheelDeltaX !== undefined) sX = -ev.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if (ev.axis !== undefined && ev.HORIZONTAL_AXIS !== undefined && ev.axis === ev.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if (ev.deltaY !== undefined) pY = ev.deltaY;
        if (ev.deltaX !== undefined) pX = ev.deltaX;
        if (ev.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && ev.deltaMode) {
            if (ev.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        mouseEntered = false;
    }
    function animateSlider(newEvent) {
        var params = getParams();
        if (params.thresholdDelta && newEvent.delta < params.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (params.thresholdTime && (0, $g9Jbh.u)() - lastScrollTime < params.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $g9Jbh.u)() - lastScrollTime < 60) // Return false as a default
        return true;
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        var params = getParams();
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event) {
        var e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        var disableParentSwiper = true;
        if (!swiper.enabled) return false;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        var params = getParams();
        if (event.target.closest(".".concat(params.noMousewheelClass))) return false;
        if (swiper.params.cssMode) e.preventDefault();
        var targetEl = swiper.el;
        if (params.eventsTarget !== 'container') targetEl = document.querySelector(params.eventsTarget);
        var targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        var _params_sensitivity;
        // Get the scroll positions
        var positions = swiper.getTranslate() + delta * ((_params_sensitivity = params.sensitivity) !== null && _params_sensitivity !== void 0 ? _params_sensitivity : 1);
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        var freeModeParams = swiper.params.freeMode;
        if (!swiper.params.freeMode || !(freeModeParams === null || freeModeParams === void 0 ? void 0 : freeModeParams.enabled)) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, $g9Jbh.u)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            var newEvent1 = {
                time: (0, $g9Jbh.u)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                var _params_sensitivity1;
                var position = swiper.getTranslate() + delta * ((_params_sensitivity1 = params.sensitivity) !== null && _params_sensitivity1 !== void 0 ? _params_sensitivity1 : 1);
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent1.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (freeModeParams === null || freeModeParams === void 0 ? void 0 : freeModeParams.sticky) {
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    var prevEvent1 = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    var firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && firstEvent && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        timeout = (0, $g9Jbh.t)(function() {
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) timeout = (0, $g9Jbh.t)(function() {
                        if (swiper.destroyed || !swiper.params) return;
                        var snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                var autoplayParams = swiper.params.autoplay;
                if (swiper.params.autoplay && (autoplayParams === null || autoplayParams === void 0 ? void 0 : autoplayParams.disableOnInteraction)) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.cancelable) e.preventDefault();
        return false;
    }
    function events(method) {
        var params = getParams();
        var targetEl = swiper.el;
        if (params.eventsTarget !== 'container') targetEl = document.querySelector(params.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener('wheel', handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', function() {
        var params = getParams();
        if (!params.enabled && swiper.params.cssMode) disable();
        if (params.enabled) enable();
    });
    swiper.mousewheel = {
        enabled: false,
        enable: enable,
        disable: disable
    };
    on('destroy', function() {
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
};

});

parcelRegister("65Ws1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $043edd289a2326dc$export$2e2bcd8739ae039; });

var $jlUaU = parcelRequire("jlUaU");

var $1k3d6 = parcelRequire("1k3d6");

var $g9Jbh = parcelRequire("g9Jbh");
var $043edd289a2326dc$var$arrowSvg = '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
var $043edd289a2326dc$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    // Initialized as a partial; remaining methods (update, init, destroy,
    // enable, disable) attach after their definitions below.
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $043edd289a2326dc$var$arrowSvg
    };
    function getParams() {
        return swiper.params.navigation;
    }
    function getEl(el) {
        var res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = (0, $jlUaU._)(document.querySelectorAll(el));
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        return res;
    }
    function toggleEl(el, disabled) {
        var params = getParams();
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            if (subEl) {
                var _subEl_classList;
                (_subEl_classList = subEl.classList)[disabled ? 'add' : 'remove'].apply(_subEl_classList, (0, $jlUaU._)(params.disabledClass.split(' ')));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        swiper.params.navigation = (0, $1k3d6.c)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        var params = getParams();
        if (!(params.nextEl || params.prevEl)) return;
        var nextEl = getEl(params.nextEl);
        var prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        var nextEls = (0, $g9Jbh.s)(nextEl);
        var prevEls = (0, $g9Jbh.s)(prevEl);
        var initButton = function(el, dir) {
            var _el_classList;
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    var tempEl = document.createElement('div');
                    (0, $g9Jbh.w)(tempEl, $043edd289a2326dc$var$arrowSvg);
                    var svgEl = tempEl.querySelector('svg');
                    if (svgEl) el.appendChild(svgEl);
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) (_el_classList = el.classList).add.apply(_el_classList, (0, $jlUaU._)(params.lockClass.split(' ')));
        };
        nextEls.forEach(function(el) {
            return initButton(el, 'next');
        });
        prevEls.forEach(function(el) {
            return initButton(el, 'prev');
        });
    }
    function destroy() {
        var params = getParams();
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        var nextEls = (0, $g9Jbh.s)(nextEl);
        var prevEls = (0, $g9Jbh.s)(prevEl);
        var destroyButton = function(el, dir) {
            var _el_classList;
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $jlUaU._)(params.disabledClass.split(' ')));
        };
        nextEls.forEach(function(el) {
            return destroyButton(el, 'next');
        });
        prevEls.forEach(function(el) {
            return destroyButton(el, 'prev');
        });
    }
    on('init', function() {
        if (getParams().enabled === false) disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', function() {
        update();
    });
    on('destroy', function() {
        destroy();
    });
    on('enable disable', function() {
        var params = getParams();
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        var nextEls = (0, $g9Jbh.s)(nextEl);
        var prevEls = (0, $g9Jbh.s)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        (0, $jlUaU._)(nextEls).concat((0, $jlUaU._)(prevEls)).filter(function(el) {
            return !!el;
        }).forEach(function(el) {
            return el.classList.add(params.lockClass);
        });
    });
    on('click', function(_s, e) {
        var params = getParams();
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        var nextEls = (0, $g9Jbh.s)(nextEl);
        var prevEls = (0, $g9Jbh.s)(prevEl);
        var targetEl = e.target;
        var targetIsButton = prevEls.includes(targetEl) || nextEls.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            var path = e.composedPath ? e.composedPath() : [];
            if (path.length) targetIsButton = path.find(function(pathEl) {
                return nextEls.includes(pathEl) || prevEls.includes(pathEl);
            });
        }
        if (params.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
            if (nextEls.length) isHidden = nextEls[0].classList.contains(params.hiddenClass);
            else if (prevEls.length) isHidden = prevEls[0].classList.contains(params.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            (0, $jlUaU._)(nextEls).concat((0, $jlUaU._)(prevEls)).filter(function(el) {
                return !!el;
            }).forEach(function(el) {
                return el.classList.toggle(params.hiddenClass);
            });
        }
    });
    var enable = function() {
        var _swiper_el_classList;
        var params = getParams();
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, $jlUaU._)(params.navigationDisabledClass.split(' ')));
        init();
        update();
    };
    var disable = function() {
        var _swiper_el_classList;
        var params = getParams();
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, $jlUaU._)(params.navigationDisabledClass.split(' ')));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
};

});
parcelRegister("1k3d6", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $a5c7ba4a9525eaab$export$db3b6bfb95261072; });

var $g9Jbh = parcelRequire("g9Jbh");
function $a5c7ba4a9525eaab$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    var target = params !== null && params !== void 0 ? params : {};
    var original = originalParams !== null && originalParams !== void 0 ? originalParams : {};
    if (swiper.params.createElements) Object.keys(checkProps).forEach(function(key) {
        if (!target[key] && target.auto === true) {
            var element = (0, $g9Jbh.e)(swiper.el, ".".concat(checkProps[key]))[0];
            if (!element) {
                element = (0, $g9Jbh.a)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            target[key] = element;
            original[key] = element;
        }
    });
    return target;
}

});


parcelRegister("lUpSt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b37756791b1671e$export$2e2bcd8739ae039; });

var $jlUaU = parcelRequire("jlUaU");

var $kAqRU = parcelRequire("kAqRU");

var $1k3d6 = parcelRequire("1k3d6");

var $g9Jbh = parcelRequire("g9Jbh");
var $4b37756791b1671e$var$isVirtualEnabled = function(swiper) {
    var _swiper_params_virtual;
    return !!swiper.virtual && !!((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled);
};
var $4b37756791b1671e$var$isFreeModeEnabled = function(swiper) {
    var _swiper_params_freeMode;
    return !!((_swiper_params_freeMode = swiper.params.freeMode) === null || _swiper_params_freeMode === void 0 ? void 0 : _swiper_params_freeMode.enabled);
};
// Slides count for bullets/fraction/progressbar totals: with grid rows the
// slides that share a column collapse into one snap position.
var $4b37756791b1671e$var$getSlidesLength = function(swiper) {
    var _swiper_params_grid;
    if ($4b37756791b1671e$var$isVirtualEnabled(swiper)) return swiper.virtual.slides.length;
    var gridRows = (_swiper_params_grid = swiper.params.grid) === null || _swiper_params_grid === void 0 ? void 0 : _swiper_params_grid.rows;
    if (swiper.grid && gridRows && gridRows > 1) return swiper.slides.length / Math.ceil(gridRows);
    return swiper.slides.length;
};
var $4b37756791b1671e$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "".concat(pfx, "-bullet"),
            bulletActiveClass: "".concat(pfx, "-bullet-active"),
            modifierClass: "".concat(pfx, "-"),
            currentClass: "".concat(pfx, "-current"),
            totalClass: "".concat(pfx, "-total"),
            hiddenClass: "".concat(pfx, "-hidden"),
            progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
            clickableClass: "".concat(pfx, "-clickable"),
            lockClass: "".concat(pfx, "-lock"),
            horizontalClass: "".concat(pfx, "-horizontal"),
            verticalClass: "".concat(pfx, "-vertical"),
            paginationDisabledClass: "".concat(pfx, "-disabled")
        }
    });
    // Initialized as a partial; remaining methods (render, update, init,
    // destroy, enable, disable) attach after their definitions below.
    swiper.pagination = {
        el: null,
        bullets: []
    };
    var bulletSize;
    var dynamicBulletIndex = 0;
    function getParams() {
        return swiper.params.pagination;
    }
    function isPaginationDisabled() {
        var elParam = getParams().el;
        return !elParam || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        var bulletActiveClass = getParams().bulletActiveClass;
        if (!bulletEl) return;
        var current = bulletEl["".concat(position === 'prev' ? 'previous' : 'next', "ElementSibling")];
        if (current) {
            current.classList.add("".concat(bulletActiveClass, "-").concat(position));
            current = current["".concat(position === 'prev' ? 'previous' : 'next', "ElementSibling")];
            if (current) current.classList.add("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return undefined;
    }
    function onBulletClick(e) {
        var targetEl = e.target;
        var bulletEl = targetEl.closest((0, $kAqRU.c)(getParams().bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        var _elementIndex, _swiper_params_slidesPerGroup;
        var index = ((_elementIndex = (0, $g9Jbh.b)(bulletEl)) !== null && _elementIndex !== void 0 ? _elementIndex : 0) * ((_swiper_params_slidesPerGroup = swiper.params.slidesPerGroup) !== null && _swiper_params_slidesPerGroup !== void 0 ? _swiper_params_slidesPerGroup : 1);
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            var moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        var rtl = swiper.rtl;
        var params = getParams();
        if (isPaginationDisabled()) return;
        var els = (0, $g9Jbh.s)(swiper.pagination.el);
        // Current/Total
        var current;
        var previousIndex;
        var slidesLength = $4b37756791b1671e$var$getSlidesLength(swiper);
        var _swiper_params_slidesPerGroup;
        var total = swiper.params.loop ? Math.ceil(slidesLength / ((_swiper_params_slidesPerGroup = swiper.params.slidesPerGroup) !== null && _swiper_params_slidesPerGroup !== void 0 ? _swiper_params_slidesPerGroup : 1)) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            var _swiper_params_slidesPerGroup1, _swiper_params_slidesPerGroup2;
            current = ((_swiper_params_slidesPerGroup1 = swiper.params.slidesPerGroup) !== null && _swiper_params_slidesPerGroup1 !== void 0 ? _swiper_params_slidesPerGroup1 : 1) > 1 ? Math.floor(swiper.realIndex / ((_swiper_params_slidesPerGroup2 = swiper.params.slidesPerGroup) !== null && _swiper_params_slidesPerGroup2 !== void 0 ? _swiper_params_slidesPerGroup2 : 1)) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex = 0;
            var lastIndex = 0;
            var midIndex = 0;
            if (params.dynamicBullets) {
                bulletSize = (0, $g9Jbh.i)(bullets[0], swiper.isHorizontal() ? 'width' : 'height');
                var dim = swiper.isHorizontal() ? 'width' : 'height';
                els.forEach(function(subEl) {
                    subEl.style[dim] = "".concat((bulletSize !== null && bulletSize !== void 0 ? bulletSize : 0) * (params.dynamicMainBullets + 4), "px");
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach(function(bulletEl) {
                var _bulletEl_classList;
                var classesToRemove = [
                    '',
                    '-next',
                    '-next-next',
                    '-prev',
                    '-prev-prev',
                    '-main'
                ].map(function(suffix) {
                    return "".concat(params.bulletActiveClass).concat(suffix);
                }).flatMap(function(s) {
                    return typeof s === 'string' && s.includes(' ') ? s.split(' ') : [
                        s
                    ];
                });
                (_bulletEl_classList = bulletEl.classList).remove.apply(_bulletEl_classList, (0, $jlUaU._)(classesToRemove));
            });
            if (els.length > 1) bullets.forEach(function(bullet) {
                var _bullet_classList;
                var bulletIndex = (0, $g9Jbh.b)(bullet);
                if (bulletIndex === current) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $jlUaU._)(params.bulletActiveClass.split(' ')));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets && bulletIndex !== undefined) {
                    var _bullet_classList1;
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) (_bullet_classList1 = bullet.classList).add.apply(_bullet_classList1, (0, $jlUaU._)("".concat(params.bulletActiveClass, "-main").split(' ')));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                var _bullet_classList;
                var bullet = bullets[current];
                if (bullet) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $jlUaU._)(params.bulletActiveClass.split(' ')));
                if (swiper.isElement) bullets.forEach(function(bulletEl, bulletIndex) {
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    var _bullets_i_classList;
                    var firstDisplayedBullet = bullets[firstIndex];
                    var lastDisplayedBullet = bullets[lastIndex];
                    for(var i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) (_bullets_i_classList = bullets[i].classList).add.apply(_bullets_i_classList, (0, $jlUaU._)("".concat(params.bulletActiveClass, "-main").split(' ')));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = ((bulletSize !== null && bulletSize !== void 0 ? bulletSize : 0) * dynamicBulletsLength - (bulletSize !== null && bulletSize !== void 0 ? bulletSize : 0)) / 2 - midIndex * (bulletSize !== null && bulletSize !== void 0 ? bulletSize : 0);
                var offsetProp = rtl ? 'right' : 'left';
                var positionDim = swiper.isHorizontal() ? offsetProp : 'top';
                bullets.forEach(function(bullet) {
                    bullet.style[positionDim] = "".concat(bulletsOffset, "px");
                });
            }
        }
        els.forEach(function(subEl, subElIndex) {
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $kAqRU.c)(params.currentClass)).forEach(function(fractionEl) {
                    fractionEl.textContent = String(params.formatFractionCurrent(current + 1));
                });
                subEl.querySelectorAll((0, $kAqRU.c)(params.totalClass)).forEach(function(totalEl) {
                    totalEl.textContent = String(params.formatFractionTotal(total));
                });
            }
            if (params.type === 'progressbar') {
                var progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                var scale = (current + 1) / total;
                var scaleX = 1;
                var scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $kAqRU.c)(params.progressbarFillClass)).forEach(function(progressEl) {
                    progressEl.style.transform = "translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")");
                    progressEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $g9Jbh.w)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        var params = getParams();
        if (isPaginationDisabled()) return;
        var slidesLength = $4b37756791b1671e$var$getSlidesLength(swiper);
        var els = (0, $g9Jbh.s)(swiper.pagination.el);
        var paginationHTML = '';
        if (params.type === 'bullets') {
            var _swiper_params_slidesPerGroup;
            var numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / ((_swiper_params_slidesPerGroup = swiper.params.slidesPerGroup) !== null && _swiper_params_slidesPerGroup !== void 0 ? _swiper_params_slidesPerGroup : 1)) : swiper.snapGrid.length;
            if (swiper.params.freeMode && $4b37756791b1671e$var$isFreeModeEnabled(swiper) && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // oxfmt-ignore
            paginationHTML += "<".concat(params.bulletElement, " ").concat(swiper.isElement ? 'part="bullet"' : '', ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + ' / ' + '<span class="'.concat(params.totalClass, '"></span>');
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
        }
        swiper.pagination.bullets = [];
        els.forEach(function(subEl) {
            var _swiper_pagination_bullets;
            if (params.type !== 'custom') (0, $g9Jbh.w)(subEl, paginationHTML || '');
            if (params.type === 'bullets') (_swiper_pagination_bullets = swiper.pagination.bullets).push.apply(_swiper_pagination_bullets, (0, $jlUaU._)(Array.from(subEl.querySelectorAll((0, $kAqRU.c)(params.bulletClass)))));
        });
        if (params.type !== 'custom') emit('paginationRender', els[0]);
    }
    function init() {
        swiper.params.pagination = (0, $1k3d6.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        var params = getParams();
        if (!params.el) return;
        var el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = (0, $jlUaU._)(document.querySelectorAll(params.el));
        if (!el) el = params.el;
        if (!el || Array.isArray(el) && el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = (0, $jlUaU._)(swiper.el.querySelectorAll(params.el));
            // check if it belongs to another nested Swiper
            if (el.length > 1) {
                var found = el.find(function(subEl) {
                    if ((0, $g9Jbh.j)(subEl, '.swiper')[0] !== swiper.el) return false;
                    return true;
                });
                if (found) el = found;
            }
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            var _subEl_classList;
            if (params.type === 'bullets' && params.clickable) (_subEl_classList = subEl.classList).add.apply(_subEl_classList, (0, $jlUaU._)((params.clickableClass || '').split(' ')));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add("".concat(params.modifierClass).concat(params.type, "-dynamic"));
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        var _subEl_classList;
        var params = getParams();
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        if (el) {
            var els = (0, $g9Jbh.s)(el);
            els.forEach(function(subEl) {
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    var _subEl_classList;
                    (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, $jlUaU._)((params.clickableClass || '').split(' ')));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(function(subEl) {
            return (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, $jlUaU._)(params.bulletActiveClass.split(' ')));
        });
    }
    on('changeDirection', function() {
        if (!swiper.pagination || !swiper.pagination.el) return;
        var params = getParams();
        var els = (0, $g9Jbh.s)(swiper.pagination.el);
        els.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', function() {
        if (getParams().enabled === false) disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', function() {
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', function() {
        update();
    });
    on('snapGridLengthChange', function() {
        render();
        update();
    });
    on('destroy', function() {
        destroy();
    });
    on('enable disable', function() {
        var el = swiper.pagination.el;
        if (el) {
            var params = getParams();
            var els = (0, $g9Jbh.s)(el);
            els.forEach(function(subEl) {
                return subEl.classList[swiper.enabled ? 'remove' : 'add'](params.lockClass);
            });
        }
    });
    on('lock unlock', function() {
        update();
    });
    on('click', function(_s, e) {
        var targetEl = e.target;
        var els = (0, $g9Jbh.s)(swiper.pagination.el);
        var params = getParams();
        if (params.el && params.hideOnClick && els && els.length > 0 && !targetEl.classList.contains(params.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = els[0].classList.contains(params.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            els.forEach(function(subEl) {
                return subEl.classList.toggle(params.hiddenClass);
            });
        }
    });
    var enable = function() {
        var params = getParams();
        swiper.el.classList.remove(params.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            var els = (0, $g9Jbh.s)(el);
            els.forEach(function(subEl) {
                return subEl.classList.remove(params.paginationDisabledClass);
            });
        }
        init();
        render();
        update();
    };
    var disable = function() {
        var params = getParams();
        swiper.el.classList.add(params.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            var els = (0, $g9Jbh.s)(el);
            els.forEach(function(subEl) {
                return subEl.classList.add(params.paginationDisabledClass);
            });
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
};

});
parcelRegister("kAqRU", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $5ac6e73ba7f3e361$export$db3b6bfb95261072; });
function $5ac6e73ba7f3e361$export$db3b6bfb95261072() {
    var classes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return ".".concat(classes.trim().replace(/([.:!+/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1').replace(/ /g, '.'));
}

});


parcelRegister("fIJRW", function(module, exports) {

var $jlUaU = parcelRequire("jlUaU");

var $kAqRU = parcelRequire("kAqRU");

var $g9Jbh = parcelRequire("g9Jbh");

var $1k3d6 = parcelRequire("1k3d6");
var $e10f8f91a0d670fe$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var isTouched = false;
    var timeout = null;
    var dragTimeout = null;
    var dragStartPos = 0;
    var dragSize = 0;
    var trackSize = 0;
    var divider = 0;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical"
        }
    });
    // Initialized as a partial; remaining methods (updateSize, setTranslate,
    // init, destroy, enable, disable) attach after their definitions below.
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function getParams() {
        return swiper.params.scrollbar;
    }
    function setTranslate() {
        var params = getParams();
        if (!params.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        var _swiper_progressLoop;
        var progress = swiper.params.loop ? (_swiper_progressLoop = swiper.progressLoop) !== null && _swiper_progressLoop !== void 0 ? _swiper_progressLoop : 0 : swiper.progress;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = "translate3d(".concat(newPos, "px, 0, 0)");
            dragEl.style.width = "".concat(newSize, "px");
        } else {
            dragEl.style.transform = "translate3d(0px, ".concat(newPos, "px, 0)");
            dragEl.style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            if (timeout) clearTimeout(timeout);
            el.style.opacity = '1';
            timeout = setTimeout(function() {
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!getParams().el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = "".concat(duration, "ms");
    }
    function updateSize() {
        var params = getParams();
        if (!params.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        var _swiper_params_slidesOffsetBefore;
        divider = swiper.size / (swiper.virtualSize + ((_swiper_params_slidesOffsetBefore = swiper.params.slidesOffsetBefore) !== null && _swiper_params_slidesOffsetBefore !== void 0 ? _swiper_params_slidesOffsetBefore : 0) - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (params.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(String(params.dragSize), 10);
        if (swiper.isHorizontal()) dragEl.style.width = "".concat(dragSize, "px");
        else dragEl.style.height = "".concat(dragSize, "px");
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (params.hide) el.style.opacity = '0';
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
    }
    function getPointerPosition(e) {
        var _e_touches_, _e_touches, _e_touches_1, _e_touches1;
        var _e_clientX, _ref;
        if (swiper.isHorizontal()) return (_ref = (_e_clientX = e.clientX) !== null && _e_clientX !== void 0 ? _e_clientX : (_e_touches = e.touches) === null || _e_touches === void 0 ? void 0 : (_e_touches_ = _e_touches[0]) === null || _e_touches_ === void 0 ? void 0 : _e_touches_.clientX) !== null && _ref !== void 0 ? _ref : 0;
        var _e_clientY, _ref1;
        return (_ref1 = (_e_clientY = e.clientY) !== null && _e_clientY !== void 0 ? _e_clientY : (_e_touches1 = e.touches) === null || _e_touches1 === void 0 ? void 0 : (_e_touches_1 = _e_touches1[0]) === null || _e_touches_1 === void 0 ? void 0 : _e_touches_1.clientY) !== null && _ref1 !== void 0 ? _ref1 : 0;
    }
    function setDragPosition(e) {
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var el = scrollbar.el;
        var positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $g9Jbh.h)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        var params = getParams();
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        if (dragTimeout) clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = '1';
        if (swiper.params.cssMode) swiper.wrapperEl.style.scrollSnapType = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        if (!isTouched) return;
        if (e.cancelable) e.preventDefault();
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        var params = getParams();
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.scrollSnapType = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            if (dragTimeout) clearTimeout(dragTimeout);
            dragTimeout = (0, $g9Jbh.t)(function() {
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        var scrollbar = swiper.scrollbar, params = swiper.params;
        var el = scrollbar.el;
        if (!el) return;
        var activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        el[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        var _elTyped_classList;
        var scrollbar = swiper.scrollbar, swiperEl = swiper.el;
        swiper.params.scrollbar = (0, $1k3d6.c)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        var params = getParams();
        if (!params.el) return;
        var el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        var elTyped = el;
        elTyped.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        var dragEl = null;
        if (elTyped) {
            dragEl = elTyped.querySelector((0, $kAqRU.c)(params.dragClass));
            if (!dragEl) {
                dragEl = (0, $g9Jbh.a)('div', params.dragClass);
                elTyped.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: elTyped,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (elTyped) (_elTyped_classList = elTyped.classList)[swiper.enabled ? 'remove' : 'add'].apply(_elTyped_classList, (0, $jlUaU._)((0, $g9Jbh.c)(params.lockClass)));
    }
    function destroy() {
        var _el_classList;
        var params = getParams();
        var el = swiper.scrollbar.el;
        if (el) (_el_classList = el.classList).remove.apply(_el_classList, (0, $jlUaU._)((0, $g9Jbh.c)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass)));
        disableDraggable();
    }
    on('changeDirection', function() {
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        var params = getParams();
        var els = (0, $g9Jbh.s)(swiper.scrollbar.el);
        els.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', function() {
        if (getParams().enabled === false) disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', function() {
        updateSize();
    });
    on('setTranslate', function() {
        setTranslate();
    });
    on('setTransition', function(_s, duration) {
        setTransition(duration);
    });
    on('enable disable', function() {
        var _el_classList;
        var el = swiper.scrollbar.el;
        if (el) (_el_classList = el.classList)[swiper.enabled ? 'remove' : 'add'].apply(_el_classList, (0, $jlUaU._)((0, $g9Jbh.c)(getParams().lockClass)));
    });
    on('destroy', function() {
        destroy();
    });
    var enable = function() {
        var _swiper_el_classList, _swiper_scrollbar_el_classList;
        var params = getParams();
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, $jlUaU._)((0, $g9Jbh.c)(params.scrollbarDisabledClass)));
        if (swiper.scrollbar.el) (_swiper_scrollbar_el_classList = swiper.scrollbar.el.classList).remove.apply(_swiper_scrollbar_el_classList, (0, $jlUaU._)((0, $g9Jbh.c)(params.scrollbarDisabledClass)));
        init();
        updateSize();
        setTranslate();
    };
    var disable = function() {
        var _swiper_el_classList, _swiper_scrollbar_el_classList;
        var params = getParams();
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, $jlUaU._)((0, $g9Jbh.c)(params.scrollbarDisabledClass)));
        if (swiper.scrollbar.el) (_swiper_scrollbar_el_classList = swiper.scrollbar.el.classList).add.apply(_swiper_scrollbar_el_classList, (0, $jlUaU._)((0, $g9Jbh.c)(params.scrollbarDisabledClass)));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
};

});

parcelRegister("9jPJC", function(module, exports) {

var $jlUaU = parcelRequire("jlUaU");

var $g9Jbh = parcelRequire("g9Jbh");
var $1002e96470686863$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    function getParams() {
        return swiper.params.parallax;
    }
    var elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    var setTransform = function(el, progress) {
        var rtl = swiper.rtl;
        var rtlFactor = rtl ? -1 : 1;
        var p = el.getAttribute('data-swiper-parallax') || '0';
        var x = el.getAttribute('data-swiper-parallax-x');
        var y = el.getAttribute('data-swiper-parallax-y');
        var scale = el.getAttribute('data-swiper-parallax-scale');
        var opacity = el.getAttribute('data-swiper-parallax-opacity');
        var rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        else x = "".concat(Number(x) * progress * rtlFactor, "px");
        if (y.indexOf('%') >= 0) y = "".concat(parseInt(y, 10) * progress, "%");
        else y = "".concat(Number(y) * progress, "px");
        if (typeof opacity !== 'undefined' && opacity !== null) {
            var opacityNum = Number(opacity);
            var currentOpacity = opacityNum - (opacityNum - 1) * (1 - Math.abs(progress));
            el.style.opacity = String(currentOpacity);
        }
        var transform = "translate3d(".concat(x, ", ").concat(y, ", 0px)");
        if (typeof scale !== 'undefined' && scale !== null) {
            var scaleNum = Number(scale);
            var currentScale = scaleNum - (scaleNum - 1) * (1 - Math.abs(progress));
            transform += " scale(".concat(currentScale, ")");
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            var currentRotate = Number(rotate) * progress * -1;
            transform += " rotate(".concat(currentRotate, "deg)");
        }
        el.style.transform = transform;
    };
    var setTranslate = function() {
        var _elements;
        var el = swiper.el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        var elements = (0, $g9Jbh.e)(el, elementsSelector);
        if (swiper.isElement) (_elements = elements).push.apply(_elements, (0, $jlUaU._)((0, $g9Jbh.e)(swiper.hostEl, elementsSelector)));
        elements.forEach(function(subEl) {
            setTransform(subEl, progress);
        });
        slides.forEach(function(slideEl, slideIndex) {
            var _slideEl_progress;
            var slideProgress = (_slideEl_progress = slideEl.progress) !== null && _slideEl_progress !== void 0 ? _slideEl_progress : 0;
            var _swiper_params_slidesPerGroup;
            var slidesPerGroup = (_swiper_params_slidesPerGroup = swiper.params.slidesPerGroup) !== null && _swiper_params_slidesPerGroup !== void 0 ? _swiper_params_slidesPerGroup : 1;
            if (slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll("".concat(elementsSelector, ", [data-swiper-parallax-rotate]")).forEach(function(subEl) {
                setTransform(subEl, slideProgress);
            });
        });
    };
    var _swiper_params_speed;
    var setTransition = function() {
        var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (_swiper_params_speed = swiper.params.speed) !== null && _swiper_params_speed !== void 0 ? _swiper_params_speed : 300;
        var _elements;
        var el = swiper.el, hostEl = swiper.hostEl;
        var elements = (0, $jlUaU._)(el.querySelectorAll(elementsSelector));
        if (swiper.isElement) (_elements = elements).push.apply(_elements, (0, $jlUaU._)(hostEl.querySelectorAll(elementsSelector)));
        elements.forEach(function(parallaxEl) {
            var attr = parallaxEl.getAttribute('data-swiper-parallax-duration');
            var parallaxDuration = (attr ? parseInt(attr, 10) : 0) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = "".concat(parallaxDuration, "ms");
        });
    };
    on('beforeInit', function() {
        if (!getParams().enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', function() {
        if (!getParams().enabled) return;
        setTranslate();
    });
    on('setTranslate', function() {
        if (!getParams().enabled) return;
        setTranslate();
    });
    on('setTransition', function(_swiper, duration) {
        if (!getParams().enabled) return;
        setTransition(duration);
    });
};

});

parcelRegister("hYIfu", function(module, exports) {

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $g9Jbh = parcelRequire("g9Jbh");
var $3366f3c00383373b$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    function getParams() {
        return swiper.params.zoom;
    }
    var currentScale = 1;
    var isScaling = false;
    var isPanningWithMouse = false;
    var mousePanStart = {
        x: 0,
        y: 0
    };
    var mousePanSensitivity = -3; // Negative to invert pan direction
    var fakeGestureTouched = false;
    var fakeGestureMoved = false;
    var evCache = [];
    var gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    var image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    var velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    var scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get: function() {
            return scale;
        },
        set: function(value) {
            if (scale !== value) {
                var imageEl = gesture.imageEl;
                var slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        var x1 = evCache[0].pageX;
        var y1 = evCache[0].pageY;
        var x2 = evCache[1].pageX;
        var y2 = evCache[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    }
    function getMaxRatio() {
        var _gesture_imageWrapEl;
        var params = getParams();
        var attr = (_gesture_imageWrapEl = gesture.imageWrapEl) === null || _gesture_imageWrapEl === void 0 ? void 0 : _gesture_imageWrapEl.getAttribute('data-swiper-zoom');
        var maxRatio = attr != null ? Number(attr) : params.maxRatio;
        var imageEl = gesture.imageEl;
        if (params.limitToOriginalSize && imageEl && imageEl.naturalWidth) {
            var imageMaxRatio = imageEl.naturalWidth / imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2 || !gesture.imageEl) return [
            null,
            null
        ];
        var box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    }
    function eventWithinSlide(e) {
        var slideSelector = getSlideSelector();
        var target = e.target;
        if (!target) return false;
        if (target.matches(slideSelector)) return true;
        if (swiper.slides.filter(function(slideEl) {
            return slideEl.contains(target);
        }).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        var selector = ".".concat(getParams().containerClass);
        var target = e.target;
        if (!target) return false;
        if (target.matches(selector)) return true;
        if ((0, $jlUaU._)(swiper.hostEl.querySelectorAll(selector)).filter(function(containerEl) {
            return containerEl.contains(target);
        }).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        var params = getParams();
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            var _gesture_slideEl;
            var target = e.target;
            var _target_closest;
            gesture.slideEl = (_target_closest = target === null || target === void 0 ? void 0 : target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"))) !== null && _target_closest !== void 0 ? _target_closest : undefined;
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            var _gesture_slideEl_querySelector;
            var imageEl = (_gesture_slideEl_querySelector = (_gesture_slideEl = gesture.slideEl) === null || _gesture_slideEl === void 0 ? void 0 : _gesture_slideEl.querySelector(".".concat(params.containerClass))) !== null && _gesture_slideEl_querySelector !== void 0 ? _gesture_slideEl_querySelector : null;
            var _imageEl_querySelectorAll_;
            if (imageEl) imageEl = (_imageEl_querySelectorAll_ = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0]) !== null && _imageEl_querySelectorAll_ !== void 0 ? _imageEl_querySelectorAll_ : null;
            gesture.imageEl = imageEl !== null && imageEl !== void 0 ? imageEl : undefined;
            var _elementParents_;
            if (imageEl) gesture.imageWrapEl = (_elementParents_ = (0, $g9Jbh.j)(imageEl, ".".concat(params.containerClass))[0]) !== null && _elementParents_ !== void 0 ? _elementParents_ : undefined;
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            var _getScaleOrigin = (0, $6ZpBv._)(getScaleOrigin(), 2), originX = _getScaleOrigin[0], originY = _getScaleOrigin[1];
            gesture.originX = originX !== null && originX !== void 0 ? originX : 0;
            gesture.originY = originY !== null && originY !== void 0 ? originY : 0;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        var params = getParams();
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        var _gesture_scaleStart;
        zoom.scale = gesture.scaleMove / ((_gesture_scaleStart = gesture.scaleStart) !== null && _gesture_scaleStart !== void 0 ? _gesture_scaleStart : 1) * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        var params = getParams();
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    var allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        if (allowTouchMoveTimeout !== undefined) clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(function() {
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        var device = swiper.device;
        if (image.isTouched) return;
        // Record the position before the imageEl guard, it is unset until the first pinch or zoom
        var event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
        if (!gesture.imageEl) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
    }
    function onTouchMove(e) {
        var isMouseEvent = e.pointerType === 'mouse';
        var isMousePan = isMouseEvent && getParams().panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $g9Jbh.q)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $g9Jbh.q)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        var _image_touchesStart_x, _image_touchesStart_y;
        var touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - ((_image_touchesStart_x = image.touchesStart.x) !== null && _image_touchesStart_x !== void 0 ? _image_touchesStart_x : 0)), Math.abs(image.touchesCurrent.y - ((_image_touchesStart_y = image.touchesStart.y) !== null && _image_touchesStart_y !== void 0 ? _image_touchesStart_y : 0)));
        if (touchesDiff > 5) swiper.allowClick = false;
        var _image_startX;
        var startX = (_image_startX = image.startX) !== null && _image_startX !== void 0 ? _image_startX : 0;
        var _image_startY;
        var startY = (_image_startY = image.startY) !== null && _image_startY !== void 0 ? _image_startY : 0;
        if (!image.isMoved && !isScaling) {
            var _image_touchesStart_x1, _image_touchesStart_x2;
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(startX) && image.touchesCurrent.x < ((_image_touchesStart_x1 = image.touchesStart.x) !== null && _image_touchesStart_x1 !== void 0 ? _image_touchesStart_x1 : 0) || Math.floor(image.maxX) === Math.floor(startX) && image.touchesCurrent.x > ((_image_touchesStart_x2 = image.touchesStart.x) !== null && _image_touchesStart_x2 !== void 0 ? _image_touchesStart_x2 : 0))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            var _image_touchesStart_y1, _image_touchesStart_y2;
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(startY) && image.touchesCurrent.y < ((_image_touchesStart_y1 = image.touchesStart.y) !== null && _image_touchesStart_y1 !== void 0 ? _image_touchesStart_y1 : 0) || Math.floor(image.maxY) === Math.floor(startY) && image.touchesCurrent.y > ((_image_touchesStart_y2 = image.touchesStart.y) !== null && _image_touchesStart_y2 !== void 0 ? _image_touchesStart_y2 : 0))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        var scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - getParams().minRatio);
        var originX = gesture.originX, originY = gesture.originY;
        var _image_touchesStart_x3;
        image.currentX = image.touchesCurrent.x - ((_image_touchesStart_x3 = image.touchesStart.x) !== null && _image_touchesStart_x3 !== void 0 ? _image_touchesStart_x3 : 0) + startX + scaleRatio * (image.width - originX * 2);
        var _image_touchesStart_y3;
        image.currentY = image.touchesCurrent.y - ((_image_touchesStart_y3 = image.touchesStart.y) !== null && _image_touchesStart_y3 !== void 0 ? _image_touchesStart_y3 : 0) + startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    }
    function onTouchEnd() {
        var zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var _velocity_x;
        var velocityX = (_velocity_x = velocity.x) !== null && _velocity_x !== void 0 ? _velocity_x : 0;
        var _velocity_y;
        var velocityY = (_velocity_y = velocity.y) !== null && _velocity_y !== void 0 ? _velocity_y : 0;
        var momentumDistanceX = velocityX * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocityY * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocityX !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocityX);
        if (velocityY !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocityY);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = "".concat(momentumDuration, "ms");
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    }
    function onTransitionEnd() {
        var zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove("".concat(getParams().zoomedSlideClass));
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        var currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        var matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        var deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        var deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        var scaledWidth = image.width * currentScale;
        var scaledHeight = image.height * currentScale;
        var slideWidth = gesture.slideWidth;
        var slideHeight = gesture.slideHeight;
        var minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        var maxX = -minX;
        var minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        var maxY = -minY;
        var newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        var newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = "translate3d(".concat(newX, "px, ").concat(newY, "px, 0)");
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        var zoom = swiper.zoom;
        var params = getParams();
        if (!gesture.slideEl) {
            var _gesture_slideEl;
            var _e_target_closest;
            if (e && typeof e !== 'number' && 'target' in e && e.target) gesture.slideEl = (_e_target_closest = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"))) !== null && _e_target_closest !== void 0 ? _e_target_closest : undefined;
            if (!gesture.slideEl) {
                var virtual = swiper.params.virtual;
                var _elementChildren_;
                if (virtual && virtual.enabled && swiper.virtual) gesture.slideEl = (_elementChildren_ = (0, $g9Jbh.e)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0]) !== null && _elementChildren_ !== void 0 ? _elementChildren_ : undefined;
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            var _gesture_slideEl_querySelector;
            var imageEl = (_gesture_slideEl_querySelector = (_gesture_slideEl = gesture.slideEl) === null || _gesture_slideEl === void 0 ? void 0 : _gesture_slideEl.querySelector(".".concat(params.containerClass))) !== null && _gesture_slideEl_querySelector !== void 0 ? _gesture_slideEl_querySelector : null;
            var _imageEl_querySelectorAll_;
            if (imageEl) imageEl = (_imageEl_querySelectorAll_ = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0]) !== null && _imageEl_querySelectorAll_ !== void 0 ? _imageEl_querySelectorAll_ : null;
            gesture.imageEl = imageEl !== null && imageEl !== void 0 ? imageEl : undefined;
            var _elementParents_;
            if (imageEl) gesture.imageWrapEl = (_elementParents_ = (0, $g9Jbh.j)(imageEl, ".".concat(params.containerClass))[0]) !== null && _elementParents_ !== void 0 ? _elementParents_ : undefined;
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        var eventIsPointer = e && typeof e !== 'number';
        if (typeof image.touchesStart.x === 'undefined' && eventIsPointer) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        var prevScale = currentScale;
        var forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        var maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $g9Jbh.h)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $g9Jbh.h)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - (touchX !== null && touchX !== void 0 ? touchX : 0);
            diffY = offsetY + slideHeight / 2 - (touchY !== null && touchY !== void 0 ? touchY : 0);
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = "translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)");
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    }
    function zoomOut() {
        var zoom = swiper.zoom;
        var params = getParams();
        if (!gesture.slideEl) {
            var _gesture_slideEl;
            var virtual = swiper.params.virtual;
            var _elementChildren_;
            if (virtual && virtual.enabled && swiper.virtual) gesture.slideEl = (_elementChildren_ = (0, $g9Jbh.e)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0]) !== null && _elementChildren_ !== void 0 ? _elementChildren_ : undefined;
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            var _gesture_slideEl_querySelector;
            var imageEl = (_gesture_slideEl_querySelector = (_gesture_slideEl = gesture.slideEl) === null || _gesture_slideEl === void 0 ? void 0 : _gesture_slideEl.querySelector(".".concat(params.containerClass))) !== null && _gesture_slideEl_querySelector !== void 0 ? _gesture_slideEl_querySelector : null;
            var _imageEl_querySelectorAll_;
            if (imageEl) imageEl = (_imageEl_querySelectorAll_ = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0]) !== null && _imageEl_querySelectorAll_ !== void 0 ? _imageEl_querySelectorAll_ : null;
            gesture.imageEl = imageEl !== null && imageEl !== void 0 ? imageEl : undefined;
            var _elementParents_;
            if (imageEl) gesture.imageWrapEl = (_elementParents_ = (0, $g9Jbh.j)(imageEl, ".".concat(params.containerClass))[0]) !== null && _elementParents_ !== void 0 ? _elementParents_ : undefined;
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (params.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        var passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach(function(eventName) {
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach(function(eventName) {
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', function() {
        if (getParams().enabled) enable();
    });
    on('destroy', function() {
        disable();
    });
    on('touchStart', function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', function() {
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', function(_s, e) {
        if (!swiper.animating && getParams().enabled && swiper.zoom.enabled && getParams().toggle) zoomToggle(e);
    });
    on('transitionEnd', function() {
        if (swiper.zoom.enabled && getParams().enabled) onTransitionEnd();
    });
    on('slideChange', function() {
        if (swiper.zoom.enabled && getParams().enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
};

});

parcelRegister("dJ2Ih", function(module, exports) {

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $jlUaU = parcelRequire("jlUaU");

var $g9Jbh = parcelRequire("g9Jbh");
var $b52d7a73550b45a9$var$LinearSpline = /*#__PURE__*/ function() {
    "use strict";
    function LinearSpline(x, y) {
        (0, $4QweW._)(this, LinearSpline);
        (0, $6tY97._)(this, "x", void 0);
        (0, $6tY97._)(this, "y", void 0);
        (0, $6tY97._)(this, "lastIndex", void 0);
        (0, $6tY97._)(this, "binarySearch", void 0);
        var maxIndex;
        var minIndex;
        var guess;
        this.binarySearch = function(array, val) {
            minIndex = -1;
            maxIndex = array.length;
            while(maxIndex - minIndex > 1){
                guess = maxIndex + minIndex >> 1;
                if (array[guess] <= val) minIndex = guess;
                else maxIndex = guess;
            }
            return maxIndex;
        };
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
    }
    (0, $6hK4i._)(LinearSpline, [
        {
            key: "interpolate",
            value: function interpolate(x2) {
                if (!x2) return 0;
                var i3 = this.binarySearch(this.x, x2);
                var i1 = i3 - 1;
                // Given an x value (x2), return the expected y2 value:
                // (x1,y1) is the known point before given value,
                // (x3,y3) is the known point after given value.
                // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
                return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
            }
        }
    ]);
    return LinearSpline;
}();
var $b52d7a73550b45a9$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function getParams() {
        return swiper.params.controller;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new $b52d7a73550b45a9$var$LinearSpline(swiper.slidesGrid, c.slidesGrid) : new $b52d7a73550b45a9$var$LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var SwiperCtor = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            var controllerParams = getParams();
            if (controllerParams.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            } else controlledTranslate = 0;
            if (!controlledTranslate || controllerParams.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (controllerParams.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) for(var i = 0; i < controlled.length; i += 1){
            var target = controlled[i];
            if (target && target !== byController && target instanceof SwiperCtor) setControlledTranslate(target);
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        var SwiperCtor = swiper.constructor;
        var controlled = swiper.controller.control;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $g9Jbh.t)(function() {
                    c.updateAutoHeight();
                });
                (0, $g9Jbh.m)(c.wrapperEl, function() {
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) for(var i = 0; i < controlled.length; i += 1){
            var target = controlled[i];
            if (target && target !== byController && target instanceof SwiperCtor) setControlledTransition(target);
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', function() {
        var controllerParam = getParams().control;
        if (typeof window !== 'undefined' && (typeof controllerParam === 'string' || controllerParam instanceof HTMLElement)) {
            var controlElements = typeof controllerParam === 'string' ? (0, $jlUaU._)(document.querySelectorAll(controllerParam)) : [
                controllerParam
            ];
            controlElements.forEach(function(controlElement) {
                if (!swiper.controller.control) swiper.controller.control = [];
                var list = swiper.controller.control;
                if (controlElement && controlElement.swiper) list.push(controlElement.swiper);
                else if (controlElement) {
                    var eventName = "".concat(swiper.params.eventsPrefix, "init");
                    var onControllerSwiper = function(e) {
                        var detail = e.detail;
                        if (detail && detail[0]) list.push(detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        // After this point control is either Swiper or Swiper[] (or null/undefined),
        // never the string/HTMLElement forms that the public option accepts.
        swiper.controller.control = controllerParam;
    });
    on('update', function() {
        removeSpline();
    });
    on('resize', function() {
        removeSpline();
    });
    on('observerUpdate', function() {
        removeSpline();
    });
    // Event payloads come typed against the legacy public Swiper class
    // (src/types/swiper-class.d.ts) until Phase 5 deletes src/types/; cast the
    // forwarded byController back to the core Swiper so it lines up with the
    // controller-internal signatures.
    on('setTranslate', function(_s, translate, byController) {
        if (!swiper.controller.control) return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', function(_s, duration, byController) {
        if (!swiper.controller.control) return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
};

});

parcelRegister("cfC7D", function(module, exports) {

var $kAqRU = parcelRequire("kAqRU");

var $g9Jbh = parcelRequire("g9Jbh");
var $1cd9cb258721c165$var$isVirtualEnabled = function(swiper) {
    var _swiper_params_virtual;
    return !!swiper.virtual && !!((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled);
};
var $1cd9cb258721c165$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    var liveRegion = null;
    var preventFocusHandler = false;
    var focusTargetSlideEl;
    var visibilityChangedTimestamp = new Date().getTime();
    function getParams() {
        return swiper.params.a11y;
    }
    function notify(message) {
        var notification = liveRegion;
        if (!notification || !message) return;
        (0, $g9Jbh.w)(notification, message);
    }
    function getRandomNumber() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
        var randomChar = function() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElLabel(el, label) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.setAttribute('aria-disabled', 'true');
        });
    }
    function enableEl(el) {
        var els = (0, $g9Jbh.s)(el);
        els.forEach(function(subEl) {
            subEl.removeAttribute('aria-disabled');
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var params = getParams();
        var paginationParams = swiper.params.pagination;
        var targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(targetEl))) {
            if (!targetEl.matches((0, $kAqRU.c)(paginationParams === null || paginationParams === void 0 ? void 0 : paginationParams.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            var prevEls = (0, $g9Jbh.s)(swiper.navigation.prevEl);
            var nextEls = (0, $g9Jbh.s)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $kAqRU.c)(paginationParams === null || paginationParams === void 0 ? void 0 : paginationParams.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return !!(swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length);
    }
    function hasClickablePagination() {
        var paginationParams = swiper.params.pagination;
        return hasPagination() && !!(paginationParams === null || paginationParams === void 0 ? void 0 : paginationParams.clickable);
    }
    function updatePagination() {
        var params = getParams();
        if (!hasPagination()) return;
        var paginationParams = swiper.params.pagination;
        swiper.pagination.bullets.forEach(function(bulletEl) {
            if (paginationParams.clickable) {
                makeElFocusable(bulletEl);
                if (!paginationParams.renderBullet) {
                    addElRole(bulletEl, 'button');
                    var _elementIndex;
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, String(((_elementIndex = (0, $g9Jbh.b)(bulletEl)) !== null && _elementIndex !== void 0 ? _elementIndex : 0) + 1)));
                }
            }
            if (bulletEl.matches((0, $kAqRU.c)(paginationParams.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    var initNavEl = function(el, _wrapperId, message) {
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
    };
    var handlePointerDown = function(e) {
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    var handlePointerUp = function() {
        preventFocusHandler = false;
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    var onVisibilityChange = function(_e) {
        visibilityChangedTimestamp = new Date().getTime();
    };
    // Loop keyboard trap (#8181): on Tab out of the last/first real slide, make other slides `inert` for the keypress so focus leaves the wrapper
    var inertSlides = [];
    var releaseInertSlides = function() {
        inertSlides.forEach(function(slideEl) {
            return slideEl.removeAttribute('inert');
        });
        inertSlides = [];
    };
    var handleTabKey = function(e) {
        var _target_closest;
        if (e.key !== 'Tab' || !swiper.params.loop || swiper.destroyed) return;
        var target = e.target;
        var slideEl = target === null || target === void 0 ? void 0 : (_target_closest = target.closest) === null || _target_closest === void 0 ? void 0 : _target_closest.call(target, ".".concat(swiper.params.slideClass, ", swiper-slide"));
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        var realIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index') || '', 10);
        if (Number.isNaN(realIndex)) return;
        var slidesLength = $1cd9cb258721c165$var$isVirtualEnabled(swiper) ? swiper.virtual.slides.length : swiper.slides.length;
        var isEdge = e.shiftKey ? realIndex === 0 : realIndex === slidesLength - 1;
        if (!isEdge) return;
        releaseInertSlides();
        swiper.slides.forEach(function(el) {
            if (el === slideEl || el.hasAttribute('inert')) return;
            el.setAttribute('inert', '');
            inertSlides.push(el);
        });
        setTimeout(releaseInertSlides, 0);
    };
    var handleFocus = function(e) {
        var params = getParams();
        if (swiper.a11y.clicked || !params.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        var target = e.target;
        var slideEl = target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        var isVirtual = $1cd9cb258721c165$var$isVirtualEnabled(swiper);
        var isActive = (isVirtual ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10) : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        var isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        var sourceCapabilities = e.sourceCapabilities;
        if (sourceCapabilities && sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(function() {
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            else if (isVirtual) swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    var initSlides = function() {
        var params = getParams();
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        var slidesLength = swiper.slides.length;
        var slideLabelMessage = params.slideLabelMessage;
        if (slideLabelMessage) swiper.slides.forEach(function(slideEl, index) {
            var slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10) : index;
            var ariaLabelMessage = slideLabelMessage.replace(/\{\{index\}\}/, String(slideIndex + 1)).replace(/\{\{slidesLength\}\}/, String(slidesLength));
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    var init = function() {
        var params = getParams();
        if (liveRegion) swiper.el.append(liveRegion);
        // Container
        var containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        var wrapperEl = swiper.wrapperEl;
        var wrapperId = String(params.id || wrapperEl.getAttribute('id') || "swiper-wrapper-".concat(getRandomNumber(16)));
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            var autoplayParams = swiper.params.autoplay;
            var live = swiper.params.autoplay && (autoplayParams === null || autoplayParams === void 0 ? void 0 : autoplayParams.enabled) ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        var nav = swiper.navigation ? swiper.navigation : {
            nextEl: undefined,
            prevEl: undefined
        };
        var nextEls = (0, $g9Jbh.s)(nav.nextEl);
        var prevEls = (0, $g9Jbh.s)(nav.prevEl);
        if (nextEls) nextEls.forEach(function(el) {
            return initNavEl(el, wrapperId, params.nextSlideMessage);
        });
        if (prevEls) prevEls.forEach(function(el) {
            return initNavEl(el, wrapperId, params.prevSlideMessage);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = (0, $g9Jbh.s)(swiper.pagination.el);
            paginationEl.forEach(function(el) {
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('keydown', handleTabKey, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        var nav = swiper.navigation ? swiper.navigation : {
            nextEl: undefined,
            prevEl: undefined
        };
        var nextEls = (0, $g9Jbh.s)(nav.nextEl);
        var prevEls = (0, $g9Jbh.s)(nav.prevEl);
        if (nextEls) nextEls.forEach(function(el) {
            return el.removeEventListener('keydown', onEnterOrSpaceKey);
        });
        if (prevEls) prevEls.forEach(function(el) {
            return el.removeEventListener('keydown', onEnterOrSpaceKey);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = (0, $g9Jbh.s)(swiper.pagination.el);
            paginationEl.forEach(function(el) {
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('keydown', handleTabKey, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
        releaseInertSlides();
    }
    on('beforeInit', function() {
        liveRegion = (0, $g9Jbh.a)('span', getParams().notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', function() {
        if (!getParams().enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', function() {
        if (!getParams().enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', function() {
        if (!getParams().enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', function() {
        if (!getParams().enabled) return;
        updatePagination();
    });
    on('destroy', function() {
        if (!getParams().enabled) return;
        destroy();
    });
};

});

parcelRegister("1mkGn", function(module, exports) {
var $a7259289330543ec$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    var initialized = false;
    var paths = {
        key: undefined,
        value: undefined
    };
    function getParams() {
        return swiper.params.history;
    }
    var slugify = function(text) {
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    var getPathValues = function(urlOverride) {
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split('/').filter(function(part) {
            return part !== '';
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    var setHistory = function(key, index) {
        var _swiper_params_virtual;
        var params = getParams();
        if (!initialized || !params.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var isVirtualEnabled = !!((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled);
        var slide = swiper.virtual && isVirtualEnabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(index, '"]')) : swiper.slides[index];
        if (!slide) return;
        var value = slugify(slide.getAttribute('data-history') || '');
        var root = params.root;
        if (root.length > 0) {
            var trimmedRoot = root[root.length - 1] === '/' ? root.slice(0, root.length - 1) : root;
            value = "".concat(trimmedRoot, "/").concat(key ? "".concat(key, "/") : '').concat(value);
        } else if (!location.pathname.includes(key || '')) value = "".concat(key ? "".concat(key, "/") : '').concat(value);
        if (params.keepQuery) value += location.search;
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (params.replaceState) window.history.replaceState({
            value: value
        }, '', value);
        else window.history.pushState({
            value: value
        }, '', value);
    };
    var scrollToSlide = function(speed, value, runCallbacks) {
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides[i];
            var slideHistory = slugify(slide.getAttribute('data-history') || '');
            if (slideHistory === value) {
                var index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    var setHistoryPopState = function() {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    var init = function() {
        var params = swiper.params.history;
        if (!params) return;
        if (!window.history || !window.history.pushState) {
            params.enabled = false;
            var hashParams = swiper.params.hashNavigation;
            if (hashParams) hashParams.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!params.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!params.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    var destroy = function() {
        if (!getParams().replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', function() {
        if (getParams().enabled) init();
    });
    on('destroy', function() {
        if (getParams().enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', function() {
        if (initialized) setHistory(getParams().key, swiper.activeIndex);
    });
    on('slideChange', function() {
        if (initialized && swiper.params.cssMode) setHistory(getParams().key, swiper.activeIndex);
    });
};

});

parcelRegister("1DdR6", function(module, exports) {

var $g9Jbh = parcelRequire("g9Jbh");
var $dc1fb274dcad36dc$var$isVirtualEnabled = function(swiper) {
    var _swiper_params_virtual;
    return !!swiper.virtual && !!((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled);
};
var $dc1fb274dcad36dc$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, on = param.on;
    var initialized = false;
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex: function(_s, hash) {
                if ($dc1fb274dcad36dc$var$isVirtualEnabled(swiper)) {
                    var slideWithHash = swiper.slides.find(function(slideEl) {
                        return slideEl.getAttribute('data-hash') === hash;
                    });
                    if (!slideWithHash) return 0;
                    var index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index') || '0', 10);
                    return index;
                }
                var matched = (0, $g9Jbh.e)(swiper.slidesEl, ".".concat(swiper.params.slideClass, '[data-hash="').concat(hash, '"], swiper-slide[data-hash="').concat(hash, '"]'))[0];
                return matched ? swiper.getSlideIndex(matched) : 0;
            }
        }
    });
    function getParams() {
        return swiper.params.hashNavigation;
    }
    var onHashChange = function() {
        emit('hashChange');
        var newHash = document.location.hash.replace('#', '');
        var activeSlideEl = $dc1fb274dcad36dc$var$isVirtualEnabled(swiper) ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            var newIndex = getParams().getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    var setHash = function() {
        var params = getParams();
        if (!initialized || !params.enabled) return;
        var activeSlideEl = $dc1fb274dcad36dc$var$isVirtualEnabled(swiper) ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (params.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, '', "#".concat(activeSlideHash) || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    var init = function() {
        var params = getParams();
        var historyParams = swiper.params.history;
        if (!params.enabled || historyParams && historyParams.enabled) return;
        initialized = true;
        var hash = document.location.hash.replace('#', '');
        if (hash) {
            var speed = 0;
            var index = params.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (params.watchState) window.addEventListener('hashchange', onHashChange);
    };
    var destroy = function() {
        if (getParams().watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', function() {
        if (getParams().enabled) init();
    });
    on('destroy', function() {
        if (getParams().enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', function() {
        if (initialized) setHash();
    });
    on('slideChange', function() {
        if (initialized && swiper.params.cssMode) setHash();
    });
};

});

parcelRegister("83P8R", function(module, exports) {

var $5djcY = parcelRequire("5djcY");
var $1d2705a61a6f885a$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit, params = param.params;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function getParams() {
        return swiper.params.autoplay;
    }
    // params here is the user-supplied passedParams; extendParams hasn't yet
    // merged the defaults into swiper.params.autoplay at this point.
    var initialAutoplayDelay = (0, $5djcY._)(params.autoplay) === 'object' && params.autoplay && typeof params.autoplay.delay === 'number' ? params.autoplay.delay : 3000;
    var timeout;
    var raf;
    var autoplayDelayTotal = initialAutoplayDelay;
    var autoplayDelayCurrent = initialAutoplayDelay;
    var autoplayTimeLeft = 0;
    var autoplayStartTime = new Date().getTime();
    var wasPaused = false;
    var isTouched = false;
    var pausedByTouch = false;
    var touchStartTimeout;
    var pausedByInteraction = false;
    var pausedByPointerEnter = false;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        var detail = e.detail;
        if (pausedByPointerEnter || detail && detail.bySwiperTouchMove) return;
        resume();
    }
    var calcTimeLeft = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        var timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(function() {
            calcTimeLeft();
        });
    };
    var getSlideDelay = function() {
        var _swiper_params_virtual;
        var activeSlideEl;
        var virtualEnabled = !!((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled);
        if (swiper.virtual && virtualEnabled) activeSlideEl = swiper.slides.find(function(slideEl) {
            return slideEl.classList.contains('swiper-slide-active');
        });
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        var attr = activeSlideEl.getAttribute('data-swiper-autoplay');
        if (attr == null) return undefined;
        return parseInt(attr, 10);
    };
    var getTotalDelay = function() {
        var totalDelay = getParams().delay;
        var currentSlideDelay = getSlideDelay();
        if (typeof currentSlideDelay === 'number' && !Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) totalDelay = currentSlideDelay;
        return totalDelay;
    };
    var run = function(delayForce) {
        if (swiper.destroyed || !swiper.autoplay.running) return 0;
        if (raf !== undefined) cancelAnimationFrame(raf);
        calcTimeLeft();
        var delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        var speed = swiper.params.speed;
        var proceed = function() {
            if (!swiper || swiper.destroyed) return;
            var autoplayParams = getParams();
            if (autoplayParams.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(function() {
                    run();
                });
            }
        };
        if (delay > 0) {
            if (timeout !== undefined) clearTimeout(timeout);
            timeout = setTimeout(function() {
                proceed();
            }, delay);
        } else requestAnimationFrame(function() {
            proceed();
        });
        return delay;
    };
    var start = function() {
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
        return true;
    };
    var stop = function() {
        swiper.autoplay.running = false;
        if (timeout !== undefined) clearTimeout(timeout);
        if (raf !== undefined) cancelAnimationFrame(raf);
        emit('autoplayStop');
        return true;
    };
    var pause = function(internal, reset) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (timeout !== undefined) clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        var proceed = function() {
            emit('autoplayPause');
            if (getParams().waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        var delay = autoplayTimeLeft || getParams().delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    var resume = function() {
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    var onVisibilityChange = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    var onPointerEnter = function(e) {
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    var onPointerLeave = function(e) {
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    var attachMouseEvents = function() {
        if (getParams().pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    var detachMouseEvents = function() {
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    var attachDocumentEvents = function() {
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    var detachDocumentEvents = function() {
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', function() {
        if (getParams().enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', function() {
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', function() {
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', function() {
        if (!getParams().disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', function(_s, _speed, internal) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !getParams().disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (getParams().disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(function() {
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', function() {
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        if (touchStartTimeout !== undefined) clearTimeout(touchStartTimeout);
        if (timeout !== undefined) clearTimeout(timeout);
        if (getParams().disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
};

});

parcelRegister("gAVbe", function(module, exports) {

var $g9Jbh = parcelRequire("g9Jbh");
var $1a0d7ee57859dc58$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    var initialized = false;
    var swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function getParams() {
        return swiper.params.thumbs;
    }
    function isVirtualEnabled() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        var virtual = thumbsSwiper.params.virtual;
        return !!virtual && !!virtual.enabled;
    }
    function onThumbClick() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        var thumbsParams = getParams();
        if (clickedSlide && clickedSlide.classList.contains(thumbsParams.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) {
            var _thumbsSwiper_clickedSlide;
            var attr = (_thumbsSwiper_clickedSlide = thumbsSwiper.clickedSlide) === null || _thumbsSwiper_clickedSlide === void 0 ? void 0 : _thumbsSwiper_clickedSlide.getAttribute('data-swiper-slide-index');
            slideToIndex = attr == null ? clickedIndex : parseInt(attr, 10);
        } else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        var thumbsParams = getParams();
        if (initialized) return false;
        initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            var thumbsSwiper = thumbsParams.swiper;
            swiper.thumbs.swiper = thumbsSwiper;
            Object.assign(thumbsSwiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(thumbsSwiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            thumbsSwiper.update();
        } else if ((0, $g9Jbh.r)(thumbsParams.swiper)) {
            var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        var thumbsSwiper1 = swiper.thumbs.swiper;
        if (!thumbsSwiper1) return false;
        thumbsSwiper1.el.classList.add(thumbsParams.thumbsContainerClass);
        thumbsSwiper1.on('tap', onThumbClick);
        if (isVirtualEnabled()) thumbsSwiper1.on('virtualUpdate', function() {
            update(false, {
                autoScroll: false
            });
        });
        return true;
    }
    function update(initial, p) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbsParams = getParams();
        var thumbActiveClass = thumbsParams.slideThumbActiveClass;
        var slidesPerView = swiper.params.slidesPerView;
        if (typeof slidesPerView === 'number' && slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = slidesPerView;
        if (!thumbsParams.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach(function(slideEl) {
            return slideEl.classList.remove(thumbActiveClass);
        });
        if (thumbsSwiper.params.loop || isVirtualEnabled()) for(var i = 0; i < thumbsToActivate; i += 1)(0, $g9Jbh.e)(thumbsSwiper.slidesEl, '[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).forEach(function(slideEl) {
            slideEl.classList.add(thumbActiveClass);
        });
        else for(var i1 = 0; i1 < thumbsToActivate; i1 += 1){
            var slide = thumbsSwiper.slides[swiper.realIndex + i1];
            if (slide) slide.classList.add(thumbActiveClass);
        }
        var _p_autoScroll;
        if ((_p_autoScroll = p === null || p === void 0 ? void 0 : p.autoScroll) !== null && _p_autoScroll !== void 0 ? _p_autoScroll : true) autoScroll(initial ? 0 : undefined);
    }
    function autoScroll(slideSpeed) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var thumbsSlidesPerView = thumbsSwiper.params.slidesPerView;
        var slidesPerView = thumbsSlidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSlidesPerView !== null && thumbsSlidesPerView !== void 0 ? thumbsSlidesPerView : 1;
        var autoScrollOffset = getParams().autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                var newThumbsSlide = thumbsSwiper.slides.find(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') === "".concat(swiper.realIndex);
                });
                newThumbsIndex = newThumbsSlide ? thumbsSwiper.slides.indexOf(newThumbsSlide) : -1;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', function() {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            var getThumbsElementAndInit = function() {
                var thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    var eventName = "".concat(swiper.params.eventsPrefix, "init");
                    var onThumbsSwiper = function(e) {
                        var detail = e.detail;
                        thumbs.swiper = detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            var watchForThumbsToAppear = function() {
                if (swiper.destroyed) return;
                var thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', function() {
        update();
    });
    on('setTransition', function(_s, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', function() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
};

});

parcelRegister("41pcR", function(module, exports) {

var $g9Jbh = parcelRequire("g9Jbh");
var $974e8868ae51cd86$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, once = param.once;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function getParams() {
        return swiper.params.freeMode;
    }
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        var translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        var data = swiper.touchEventsData, touches = swiper.touches;
        var _data_touchStartTime;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: (_data_touchStartTime = data.touchStartTime) !== null && _data_touchStartTime !== void 0 ? _data_touchStartTime : (0, $g9Jbh.u)()
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $g9Jbh.u)()
        });
    }
    function onTouchEnd(param) {
        var currentPos = param.currentPos;
        if (swiper.params.cssMode) return;
        var wrapperEl = swiper.wrapperEl, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid, data = swiper.touchEventsData;
        var params = swiper.params;
        var freeModeParams = getParams();
        // Time diff
        var touchEndTime = (0, $g9Jbh.u)();
        var _data_touchStartTime;
        var timeDiff = touchEndTime - ((_data_touchStartTime = data.touchStartTime) !== null && _data_touchStartTime !== void 0 ? _data_touchStartTime : touchEndTime);
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (freeModeParams.momentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < freeModeParams.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $g9Jbh.u)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= freeModeParams.momentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * freeModeParams.momentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * freeModeParams.momentumBounceRatio;
            var needsLoopFix = false;
            if (newPosition < swiper.maxTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (freeModeParams.sticky) {
                var nextSlide = 0;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                var _snapGrid_;
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(((_snapGrid_ = snapGrid[nextSlide - 1]) !== null && _snapGrid_ !== void 0 ? _snapGrid_ : snapGrid[nextSlide]) - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', function() {
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (freeModeParams.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    var speed = params.speed;
                    if (moveDistance < currentSlideSize) momentumDuration = speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = speed * 1.5;
                    else momentumDuration = speed * 2.5;
                }
            } else if (freeModeParams.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (freeModeParams.momentumBounce && doBounce && afterBouncePosition !== undefined) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $g9Jbh.m)(wrapperEl, function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        (0, $g9Jbh.m)(wrapperEl, function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $g9Jbh.m)(wrapperEl, function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (freeModeParams.sticky) {
            swiper.slideToClosest();
            return;
        } else emit('_freeModeNoMomentumRelease');
        if (!freeModeParams.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    swiper.freeMode = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
};

});

parcelRegister("92XIM", function(module, exports) {

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");
var $3fd940d41914412e$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    function getParams() {
        return swiper.params.grid;
    }
    var slidesNumberEvenToRows;
    var slidesPerRow;
    var numFullColumns;
    var wasMultiRow;
    var getSpaceBetween = function() {
        var _swiper_params_spaceBetween;
        var spaceBetween = (_swiper_params_spaceBetween = swiper.params.spaceBetween) !== null && _swiper_params_spaceBetween !== void 0 ? _swiper_params_spaceBetween : 0;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    var isVirtualEnabled = function() {
        var virtualParams = swiper.params.virtual;
        return !!swiper.virtual && (typeof virtualParams === "undefined" ? "undefined" : (0, $5djcY._)(virtualParams)) === 'object' && virtualParams !== null && !!virtualParams.enabled;
    };
    var initSlides = function(slides) {
        var slidesPerView = swiper.params.slidesPerView;
        var _getParams = getParams(), rows = _getParams.rows, fill = _getParams.fill;
        var slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, Math.floor(slidesPerView !== null && slidesPerView !== void 0 ? slidesPerView : 1) * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    var unsetSlides = function() {
        if (swiper.slides) swiper.slides.forEach(function(slide) {
            var gridSlide = slide;
            if (gridSlide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style.setProperty(swiper.getDirectionLabel('margin-top'), '');
            }
        });
    };
    var updateSlide = function(i, slide, slides) {
        var slidesPerGroup = swiper.params.slidesPerGroup;
        var spaceBetween = getSpaceBetween();
        var _getParams = getParams(), rows = _getParams.rows, fill = _getParams.fill;
        var slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        var newSlideOrderIndex;
        var column;
        var row;
        if (fill === 'row' && (slidesPerGroup !== null && slidesPerGroup !== void 0 ? slidesPerGroup : 1) > 1) {
            var groupsPer = slidesPerGroup !== null && slidesPerGroup !== void 0 ? slidesPerGroup : 1;
            var groupIndex = Math.floor(i / (groupsPer * rows));
            var slideIndexInGroup = i - rows * groupsPer * groupIndex;
            var columnsInGroup = groupIndex === 0 ? groupsPer : Math.min(Math.ceil((slidesLength - groupIndex * rows * groupsPer) / rows), groupsPer);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * groupsPer;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = String(newSlideOrderIndex);
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        var gridSlide = slide;
        gridSlide.row = row;
        gridSlide.column = column;
        slide.style.height = "calc((100% - ".concat((rows - 1) * spaceBetween, "px) / ").concat(rows, ")");
        slide.style.setProperty(swiper.getDirectionLabel('margin-top'), row !== 0 && spaceBetween ? "".concat(spaceBetween, "px") : '');
        gridSlide.swiperSlideGridSet = true;
    };
    var updateWrapperSize = function(slideSize, snapGrid) {
        var _swiper_params = swiper.params, centeredSlides = _swiper_params.centeredSlides, roundLengths = _swiper_params.roundLengths;
        var spaceBetween = getSpaceBetween();
        var rows = getParams().rows;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style.setProperty(swiper.getDirectionLabel('width'), "".concat(swiper.virtualSize + spaceBetween, "px"));
        if (centeredSlides) {
            var _snapGrid;
            var newSlidesGrid = [];
            for(var i = 0; i < snapGrid.length; i += 1){
                var slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            (_snapGrid = snapGrid).push.apply(_snapGrid, (0, $jlUaU._)(newSlidesGrid));
        }
    };
    var onInit = function() {
        var gridParams = swiper.params.grid;
        var _gridParams_rows;
        wasMultiRow = !!(gridParams && ((_gridParams_rows = gridParams.rows) !== null && _gridParams_rows !== void 0 ? _gridParams_rows : 1) > 1);
    };
    var onUpdate = function() {
        var params = swiper.params, el = swiper.el;
        var gridParams = params.grid;
        var _gridParams_rows;
        var isMultiRow = !!(gridParams && ((_gridParams_rows = gridParams.rows) !== null && _gridParams_rows !== void 0 ? _gridParams_rows : 1) > 1);
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add("".concat(params.containerModifierClass, "grid"));
            if (gridParams.fill === 'column') el.classList.add("".concat(params.containerModifierClass, "grid-column"));
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
};

});

parcelRegister("cvzkk", function(module, exports) {

var $g9Jbh = parcelRequire("g9Jbh");
function $bfe6de5ae1daeccb$var$addSlide(index, slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        var _swiper_loopedSlides;
        activeIndexBuffer -= (_swiper_loopedSlides = swiper.loopedSlides) !== null && _swiper_loopedSlides !== void 0 ? _swiper_loopedSlides : 0;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides[i];
        if (!currentSlide) continue;
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (Array.isArray(slides)) {
        for(var i1 = 0; i1 < slides.length; i1 += 1){
            var slide = slides[i1];
            if (slide) slidesEl.append(slide);
        }
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)slidesEl.append(slidesBuffer[i2]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    var _swiper_loopedSlides1;
    if (params.loop) swiper.slideTo(newActiveIndex + ((_swiper_loopedSlides1 = swiper.loopedSlides) !== null && _swiper_loopedSlides1 !== void 0 ? _swiper_loopedSlides1 : 0), 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $bfe6de5ae1daeccb$var$appendSlide(slides) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var appendElement = function(slideEl) {
        if (typeof slideEl === 'string') {
            var tempDOM = document.createElement('div');
            (0, $g9Jbh.w)(tempDOM, slideEl);
            var child = tempDOM.children[0];
            if (child) slidesEl.append(child);
            (0, $g9Jbh.w)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (Array.isArray(slides)) for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        if (slide) appendElement(slide);
    }
    else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $bfe6de5ae1daeccb$var$prependSlide(slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    var prependElement = function(slideEl) {
        if (typeof slideEl === 'string') {
            var tempDOM = document.createElement('div');
            (0, $g9Jbh.w)(tempDOM, slideEl);
            var child = tempDOM.children[0];
            if (child) slidesEl.prepend(child);
            (0, $g9Jbh.w)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (Array.isArray(slides)) {
        for(var i = 0; i < slides.length; i += 1){
            var slide = slides[i];
            if (slide) prependElement(slide);
        }
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $bfe6de5ae1daeccb$var$removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $bfe6de5ae1daeccb$var$removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        var _swiper_loopedSlides;
        activeIndexBuffer -= (_swiper_loopedSlides = swiper.loopedSlides) !== null && _swiper_loopedSlides !== void 0 ? _swiper_loopedSlides : 0;
        swiper.loopDestroy();
    }
    var newActiveIndex = activeIndexBuffer;
    if (Array.isArray(slidesIndexes)) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            var indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        var indexToRemove1 = slidesIndexes;
        if (swiper.slides[indexToRemove1]) swiper.slides[indexToRemove1].remove();
        if (indexToRemove1 < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    var _swiper_loopedSlides1;
    if (params.loop) swiper.slideTo(newActiveIndex + ((_swiper_loopedSlides1 = swiper.loopedSlides) !== null && _swiper_loopedSlides1 !== void 0 ? _swiper_loopedSlides1 : 0), 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
var $bfe6de5ae1daeccb$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper;
    Object.assign(swiper, {
        appendSlide: $bfe6de5ae1daeccb$var$appendSlide.bind(swiper),
        prependSlide: $bfe6de5ae1daeccb$var$prependSlide.bind(swiper),
        addSlide: $bfe6de5ae1daeccb$var$addSlide.bind(swiper),
        removeSlide: $bfe6de5ae1daeccb$var$removeSlide.bind(swiper),
        removeAllSlides: $bfe6de5ae1daeccb$var$removeAllSlides.bind(swiper)
    });
};

});

parcelRegister("cLqMg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03d3dee82b181671$export$2e2bcd8739ae039; });

var $fSlhb = parcelRequire("fSlhb");

var $f14ux = parcelRequire("f14ux");

var $eo33C = parcelRequire("eo33C");

var $g9Jbh = parcelRequire("g9Jbh");
var $03d3dee82b181671$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        fadeEffect: {
            crossFade: false,
            mode: 'default'
        }
    });
    // duration of the pending `out-in` transition, passed from setTransition to
    // setTranslate where the incoming slide is known
    var outInDuration = 0;
    function getParams() {
        return swiper.params.fadeEffect;
    }
    function getMode() {
        var params = getParams();
        if (params.mode === 'default' && params.crossFade) return 'cross-fade';
        return params.mode;
    }
    var setTranslate = function() {
        var slides = swiper.slides;
        var params = getParams();
        var mode = getMode();
        var outInTransition = mode === 'out-in' && outInDuration > 0;
        var duration = outInDuration;
        outInDuration = 0;
        var targetEls = [];
        var incomingEls = [];
        var hasFadingOut = false;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var _slideEl_swiperSlideOffset;
            var offset = (_slideEl_swiperSlideOffset = slideEl.swiperSlideOffset) !== null && _slideEl_swiperSlideOffset !== void 0 ? _slideEl_swiperSlideOffset : 0;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var _slideEl_progress;
            var slideProgress = (_slideEl_progress = slideEl.progress) !== null && _slideEl_progress !== void 0 ? _slideEl_progress : 0;
            var slideOpacity = void 0;
            if (mode === 'cross-fade') slideOpacity = Math.max(1 - Math.abs(slideProgress), 0);
            else if (mode === 'out-in') slideOpacity = Math.max(1 - 2 * Math.abs(slideProgress), 0);
            else slideOpacity = 1 + Math.min(Math.max(slideProgress, -1), 0);
            var targetEl = (0, $f14ux.e)(params, slideEl);
            if (outInTransition) {
                var prevOpacity = parseFloat(targetEl.style.opacity);
                if (slideOpacity === 0 && prevOpacity > 0) hasFadingOut = true;
                if (slideOpacity > 0) incomingEls.push(targetEl);
                targetEls.push(targetEl);
            }
            targetEl.style.opacity = String(slideOpacity);
            targetEl.style.transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)");
        }
        if (outInTransition) {
            targetEls.forEach(function(el) {
                var delayed = hasFadingOut && incomingEls.includes(el);
                el.style.transitionDuration = "".concat(duration / 2, "ms");
                el.style.transitionDelay = delayed ? "".concat(duration / 2, "ms") : '0ms';
            });
            (0, $eo33C.e)({
                swiper: swiper,
                duration: duration,
                transformElements: incomingEls,
                allSlides: true
            });
        }
    };
    var setTransition = function(duration) {
        var mode = getMode();
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $g9Jbh.p)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            if (mode === 'out-in' && duration === 0) el.style.transitionDelay = '';
        });
        if (mode === 'out-in' && duration > 0 && !swiper.params.cssMode) {
            // sequencing (half durations, delay on the incoming slide) and the
            // transitionend listener are set in setTranslate, which runs right after
            // with up-to-date slides progress. Attaching transitionend here to all
            // slides would end the transition when outgoing slides finish at half time
            outInDuration = duration;
            return;
        }
        (0, $eo33C.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $fSlhb.e)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
};

});
parcelRegister("fSlhb", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $af91e1f26f1a34cc$export$f1e1789686576879; });
function $af91e1f26f1a34cc$export$f1e1789686576879(params) {
    var effect = params.effect, swiper = params.swiper, on = params.on, setTranslate = params.setTranslate, setTransition = params.setTransition, overwriteParams = params.overwriteParams, perspective = params.perspective, recreateShadows = params.recreateShadows, getEffectParams = params.getEffectParams;
    on('beforeInit', function() {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass).concat(effect));
        if (perspective && perspective()) swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', function() {
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', function(_s, duration) {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', function() {
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            var effectParams = getEffectParams ? getEffectParams() : undefined;
            if (!effectParams || !effectParams.slideShadows) return;
            swiper.slides.forEach(function(slideEl) {
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                    return shadowEl.remove();
                });
            });
            recreateShadows();
        }
    });
    var requireUpdateOnVirtual = false;
    on('virtualUpdate', function() {
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(function() {
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

});

parcelRegister("f14ux", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $70b3456cf4ce8fe5$export$f1e1789686576879; });

var $g9Jbh = parcelRequire("g9Jbh");
function $70b3456cf4ce8fe5$export$f1e1789686576879(_effectParams, slideEl) {
    var transformEl = (0, $g9Jbh.p)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style.setProperty('-webkit-backface-visibility', 'hidden');
    }
    return transformEl;
}

});

parcelRegister("eo33C", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $59dd421fb76ee58b$export$f1e1789686576879; });

var $g9Jbh = parcelRequire("g9Jbh");
function $59dd421fb76ee58b$export$f1e1789686576879(param) {
    var swiper = param.swiper, duration = param.duration, transformElements = param.transformElements, allSlides = param.allSlides;
    var activeIndex = swiper.activeIndex;
    var getSlide = function(el) {
        if (!el.parentElement) // assume shadow root
        return swiper.slides.find(function(slideEl) {
            return slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode;
        });
        if (el.parentElement instanceof HTMLElement) return el.parentElement;
        return undefined;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        var transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter(function(transformEl) {
            var el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return !!el && swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach(function(el) {
            (0, $g9Jbh.m)(el, function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var evt = new CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}

});


parcelRegister("bV7YR", function(module, exports) {

var $fSlhb = parcelRequire("fSlhb");

var $g9Jbh = parcelRequire("g9Jbh");
var $96e4b313e60da04d$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    function getParams() {
        return swiper.params.cubeEffect;
    }
    var createSlideShadows = function(slideEl, progress, isHorizontal) {
        var shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $g9Jbh.a)('div', "swiper-slide-shadow-cube swiper-slide-shadow-".concat(isHorizontal ? 'left' : 'top').split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $g9Jbh.a)('div', "swiper-slide-shadow-cube swiper-slide-shadow-".concat(isHorizontal ? 'right' : 'bottom').split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter) shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    var recreateShadows = function() {
        // create new ones
        var isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach(function(slideEl) {
            var _slideEl_progress;
            var progress = Math.max(Math.min((_slideEl_progress = slideEl.progress) !== null && _slideEl_progress !== void 0 ? _slideEl_progress : 0, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    var setTranslate = function() {
        var _swiper_params_virtual;
        var el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size;
        var r = (0, $g9Jbh.o)(swiper);
        var params = getParams();
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = !!(swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled));
        var wrapperRotate = 0;
        var cubeShadowEl = null;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $g9Jbh.a)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = "".concat(swiperWidth, "px");
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $g9Jbh.a)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideIndex = i;
            var _slideEl_getAttribute;
            if (isVirtual) slideIndex = parseInt((_slideEl_getAttribute = slideEl.getAttribute('data-swiper-slide-index')) !== null && _slideEl_getAttribute !== void 0 ? _slideEl_getAttribute : '0', 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var _slideEl_progress;
            var progress = Math.max(Math.min((_slideEl_progress = slideEl.progress) !== null && _slideEl_progress !== void 0 ? _slideEl_progress : 0, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(".concat(r(isHorizontal ? 0 : -slideAngle), "deg) rotateY(").concat(r(isHorizontal ? slideAngle : 0), "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = "50% 50% -".concat(swiperSize / 2, "px");
        wrapperEl.style.setProperty('-webkit-transform-origin', "50% 50% -".concat(swiperSize / 2, "px"));
        if (params.shadow && cubeShadowEl) {
            if (isHorizontal) cubeShadowEl.style.transform = "translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(89.99deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")");
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                cubeShadowEl.style.transform = "scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-89.99deg)");
            }
        }
        wrapperEl.style.transform = "translate3d(0px,0,0px) rotateX(".concat(r(swiper.isHorizontal() ? 0 : wrapperRotate), "deg) rotateY(").concat(r(swiper.isHorizontal() ? -wrapperRotate : 0), "deg)");
        wrapperEl.style.setProperty('--swiper-cube-translate-z', '0px');
    };
    var setTransition = function(duration) {
        var _swiper_params_cubeEffect;
        var el = swiper.el, slides = swiper.slides;
        slides.forEach(function(slideEl) {
            slideEl.style.transitionDuration = "".concat(duration, "ms");
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(subEl) {
                subEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        if (((_swiper_params_cubeEffect = swiper.params.cubeEffect) === null || _swiper_params_cubeEffect === void 0 ? void 0 : _swiper_params_cubeEffect.shadow) && !swiper.isHorizontal()) {
            var shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = "".concat(duration, "ms");
        }
    };
    (0, $fSlhb.e)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.cubeEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
        }
    });
};

});

parcelRegister("e5B0u", function(module, exports) {

var $fGdwA = parcelRequire("fGdwA");

var $fSlhb = parcelRequire("fSlhb");

var $f14ux = parcelRequire("f14ux");

var $eo33C = parcelRequire("eo33C");

var $g9Jbh = parcelRequire("g9Jbh");
var $e06477b07eb38024$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    function getParams() {
        return swiper.params.flipEffect;
    }
    var createSlideShadows = function(slideEl, progress) {
        var shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $fGdwA.c)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $fGdwA.c)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter) shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    var recreateShadows = function() {
        // Set shadows
        var params = getParams();
        swiper.slides.forEach(function(slideEl) {
            var _slideEl_progress;
            var progress = (_slideEl_progress = slideEl.progress) !== null && _slideEl_progress !== void 0 ? _slideEl_progress : 0;
            if (params.limitRotation) progress = Math.max(Math.min(progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    var setTranslate = function() {
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        var params = getParams();
        var rotateFix = (0, $g9Jbh.o)(swiper);
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var _slideEl_progress;
            var progress = (_slideEl_progress = slideEl.progress) !== null && _slideEl_progress !== void 0 ? _slideEl_progress : 0;
            if (params.limitRotation) progress = Math.max(Math.min(progress, 1), -1);
            var _slideEl_swiperSlideOffset;
            var offset = (_slideEl_swiperSlideOffset = slideEl.swiperSlideOffset) !== null && _slideEl_swiperSlideOffset !== void 0 ? _slideEl_swiperSlideOffset : 0;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = String(-Math.abs(Math.round(progress)) + slides.length);
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateFix(rotateX), "deg) rotateY(").concat(rotateFix(rotateY), "deg)");
            var targetEl = (0, $f14ux.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $g9Jbh.p)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $eo33C.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $fSlhb.e)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.flipEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
};

});
parcelRegister("fGdwA", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $07a10bc6c3263b3f$export$db3b6bfb95261072; });

var $g9Jbh = parcelRequire("g9Jbh");
function $07a10bc6c3263b3f$export$db3b6bfb95261072(suffix, slideEl, side) {
    var shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : '').concat(suffix ? " swiper-slide-shadow-".concat(suffix) : '');
    var shadowContainer = (0, $g9Jbh.p)(slideEl);
    var selector = ".".concat(shadowClass.split(' ').join('.'));
    var existing = shadowContainer.querySelector(selector);
    if (existing) return existing;
    var created = (0, $g9Jbh.a)('div', shadowClass.split(' '));
    shadowContainer.append(created);
    return created;
}

});


parcelRegister("f1wTr", function(module, exports) {

var $fGdwA = parcelRequire("fGdwA");

var $fSlhb = parcelRequire("fSlhb");

var $f14ux = parcelRequire("f14ux");

var $g9Jbh = parcelRequire("g9Jbh");
var $1023d58f05300ab9$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    function getParams() {
        return swiper.params.coverflowEffect;
    }
    var setTranslate = function() {
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = getParams();
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        var r = (0, $g9Jbh.o)(swiper);
        // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var slideEl = slides[i];
            var slideSize = slidesSizesGrid[i];
            var _slideEl_swiperSlideOffset;
            var slideOffset = (_slideEl_swiperSlideOffset = slideEl.swiperSlideOffset) !== null && _slideEl_swiperSlideOffset !== void 0 ? _slideEl_swiperSlideOffset : 0;
            var centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            var offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = typeof params.stretch === 'string' && params.stretch.indexOf('%') !== -1 ? parseFloat(params.stretch) / 100 * slideSize : params.stretch;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(r(rotateX), "deg) rotateY(").concat(r(rotateY), "deg) scale(").concat(scale, ")");
            var targetEl = (0, $f14ux.e)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = String(-Math.abs(Math.round(offsetMultiplier)) + 1);
            if (params.slideShadows) {
                // Set shadows
                var shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                var shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $fGdwA.c)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $fGdwA.c)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = String(offsetMultiplier > 0 ? offsetMultiplier : 0);
                if (shadowAfterEl) shadowAfterEl.style.opacity = String(-offsetMultiplier > 0 ? -offsetMultiplier : 0);
            }
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $g9Jbh.p)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
    };
    (0, $fSlhb.e)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true
            };
        }
    });
};

});

parcelRegister("3Ei1g", function(module, exports) {

var $fGdwA = parcelRequire("fGdwA");

var $fSlhb = parcelRequire("fSlhb");

var $f14ux = parcelRequire("f14ux");

var $eo33C = parcelRequire("eo33C");

var $g9Jbh = parcelRequire("g9Jbh");
var $3c90a2f3cff65ab7$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    function getParams() {
        return swiper.params.creativeEffect;
    }
    var getTranslateValue = function(value) {
        if (typeof value === 'string') return value;
        return "".concat(value, "px");
    };
    var setTranslate = function() {
        var _loop = function(i) {
            var slideEl = slides[i];
            var _slideEl_progress;
            var slideProgress = (_slideEl_progress = slideEl.progress) !== null && _slideEl_progress !== void 0 ? _slideEl_progress : 0;
            var progress = Math.min(Math.max(slideProgress, -params.limitProgress), params.limitProgress);
            var originalProgress = progress;
            var _slideEl_originalProgress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max((_slideEl_originalProgress = slideEl.originalProgress) !== null && _slideEl_originalProgress !== void 0 ? _slideEl_originalProgress : 0, -params.limitProgress), params.limitProgress);
            var _slideEl_swiperSlideOffset;
            var offset = (_slideEl_swiperSlideOffset = slideEl.swiperSlideOffset) !== null && _slideEl_swiperSlideOffset !== void 0 ? _slideEl_swiperSlideOffset : 0;
            var t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            var r = [
                0,
                0,
                0
            ];
            var custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            var data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach(function(value, index) {
                t[index] = "calc(".concat(value, "px + (").concat(getTranslateValue(data.translate[index]), " * ").concat(Math.abs(progress * multiplier), "))");
            });
            // set rotates
            r.forEach(function(_value, index) {
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            var translateString = t.join(', ');
            var rotateString = "rotateX(".concat(rotateFix(r[0]), "deg) rotateY(").concat(rotateFix(r[1]), "deg) rotateZ(").concat(rotateFix(r[2]), "deg)");
            var scaleString = originalProgress < 0 ? "scale(".concat(1 + (1 - data.scale) * originalProgress * multiplier, ")") : "scale(".concat(1 - (1 - data.scale) * originalProgress * multiplier, ")");
            var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            var transform = "translate3d(".concat(translateString, ") ").concat(rotateString, " ").concat(scaleString);
            // Set shadows
            if (custom && data.shadow || !custom) {
                var shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $fGdwA.c)('creative', slideEl);
                if (shadowEl) {
                    var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = String(Math.min(Math.max(Math.abs(shadowOpacity), 0), 1));
                }
            }
            var targetEl = (0, $f14ux.e)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = String(opacityString);
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        };
        var slides = swiper.slides, wrapperEl = swiper.wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = getParams();
        var multiplier = params.progressMultiplier;
        var isCenteredSlides = swiper.params.centeredSlides;
        var rotateFix = (0, $g9Jbh.o)(swiper);
        if (isCenteredSlides) {
            var _swiper_params_slidesOffsetBefore;
            var margin = slidesSizesGrid[0] / 2 - ((_swiper_params_slidesOffsetBefore = swiper.params.slidesOffsetBefore) !== null && _swiper_params_slidesOffsetBefore !== void 0 ? _swiper_params_slidesOffsetBefore : 0);
            wrapperEl.style.transform = "translateX(calc(50% - ".concat(margin, "px))");
        }
        for(var i = 0; i < slides.length; i += 1)_loop(i);
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $g9Jbh.p)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll('.swiper-slide-shadow').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $eo33C.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $fSlhb.e)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return getParams().perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
};

});

parcelRegister("51qv4", function(module, exports) {

var $fGdwA = parcelRequire("fGdwA");

var $fSlhb = parcelRequire("fSlhb");

var $f14ux = parcelRequire("f14ux");

var $eo33C = parcelRequire("eo33C");

var $g9Jbh = parcelRequire("g9Jbh");
var $5e00f2e8563c562b$export$2e2bcd8739ae039 = function(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    function getParams() {
        return swiper.params.cardsEffect;
    }
    var setTranslate = function() {
        var slides = swiper.slides, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate;
        var params = getParams();
        var _swiper_touchEventsData = swiper.touchEventsData, startTranslate = _swiper_touchEventsData.startTranslate, isTouched = _swiper_touchEventsData.isTouched;
        var currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(var i = 0; i < slides.length; i += 1){
            var _swiper_params_virtual;
            var slideEl = slides[i];
            var _slideEl_progress;
            var slideProgress = (_slideEl_progress = slideEl.progress) !== null && _slideEl_progress !== void 0 ? _slideEl_progress : 0;
            var progress = Math.min(Math.max(slideProgress, -4), 4);
            var _slideEl_swiperSlideOffset;
            var offset = (_slideEl_swiperSlideOffset = slideEl.swiperSlideOffset) !== null && _slideEl_swiperSlideOffset !== void 0 ? _slideEl_swiperSlideOffset : 0;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = "translateX(".concat(swiper.minTranslate(), "px)");
            var _slides__swiperSlideOffset;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= (_slides__swiperSlideOffset = slides[0].swiperSlideOffset) !== null && _slides__swiperSlideOffset !== void 0 ? _slides__swiperSlideOffset : 0;
            var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var tY = 0;
            var tZ = -100 * Math.abs(progress);
            var scale = 1;
            var rotate = -params.perSlideRotate * progress;
            var tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            var slideIndex = swiper.virtual && ((_swiper_params_virtual = swiper.params.virtual) === null || _swiper_params_virtual === void 0 ? void 0 : _swiper_params_virtual.enabled) ? swiper.virtual.from + i : i;
            var isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && (currentTranslate !== null && currentTranslate !== void 0 ? currentTranslate : 0) < (startTranslate !== null && startTranslate !== void 0 ? startTranslate : 0);
            var isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && (currentTranslate !== null && currentTranslate !== void 0 ? currentTranslate : 0) > (startTranslate !== null && startTranslate !== void 0 ? startTranslate : 0);
            if (isSwipeToNext || isSwipeToPrev) {
                var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = "".concat((params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress), "%");
            }
            if (progress < 0) // next
            tX = "calc(".concat(tX, "px ").concat(rtl ? '-' : '+', " (").concat(tXAdd * Math.abs(progress), "%))");
            else if (progress > 0) // prev
            // wrap the value in parentheses instead of prepending `-` to the string,
            // as a negative tXAdd would otherwise produce an invalid `--` in calc()
            tX = "calc(".concat(tX, "px ").concat(rtl ? '-' : '+', " (").concat(-tXAdd * Math.abs(progress), "%))");
            else tX = "".concat(tX, "px");
            if (!swiper.isHorizontal()) {
                var prevY = tY;
                tY = tX;
                tX = prevY;
            }
            var scaleString = progress < 0 ? "".concat(1 + (1 - scale) * progress) : "".concat(1 - (1 - scale) * progress);
            var transform = "\n        translate3d(".concat(tX, ", ").concat(tY, ", ").concat(tZ, "px)\n        rotateZ(").concat(params.rotate ? rtl ? -rotate : rotate : 0, "deg)\n        scale(").concat(scaleString, ")\n      ");
            if (params.slideShadows) {
                // Set shadows
                var shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $fGdwA.c)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = String(Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1));
            }
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            var targetEl = (0, $f14ux.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $g9Jbh.p)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll('.swiper-slide-shadow').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $eo33C.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $fSlhb.e)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: getParams().rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
};

});



var $6ZpBv = parcelRequire("6ZpBv");

var $gMqb0 = parcelRequire("gMqb0");
parcelRequire("jAcWp");
var $iQHBV = parcelRequire("iQHBV");
parcelRequire("kP7YF");
var $cLqMg = parcelRequire("cLqMg");
var $cogvT = parcelRequire("cogvT");
var $a053994323e16434$var$selectors = {
    animationContainer: 'canvas',
    container: '.milestone',
    slider: '.milestone-slider',
    contentSlider: '.milestone-slider--content > .swiper',
    visualSlider: '.milestone-slider--visual > .swiper',
    yearSlider: '.milestone-slider--years > .swiper',
    hint: '.milestone-slider__hint'
};
var $a053994323e16434$var$classNames = {
    activeHint: 'active',
    transition: 'transition'
};
document.querySelectorAll($a053994323e16434$var$selectors.container).forEach(function(ctr) {
    var touchHintClassList = ctr.querySelector($a053994323e16434$var$selectors.hint).classList;
    /**
	 * Initialization
	 */ var sliders = {
        visual: {},
        content: {},
        year: {}
    };
    var fadeSliderConfig = {
        modules: [
            (0, $cLqMg.default)
        ],
        init: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 500
    };
    sliders.visual.swiper = new (0, $iQHBV.S)(ctr.querySelector($a053994323e16434$var$selectors.visualSlider), fadeSliderConfig);
    sliders.content.swiper = new (0, $iQHBV.S)(ctr.querySelector($a053994323e16434$var$selectors.contentSlider), fadeSliderConfig);
    sliders.year.swiper = new (0, $iQHBV.S)(ctr.querySelector($a053994323e16434$var$selectors.yearSlider), {
        modules: [
            (0, $cogvT.default)
        ],
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        init: false,
        slidesPerView: 3,
        centeredSlides: true,
        slideToClickedSlide: true,
        breakpoints: {
            768: {
                slidesPerView: 4
            },
            992: {
                slidesPerView: 5
            }
        },
        speed: 500
    });
    /**
	 * Events
	 */ // Events: Slide Changed
    sliders.visual.swiper.on('slideChange', function(swiper) {
        sliders.year.swiper.slideTo(swiper.activeIndex);
        sliders.content.swiper.slideTo(swiper.activeIndex);
    });
    sliders.year.swiper.on('slideChange', function(swiper) {
        sliders.visual.swiper.slideTo(swiper.activeIndex);
        sliders.content.swiper.slideTo(swiper.activeIndex);
    });
    sliders.content.swiper.on('slideChange', function(swiper) {
        sliders.visual.swiper.slideTo(swiper.activeIndex);
        sliders.year.swiper.slideTo(swiper.activeIndex);
        // Hide touch hint
        if (touchHintClassList.contains($a053994323e16434$var$classNames.activeHint)) touchHintClassList.remove($a053994323e16434$var$classNames.activeHint);
    });
    // Events: Slide Transition
    sliders.year.swiper.on('transitionStart', function(swiper) {
        swiper.el.classList.add($a053994323e16434$var$classNames.transition);
    });
    sliders.year.swiper.on('transitionEnd', function(swiper) {
        swiper.el.classList.remove($a053994323e16434$var$classNames.transition);
    });
    sliders.content.swiper.on('transitionStart', function(swiper) {
        swiper.el.closest($a053994323e16434$var$selectors.slider).classList.add($a053994323e16434$var$classNames.transition);
    });
    sliders.content.swiper.on('transitionEnd', function(swiper) {
        swiper.el.closest($a053994323e16434$var$selectors.slider).classList.remove($a053994323e16434$var$classNames.transition);
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $6ZpBv._)(_step.value, 2), name = _step_value[0], slider = _step_value[1];
            if ([
                'visual',
                'content'
            ].includes(name)) {
                // 1. Load all animations
                slider.animations = [];
                slider.swiper.on('init', function(swiper) {
                    swiper.slides.forEach(function(slide, index) {
                        var animationCanvas = slide.querySelector($a053994323e16434$var$selectors.animationContainer);
                        if (animationCanvas) slider.animations[index] = new (0, $gMqb0.Animation)(animationCanvas, animationCanvas.getAttribute('data-src'), {
                            loop: true,
                            autoplay: true,
                            workerId: 'milestone'
                        });
                    });
                });
                // 2. Listen to slideChange event to play / stop animations
                slider.swiper.on('slideChange', function(swiper) {
                    // 1. Stop previous animations
                    var prevIndex = swiper.previousIndex;
                    if (prevIndex !== 'undefined' && prevIndex in slider.animations) slider.animations[prevIndex].stop();
                    // 2. Play current animation
                    var activeIndex = swiper.activeIndex;
                    if (activeIndex in slider.animations) slider.animations[activeIndex].play();
                });
            }
            // Initialize all sliders
            slider.swiper.init();
        };
        // Events: Animation Handling
        for(var _iterator = Object.entries(sliders)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});

})();
//# sourceMappingURL=milestone.min.js.map
